import landingEn from '@/copy/landing.en.js';
import landingFr from '@/copy/landing.fr.js';
import landingEs from '@/copy/landing.es.js';
import landingRu from '@/copy/landing.ru.js';
import landingLt from '@/copy/landing.lt.js';
import storyEn from '@/copy/story.en.js';
import storyRu from '@/copy/story.ru.js';
import storyLt from '@/copy/story.lt.js';
import storyDe from '@/copy/story.de.js';
import storyNo from '@/copy/story.no.js';
import storyEs from '@/copy/story.es.js';
import storyFr from '@/copy/story.fr.js';

export const translations = {
  en: {
    // daily-words
    "dailyWords.row": "Daily words",
    "dailyWords.rowHint": "Type the words your child is learning each day",
    "dailyWords.title": "Daily words",
    "dailyWords.intro": "Type the words your child is learning now. Timo shows one each day and asks your child to say it.",
    "dailyWords.close": "Close",
    "dailyWords.modeTitle": "Which words Timo shows",
    "dailyWords.modeMine": "Only my words",
    "dailyWords.modeMineHint": "One of your words each day, in list order.",
    "dailyWords.modeMix": "My words and Timo's",
    "dailyWords.modeMixHint": "One day your word, the next day one of Timo's.",
    "dailyWords.today": "Today's word: {word}",
    "dailyWords.todayBadge": "Today",
    "dailyWords.add": "Add word",
    "dailyWords.inputLabel": "Word",
    "dailyWords.placeholder": "For example, apple",
    "dailyWords.pictureTitle": "Picture (optional)",
    "dailyWords.noPicture": "No picture",
    "dailyWords.photo": "Photo",
    "dailyWords.removePhoto": "Remove photo",
    "dailyWords.listTitle": "Your words",
    "dailyWords.empty": "No words yet. Until you add some, Timo shows his own words.",
    "dailyWords.edit": "Edit",
    "dailyWords.save": "Save",
    "dailyWords.cancel": "Cancel",
    "dailyWords.delete": "Delete",
    "dailyWords.deleteConfirm": "Delete “{word}”?",
    "dailyWords.listen": "Listen",
    "dailyWords.moveUp": "Move up",
    "dailyWords.moveDown": "Move down",
    "dailyWords.saved": "Saved",
    "dailyWords.deviceOnly": "Words are saved on this device only. Another phone or tablet will not have them.",
    "dailyWords.errEmpty": "Type a word first.",
    "dailyWords.errDuplicate": "That word is already on the list.",
    "dailyWords.errFull": "The list already has {max} words. Delete one to add a new one.",
    "dailyWords.errSave": "Could not save. The device storage may be full. Try without a photo.",
    "dailyWords.errImage": "That photo could not be opened. Pick another one.",
    // end daily-words
    'idiom.phraseDetected': 'Phrase detected',
    'idiom.theySaid': 'They said:',
    'idiom.thisMeans': 'This means:',
    'idiom.context': 'Context',
    'idiom.gotIt': 'Got it!',
    'idiom.dismiss': 'Dismiss',
    'house.room.living': 'Living room',
    'house.room.talk': 'Phone room',
    'house.room.play': 'Play room',
    'house.room.study': 'Study corner',
    'house.hotspot.couch': 'Bounce on the couch',
    'house.hotspot.window': 'Look out the window',
    'house.hotspot.timo': 'Play with Timo',
    'house.hotspot.pet': 'Play with Timo',
    'house.hotspot.phone': 'Talk on the phone',
    'house.hotspot.shelf': 'Open the picture cards',
    'house.hotspot.toybox': 'Open the toy box',
    'house.hotspot.desk': 'Word of the day',
    'house.parent.settings': 'Grown-ups',
    'house.parent.button': 'Grown-ups',
    'house.nav.rooms': 'Rooms',
    'house.nav.prev': 'Previous room',
    'house.nav.next': 'Next room',
    'house.badge.stars': 'Stars earned',
    'house.hotspot.beanbag': 'Beanbag',
    'house.hotspot.bookshelf': 'Bookshelf',
    'house.hotspot.curtain': 'Curtain',
    'house.hotspot.easel': 'Easel',
    'house.hotspot.lamp': 'Lamp',
    'house.hotspot.lights': 'Lights',
    'house.hotspot.pinboard': 'Pinboard',
    'house.hotspot.plant': 'Plant',
    'house.hotspot.playwindow': 'Window',
    'house.hotspot.rainbowrug': 'Rainbow rug',
    'house.hotspot.rug': 'Rug',
    'house.hotspot.stool': 'Stool',
    'house.map.title': 'House map',
    'house.map.close': 'Close map',
    'house.map.here': 'You are here',
    'house.map.go': 'Go',
    'house.map.activity.talk': 'Talk',
    'house.map.activity.cards': 'Cards',
    'house.map.activity.word': 'Word',
    'house.a11y.roomOf': 'Room {n} of {total}',
      // In-app browser overlay (Facebook / Instagram detection)
      'iab.title': 'Switch your browser',
      'iab.body': "Sign-in won't work inside {source}.",
      'iab.openChrome': 'Open in Chrome',
      'iab.openSafari': 'Open in Safari',
      'iab.openBrowser': 'Open in browser',
      'iab.copyLink': 'Copy link',
      'iab.copied': 'Copied',
      'iab.hintIos': 'Or tap the ⋯ menu → Open in Safari',
      'iab.hintAndroid': 'Or tap the ⋮ menu → Open in browser',
      'iab.hintOther': 'Or paste the link in your browser',
      'iab.iosCopyAndOpen': 'Copy link',
      'iab.iosLinkCopied': 'Link copied. Open Safari next.',
      'iab.iosStep1': 'Tap the link button to copy it.',
      'iab.iosStep2': 'Open Safari (long-press the home indicator or swipe up).',
      'iab.iosStep3': 'Paste the link in the address bar.',
      'iab.continueAnyway': 'Continue here',
      'obp.successTitle': "You're all set!",
      'obp.successBody': "You're in your browser now. Everything works here, sign-in included.",
      'obp.successCta': 'Continue',
      // Streak Popup
      'streak.popupTitle': 'DAILY CHAT STREAK INCREASED!',
      'streak.popupDayStreak': 'DAY STREAK',
      'streak.popupGreatStart': 'GREAT START!',
      'streak.popupOnFire': "YOU'RE ON FIRE! 🔥",
      'profile.viewStreakDetails': 'View Streak',
    // Newsletter landing page
    'newsletter.heroTitle': 'Time To Talk',
    'newsletter.heroSubtitle': 'Your AI companion for confident conversations',
    'newsletter.description': 'Join our newsletter to be the first to know when our app launches. Get early access, exclusive updates, and helpful communication tips.',
    'newsletter.emailPlaceholder': 'Enter your email address',
    'newsletter.subscribe': 'Subscribe',
    'newsletter.subscribing': 'Subscribing...',
    'newsletter.success': 'Thank you for subscribing!',
    'newsletter.successMessage': 'Check your email to confirm your subscription.',
    'newsletter.error': 'Something went wrong. Please try again.',
    'newsletter.emailInvalid': 'Please enter a valid email address',
    'newsletter.emailRequired': 'Email is required',
    'newsletter.features.title': 'What to Expect',
    'newsletter.features.earlyAccess': 'Early Access',
    'newsletter.features.earlyAccessDesc': 'Be among the first to try our app',
    'newsletter.features.updates': 'Exclusive Updates',
    'newsletter.features.updatesDesc': 'Get the latest news and features',
    'newsletter.features.tips': 'Communication Tips',
    'newsletter.features.tipsDesc': 'Helpful guides and strategies',
    'newsletter.requestAccess': 'Request Access',
    'newsletter.requestAccessTitle': 'Request Website Access',
    'newsletter.requestAccessSuccess': 'Request submitted! We\'ll review and get back to you.',
    'newsletter.name': 'Name',
    'newsletter.namePlaceholder': 'Your name (optional)',
    'newsletter.reason': 'Reason',
    'newsletter.reasonPlaceholder': 'Why do you need access? (optional)',
    'newsletter.submitRequest': 'Submit Request',
    'newsletter.submitting': 'Submitting...',
    'newsletter.beTheFirst': 'Be the First',
    'newsletter.beTheFirstDesc': 'Get early access and communication tips delivered to your inbox.',
    'newsletter.emailPlaceholderExample': 'your@email.com',
    'newsletter.gettingAccess': 'Getting Access...',
    'newsletter.getEarlyAccess': 'Get Early Access',
    'newsletter.noSpam': 'No spam. Unsubscribe anytime.',
    'newsletter.thankYouJoining': 'Thank you for joining! We\'ll keep you updated.',
    'newsletter.learnMoreBelow': 'Learn more below',
    'newsletter.downloadApp': 'Download the app',
    'newsletter.whyBuilding': 'Why We\'re Building This',
    'newsletter.whyBuildingDesc': 'Social situations move fast. The right words don\'t come when you need them. We\'re building this because communication shouldn\'t feel impossible.',
    'newsletter.whoWeHelp': 'Who We Help',
    'newsletter.whoWeHelpDesc': 'Social anxious, introverts, ASD, and anyone who wants to try speaking and needs help.',
    'newsletter.whatWeDo': 'What We Do',
    'newsletter.whatWeDoDesc': 'AI app that helps you understand conversations and respond. Gently, clearly, no pressure. Everything is game-like to make practice fun.',
    'newsletter.nonVerbalSupport': 'Non-Verbal Support',
    'newsletter.nonVerbalSupportDesc': 'We help non-verbal people and parents of non-verbal kids to communicate. Our Speak mode provides tools to speak without forcing speech.',
    'newsletter.safe': 'Safe',
    'newsletter.simple': 'Simple',
    'newsletter.supportive': 'Supportive',
    'newsletter.reportBug': 'report a bug',

    // Common
    'common.startVoice': 'Start voice input',
    'common.stopRecording': 'Stop recording',
    'common.close': 'Close',
    'common.help': 'Help',
    'common.back': 'Back',

    // Practice Chat
    'practice.pageTitle': 'Practice Chat',
    'practice.greeting': 'Hey! Ready to chat?',
    'practice.thinking': 'Thinking...',
    'practice.fallback': 'Got it!',
    'practice.end': 'Baigti',
    'practice.me': 'Me',
    'practice.other': 'Other',
    'practice.placeholder': 'Type something...',
    'practice.switchText': 'Switch to text',
    'practice.switchVoice': 'Switch to voice',
    'practice.errorTitle': 'Error',
    'practice.errorDesc': 'Failed to get response',
    
    // Home page
    'home.goodMorning': 'Good morning',
    'home.goodAfternoon': 'Good afternoon',
    'home.goodEvening': 'Good evening',
    'home.needHelpTalking': 'Need help talking?',
    'home.suggestWhatToSay': 'I\'ll suggest what to say',
    'home.quickActions': 'Quick Actions',
    'home.nonVerbal': 'Speak',
    'home.history': 'History',
    'home.scripts': 'Scripts',
    'home.startTalking': 'Start Talking',
    'home.reportBug': 'Report Bug',
    'home.underConstruction': 'Under Construction',
    'home.stillBuilding': 'Still building! Some things might not work yet.',
    'home.dontShowAgain': 'Don\'t show again',
    'home.gotIt': 'Got it!',
    'home.howToUse': 'How to use',
    'home.settings': 'Settings',
    'home.talkModeBeta': 'Beta',
    'home.talkModeUnderDevelopment': 'Currently under development',
    'home.talk': 'Talk',
    'home.show': 'Show',
    'home.breathing': 'Breathing',
    'home.greeting.morning': 'Good morning!',
    'home.greeting.afternoon': 'Good afternoon!',
    'home.greeting.evening': 'Good evening!',
    'home.timoHomeHint': 'Tap me to come in!',
    'timo.home.title': "Timo's home",
    'timo.home.back': 'Back',
    'timo.home.close': 'Close',
    // teacher-first-run: the help screen and its door on the landing screen.
    "timo.home.helpButton": "How to use",
    "help.metaTitle": "How to use Timo",
    "help.title": "How to use Timo",
    "help.intro": "Five short steps. It takes a minute to read.",
    "help.back": "Back",
    "help.langLabel": "Language",
    "help.teacher.title": "For teachers and therapists",
    "help.teacher.body": "The app says \"your child\". If you are a teacher, that means your student. Everything works the same, even if you signed up as a parent.",
    // school-use
    "help.school.title": "At school, with a student",
    "help.school.point1": "Use one account on the school tablet. Sign in once and it stays signed in.",
    "help.school.point2": "Hand the tablet to the child on the Timo screen. The child talks to Timo or taps the cards.",
    "help.school.point3": "Everything for grown-ups sits behind the Grown-ups button at the top: settings, progress and the subscription.",
    "help.school.point4": "Type the child's name under Grown-ups > Progress and the child's name. Then the cards and Timo use the child's name, not yours.",
    "help.school.point5": "Got a code from the school or an event? Tap “I have a code” on the start page, the sign-in screen, the payment page or in Settings.",
    "help.step1.title": "Start in Timo's room",
    "help.step1.body": "After you log in, you always land here. This is the start screen, and everything is one tap away.",
    "help.step1.alt": "Timo's room on a phone",
    "help.step2.title": "Tap Timo and talk",
    "help.step2.body": "Tap Timo or the Talk button and allow the microphone. The child speaks, Timo answers out loud.",
    "help.step2.alt": "The Talk button at the bottom of the screen",
    "help.step3.title": "Pictures when talking is hard",
    "help.step3.body": "The Pictures button opens picture cards. The child taps a card and the app says it out loud. No microphone needed, so it still works when the mic does not.",
    "help.step3.alt": "Picture cards",
    "help.step4.title": "Word of the day",
    "help.step4.body": "Every day Timo picks one new word. Tap the word card and say it together with the child.",
    "help.step4.alt": "The word of the day card",
    "help.step5.title": "For grown-ups",
    "help.step5.body": "The Grown-ups button at the top opens settings: language, voice and subscription. This guide is always right next to it.",
    "help.step5.alt": "The How to use and Grown-ups buttons at the top of the screen",
    "help.cta": "Go to Timo",
    "help.contact": "Questions? Email info@timetotalk.lt",
    // The paywall a teacher meets: this label had no key anywhere, so every language showed "per day".
    "pricing.perDayLabel": "per day",
    // Settings rows for what the hidden homes used to link: progress, profile, breathing.
    "settings.grownUps.title": "For grown-ups",
    "settings.grownUps.progress": "Progress and the child's name",
    "settings.grownUps.progressHint": "Words, streaks and the name Timo says",
    "settings.grownUps.profile": "Profile",
    "settings.grownUps.breathing": "Breathing exercise",
    "settings.grownUps.breathingHint": "Calm breathing together with the child",
    // Promo codes (MOKOMES and the rest): the landing confirmation and the banner on /timo.
    "promoGrant.accepted": "Code accepted: {days} free. Log in to activate it.",
    "promoGrant.acceptedUnlimited": "Code accepted: free unlimited access. Log in to activate it.",
    "promoGrant.continue": "Continue",
    "promoGrant.day.one": "day",
    "promoGrant.day.few": "days",
    "promoGrant.day.many": "days",
    "promoGrant.day.other": "days",
    "promoGrant.banner": "You have {days} of free access until {date}.",
    "promoGrant.bannerUnlimited": "You have free unlimited access.",
    "promoGrant.alreadyUsed": "The code {code} was already used, so it could not be activated again.",
    "promoGrant.close": "Close",
    // promo-codes-2: "I have a code" for signed-in people (/pricing, Settings) and the entry links.
    "promoCodes2.open": "I have a code",
    "promoCodes2.label": "Enter your code",
    "promoCodes2.submit": "Activate",
    "promoCodes2.checking": "Checking...",
    "promoCodes2.success": "Code accepted: {days} free, until {date}.",
    "promoCodes2.successUnlimited": "Code accepted: free unlimited access.",
    "promoCodes2.alreadyActive": "Your access is already active, no code needed.",
    "promoCodes2.err.empty": "Type the code first.",
    "promoCodes2.err.invalid": "That code does not exist. Check it and try again.",
    "promoCodes2.err.usedOnAccount": "This code was already used on your account.",
    "promoCodes2.err.usedOnNetwork": "This code was already used from this network. Email info@timetotalk.lt and we will help.",
    "promoCodes2.err.fullyClaimed": "This code has been fully claimed.",
    "promoCodes2.err.network": "Could not connect. Check the internet and try again.",
    "promoCodes2.err.error": "Could not activate the code. Try again.",
    'timo.home.dressTitle': 'Dress Timo up',
    'timo.home.foodTitle': 'What does Timo want?',
    'timo.home.action.feed': 'Feed',
    'timo.home.action.drink': 'Drink',
    'timo.home.action.sleep': 'Sleep',
    'timo.home.action.walk': 'Walk',
    'timo.home.action.potty': 'Potty',
    'timo.home.action.cheer': 'Cheer',
    'timo.home.action.dress': 'Dress up',
    'timo.home.sleep.notNight': "Timo isn't sleepy yet",
    'timo.home.outfit.default': 'Normal',
    'timo.home.outfit.beanie': 'Beanie',
    'timo.home.outfit.panama': 'Panama',
    'timo.home.outfit.cool': 'Cool shades',
    'timo.home.outfit.ai': 'Future Timo',
    'timo.home.outfit.yoga': 'Yoga Timo',
    'timo.home.food.apple': 'Apple',
    'timo.home.food.banana': 'Banana',
    'timo.home.food.berries': 'Berries',
    'timo.home.food.bread': 'Bread',
    'timo.home.food.fish': 'Fish',
    'timo.home.food.acorn': 'Acorn',
    'timo.home.food.cheese': 'Cheese',
    'timo.home.food.cookie': 'Cookie',
    // Talking Timo
    'timo.talk.tapHint': 'Tap me to talk!',
    'timo.talk.greeting': "Hi! I am Timo. What do you want to talk about?",
    'timo.talk.tapToTalk': 'Tap to talk',
    'timo.talk.listening': 'I am listening',
    'timo.talk.tapWhenDone': 'Tap when you are done',
    'timo.talk.thinking': 'Timo is thinking',
    'timo.talk.speaking': 'Timo is talking',
    'timo.talk.emptyReprompt': 'I am listening! Tell me something.',
    'timo.talk.llmErrorReply': 'I love talking with you! What is your favorite animal?',
    'timo.talk.micDenied': 'Timo needs your microphone',
    'timo.talk.micDeniedHelp': 'Ask a grown-up to allow the microphone in the browser settings, then tap try again.',
    // mic-school-devices
    'mic.fail.blocked.title': 'The microphone is blocked',
    'mic.fail.blocked.body': 'Timo cannot hear because this browser is not allowed to use the microphone. Allow it, then tap Try again.',
    'mic.fail.blocked.again': 'Tapped Block before? The browser will not ask again on its own. Change it in the settings, then reload the page.',
    'mic.fail.steps.ios': 'iPad or iPhone: tap aA in the address bar, then Website Settings, then set Microphone to Allow. Or open Settings, then Safari, then Microphone, and choose Allow.',
    'mic.fail.steps.chromebook': 'Chromebook: click the icon left of the web address, turn Microphone on, then reload the page. If the switch is grey, the school has blocked it. Ask your IT admin.',
    'mic.fail.steps.android': 'Android: tap the icon left of the web address, then Permissions, then set Microphone to Allow. Reload the page.',
    'mic.fail.steps.desktop': 'Computer: click the icon left of the web address, set Microphone to Allow, then reload the page. If it still does not work, check the privacy settings of the computer.',
    'mic.fail.steps.native': 'In the Timo app: open your phone Settings, then Timo, and turn Microphone on. Come back and tap Try again.',
    'mic.fail.no_device.title': 'No microphone found',
    'mic.fail.no_device.body': 'This device has no working microphone. Plug in a microphone or a headset, then tap Try again.',
    'mic.fail.in_use.title': 'The microphone is busy',
    'mic.fail.in_use.body': 'Another app or tab is using the microphone. Close it, video calls too, then tap Try again.',
    'mic.fail.insecure_context.title': 'This link cannot use the microphone',
    'mic.fail.insecure_context.body': 'The page is not on a secure address, so the browser hides the microphone. Open the address that starts with https://.',
    'mic.fail.unsupported.title': 'This browser cannot use the microphone',
    'mic.fail.unsupported.body': 'Open Timo in Chrome or Safari to talk. You can use the picture cards now.',
    'mic.fail.in_app_browser.title': 'Open Timo in your browser',
    'mic.fail.in_app_browser.body': 'Instagram, Facebook and similar apps open links in their own window, and the microphone does not work there. Open this page in Chrome or Safari.',
    'mic.fail.inapp.ios': 'Tap the three dots (...) at the top, then choose to open in the browser.',
    'mic.fail.inapp.android': 'Tap the three dots in the corner, then choose Open in Chrome.',
    'mic.fail.offline.title': 'No internet',
    'mic.fail.offline.body': 'Timo needs the internet to hear. Connect to Wi-Fi or mobile data, then tap Try again.',
    'mic.fail.stt_unreachable.title': 'Timo cannot reach his listening service',
    'mic.fail.stt_unreachable.body': 'The microphone works, but the network is blocking the speech service. This often happens on school Wi-Fi. Tap Try again, or ask your IT admin to allow api.deepgram.com and time-to-talk.onrender.com.',
    'mic.fail.stt_service_error.title': 'The listening service is having trouble',
    'mic.fail.stt_service_error.body': 'The microphone and the internet work, but the speech service answered with an error. Wait a minute, then tap Try again.',
    'mic.fail.signed_out.title': 'Please sign in again',
    'mic.fail.signed_out.body': 'Your sign-in has run out, so Timo cannot listen. Sign in again, then tap Try again.',
    'mic.fail.unknown.title': 'Timo cannot hear right now',
    'mic.fail.unknown.body': 'Something stopped the microphone. Tap Try again. If it keeps happening, reload the page.',
    'mic.fail.retry': 'Try again',
    'mic.fail.tiles': 'Use picture cards',
    'mic.fail.openBrowser': 'Open in browser',
    'mic.fail.signIn': 'Sign in',
    'timo.talk.exit': 'Done',
    'timo.word.title': 'Word of the Day',
    'timo.word.sayIt': 'Say it!',
    'timo.word.listening': 'I am listening',
    'timo.word.hearAgain': 'Hear it again',
    'timo.word.tryAgain': 'Can you say it with me?',
    'timo.word.great': 'Great job!',
    'timo.word.days': 'day streak',
    'timo.word.open': 'Word of the Day',
    'timo.word.close': 'Close',
    'timo.word.newWordSoon': 'New word tomorrow!',
    'timo.talk.waiting': 'Timo is thinking...',
    'timo.talk.youSaid': 'You said:',
    'timo.talk.voiceResting': "Timo's big voice is resting, so this one sounds robot-like.",
    'timo.teach.remember': 'Remember it',
    'timo.teach.hearIt': 'Hear it',
    'timo.teach.gotIt': 'Got it!',
    'timo.reward.earned': 'You earned {amount} stars!',
    'timo.words.title': 'My Words',
    'timo.words.wordSingular': 'word',
    'timo.words.wordPlural': 'words',
    'timo.words.tapHint': 'Tap a word to hear it',
    'timo.words.lockedHint': 'Say this word with Timo to unlock it',
    'timo.words.empty': 'No words yet',
    'timo.words.emptySub': 'Say the Word of the Day with Timo to start your collection!',
    'timo.words.close': 'Close',
    'timo.words.locked': 'Not yet',
    'timo.recap.title': 'Today with Timo',
    'timo.recap.wordsLead': 'Words your child said today',
    'timo.recap.noWords': 'Lots of happy chatting today',
    'timo.recap.turnsLabel': 'little conversations',
    'timo.recap.streakLabel': 'day streak',
    'timo.recap.minutesLabel': 'min together',
    'timo.recap.tipLead': 'Tip',
    'timo.recap.tip1': 'Try saying one of these words together at dinner tonight.',
    'timo.recap.tip2': 'Every little chat counts. A few minutes a day adds up fast.',
    'timo.recap.tip3': 'Ask your child to teach you what Timo said today.',
    'timo.recap.tip4': 'Praise the trying, not just the getting it right.',
    'timo.recap.dismiss': 'Close',
    'timo.recap.historyTitle': 'This week with Timo',
    'timo.recap.historyEmpty': 'No chats yet. Tap Timo to start one!',
    'timo.talk.greetingNamed': 'Hi {name}! I am so happy to see you!',
    'timo.talk.greetingWord': "Hi! Today's word is {word}. Can you say it?",
    'timo.talk.greetingWordNamed': "Hi {name}! Today's word is {word}. Can you say it?",
    'timo.onboarding.intro': 'Hi! I am Timo. I am your friend.',
    'timo.onboarding.askName': 'What is your name?',
    'timo.onboarding.heard': 'Did I hear {name}?',
    'timo.onboarding.confirmYes': 'Yes!',
    'timo.onboarding.confirmNo': 'Try again',
    'timo.onboarding.retry': 'Oops! Say your name again.',
    'timo.onboarding.typeInstead': 'Type my name',
    'timo.onboarding.namePlaceholder': 'Your name',
    'timo.onboarding.save': 'Save',
    'timo.onboarding.skip': 'Skip for now',
    'timo.onboarding.welcome': 'Nice to meet you, {name}!',
    'timo.onboarding.micDenied': 'I cannot hear you. You can type your name.',
    // Timo tells a story: UI chrome only. The story prose itself lives in
    // src/copy/story.en.js under the story.* keys, not here.
    'timo.story.tapToStart': 'Start the story',
    'timo.story.listening': 'Your turn',
    'timo.story.narrating': 'Timo is telling the story',
    'timo.story.close': 'Done',
    'timo.story.replay': 'Again',
    'timo.story.finished': 'The end',
    'timo.story.next': 'Next',
    // Timo's story copy lives in src/copy/story.en.js so it can be edited on its
    // own, same pattern as the landing copy above. English only for now: the
    // other six locales are coming and until then t() falls back to these
    // English lines rather than showing a blank story.
    ...storyEn,
    'parent.title': 'Progress',
    'parent.backAria': 'Back to home',
    'parent.noKidName': 'Your child',
    'parent.subtitle': 'Speech practice progress',
    'parent.tierLabel': 'Level',
    'parent.statStreak': 'Day streak',
    'parent.statWords': 'Words learned',
    'parent.statStars': 'Stars earned',
    'parent.statDaysActive': 'Active days',
    'parent.statDaysActiveHint': 'Last 30 days',
    'parent.statLongest': 'Longest streak',
    'parent.statWordsWeek': 'New words this week',
    'parent.calendarTitle': 'Practice calendar',
    'parent.calendarPrevAria': 'Previous month',
    'parent.calendarNextAria': 'Next month',
    'parent.calendarLegendPracticed': 'Practiced',
    'parent.calendarLegendToday': 'Today',
    'parent.calendarDayPracticed': 'practiced',
    'parent.calendarEmptyMonth': 'No practice recorded this month yet.',
    'parent.timelineTitle': 'Words learned',
    'parent.timelineToday': 'Today',
    'parent.timelineYesterday': 'Yesterday',
    'parent.timelineDaysAgo': '{n} days ago',
    'parent.timelineEmptyTitle': 'The journey starts here',
    'parent.timelineEmptyBody': 'Every word your child learns with Timo will show up here. Even one word a day adds up fast.',
    'parent.timelineWordCount': '{n} words',
    'parent.timelineWordCountOne': '1 word',
    'parent.printLabel': 'Print',
    'parent.printAria': 'Print this page',
    'parent.footerNote': 'Progress is saved on this device and synced to your account.',
    'timo.recap.today': 'Today',
    'timo.recap.yesterday': 'Yesterday',
    'breathing.prototypeNotice':
      'This is still a prototype. It does not work as planned yet, we are improving it.',
    
    // Scripts page
    'scripts.myScripts': 'My Scripts',
    'scripts.searchPlaceholder': 'Search scripts...',
    'scripts.usedTime': 'Played 1 time',
    'scripts.usedTimes': 'Played {count} times',
    'scripts.use': 'Use',
    'scripts.listen': 'Listen',
    'scripts.delete': 'Delete',
    'scripts.swipeToDelete': '← Swipe to delete',
    'scripts.noScriptsYet': 'No scripts yet',
    'scripts.savePhrasesDesc': 'Save phrases to reuse later 💬',
    'scripts.startTalking': 'Start Talking',
    'scripts.addScript': 'Add Script',
    'scripts.chooseEmoji': 'Choose an emoji',
    'scripts.yourPhrase': 'Your phrase',
    'scripts.phrasePlaceholder': 'e.g., Thank you for helping me',
    'scripts.cancel': 'Cancel',
    'scripts.save': 'Save',
    'scripts.addNewScript': 'Add new script',
    'scripts.noScriptsFound': 'No scripts found matching your search.',
    'scripts.copied': 'Copied!',
    'scripts.copiedToClipboard': 'Script copied to clipboard',
    'scripts.deleted': 'Deleted',
    'scripts.removedFromCollection': 'Script removed from your collection',
    'scripts.saved': 'Saved!',
    'scripts.addedToCollection': 'Script added to your collection',
    'scripts.alreadyExists': 'Already exists',
    'scripts.alreadySaved': 'You already have this script saved',
    'scripts.categoryAll': 'All',
    'scripts.categoryNonverbal': 'Speak',
    'scripts.categoryChats': 'Chats',
    
    // Profile page
    'profile.title': 'Profile',
    'profile.navSubscription': 'Subscription',
    'profile.navAboutUs': 'About us',
    'profile.sessions': 'Days',
    'profile.trophies': 'Trophies',
    'profile.sent': 'Sent',
    'profile.streak': 'Streak',
    'profile.activity': 'Activity',
    'profile.awards': 'Awards',
    'profile.startChatting': 'Start Chatting',
    'profile.friend': 'Friend',
    'profile.chat1': '1 Chat',
    'profile.chat5': '5 Chats',
    'profile.chat10': '10 Chats',
    'profile.chat25': '25 Chats',
    'profile.chat50': '50 Chats',
    'profile.chat100': '100 Chats',
    'profile.less': 'Less',
    'profile.more': 'More',
    'profile.chats': 'chats',
    'profile.goBack': 'Go back',
    'profile.reportBug': 'Report bug',
    'profile.sendFeedback': 'Send Feedback',
    'profile.feedbackTypeBug': 'Bug Report',
    'profile.feedbackTypeComment': 'Comment',
    'profile.feedbackPlaceholderBug': 'Describe the bug...',
    'profile.feedbackPlaceholderComment': 'Share your thoughts...',
    'profile.feedbackSend': 'Send',
    'profile.feedbackCancel': 'Cancel',
    'profile.feedbackSending': 'Sending...',
    'profile.feedbackSuccess': 'Thank you!',
    'profile.feedbackError': 'Failed. Try again.',
    'profile.editProfile': 'Edit Profile',
    'profile.username': 'Username',
    'profile.enterName': 'Enter your name',
    'profile.borderColor': 'Border Color',
    'profile.cancel': 'Cancel',
    'profile.save': 'Save',
    'profile.nameTooShort': 'Name must be at least 3 characters',
    'profile.nameInappropriate': 'Please choose an appropriate name',
    'profile.logout': 'Log out',
    'profile.logoutConfirmTitle': 'Are you sure?',
    'profile.logoutConfirmText': 'You will be logged out and returned to landing.',
    'profile.logoutYes': 'Yes',
    'profile.logoutNo': 'No',
    'profile.loggingOut': 'Logging out...',
    
    // Login page (kept for dev access)
    'login.welcome': 'Welcome',
    'login.subtitle': 'Please enter your details to continue',
    'login.firstName': 'First Name',
    'login.firstNamePlaceholder': 'Enter your first name',
    'login.firstNameRequired': 'First name is required',
    'login.lastName': 'Last Name',
    'login.lastNamePlaceholder': 'Enter your last name',
    'login.optional': 'optional',
    'login.email': 'Email',
    'login.emailPlaceholder': 'Enter your email',
    'login.emailRequired': 'Email is required',
    'login.emailInvalid': 'Please enter a valid email address',
    'login.error': 'Something went wrong. Please try again.',
    'login.pleaseWait': 'Please wait...',
    'login.continue': 'Continue',
    'login.disclaimer': 'This info may be used for promoting our app after final development.',
    
    appName: 'Time To Talk',
    tagline: 'Sometimes the biggest step is just saying "Hi"',
    start: 'Start',
    situations: 'Situations',
    chat: 'Chat',
    settings: 'Settings',
    home: 'Home',
    
    // Navigation
    'nav.home': 'Home',
    'nav.scripts': 'Scripts',
    'nav.settings': 'Settings',
    'nav.chat': 'Chat',
    'nav.live': 'Live',
    'nav.profile': 'Profile',
    'nav.nonverbal': 'Speak',
    selectSituation: 'Select a Situation',
    store: 'Store',
    cafe: 'Café',
    bus: 'Bus',
    hospital: 'Hospital',
    school: 'School',
    party: 'Party',
    chatFriend: 'AI Chat Friend',
    typeMessage: 'Type your message...',
    send: 'Send',
    playVoice: 'Play Voice',
    'tts.ltPreviewTitle': 'Voice - how it will sound',
    accessibilitySettings: 'Accessibility Settings',
    hideImages: 'Hide Images',
    showImages: 'Show Images',
    dyslexiaMode: 'Dyslexia Mode',
    textSize: 'Text Size',
    backgroundMode: 'Background Mode',
    monochrome: 'Monochrome',
    colored: 'Colored',
    resetDefaults: 'Reset to Defaults',
    language: 'Language',
    english: 'English',
    lithuanian: 'Lithuanian',
    detailMode: 'Detail Mode',
    detailModeDescription: 'Show more detailed instructions',
    instructions: 'Instructions',
    backToChat: 'Back to Chat',
    startChat: 'Start Chat',
    moreDetail: 'More Detail',
    lessDetail: 'Less Detail',
    addCustomSituation: "Add Custom Situation",
    createYourOwn: "Create Your Own Situation",
    situationName: "Situation Name (e.g., Library)",
    situationIcon: "Situation Icon (e.g., 📚)",
    situationNameEn: "Situation Name (English)",
    situationNameLt: "Situation Name (Lithuanian)",
    steps: "Steps",
    addStep: "Add Step",
    step: "Step",
    instructionSimpleEn: "Simple Instruction (English)",
    instructionDetailedEn: "Detailed Instruction (English)",
    instructionSimpleLt: "Simple Instruction (Lithuanian)",
    instructionDetailedLt: "Detailed Instruction (Lithuanian)",
    saveSituation: "Save Situation",
    delete: "Delete",
    stageName: "Stage Name",
    stageNameEn: "Stage Name (English)",
    stageNameLt: "Stage Name (Lithuanian)",
    coachLine: "Coach Line",
    icon: "Icon",
    textEn: "Text (English)",
    textLt: "Text (Lithuanian)",
    removeStep: "Remove Step",
    edit: "Edit",
    awards: "Awards",
    totalTrophies: "Total Trophies",
    colorThemes: "Color Themes",
    situationRewards: "Conversation Stats",
    unlocksAt: "Unlocks at",
    trophies: "trophies",
    successfulInteractions: "Successful interactions",
    applyTheme: "Apply Theme",
    applied: "Applied",
    chimeSound: "Reward Chime Sound",
    chimeSoundDescription: "Play a sound when unlocking a reward",
    // Settings Page
    'settings.title': 'Settings',
    'settings.backAria': 'Go back',
    'settings.appearance': 'Appearance',
    'settings.sounds': 'Sounds',
    'settings.background': 'Background',
    'settings.language': 'Language',
    'settings.account': 'Account',
    'settings.voiceprint.title': 'Voice recognition',
    'settings.voiceprint.description': 'Time to Talk learns to recognise your voice on this device so it can tell who is speaking in live conversations. Your voice profile is stored locally and never sent to our servers.',
    'settings.voiceprint.forget': 'Forget my voice',
    'settings.voiceprint.forgetDesc': 'Clear the saved voice profile and start fresh',
    'settings.voiceprint.forgotten': 'Voice profile cleared',
    'settings.voiceprint.forgottenDesc': 'Time to Talk will relearn your voice on the next live session.',
    'settings.theme': 'Theme',
    'settings.dark': 'Dark',
    'settings.light': 'Light',
    'settings.textSize': 'Text Size',
    'settings.textSizeSmall': 'A',
    'settings.textSizeMedium': 'A+',
    'settings.textSizeLarge': 'A++',
    'settings.reduceMotion': 'Reduce Motion',
    'settings.dyslexiaFont': 'Dyslexia Font',
    'settings.showImages': 'Show Images',
    'settings.rewardSounds': 'Reward Sounds',
    'settings.rainAnimation': 'Rain Animation',
    'settings.rainSounds': 'Rain Sounds',
    'settings.celebration': 'Celebration effects',
    'settings.partyModePhone': 'Celebration effects on phone',
    'settings.partyModeDesktop': 'Celebration effects on computer',
    'settings.forest': 'Forest',
    'settings.city': 'City',
    'settings.beach': 'Beach',
    // ...existing code...
    'settings.privacyPolicy': 'Privacy Policy',
    'settings.termsOfService': 'Terms of Service',
    'settings.helpSupport': 'Help & Support',
    'settings.replayTutorial': 'Replay Tutorial',
    'settings.replayTutorialDescription': 'See the app walkthrough again',
    'settings.resetPermissions': 'Reset Permissions',
    'settings.resetPermissionsDescription': 'Request microphone and device access again',
    'settings.resetToDefaults': 'Reset to Defaults',
    'settings.followUs': 'Follow us',
    'settings.version': 'Timo v1.0.0 • Made with ❤️',
    'settings.deleteAccount': 'Delete Account',
    'settings.deleteAccountConfirmTitle': 'Delete your account?',
    'settings.deleteAccountConfirmBody': 'This will permanently delete your account and all data. This cannot be undone.',
    'settings.deleteAccountConfirm': 'Yes, delete my account',
    'settings.deleteAccountCancel': 'Cancel',
    'settings.deleteAccountSuccess': 'Account deleted',
    'settings.deleteAccountError': 'Could not delete account. Please try again or contact support.',
    'settings.voiceTitle': 'Voice',
    'settings.voiceDescription': 'Choose a voice',
    'settings.voiceChildishFemale': 'Childish, Female',
    'settings.voiceAdultMale': 'More adult, Male',
    
    // Tutorial translations
    'tutorial.skip': 'Skip',
    'tutorial.next': 'Next',
    'tutorial.startApp': 'Start Using App',
    
    'tutorial.welcome.title': 'Welcome to Time To Talk! 🎉',
    'tutorial.welcome.subtitle': 'Let me show you around',
    'tutorial.welcome.description': "I'm Timo, your communication helper. This quick tour will show you everything I can do for you!",
    'tutorial.welcome.timoMessage': "Ready to learn? Let's go!",
    
    'tutorial.home.title': 'Your Home Base 🏠',
    'tutorial.home.subtitle': 'Everything starts here',
    'tutorial.home.description': 'The home screen shows your quick actions and the main button to start talking. You can access all features from here.',
    'tutorial.home.timoMessage': 'This is where you start!',
    
    'tutorial.chat.title': 'Chat with Me 💬',
    'tutorial.chat.subtitle': 'Your main helper',
    'tutorial.chat.description': "Tap the Timo button (that's me!) in the center of the menu to get help with conversations. Tell me what someone said, and I'll suggest what you could say back.",
    'tutorial.chat.timoMessage': "I'm always here to help!",
    'tutorial.chat.tip1': 'Type or use voice to tell me what happened',
    'tutorial.chat.tip2': "I'll suggest responses you can use",
    'tutorial.chat.tip3': 'Tap the speaker icon to hear suggestions read aloud',
    
    'tutorial.nonverbal.title': 'Speak Mode 🗣️',
    'tutorial.nonverbal.subtitle': 'When words are hard',
    'tutorial.nonverbal.description': "Sometimes speaking is difficult. Use Speak mode to tap symbols and build sentences that I'll speak for you.",
    'tutorial.nonverbal.timoMessage': 'No speaking needed here!',
    'tutorial.nonverbal.tip1': 'Tap symbols to build your message',
    'tutorial.nonverbal.tip2': 'Press the play button to speak it out loud',
    'tutorial.nonverbal.tip3': 'Great for when you need a break from talking',
    
    'tutorial.scripts.title': 'Your Scripts 📝',
    'tutorial.scripts.subtitle': 'Save favorite phrases',
    'tutorial.scripts.description': 'Found a response you love? Save it to Scripts! Your saved phrases are always ready when you need them.',
    'tutorial.scripts.timoMessage': 'Keep your favorites handy!',
    'tutorial.scripts.tip1': 'Tap + to add a new phrase',
    'tutorial.scripts.tip2': 'Organize by category',
    'tutorial.scripts.tip3': 'Tap to copy or speak any script',
    
    'tutorial.settings.title': 'Make It Yours ⚙️',
    'tutorial.settings.subtitle': 'Customize your experience',
    'tutorial.settings.description': 'Change your theme, text size, sounds, and more. Make the app comfortable for you!',
    'tutorial.settings.timoMessage': 'Set it up your way!',
    'tutorial.settings.tip1': 'Switch between light and dark mode',
    'tutorial.settings.tip2': 'Adjust text size for easier reading',
    'tutorial.settings.tip3': 'Turn sounds on or off',
    'tutorial.settings.tip4': 'Choose your favorite background',
    
    'tutorial.profile.title': 'Your Profile 📊',
    'tutorial.profile.subtitle': 'Track your conversations',
    'tutorial.profile.description': "Every conversation helps you grow! Check your profile to see your history and track your progress.",
    'tutorial.profile.timoMessage': "You're doing great!",
    'tutorial.profile.tip1': 'View your conversation history',
    'tutorial.profile.tip2': 'See your conversation history',
    'tutorial.profile.tip3': 'Track your progress over time',
    
    'tutorial.complete.title': "You're Ready! 🌟",
    'tutorial.complete.subtitle': "Let's start talking",
    'tutorial.complete.description': "That's everything! Remember, I'm here whenever you need help. There's no pressure - go at your own pace.",
    'tutorial.complete.timoMessage': "I believe in you! 💚",
    
    // Guided Tour translations
    'tour.skip': 'Skip',
    'tour.next': 'Next',
    'tour.back': 'Back',
    'tour.finish': 'Got it!',
    
    'tour.welcome.title': 'Hey there! 👋',
    'tour.welcome.message': "I'm Timo, your communication helper! Let me show you around the app real quick.",
    
    'tour.navbar.title': 'Navigation Bar',
    'tour.navbar.message': 'This is how you get around! All the main features are right here at the bottom.',
    
    'tour.timoButton.title': 'Chat with Me!',
    'tour.timoButton.message': "Tap me whenever you need help with conversations. I'll suggest what you could say!",
    
    'tour.homeTab.title': 'Home',
    'tour.homeTab.message': 'Your starting point. Quick access to everything and your daily progress.',
    
    'tour.nonverbalTab.title': 'Speak Mode',
    'tour.nonverbalTab.message': "When talking feels hard, tap here. You can build messages with symbols and I'll speak for you!",
    
    'tour.scriptsTab.title': 'Scripts',
    'tour.scriptsTab.message': 'Save your favorite phrases here. Quick access to responses you use often!',
    
    'tour.settingsTab.title': 'Settings',
    'tour.settingsTab.message': 'Make the app yours! Change colors, text size, sounds, and more.',
    
    'tour.profileTab.title': 'Profile',
    'tour.profileTab.message': 'See your progress here. Every conversation helps you grow!',
    
    'tour.complete.title': "You're all set! 🎉",
    'tour.complete.message': "That's the tour! Remember, just tap me anytime you need help. No pressure - go at your own pace!",
    
    'settings.resetToastTitle': '✅ Settings Reset',
    'settings.resetToastDescription': 'All accessibility settings have been restored to defaults.',
    'settings.metaDescription': 'Customize accessibility settings including dyslexia mode, text size, and background preferences.',
    'settings.rainBackgroundTitle': 'Animated Rain Background',
    'settings.rainBackgroundDescription': 'Show rain animation',
    'settings.disableRainBackground': 'Disable rain background',
    'settings.enableRainBackground': 'Enable rain background',
    'settings.rainSoundTitle': 'Looping Rain Sound',
    'settings.rainSoundDescription': 'Play background rain audio',
    'settings.disableRainSound': 'Disable rain sound',
    'settings.enableRainSound': 'Enable rain sound',
    'settings.volumeLabel': 'Volume',
    'settings.rainVolumeAria': 'Rain sound volume',
    'settings.imagesDescription': 'Toggle visual icons and images',
    'settings.openDyslexicTitle': 'OpenDyslexic font',
    'settings.openDyslexicDescription': 'Uses the OpenDyslexic font to make letters easier to distinguish.',
    'settings.openDyslexicAria': 'OpenDyslexic font',
    'settings.textSizeTitle': 'Text Size',
    'settings.mediumFont': 'Medium text size',
    'settings.largeFont': 'Large text size',
    'settings.xlargeFont': 'Extra large text size',
    'settings.ttsModelTitle': 'Voice Model',
    'settings.ttsModelDescription': 'Choose which AI voice model to use for speech',
    'settings.ttsModelBrowser': 'Robo',
    'settings.ttsModelElevenLabs': 'Natt',
    'settings.ttsModelOpenAI': 'Nova',
    'settings.ttsModelGemini': 'Puck',
    'settings.themeIconsTitle': 'Background Icons',
    'settings.themeIconsDescription': 'Show floating emoji icons that match your theme',
    'settings.showImagesIcons': 'Show Images & Icons',
    'settings.soundTitle': 'Sound',
    'settings.rewardSound': 'Reward Sound',
    'firstTimeGuide.title': 'How Time To Talk works',
    'firstTimeGuide.step1': 'Click "Your Situation".',
    'firstTimeGuide.step2': 'Type or use voice to tell what happened.',
    'firstTimeGuide.step3': 'The AI will suggest what you could say next',
    'firstTimeGuide.step4': 'After the conversation, rate how it felt.',
    'firstTimeGuide.step5': 'You can also practice with AI by clicking "Instructions".',
    'firstTimeGuide.reassurance': 'You are always in control. You can stop any time.',
    'firstTimeGuide.dontShowAgain': 'Don\'t show this guide again',
    'firstTimeGuide.startButton': 'Start using the app',
    'newFeature.title': 'New Feature!',
    'newFeature.subtitle': 'We\'ve added something new to help you communicate',
    'newFeature.feature1Title': 'Speak Mode',
    'newFeature.feature1Desc': 'Tap symbols to build sentences and speak them out loud',
    'newFeature.feature2Title': 'Simple & Calm',
    'newFeature.feature2Desc': 'Designed to be easy to use when words are hard',
    'newFeature.feedbackRequest': 'This is a new feature - we\'d love your feedback! Let us know if you find any bugs or have suggestions.',
    'newFeature.dontShowAgain': 'Don\'t show this again',
    'newFeature.messageButton': 'Message Us',
    'newFeature.tryButton': 'Try It Now',
    // Home page - New design
    'home.feature1Title': 'Real-time help',
    'home.feature1Desc': 'Get suggestions while you talk',
    'home.feature2Title': 'Voice support',
    'home.feature2Desc': 'Speak or type - your choice',
    'home.feature3Title': 'Listen back',
    'home.feature3Desc': 'Hear responses read aloud',
    'home.howItWorksTitle': 'How it works',
    'home.howItWorksDesc': "Tell us what they said, and we'll help you find the right words.",
    'home.step1': 'Listen',
    'home.step2': 'Think',
    'home.step3': 'Reply',
    'home.tryNow': 'Try it now',
    'home.reassurance': 'No judgment. No pressure. Just help when you need it.',
    'home.reassuranceSub': 'Timo is here for you, at your own pace.',
    // Home page - Legacy (kept for backward compatibility)
    'home.timoTitle': 'Meet Timo AI',
    'home.timoSubtitle': 'Your calm communication guide',
    'home.timoCard1Title': 'The Forest Mediator',
    'home.timoCard1Text': 'Diplomacy chose Timo. In his forest, all conflict ended with him setting things right.',
    'home.timoCard2Title': 'Forest Chaos',
    'home.timoCard2Text': 'Before Timo, all the animals had problems amongst themselves. Squirrels vs. crows (nuts went missing every day), ducks vs. literally everybody (they just… quacked aggressively). But once Timo moved in, he settled everybody’s problems like it was nothing.',
    'home.timoCard3Title': 'A Great Listener',
    'home.timoCard3Text': 'Not loud or bossy. Timo can really listen and help others understand each other.',
    'home.timoCard4Title': 'An Important Realization',
    'home.timoCard4Text': 'Conflicts don\'t come from bad intentions. They come from not knowing how to express yourself.',
    'home.timoCard5Title': 'A Clear Mission',
    'home.timoCard5Text': 'Communication isn\'t about who is smartest or loudest. It\'s about helping others understand you.',
    'home.timoCard6Title': 'Helping Humans',
    'home.timoCard6Text': 'When Timo heard that humans struggled with conversations aswell, he promptly left his forest to help.',
    'home.timoCard7Title': 'Your Guide',
    'home.timoCard7Text': 'Patient, observant, non-judgmental. Timo gives you the right words at the right moment.',
    'home.drawerOpen': 'Read more',
    'home.drawerClose': 'Read less',
    'unknown.startConversation': 'Start a conversation',
    'unknown.continueConversation': 'Continue conversation',
    'unknown.askForHelp': 'Ask for help',
    'unknown.sayNoPolitely': 'Say no politely',
    'unknown.endConversation': 'End conversation',
    'unknown.metaTitle': 'Your Situation',
    'unknown.metaDescription': 'Practice conversation with AI that infers context.',
    'unknown.backAria': 'Go back to "Your Situation"',
    'unknown.title': 'Your Situation',
    'unknown.subtitle': 'Type what you or the other person said. Timo AI will figure it out and help.',
    'unknown.subtitleShort': 'Type what the other person said, so Timo AI can help.',
    'unknown.helper': 'How can Timo AI help?',
    'unknown.youCouldSay': 'You also could say…',
    'unknown.firstMessage': 'Tell me what happened or what they said.',
    'unknown.inputPlaceholder': 'Ask Timo AI for help…',
    'unknown.inputAria': 'Ask Timo AI for help',
    'unknown.sendAria': 'Send message',
    'unknown.finishAria': 'Finish conversation',
    'unknown.finishButton': 'Finish',
    'unknown.finishedNotice': 'Conversation finished',
    'unknown.startNewConversation': 'Start New Conversation',
    'unknown.finishToastTitle': 'Conversation finished',
    'unknown.finishToastDescription': 'The conversation has ended. You can start a new one.',
    'unknown.errorTitle': 'Error',
    'unknown.errorDescription': 'Failed to send message. Please try again.',
    'unknown.contextPlace': 'Place',
    'unknown.contextRelationship': 'Relationship',
    'unknown.contextGoal': 'Goal',
    'unknown.emptyState': 'Start by typing what happened or what was said!',
    'unknown.playVoiceAria': 'Play voice',
    'unknown.finishedTitle': 'You finished this situation!',
    'unknown.motivationalMessage': 'Nice work for trying.',
    'unknown.howDidItFeel': 'How did it feel this time?',
    'unknown.itFeltGood': 'It felt good',
    'unknown.itWasHard': 'It was hard this time',
    'unknown.bothChoicesOkay': 'Both choices are okay - the important part is that you tried.',
    'unknown.goalSelectionTitle': 'What do you need help with?',
    'unknown.goalSelectionSubtitle': 'Choose the option that best fits your situation.',
    'unknown.goalHelpSpeaking': 'I need help speaking',
    'unknown.goalHelpAsking': 'I need help asking something',
    'unknown.goalLost': 'I don\'t know what to say',
    'unknown.goalSayNo': 'I want to say no politely',
    'unknown.goalSkip': 'This doesn\'t fit my situation',
    'unknown.goalBadgeHelpSpeaking': 'Goal: Help speaking',
    'unknown.goalBadgeHelpAsking': 'Goal: Help asking',
    'unknown.goalBadgeLost': 'Goal: I don\'t know what to say',
    'unknown.goalBadgeSayNo': 'Goal: Say no politely',
    'unknown.recordOtherSpeaker': 'Record what they said',
    'unknown.recording': 'Recording…',
    'unknown.otherPersonSaid': 'Other person said:',
    'unknown.speakerLabel': 'You could say:',
    'unknown.timoAILabel': 'Timo AI:',
    'unknown.otherPersonLabel': 'Other person:',
    'unknown.youLabel': 'You:',
    'voice.unsupportedAlert': 'Voice input not supported in this browser. Please type.',
    'voice.stopRecordingAria': 'Stop recording',
    'voice.startRecordingAria': 'Record voice',
    'voice.stopRecordingTooltip': 'Stop recording',
    'voice.startRecordingTooltip': 'Record',
    'voice.recordingIndicator': '● Rec',
    about: 'About',
    'about.pageTitle': 'About Us - Time To Talk',
    'about.metaDescription': 'Learn about the story and mission behind Time To Talk.',
    'about.intro1': 'Time To Talk was created from a simple, meaningful moment.',
    'about.intro2': "Our founder's brother, who has autism, once asked if he could take a picture of the moon - a small question that inspired a big idea: to help people who find everyday social situations confusing or stressful.",
    'about.founderImageAlt': 'The founder and his brother',
    'about.teamImageAlt': 'The Time To Talk team working together',
    'about.missionTitle': 'Our Mission',
    'about.missionText': 'To make communication easier to understand, practice, and experience. Time To Talk helps users learn what to say and do through gentle AI guidance, clear visuals, and calm design.',
    'about.goalTitle': 'Our Goal',
    'about.goalText': "To build confidence, one situation at a time. We're here for anyone who needs support - people with autism, social anxiety, or anyone who just finds social moments challenging.",
    'about.back': 'Back',
    'about.timo': 'Timo',
    'about.tagline': 'Your conversation companion',
    'about.missionIntro': 'We believe everyone deserves support in their daily conversations. Timo is built for people who sometimes find social interactions challenging - whether you\'re autistic, anxious, introverted, or just having a tough day.',
    'about.missionSub': 'Our goal is simple: give you confidence when you need it most, without judgment or pressure.',
    'about.features': 'What Timo Does',
    'about.feature.conversation': 'Conversation Help',
    'about.feature.conversationDesc': 'Get response suggestions when you\'re not sure what to say',
    'about.feature.voice': 'Voice Input',
    'about.feature.voiceDesc': 'Speak or type - whatever works best for you',
    'about.feature.scripts': 'Save Scripts',
    'about.feature.scriptsDesc': 'Keep your favorite responses for quick access',
    'about.feature.privacy': 'Private & Secure',
    'about.feature.privacyDesc': 'Your conversations stay on your device',
    'about.madeBy': 'Made By',
    'about.teamName': 'The Time to Talk team',
    'about.teamRole': 'Building tools for better communication',
    'about.privacyPolicy': 'Privacy Policy',
    'about.terms': 'Terms of Service',
    'about.contact': 'Contact Us',
    'about.version': 'Version 1.0.0',
    'about.madeWith': 'Made with ❤️ for better conversations',
    'header.disableRainBg': 'Turn off rain background',
    'header.enableRainBg': 'Turn on rain background',
    'header.disableRainSound': 'Turn off rain sound',
    'header.enableRainSound': 'Turn on rain sound',
    'situations.metaDescription': 'Choose a real-life situation to practice communication with AI guidance.',
    'situations.helperText': 'Pick the situation to practice or speak with Timo AI help',
    'situations.customTitle': 'Your Situation',
    'situations.customSubtitle': 'Click to start and Timo AI will help',
    'situations.recommended': 'Recommended',
    'situations.deleteConfirmTitle': 'Are you sure?',
    'situations.deleteConfirmDescription': 'This cannot be undone.',
    'situations.history': 'History',
    'situations.historySubtitle': 'View your past conversations',
    'situations.chooseWhereTitle': 'Where are you?',
    'situations.chooseWhereSubtitle': 'Pick one or start a free chat',
    'situations.freeChat': 'Free Chat',
    'situations.liveModeBeta': 'Live Mode - Beta',
    'situations.backToHome': 'Back to home',
    'situations.accessCodeTitle': 'Access Code Required',
    'situations.accessCodeHint': 'Enter the access code to use Live Mode:',
    'situations.enterCodePlaceholder': 'Enter code...',
    'situations.codeIncorrect': 'Incorrect code. Please try again.',
    'situations.accessLiveModeButton': 'Access Live Mode',
    // Chat (Unknown / practice chat)
    'chat.pageTitle': 'Chat with Timo',
    'chat.metaDescription': 'Talk to Timo - Get help with what to say',
    'chat.backAria': 'Go back',
    'chat.subtitle': 'Your AI helper',
    'chat.end': 'End',
    'chat.helpDefault': 'Help',
    'chat.greeting': 'Hey! What do you need help saying?',
    'chat.suggestionsTitle': 'What should I say?',
    'chat.suggestionsHint': 'Tap one option - it will read it and send it',
    'chat.suggestionsUpdating': 'Updating...',
    'chat.noSuggestions': 'No suggestions available',
    'chat.thinking': 'Thinking...',
    'chat.gettingSuggestions': 'Getting suggestions for you',
    'chat.quickRepliesLabel': 'Quick replies:',
    'chat.speaking': 'Speaking:',
    'chat.speakerMe': 'Me',
    'chat.speakerOther': 'Other',
    'chat.placeholder': 'Type a message...',
    'chat.sendAria': 'Send message',
    'chat.getHelpAria': 'Get help',
    'chat.playTtsAria': 'Play text-to-speech',
    'chat.ariaHearTimo': "Hear Timo's message",
    'chat.ariaHearIt': 'Hear it',
    'chat.ariaSaveScript': 'Save to scripts',
    'chat.recordMicMe': 'Hold to record your voice',
    'chat.recordMicOther': 'Hold to record what they said',
    'chat.recordingMe': 'Recording your voice...',
    'chat.recordingOther': 'Recording what they said...',
    'chat.ttsWait': 'Wait {seconds}s... ({left} plays left)',
    'chat.youCan': 'You can say:',
    'chat.timoSuggests': 'Timo suggests...',
    'chat.safetyTitle': 'Safety Alert',
    'chat.safetyBody': 'This conversation may be unsafe. If you feel threatened, leave immediately.',
    'chat.fallbackAi': 'Hey! What do you need help saying?',
    'chat.fallbackCoaching': 'Message sent successfully! 👍 Need anything else?',
    'chat.needMoreHelp': 'Need help with anything else?',
    'chat.praise1': 'Nice!',
    'chat.praise2': 'Great!',
    'chat.praise3': 'Well done!',
    'chat.toast.errorTitle': 'Error',
    'chat.toast.errorDesc': 'Failed to get response. Please try again.',
    'chat.toast.ttsLimitTitle': 'TTS limit reached',
    'chat.toast.ttsLimitDesc': 'Maximum 5 plays per session to save resources.',
    'chat.toast.savedTitle': 'Saved!',
    'chat.toast.savedDesc': 'Added to your Scripts.',
    'chat.toast.duplicateTitle': 'Already saved',
    'chat.toast.duplicateDesc': 'You already have this phrase.',
    'chat.toast.voiceTestTitle': 'Voice test',
    'chat.toast.voiceTestDesc': 'Playing sample audio...',
    'chat.toast.voiceFailTitle': 'Voice test failed',
    'chat.toast.voiceFailDesc': 'Check console for details.',
    'chat.toast.connectionTitle': 'Connection issue',
    'chat.toast.connectionDesc': 'Could not get full response, but your message was great!',
    'chat.testVoice.lt': 'Sveiki, aš esu Timo, jūsų dirbtinis intelektas.',
    'chat.testVoice.en': "Hi, I'm Timo, your AI helper.",
    'chat.testVoice.ru': 'Привет! Я Тимо, твой помощник на базе искусственного интеллекта.',
    'chat.qr.hey1': 'Hey!',
    'chat.qr.hey2': 'Hi there',
    'chat.qr.hey3': "What's up?",
    'chat.qr.yes1': 'Yes',
    'chat.qr.yes2': 'No',
    'chat.qr.yes3': 'Maybe',
    'chat.qr.how1': 'Good!',
    'chat.qr.how2': 'Not bad',
    'chat.qr.how3': "I'm okay",
    'chat.qr.inv1': 'Sure!',
    'chat.qr.inv2': 'Maybe later',
    'chat.qr.inv3': "Can't sorry",
    'chat.qr.help1': 'Sure',
    'chat.qr.help2': "What's up?",
    'chat.qr.help3': 'How can I help?',
    'chat.qr.thanks1': 'No problem!',
    'chat.qr.thanks2': 'Anytime',
    'chat.qr.thanks3': "You're welcome",
    'chat.qr.comp1': 'Thanks!',
    'chat.qr.comp2': 'Appreciate it',
    'chat.qr.comp3': '😊',
    'chat.qr.sorry1': 'No worries',
    'chat.qr.sorry2': "It's okay",
    'chat.qr.sorry3': 'All good',
    'chat.qr.info1': 'Really?',
    'chat.qr.info2': 'Tell me',
    'chat.qr.info3': 'What?',
    'chat.qr.plan1': 'Sounds good',
    'chat.qr.plan2': 'What time?',
    'chat.qr.plan3': 'Maybe',
    'chat.qr.conf1': 'Yep',
    'chat.qr.conf2': 'Exactly',
    'chat.qr.conf3': 'For sure',
    'chat.qr.wq1': 'Not sure',
    'chat.qr.wq2': 'Let me think',
    'chat.qr.wq3': "I'll check",
    'chat.qr.genq1': 'Yeah',
    'chat.qr.genq2': 'Nah',
    'chat.qr.genq3': 'Maybe',
    'chat.qr.stat1': 'Cool',
    'chat.qr.stat2': 'Nice',
    'chat.qr.stat3': 'Oh really?',
    'chat.qr.def1': 'Okay',
    'chat.qr.def2': 'Got it',
    'chat.qr.def3': 'Cool',
    'history.title': 'Conversation History',
    'history.empty': 'No conversations yet. Start chatting to see your history here!',
    'history.loading': 'Loading conversations...',
    'history.error': 'Failed to load conversations. Please try again.',
    'history.deleteConfirm': 'Delete this conversation?',
    'history.deleteError': 'Failed to delete conversation. Please try again.',
    'history.resume': 'Resume',
    'history.view': 'View',
    'history.delete': 'Delete',
    'history.noTitle': 'Untitled Conversation',
    'history.lastUpdated': 'Last updated',
    'history.deleteAll': 'Delete All',
    'history.deleteAllConfirm': 'Delete all?',
    'history.deleteAllConfirmDesc': 'All conversations will be removed.',
    'history.deleteAllSuccess': 'Success',
    'history.deleteAllSuccessDesc': 'All conversations deleted',
    'history.justNow': 'Just now',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'customSetup.intentStart': 'Start a conversation',
    'customSetup.intentContinue': 'Continue conversation',
    'customSetup.intentFinish': 'Finish conversation',
    'customSetup.metaTitle': 'Custom Situation - Setup',
    'customSetup.metaDescription': 'Set up a custom conversation practice scenario.',
    'customSetup.title': 'Custom Situation',
    'customSetup.subtitle': 'Choose where you are and what you want to do.',
    'customSetup.situationLabel': 'Situation',
    'customSetup.placeholder': 'e.g., Party, School, Store, Bus, Hospital',
    'customSetup.examplesHint': 'Or click an example below:',
    'customSetup.examples.party': 'Party',
    'customSetup.examples.school': 'School',
    'customSetup.examples.store': 'Store',
    'customSetup.examples.bus': 'Bus',
    'customSetup.examples.hospital': 'Hospital',
    'customSetup.intentQuestion': 'What do you want to do?',
    'customSetup.startButton': 'Start',
    'customChat.metaTitle': 'Custom Situation Chat',
    'customChat.genericSituation': 'situation',
    'customChat.metaDescriptionPrefix': 'Practice conversation:',
    'customChat.backAria': 'Go back to setup',
    'customChat.inputPlaceholder': 'Type your message...',
    'customChat.inputAria': 'Type your message',
    'customChat.finishToastTitle': 'Conversation finished',
    'customChat.finishToastDescription': 'The conversation has ended. You can start a new one.',
    'customChat.errorTitle': 'Error',
    'customChat.errorDescription': 'Failed to send message. Please try again.',
    'customChat.finishFallbackShort': 'Goodbye!',
    'customChat.finishFallbackLong': 'I need to go now, thanks!',
    'customChat.finishedNotice': 'Conversation finished',
    // Non-verbal Mode
    'nonVerbalMode': 'Speak',
    'nonVerbalSelectPrompt': 'Tap symbols to build your sentence',
    'nonVerbalAIGrammar': 'AI grammar fix',
    'nv.speakModalTitle': 'I am saying:',
    'nv.speaking': 'Speaking...',
    'nv.speak': 'Speak',
    'nv.speakAgain': 'Speak again',
    'nv.speakLoading': 'Building sentence...',
    'nv.imageAlt': 'Image',
    'nv.sentenceBarAria': 'Sentence bar',
    'nv.tapSymbol': 'Tap a symbol...',
    'nv.clearAll': 'Clear all',
    'nv.deleteLast': 'Delete last',
    'nv.speakSentence': 'Speak sentence',
    'nv.kalbeti': 'Speak',
    'nv.clear': '✕ Clear',
    'nv.backAria': 'Back',
    'nv.scriptsAria': 'Scripts',
    'nv.historyAria': 'History',
    'nv.searchPlaceholder': 'Search symbol...',
    'nv.noResults': 'Nothing matched that word',
    'nv.ttsFailed': 'No sound came through. Tap to try again.',
    'nv.searchAria': 'Search symbol',
    'nv.loading': 'Loading...',
    'nv.noPhotos': 'No photos yet',
    'nv.addPhotosHint': 'Add your own photos for communication',
    'nv.addPhoto': 'Add Photo',
    'nv.add': 'Add',
    'nv.showLess': 'Show less',
    'nv.moreCount': 'More ({count})',
    'nv.comingSoon': 'Coming soon!',
    'nv.historyTitle': 'History',
    'nv.historyEmpty': 'No sentences yet. Tap emojis and speak to build history.',
    'nv.useAgain': 'Use again',
    'nv.addToScripts': 'Add to scripts',
    'nv.savedToScripts': 'Saved to scripts!',
    'nv.clearHistory': 'Clear history',
    'nv.customAddPhoto': 'Add Photo',
    'nv.customPreview': 'Preview',
    'nv.customAddLabel': 'Add Label',
    'nv.customTakePhoto': 'Take Photo',
    'nv.customUseCamera': 'Use camera',
    'nv.customFromGallery': 'Choose from Gallery',
    'nv.customFromDevice': 'From computer or phone',
    'nv.customWordOnly': 'Just a word',
    'nv.customWordOnlyHint': 'No picture needed',
    'nv.customChange': 'Change',
    'nv.customContinue': 'Continue',
    'nv.customHintLabels': 'Add text that will be shown and spoken',
    'nv.customNameEn': 'Name (English)',
    'nv.customPlaceholderName': 'e.g., "Mom", "John"',
    'nv.customNameLt': 'Name in Lithuanian',
    'nv.customNameRu': 'Name in Russian',
    'nv.customOptional': 'optional',
    'nv.customCategory': 'Category',
    'nv.customBack': 'Back',
    'nv.customSave': 'Save',
    'nv.customSaving': 'Saving...',
    'nv.customErrImage': 'Please select an image file',
    'nv.customErrSize': 'File too large (max 10MB)',
    'nv.customErrLabel': 'Please enter a label',
    'nv.customErrSave': 'Error saving',
    'nv.manageTitle': 'My Photos',
    'nv.deleteConfirm': 'Delete "{name}"?',
    'nv.cancel': 'Cancel',
    'nv.delete': 'Delete',
    'speak': 'Speak',
    'speaking': 'Speaking...',
    'clear': 'Clear',
    'back': 'Back',
    'skip': 'Skip',
    'continue': 'Continue',
    // Onboarding
    'onboarding.welcomeTitle': "Hi, I'm Timo",
    'onboarding.welcomeSubtitle': 'Your calm companion for everyday conversations',
    'onboarding.welcomeDesc': "I'm here to help when talking feels tricky. Let's set things up in a minute.",
    'onboarding.getStarted': "Let's get started",
    'onboarding.languageTitle': 'Choose your language',
    'onboarding.languageDesc': 'You can change this later in settings',
    'onboarding.accessibilityTitle': 'Make it comfortable',
    'onboarding.accessibilityDesc': 'Adjust these to suit your needs',
    'onboarding.reducedMotion': 'Reduced motion',
    'onboarding.reducedMotionDesc': 'Simpler animations for less distraction',
    'onboarding.sounds': 'Sound effects',
    'onboarding.soundsDesc': 'Gentle chimes for feedback',
    'onboarding.showImages': 'Show images',
    'onboarding.showImagesDesc': 'Display illustrations and icons',
    'onboarding.howItWorksTitle': 'How it works',
    'onboarding.howItWorksDesc': 'Three simple steps to help you communicate',
    'onboarding.step1Title': 'They speak',
    'onboarding.step1Desc': 'Tell us what the other person said',
    'onboarding.step2Title': 'We help',
    'onboarding.step2Desc': 'Timo suggests what you could say',
    'onboarding.step3Title': 'You reply',
    'onboarding.step3Desc': 'Pick a suggestion or say your own',
    'onboarding.readyTitle': "You're all set!",
    'onboarding.readyDesc': 'Timo is ready to help whenever you need.',
    'onboarding.readyTip': 'Tip: You can always access settings later to adjust preferences.',
    'onboarding.startUsing': 'Start using Time To Talk',
    
    // Push to Talk (State Machine UI)
    'pushToTalk.title': 'Help Me Respond',
    'pushToTalk.ready': 'Ready when you are',
    'pushToTalk.helpMeRespond': 'Help me respond',
    'pushToTalk.tapToStart': 'Tap to record what they said',
    'pushToTalk.recording': 'Recording what they said...',
    'pushToTalk.done': 'Done',
    'pushToTalk.cancel': 'Cancel',
    'pushToTalk.understanding': 'Understanding...',
    'pushToTalk.theySaid': 'They said:',
    'pushToTalk.soundsLike': 'This sounds like',
    'pushToTalk.yesHelpMe': 'Yes, help me respond',
    'pushToTalk.notQuite': 'Not quite, try again',
    'pushToTalk.startOver': 'Start over',
    'pushToTalk.findingResponses': 'Finding good responses...',
    'pushToTalk.pickResponse': 'Pick a response:',
    'pushToTalk.youllSay': "You'll say:",
    'pushToTalk.illSayIt': "I'll say it",
    'pushToTalk.speakForMe': 'Speak for me',
    'pushToTalk.chooseAnother': 'Choose another',
    'pushToTalk.differentOptions': 'Different options',
    'pushToTalk.speaking': 'Speaking...',
    'pushToTalk.stop': 'Stop',
    'pushToTalk.responseReady': 'Response ready!',
    'pushToTalk.needMoreHelp': 'Need more help',
    'pushToTalk.imDone': "I'm done",
    'pushToTalk.autoReset': 'Will return home automatically',
    'pushToTalk.stillThere': 'Still there?',
    'pushToTalk.takeYourTime': 'Take your time, no rush.',
    'pushToTalk.continue': 'Continue',
    'pushToTalk.didntCatch': "I didn't catch that",
    'pushToTalk.tryAgainOrType': 'Try again or type instead',
    'pushToTalk.tryAgain': 'Try again',
    'pushToTalk.typeInstead': 'Type instead',
    'pushToTalk.whatDidTheySay': 'What did they say?',
    'pushToTalk.typeHere': 'Type what they said...',
    'pushToTalk.somethingWrong': 'Something went wrong',
    'pushToTalk.pleaseTryAgain': 'Please try again',
    'pushToTalk.panic': 'Stop and go back',
    
    // Live Mode
    'live.title': 'Live Mode',
    'live.back': 'Back',
    'live.endSession': 'End',
    'live.error': 'Error',
    'live.dismiss': 'Dismiss',
    'live.status.ready': 'Ready',
    'live.status.connecting': 'Connecting...',
    'live.status.listening': 'Listening...',
    'live.tapToStart': 'Start',
    'live.tapToStop': 'Stop',
    'live.connecting': 'Connecting...',
    'live.stats.totalMessages': 'Total',
    'live.stats.you': 'You',
    'live.stats.otherPerson': 'Other',
    'live.conversation': 'Conversation',
    'live.emptyState.listening': 'Listening...',
    'live.emptyState.startRecording': 'Start',
    'live.getAiHelp': 'Timo Help',
    'live.askAi': 'Ask Timo',
    'live.theyreSpeaking': "They're Speaking",
    'live.emptyState.instruction': 'Click the microphone button to begin the conversation',
    'live.betaWarning.title': 'Live Mode - Beta',
    'live.betaWarning.description': 'This feature is under development. Feel free to test!',
    'live.betaWarning.note': 'Works best in English',
    'live.betaWarning.close': 'Got it',
    
    // Rate Limit
    'rateLimit.title': "You've reached today's limit",
    'rateLimit.message': 'You have reached your daily limit. Please try again tomorrow.',
    'rateLimit.ok': 'OK',
    'rateLimit.close': 'Close',
    
    // New Landing Page
    // Landing copy lives in src/copy/landing.en.js so it can be edited on its own.
    ...landingEn,
    'login.title': 'Log in',
    'login.startSubtitle': 'Log in with Google or email.',
    'login.fbBrowserWarning': "Google sign-in doesn't work in Facebook's browser. Use email below, or open this page in Safari / Chrome.",
    'login.googleBtn': 'Continue with Google',
    'login.facebookBtn': 'Continue with Facebook',
    'login.appleBtn': 'Continue with Apple',
    'login.openInBrowser': 'For Google, Facebook or Apple sign-in, tap the menu and choose "Open in browser". Or just use email below.',
    'login.emailBtn': 'Continue with Email',
    'login.signUpPrompt': "Don't have an account yet?",
    'login.signUpLink': 'Sign up below',
    'login.registerBtn': "Already have an account?",
    'login.signInLink': 'Sign in',
    'login.signinTitle': 'Sign In',
    'login.signupTitle': 'Register',
    'login.signinSubtitle': 'Sign in with your email',
    'login.signupSubtitle': 'Create your account',
    'login.emailLabel': 'Email Address',
    'login.passwordLabel': 'Password',
    'login.passwordSignupPlaceholder': 'Password (min. 6 chars)',
    'login.submitSignin': 'Sign In',
    'login.submitSignup': 'Register',
    'login.processing': 'Processing...',
    'login.noAccount': "Don't have an account? Register",
    'login.haveAccount': 'Already have an account? Sign In',
    'login.successSignin': 'Sign in successful!',
    'login.successSignup': 'Check your email for confirmation!',
    'login.failed': 'Sign in failed. Please try again.',
    'login.unknownError': 'Unknown error. Please try again.',
    'login.registrationFailed': 'Registration failed:',
    'login.confirmationEmail': 'Check your email - we sent a confirmation link.',
    'login.linkExpired': 'Your login link expired. Please request a new one.',
    'login.resendMagicLink': 'Email me a new login link',
    'login.magicLinkSent': 'Check your email for a new login link.',
    'login.loginSuccessful': 'Sign in successful!',
    'login.devAccessNotAvailable': 'Dev access not available',
    'login.invalidCode': 'Invalid code',
    'login.accessPlaceholder': 'access',
    'login.forgotPassword': 'Forgot password?',
    'login.resetTitle': 'Reset Password',
    'login.resetSubtitle': 'We\'ll send you a reset link.',
    'login.submitReset': 'Send Reset Link',
    'login.resetSent': 'Check your email for a reset link.',
    'login.resetRateLimited': 'Email already sent - wait a few minutes before trying again.',
    'login.resetWaitBtn': 'Wait {n}s',
    'login.newPasswordTitle': 'Set New Password',
    'login.newPasswordSubtitle': 'Enter your new password below.',
    'login.newPasswordLabel': 'New Password (min. 6 chars)',
    'login.submitNewPassword': 'Set Password',
    'login.passwordUpdated': 'Password updated! Signing you in...',
    'login.backToSignin': 'Back to sign in',
    'login.fbEmailFallback': 'Or sign in with email',
    'login.fbLinkCopied': 'Link copied - paste it in Chrome or Safari',

    'home.urgencyBanner': 'Your subscription is not active - unlock all features',
    'home.urgencyBannerCta': 'See plans',
    'subscription.choosePlanCta': 'Choose a plan',
    'home.sessionsCompleted': '{n} sessions completed',

    // Landing Page - Localization keys

    // Landing v2 - direct-pay funnel

    // Keiki-layout landing (/landing-keiki). English only for now: t() falls back
    // to en, so the other locales read these until they are translated.
    // Article rail: the categories are index-aligned with the ARTICLES arrays,
    // which list the same five pieces in the same order in every locale.
    // Long-form block. Carries the search terms parents actually type, and the
    // plain description of the product that the card sections cannot fit.

    
    // Pricing Card
    'pricingCard.howManyMonths': 'How many months?',
    'pricingCard.fullAccess': 'Full access to all features',
    'pricingCard.offline': 'Works offline',
    'pricingCard.newFeatures': 'New features monthly',
    'pricingCard.cancelAnytime': 'Cancel anytime',
    'pricingCard.tryBeforePay': 'Try before you pay',
    'pricingCard.lockInPrice': 'Lock in the price',
    
    // Footer
    'footer.privacy': 'Privacy Policy',
    'footer.articles': 'Articles',
    'footer.terms': 'Terms',
    'footer.contact': 'Contact',
    'footer.copyright': '© 2026 Time To Talk',
    'common.appName': 'Time To Talk',
    
    // Pricing Page
    'pricing.yourChildDeserves': 'Your child deserves to be heard.',
    'pricing.feature1': 'Tap a picture. Timo speaks for them.',
    'pricing.feature2': 'Practice talking safely, at their own pace.',
    'pricing.feature3': 'Help in real conversations. In real time.',
    'pricing.letsGo': "Let's Go",
    'pricing.cancelBeforeDay7': 'Cancel before day 7. You pay nothing.',
    'pricing.reminderTitle': "We'll remind you before it ends.",
    'pricing.today': 'Today',
    'pricing.day5': 'Day 5',
    'pricing.day5Desc': 'We send you a reminder email.',
    'pricing.day7': 'Day 7',
    'pricing.soundsGood': 'Sounds good',
    'pricing.controlIt': 'You control it. Cancel anytime.',
    'pricing.choosePlan': 'Choose your plan.',
    'pricing.fullAccessBadge': 'FULL ACCESS',
    'pricing.perMonthLabel': 'per month',
    'pricing.fullAccessFromToday': 'All 3 modes, unlocked today',
    'pricing.billedMonthlyCancelAnytime': 'Billed monthly. Cancel anytime.',
    'pricing.getAccessCta': 'Get access',
    'pricing.chargedTodayNote': 'You are charged today. Cancel anytime in Profile then Subscription.',
    'pricing.fullAccessSub': 'Full access to all 3 modes. Cancel anytime.',
    'pricing.cancelAnytimeNote': 'Cancel anytime in Profile then Subscription.',
    'pricing.oldPrice': '€11.49/mo',
    'pricing.foundingRate': 'Founding rate',
    'pricing.oneMonth': '1 Month',
    'pricing.threeMonths': '3 Months',
    'pricing.sixMonths': '6 Months',
    'pricing.monthlyPer': '/mo',
    'pricing.monthlyWeek': '€1.50/week',
    'pricing.quarterlyPrice': '€5.83',
    'pricing.quarterlyPer': '/mo',
    'pricing.quarterlyWeek': '€1.35/week',
    'pricing.popularBadge': 'MOST POPULAR',
    'pricing.saveQuarterly': 'Save €16',
    'pricing.biannualPrice': '€5.00',
    'pricing.biannualPer': '/mo',
    'pricing.biannualWeek': '€1.15/week',
    'pricing.bestValueBadge': 'BEST VALUE',
    'pricing.saveBiannual': 'Save €39',
    'pricing.switchesTo': 'Switches to 6 Months plan',
    'pricing.families': '🌍 130+ families already using Time To Talk',
    'pricing.monthlyLabel': 'Monthly',
    'pricing.buyNowCta': 'Get full access',
    'pricing.cancelBeforeDay30': 'Cancel anytime in Profile then Subscription.',
    'pricing.dueTodayLabel': 'Due today',
    'pricing.thenPerDayBilled': 'billed monthly, cancel anytime',
    'pricing.reassureTitle': 'You pay nothing today',
    'pricing.reassureTodayLabel': 'Today',
    'pricing.reassureAfterDesc': 'Cancel in one tap. No email, no phone call.',
    'pricing.reassureCheap': "That's less than a coffee a month",
    'pricing.reassureCta': 'See my plan',
    'pricing.secureCheckoutStripe': 'Secure checkout via Stripe.',
    'pricing.offerPercentBadge': '{percent}% off',
    'pricing.breakoutReminderCta': 'Show me how',
    'pricing.founderName': 'Gintaras, founder',
    'pricing.founderHeadline': 'Want a personal offer?',
    'pricing.founderBody': "Quick 10-min call: learn more, get help, and maybe share ideas I'll turn into new features for you.",
    'pricing.teacherHeadline': 'Set up Time to Talk for your students.',
    'pricing.teacherSub': 'Full access to all 3 modes for your classroom. Cancel anytime.',
    'pricing.teacherFeature1': 'Use it with every student you support',
    'pricing.teacherFeature2': 'Lithuanian and English, voice built in',
    'pricing.teacherFeature3': 'A free setup call to tailor it to your class',
    'pricing.teacherFounderHeadline': 'Let me set it up with you',
    'pricing.teacherFounderBody': "Quick 15-min call: I'll help you set up Time to Talk for your students and answer anything you need.",
    'pricing.founderCtaPrimary': 'Book a call with Gintaras',
    'pricing.founderSkip': 'Continue without call',
    'pricing.day27': 'Any time',
    'pricing.day27Desc': 'Cancel in one tap from Profile, then Subscription.',
    'pricing.noActiveSubscription': 'No active subscription found. If you just paid, please wait a few minutes.',
    'pricing.errorCheckingSubscription': 'Error checking subscription. Please try again.',
    'pricing.checking': 'Checking...',
    'pricing.restorePurchase': 'Restore Purchase',
    'pricing.backToOnboarding': 'Back to onboarding',
    'pricing.somethingWentWrong': 'Something went wrong. Please try again.',
    'pricing.promoErrorAlreadyAccount': "Promo code {code} was already used on your account. Subscribe below to keep going, the subscription is one tap away.",
    'pricing.promoErrorAlreadyNetwork': "Promo code {code} has already been used from your network. Subscribe below, the subscription is one tap away.",
    'pricing.promoErrorGeneric': "We couldn't apply promo code {code}. Subscribe below or try again later.",
    'pricing.promoErrorDismiss': 'Got it',
    'pricing.terms': 'Terms',
    'pricing.privacy': 'Privacy',
    'success.badge': "You're Premium",
    'success.title': "You're all set.",
    'success.sub': 'Timo is ready to help your child find their voice.',
    'success.cta': "Let's go",
    'success.unlock1': 'Full access unlocked, nothing held back',
    'success.unlock2': 'Chat, Live and Speak ready to explore',
    'success.unlock3': 'In sync on every phone and tablet',
    'success.footer': 'All Premium features are active on your account.',
    'download.appInstalled': 'App installed',
    'download.continuingOnboarding': 'Continuing to onboarding...',
    'download.installApp': 'Install app',
    'download.bestExperience': 'Best experience is in the installed app.',
    'download.apple': 'Apple',
    'download.iphoneIpad': 'iPhone / iPad',
    'download.android': 'Android',
    'download.chromeInstall': 'Chrome install',
    'download.appleInstall': 'Apple install',
    'download.homeScreenQuality': 'Best quality experience is from Home Screen.',
    'download.openSafari1': '1. Open this page in Safari.',
    'download.openSafari2': '2. In Safari tap Share.',
    'download.openSafari3': '3. Tap Add to Home Screen then Add.',
    'download.copyLinkSafari': 'Copy Link for Safari',
    'download.linkCopiedSafari': 'Link copied. Open Safari and paste the link.',
    'download.copyFailed': 'Copy failed. Please copy the URL manually and open in Safari.',
    'download.tapShare1': 'Tap Share (square + arrow).',
    'download.tapShare2': 'Tap Add to Home Screen.',
    'download.tapShare3': 'Tap Add.',
    'download.openShareMenu': 'Open Share Menu',
    'download.inAppBrowserHint': 'If you are in Instagram/Facebook browser, open menu and tap Open in Safari.',
    'download.androidInstall': 'Android install',
    'download.androidStep1': 'Open the Chrome menu (⋮ in the top right corner)',
    'download.androidStep2': 'Tap "Add to Home screen" or "Install app"',
    'download.androidStep3': 'Tap "Install" to confirm',
    'download.otherDeviceTitle': 'Want the app on another device?',
    'download.otherDeviceBody': 'Open a browser on that device, go to timohelps.com and log in with the same details.',
    'download.otherDeviceHelp': 'Any problems? Message us at',
    'download.promptAutoOpen': 'Install prompt should open automatically.',
    'download.promptAutoOpenAndroid': 'On Android (Chrome), the install dialog may open automatically.',
    'download.androidInstallOnlyNote':
      'One-tap install is for Android (Chrome). iPhone and iPad use Add to Home Screen - see below.',
    'download.iosInstallTitle': 'iPhone & iPad',
    'download.iosInstallHint':
      'In Safari, tap Share, then Add to Home Screen. If you don’t see it, tap More in the share sheet first, then Add to Home Screen, then Add.',
    'download.downloadApp': 'Download App',
    'download.promptNotOpen': 'Install prompt did not open. Open browser menu and tap "Install app" or "Add to Home screen".',
    'download.desktopHint': 'For best results, open this on iPhone/iPad/Android and install the app.',
    'download.backToLanding': 'Back to website',
    'download.continueWeb': 'Continue on web',
    'download.webUseEverything': 'You can still use everything on web.',
    'download.windowsTitle': 'Windows & Desktop',
    'download.windowsHint': 'Click the install icon in your browser address bar (Chrome or Edge recommended).',
    'download.iosVideoSoon': 'Video guide coming soon',
    'download.continueSetup': 'Continue to setup',
    'download.installedSuccess': 'App installed successfully',

    // Landing Page - Pricing Card strings
    'landingPricing.oldPriceCurrency': '€11.49/mo',
    'landingPricing.oneMonth': '1 Month',
    'landingPricing.threeMonths': '3 Months',
    'landingPricing.sixMonths': '6 Months',
    'landingPricing.perMonth': '/mo',
    'landingPricing.week1': '€1.50/week',
    'landingPricing.week3': '€1.35/week',
    'landingPricing.week6': '€1.15/week',
    'landingPricing.badgePopular': 'MOST POPULAR',
    'landingPricing.badgeBest': 'BEST VALUE',
    'landingPricing.save16': 'Save €16',
    'landingPricing.save39': 'Save €39',

    'cookie.title': 'Cookies',
    'cookie.body': 'We use cookies for analytics (PostHog) and ad measurement (Meta). We never sell your data, and the app works fully if you decline.',
    'cookie.accept': 'Accept',
    'cookie.decline': 'Decline',
    'cookie.learnMore': 'Privacy Policy',

    // Referral page
    'referral.pageTitle': 'Invite friends, earn free months',
    'referral.pageSubtitle': 'Share Time To Talk. When a friend pays for their first month, you get one free.',
    'referral.heroEarnedLabel': "You've earned",
    'referral.heroMonths': '{n} months',
    'referral.heroOneMonth': '1 month',
    'referral.heroNoMonths': '0 months',
    'referral.heroFromConversions': 'from {n} referrals',
    'referral.heroFromOneConversion': 'from 1 referral',
    'referral.heroFromZero': 'no referrals yet',
    'referral.heroCapUsed': '{used} of {total} yearly cap used',
    'referral.heroFirstTime': 'Share your link and earn your first free month.',
    'referral.codeLabel': 'Your code',
    'referral.linkLabel': 'Your link',
    'referral.copy': 'Copy link',
    'referral.copied': 'Copied!',
    'referral.share': 'Share',
    'referral.shareNative': 'Share',
    'referral.shareWhatsapp': 'WhatsApp',
    'referral.shareMessenger': 'Messenger',
    'referral.shareEmail': 'Email',
    'referral.shareSms': 'SMS',
    'referral.shareMessage': 'I use Timo Helps to help my child practise talking out loud. Take a look: {link}',
    'referral.shareEmailSubject': 'Try Time To Talk with me',
    'referral.howTitle': 'How it works',
    'referral.howStep1': 'Send your link to a friend.',
    'referral.howStep2': 'They subscribe using your link.',
    'referral.howStep3': 'When they pay for their first month, you get 1 month free, automatically.',
    'referral.rules': 'One reward per friend. Up to 12 free months per year. Self-referrals and shared accounts will not be rewarded.',
    'referral.errorLoad': "Couldn't load your referral info. Please refresh.",
    'referral.capReached': "You have hit this year's cap of 12 free months. Thank you for sharing.",
    'referral.bannerInvited': 'Invited by a friend. Welcome to Timo Helps.',
    'referral.bannerInvitedShort': 'Invited by a friend.',
    'referral.announceTitle': 'New: Get 1 month free',
    'referral.announceBody': 'Invite a friend to Time To Talk. When they pay for their first month, you get one free.',
    'referral.announceCta': 'See how it works',
    'referral.announceLater': 'Maybe later',
    'referral.youGetLabel': 'You get',
    'referral.youGetReward': '1 month free',
    'referral.friendGetsLabel': 'Friend gets',
    'referral.friendGetsReward': 'Full access from day one',
    'referral.linkOnlyNote': 'Only this exact link credits your account. Sharing the code alone will not work.',


    // --- Native iOS port (WS-2 auth, WS-3 purchases, WS-4 speech, WS-5 media,
    //     WS-6 install, WS-7 AI consent and content reporting). Merged from
    //     src/native/_i18n/*.strings.json. Additive: no existing key was changed.
    'native.auth.browserUnavailable': 'The sign in window could not be opened. Please try again.',
    'native.auth.oauthCancelled': 'Sign in was cancelled.',
    'native.auth.oauthFailed': 'Sign in did not finish. Please try again.',
    'native.auth.passwordResetOpensBrowser': 'Password reset opens a secure page in your browser. Change your password there, then come back and sign in with the new one.',
    'native.auth.sessionFailed': 'We could not finish signing you in. Please try again.',
    'native.consent.agree': 'I agree',
    'native.consent.contact': 'Questions? Write to us:',
    'native.consent.declinedAgree': 'I have changed my mind, I agree',
    'native.consent.declinedBody': 'Without this, Timo cannot listen or reply. You can still use the pictures, the saved scripts and all the settings. Whenever you are ready, turn it on in Settings, under Privacy.',
    'native.consent.declinedContinue': 'Continue without Timo talking',
    'native.consent.declinedTitle': 'Timo will stay quiet for now',
    'native.consent.forLabel': 'For:',
    'native.consent.getsLabel': 'Gets:',
    'native.consent.intro': 'Timo uses a few outside companies to turn speech into text, to write his replies, and to say them out loud. That means some of what you say and type is sent to them. Here is exactly who they are and what each one gets.',
    'native.consent.notNow': 'Not now',
    'native.consent.privacyLink': 'Read our privacy policy',
    'native.consent.proc.anthropic.purpose': 'Writing Timo\'s replies',
    'native.consent.proc.anthropic.receives': 'Your conversation with Timo, as text',
    'native.consent.proc.deepgram.purpose': 'Turning speech into text',
    'native.consent.proc.deepgram.receives': 'Your voice while the microphone is on',
    'native.consent.proc.elevenlabs.purpose': 'Turning that text into Timo\'s voice',
    'native.consent.proc.elevenlabs.receives': 'The text Timo is about to say',
    'native.consent.proc.google.purpose': 'Writing Timo\'s replies when Google is the active provider',
    'native.consent.proc.google.receives': 'Your conversation with Timo, as text',
    'native.consent.proc.openai.purpose': 'Checking Lithuanian grammar',
    'native.consent.proc.openai.receives': 'Timo\'s Lithuanian replies, as text',
    'native.consent.promise': 'We do not sell your data and we do not use it for advertising. You can turn this off at any time in Settings. If you turn it off, Timo cannot listen or reply, and everything else in the app keeps working.',
    'native.consent.settings.agreedOn': 'You agreed on',
    'native.consent.settings.confirmBody': 'Timo will stop listening and replying. Everything else in the app keeps working, and you can turn it back on at any time.',
    'native.consent.settings.confirmKeep': 'Keep it on',
    'native.consent.settings.confirmTitle': 'Turn this off?',
    'native.consent.settings.confirmTurnOff': 'Turn it off',
    'native.consent.settings.description': 'Lets Timo send speech and conversation text to the companies listed below, so he can listen, reply and speak.',
    'native.consent.settings.label': 'Share with AI services',
    'native.consent.settings.offNote': 'Timo cannot listen or reply while this is off.',
    'native.consent.settings.section': 'Privacy',
    'native.consent.settings.whoGetsWhat': 'See who gets what',
    'native.consent.title': 'Before Timo starts talking',
    'native.install.alreadyInstalledBody': 'You are using the Timo app on this device, so there is nothing to install.',
    'native.install.alreadyInstalledTitle': 'You already have the app',
    'native.install.otherDevices': 'Want Timo on another device? Sign in there with the same account and everything is waiting for you.',
    'native.manage.appleBilled': 'Apple handles this subscription. You can cancel it or change your plan in your App Store subscription settings.',
    'native.manage.cta': 'Manage in the App Store',
    'native.manage.failed': 'We could not open your App Store subscriptions. Open Settings, tap your name, then Subscriptions.',
    'native.mic.backgroundStopped': 'Listening stopped because the app went to the background. Tap to start again.',
    'native.mic.continueWithoutMic': 'Continue without the microphone',
    'native.mic.deniedBody': 'iPhone only asks once. Open Settings and turn the microphone on for Timo.',
    'native.mic.deniedTitle': 'Microphone is turned off',
    'native.mic.openSettings': 'Open Settings',
    'native.mic.primerAllow': 'Allow microphone',
    'native.mic.primerBody': 'So Timo can hear what the other person said and help you answer.',
    'native.mic.primerNotNow': 'Not now',
    'native.mic.primerPoint1': 'Your voice is used only to turn speech into text.',
    'native.mic.primerPoint2': 'Recording happens only while a turn is open, never in the background.',
    'native.mic.primerPoint3': 'You can turn the microphone off again in Settings.',
    'native.mic.primerTitle': 'Timo needs your microphone',
    'native.mic.unavailableBody': 'This device has no microphone Timo can use.',
    'native.mic.unavailableTitle': 'No microphone found',
    'native.minors.affirmation': 'By tapping I agree you confirm that you are a parent, guardian or carer, or that you are 16 or older.',
    'native.minors.ageNote': 'In most of Europe a parent or guardian has to agree for anyone under 16. In Lithuania that age is 14, and in the United States it is 13.',
    'native.minors.askGrownUp': 'Please ask a parent, guardian or carer to look at this with you and tap I agree for you.',
    'native.minors.underAgeLink': 'I am under 16',
    'native.personalVoice.allow': 'Allow Personal Voice',
    'native.personalVoice.denied': 'Timo does not have permission to use your Personal Voice. Turn on Allow Apps to Request to Use in Settings, Accessibility, Personal Voice.',
    'native.personalVoice.description': 'If you have recorded a Personal Voice on this iPhone or iPad, Timo can speak with it. The voice is made on the device, stays on the device, and is never sent anywhere.',
    'native.personalVoice.languageUnavailable': 'Apple offers Personal Voice in English, Spanish and Chinese only, so it cannot speak this language yet.',
    'native.personalVoice.none': 'No Personal Voice has been recorded on this device yet. You can make one in Settings, Accessibility, Personal Voice.',
    'native.personalVoice.ready': 'Personal Voice is ready. Choose it in the list of voices.',
    'native.personalVoice.speaking': 'Speaking with your Personal Voice',
    'native.personalVoice.title': 'Use a Personal Voice',
    'native.personalVoice.unsupportedDevice': 'This device cannot make a Personal Voice. A newer iPhone or iPad is needed.',
    'native.purchase.alreadyOwned': 'You already have this plan. Tap Restore purchase to get your access back.',
    'native.purchase.failed': 'We could not complete the purchase. Please try again, or write to us and we will sort it out.',
    'native.purchase.network': 'No connection to the App Store. Check your internet and try again.',
    'native.purchase.notAllowed': 'This device is not allowed to make purchases. Check the Screen Time restrictions in Settings.',
    'native.purchase.pending': 'Your purchase is waiting for approval. As soon as it is approved, your access opens automatically.',
    'native.purchase.signInFirst': 'Please sign in first, so your subscription is linked to your account.',
    'native.purchase.unavailable': 'The App Store is not available right now. Please try again in a few minutes.',
    'native.report.body': 'Thank you for telling us. Timo\'s replies are written by a computer, so he sometimes gets things wrong. Tell us what happened and a person will read it.',
    'native.report.cancel': 'Cancel',
    'native.report.done': 'Done',
    'native.report.error': 'The report could not be sent. Check your connection and try again.',
    'native.report.noteLabel': 'Anything you want to add (optional)',
    'native.report.reason.language': 'It was in the wrong language',
    'native.report.reason.other': 'Something else',
    'native.report.reason.unkind': 'It was rude or unkind',
    'native.report.reason.unsafe': 'It was not safe for a child',
    'native.report.reason.wrong': 'It was wrong or confusing',
    'native.report.safetyNote': 'If someone is in danger right now, contact your local emergency services.',
    'native.report.send': 'Send report',
    'native.report.sending': 'Sending...',
    'native.report.sentBody': 'A person reads every report. If you would like a reply, write to us:',
    'native.report.sentTitle': 'Report sent. Thank you.',
    'native.report.stopConversation': 'Also end this conversation',
    'native.report.title': 'Report this response',
    'native.report.trigger': 'Report this response',
    'native.restore.restored': 'Your access is back. Welcome back!',
    'native.speech.interrupted': 'Listening stopped because of a call or another sound. Tap to start again.',
    'native.speech.languageNotSupported': 'This iPhone cannot recognise this language on its own, so Timo listens the way he always has.',
    'native.speech.onDevice': 'Your voice stays on this device',
    'native.speech.permissionNeeded': 'Timo needs the microphone and speech recognition to hear you. You can turn them on in Settings.',
    'native.voice.preview': 'Hear this voice',
    'native.voice.systemVoices': 'Voices on this device',
    'native.voice.title': 'Timo\'s voice',
    'pushToTalk.micBackgroundTitle': 'Listening stopped',
    'pushToTalk.micBlockedBody': 'The microphone is blocked, so nothing was recorded. Allow the microphone, or type what they said.',
    'pushToTalk.micBlockedTitle': 'Timo cannot hear',
    'pushToTalk.micNotNowBody': 'You can turn the microphone on any time. For now, type what they said.',
    'pushToTalk.micNotNowTitle': 'Microphone is off',
    'pushToTalk.micProblemBody': 'Listening stopped unexpectedly, so nothing was recorded. Try again, or type what they said.',
    'pushToTalk.micProblemTitle': 'Listening stopped',
    'pushToTalk.micUnavailableBody': 'This device has no microphone Timo can use. You can type what they said instead.',
    'pushToTalk.micUnavailableTitle': 'No microphone found',
    'pushToTalk.micUnsupportedBody': 'Speech recognition is not available here, so nothing was recorded. You can type what they said instead.',
    'pushToTalk.micUnsupportedTitle': 'This browser cannot listen',
    'settings.microphone.checkDesc': 'See whether Timo can hear you, and fix it if not',
    'settings.microphone.checkLabel': 'Check microphone access',
    'settings.microphone.denied': 'Microphone is blocked. Open Settings to allow it.',
    'settings.microphone.granted': 'Microphone is working',
    'settings.microphone.title': 'Microphone',
    'settings.microphone.unavailable': 'No microphone found on this device',

    // --- merged from src/native/_i18n: WS-C, WS-F, PRIVACY ---
    // WS-C
    'chat.ariaGoBack': 'Go back',
    'chat.ariaInputMode': 'Input mode',
    'chat.ariaInputModeSpeak': 'Speak',
    'chat.ariaInputModeType': 'Type',
    'chat.ariaPlayAloud': 'Play aloud',
    'chat.ariaSendMessage': 'Send message',
    'chat.ariaRecordMe': 'Record my voice',
    'chat.ariaRecordOther': 'Record the other person',
    'live.ariaFlipSpeakers': 'Swap the speakers',
    'live.ariaClearConversation': 'Clear the conversation',
    'live.ariaCalibrationSettings': 'Calibration settings',
    'live.ariaClose': 'Close',
    'live.whatShouldISay': 'What should I say?',
    'live.manageScriptsHint': 'You can manage your saved scripts in the Scripts section.',
    'live.safetyTitle': 'Safety alert',
    'live.safetyBody': 'This conversation may not be safe. If you feel threatened, leave right away.',
    'quickChoice.send': 'Send',
    'quickChoice.tellMeMorePlaceholder': 'Tell me more...',
    // WS-F
    'common.closeAria': 'Close',
    'common.goBackAria': 'Go back',
    // PRIVACY
    'privacy.minors.heading': '5. Children, Minors, and Parental Consent',
    'privacy.minors.s1.heading': '5.1 Who this app is for, and who holds the account',
    'privacy.minors.s1.p1': 'Time To Talk (the Timo app) is built for children with a speech delay, for autistic children and adults, and for anyone who finds talking hard. Many of our users are children.',
    'privacy.minors.s1.p2': 'The account belongs to an adult: a parent, guardian, carer, therapist or teacher. That adult creates the account, holds the login and pays for the subscription. A child does not sign up on their own.',
    'privacy.minors.s1.p3': 'The child does use the app, though. When they do, the app receives what they type and, while the microphone is on, what they say. We would rather write that plainly than claim we never hear from a child.',
    'privacy.minors.s2.heading': '5.2 The age at which a parent or guardian has to agree',
    'privacy.minors.s2.intro': 'If the person using the app is below the age shown for your country, a parent, guardian or carer must agree before the app is used.',
    'privacy.minors.s2.col.where': 'Where you are',
    'privacy.minors.s2.col.age': 'A parent or guardian must agree for anyone under',
    'privacy.minors.s2.col.rule': 'The rule behind it',
    'privacy.minors.s2.lt.where': 'Lithuania',
    'privacy.minors.s2.lt.age': '14',
    'privacy.minors.s2.lt.rule': 'GDPR Article 8, at the age set in Lithuanian law',
    'privacy.minors.s2.us.where': 'United States',
    'privacy.minors.s2.us.age': '13',
    'privacy.minors.s2.us.rule': 'COPPA, the Children\'s Online Privacy Protection Act',
    'privacy.minors.s2.eu.where': 'Rest of the EU and EEA',
    'privacy.minors.s2.eu.age': '16, unless your country has set a lower age, which can never be below 13',
    'privacy.minors.s2.eu.rule': 'GDPR Article 8',
    'privacy.minors.s2.world.where': 'Everywhere else',
    'privacy.minors.s2.world.age': '16',
    'privacy.minors.s2.world.rule': 'Our own baseline, which we apply worldwide',
    'privacy.minors.s2.p1': 'Lithuania is our home country and our main market. The age there is 14.',
    'privacy.minors.s2.p2': 'Before any conversation is sent to the companies listed in 5.4, the app shows a screen that names every one of them and asks you to agree. The sentence above the "I agree" button asks you to confirm that you are a parent, guardian or carer, or that you are 16 or older. If a child taps "I am under 16", nothing bad happens and nobody is told off: the app simply asks them to fetch a grown up. You can withdraw that agreement later in Settings, under Privacy.',
    'privacy.minors.s2.p3': 'We never ask for a date of birth. Asking would mean collecting more information about a child, which is the opposite of what this section is for.',
    'privacy.minors.s3.heading': '5.3 What we collect when a child uses the app',
    'privacy.minors.s3.intro': 'Three things:',
    'privacy.minors.s3.email': 'An email address, once, at sign up. It is the adult account holder\'s address. We never ask a child for an email address of their own.',
    'privacy.minors.s3.text': 'Conversation text. What is typed or said to Timo, and what Timo replies. Practice conversations are saved to the account so they can be reopened later in History. Each one can be deleted there.',
    'privacy.minors.s3.voice': 'Voice, only while the microphone is on. The audio goes from the device straight to Deepgram, which turns it into text. We do not store voice recordings on our servers. The microphone stays off until you switch it on.',
    'privacy.minors.s3.p2': 'We do not ask a child for a real name, a home address, a phone number, a school, a photo, an age or a diagnosis. Nothing in the app requires any of them. If any of that is typed into a conversation it is saved with that conversation, and you can delete it in History.',
    'privacy.minors.s4.heading': '5.4 The companies that receive this data',
    'privacy.minors.s4.intro': 'Timo cannot listen, answer or speak without help from outside companies. These five see conversation content. This is the same list the app shows you before you agree.',
    'privacy.minors.s4.col.company': 'Company',
    'privacy.minors.s4.col.receives': 'What it receives',
    'privacy.minors.s4.col.purpose': 'What it is for',
    'privacy.minors.s4.anthropic.receives': 'Your conversation with Timo, as text',
    'privacy.minors.s4.anthropic.purpose': 'Writing Timo\'s replies',
    'privacy.minors.s4.google.receives': 'Your conversation with Timo, as text',
    'privacy.minors.s4.google.purpose': 'Writing Timo\'s replies when Google is the active provider',
    'privacy.minors.s4.openai.receives': 'Timo\'s Lithuanian replies, as text',
    'privacy.minors.s4.openai.purpose': 'Checking Lithuanian grammar',
    'privacy.minors.s4.deepgram.receives': 'Your voice while the microphone is on',
    'privacy.minors.s4.deepgram.purpose': 'Turning speech into text',
    'privacy.minors.s4.elevenlabs.receives': 'The text Timo is about to say',
    'privacy.minors.s4.elevenlabs.purpose': 'Turning that text into Timo\'s voice',
    'privacy.minors.s4.note': 'Google receives conversation text only when Google is the active model provider. OpenAI is used only for Lithuanian, to correct the grammar of a reply Timo has already written. Deepgram is also used as a backup voice in a few languages, and when that happens it receives the text Timo is about to say.',
    'privacy.minors.s4.others': 'The other companies we work with, listed in Section 7, handle the account, payment, email and analytics side of the Service rather than the conversation itself.',
    'privacy.minors.s4.noPermission': 'None of these companies is permitted to use a child\'s data for their own advertising, or to train their own models beyond what their published policies state.',
    'privacy.minors.s5.heading': '5.5 What we never do with a child\'s data',
    'privacy.minors.s5.item1': 'We never sell it. Not to anyone, in any form, at any price.',
    'privacy.minors.s5.item2': 'We never use it for advertising, and we never build advertising profiles of children.',
    'privacy.minors.s5.item3': 'We never use it to train AI models, ours or anyone else\'s.',
    'privacy.minors.s5.item4': 'We never use it to build behavioural, psychological, clinical or educational profiles of a child.',
    'privacy.minors.s5.item5': 'We never publish it, and we never show it to other users.',
    'privacy.minors.s5.pixel': 'Our public website and app pages carry the Meta advertising measurement tag described in Section 12. It counts page views and sign-ups so we can tell which adverts work. It never receives conversation content, voice, or anything a child types.',
    'privacy.minors.s6.heading': '5.6 What a parent or guardian can ask for',
    'privacy.minors.s6.intro': 'At any time, you can:',
    'privacy.minors.s6.see': 'See it. Ask for a copy of everything we hold about the account.',
    'privacy.minors.s6.correct': 'Correct it. Ask us to fix anything that is wrong.',
    'privacy.minors.s6.delete': 'Delete it. Delete conversations one at a time in History, or delete the whole account.',
    'privacy.minors.s6.withdraw': 'Take your agreement back. Withdraw the AI consent in Settings, under Privacy. Timo then stops listening and replying. The pictures, the saved scripts and every setting keep working. Withdrawing does not undo processing that already happened lawfully.',
    'privacy.minors.s6.deleteHeading': 'Deleting the account. Settings has a Delete account button. When you use it:',
    'privacy.minors.s6.step1': 'We first cancel every open subscription you have with Stripe, so that you cannot be billed again.',
    'privacy.minors.s6.step2': 'If any of those cancellations fails, we stop and your account is not deleted. You will see an error asking you to contact us, and we will finish it by hand. Leaving you logged in is better than leaving you paying for an account you can no longer reach.',
    'privacy.minors.s6.step3': 'If cancellation succeeds, we delete your login and account record from our authentication system: the email address, the password, and the settings and consent records stored with it.',
    'privacy.minors.s6.step4': 'We mark your subscription record as cancelled and keep a small deletion record, which is the email address, the date, and the reference of the cancelled subscription. It exists so we can show when the account was deleted and that billing stopped.',
    'privacy.minors.s6.step5': 'Payment and invoice records stay with Stripe for as long as Lithuanian accounting law requires, which is ten years. See Section 9. We cannot delete those sooner.',
    'privacy.minors.s6.after': 'If there is anything else you want removed that the button does not reach, email us and we will do it by hand.',
    'privacy.minors.s7.heading': '5.7 How to reach us about a child\'s data',
    'privacy.minors.s7.p1': 'Email info@timetotalk.lt. Put "Child data request" in the subject line and tell us the email address of the account.',
    'privacy.minors.s7.p2': 'We answer every request. We will acknowledge yours within 5 working days and complete it within 30 days, which is the deadline GDPR sets. If a request is complicated and we need longer, we will tell you before the 30 days are up and explain why. We may first have to check that you are the account holder, because giving a child\'s data to the wrong person would be a far worse failure than a slow reply.',
    'privacy.minors.s7.p3': 'You can also complain to the State Data Protection Inspectorate of Lithuania (Valstybine duomenu apsaugos inspekcija) at vdai.lrv.lt or ada@ada.lt, or to the data protection authority in your own EEA country.',
    'privacy.minors.s8.heading': '5.8 How long we keep a child\'s data',
    'privacy.minors.s8.intro': 'Section 9 gives the retention period for every category of data. The short version:',
    'privacy.minors.s8.voice': 'Voice: we do not store it at all.',
    'privacy.minors.s8.conversations': 'Conversations: kept in the account until you delete them in History or delete the account.',
    'privacy.minors.s8.account': 'Account data, including the email address: as set out in Section 9.',
    'privacy.minors.s8.p2': 'If you believe a child has signed up without a parent or guardian knowing, contact info@timetotalk.lt. We will delete the account and its data promptly once we have verified the request.',
  },
  ru: {
    // daily-words
    "dailyWords.row": "Изучаемые слова",
    "dailyWords.rowHint": "Слова, которые ребёнок учит каждый день",
    "dailyWords.title": "Изучаемые слова",
    "dailyWords.intro": "Впишите слова, которые ребёнок сейчас учит. Тимо каждый день покажет одно и попросит его сказать.",
    "dailyWords.close": "Закрыть",
    "dailyWords.modeTitle": "Какие слова показывать",
    "dailyWords.modeMine": "Только мои слова",
    "dailyWords.modeMineHint": "Каждый день одно ваше слово, по порядку списка.",
    "dailyWords.modeMix": "Мои слова и слова Тимо",
    "dailyWords.modeMixHint": "Один день ваше слово, на следующий день слово Тимо.",
    "dailyWords.today": "Слово дня: {word}",
    "dailyWords.todayBadge": "Сегодня",
    "dailyWords.add": "Добавить слово",
    "dailyWords.inputLabel": "Слово",
    "dailyWords.placeholder": "Например, яблоко",
    "dailyWords.pictureTitle": "Картинка (необязательно)",
    "dailyWords.noPicture": "Без картинки",
    "dailyWords.photo": "Фото",
    "dailyWords.removePhoto": "Убрать фото",
    "dailyWords.listTitle": "Ваши слова",
    "dailyWords.empty": "Слов пока нет. Пока список пуст, Тимо показывает свои слова.",
    "dailyWords.edit": "Изменить",
    "dailyWords.save": "Сохранить",
    "dailyWords.cancel": "Отмена",
    "dailyWords.delete": "Удалить",
    "dailyWords.deleteConfirm": "Удалить «{word}»?",
    "dailyWords.listen": "Послушать",
    "dailyWords.moveUp": "Выше",
    "dailyWords.moveDown": "Ниже",
    "dailyWords.saved": "Сохранено",
    "dailyWords.deviceOnly": "Слова хранятся только на этом устройстве. На другом телефоне или планшете их не будет.",
    "dailyWords.errEmpty": "Сначала впишите слово.",
    "dailyWords.errDuplicate": "Это слово уже есть в списке.",
    "dailyWords.errFull": "В списке уже {max} слов. Удалите одно, чтобы добавить новое.",
    "dailyWords.errSave": "Не удалось сохранить. Возможно, память устройства заполнена. Попробуйте без фото.",
    "dailyWords.errImage": "Не удалось открыть это фото. Выберите другое.",
    // end daily-words
    'house.room.living': 'Гостиная',
    'house.room.talk': 'Комната с телефоном',
    'house.room.play': 'Игровая',
    'house.room.study': 'Уголок для занятий',
    'house.hotspot.couch': 'Попрыгать на диване',
    'house.hotspot.window': 'Посмотреть в окно',
    'house.hotspot.timo': 'Поиграть с Тимо',
    'house.hotspot.pet': 'Поиграть с Тимо',
    'house.hotspot.phone': 'Поговорить по телефону',
    'house.hotspot.shelf': 'Открыть карточки с картинками',
    'house.hotspot.toybox': 'Открыть коробку с игрушками',
    'house.hotspot.desk': 'Слово дня',
    'house.parent.settings': 'Взрослым',
    'house.parent.button': 'Взрослым',
    'house.nav.rooms': 'Комнаты',
    'house.nav.prev': 'Предыдущая комната',
    'house.nav.next': 'Следующая комната',
    'house.badge.stars': 'Заработанные звёзды',
    'house.hotspot.beanbag': 'Пуфик',
    'house.hotspot.bookshelf': 'Книжная полка',
    'house.hotspot.curtain': 'Штора',
    'house.hotspot.easel': 'Мольберт',
    'house.hotspot.lamp': 'Лампа',
    'house.hotspot.lights': 'Гирлянда',
    'house.hotspot.pinboard': 'Доска',
    'house.hotspot.plant': 'Растение',
    'house.hotspot.playwindow': 'Окно',
    'house.hotspot.rainbowrug': 'Радужный коврик',
    'house.hotspot.rug': 'Коврик',
    'house.hotspot.stool': 'Табурет',
    'house.map.title': 'Карта дома',
    'house.map.close': 'Закрыть карту',
    'house.map.here': 'Вы здесь',
    'house.map.go': 'Идти',
    'house.map.activity.talk': 'Говорить',
    'house.map.activity.cards': 'Карточки',
    'house.map.activity.word': 'Слово',
    'house.a11y.roomOf': 'Комната {n} из {total}',
    'timo.word.newWordSoon': 'Новое слово завтра!',
    'timo.talk.waiting': 'Тимо думает...',
    'timo.talk.youSaid': 'Ты сказал:',
    'timo.talk.voiceResting': 'Большой голос Тимо отдыхает, поэтому этот звучит как робот.',
    'timo.teach.remember': 'Запомни',
    'timo.teach.hearIt': 'Послушай',
    'timo.teach.gotIt': 'Понятно!',
    'timo.reward.earned': 'Ты заработал {amount} звёзд!',
    'timo.words.title': 'Мои слова',
    'timo.words.wordSingular': 'слово',
    'timo.words.wordPlural': 'слов',
    'timo.words.tapHint': 'Нажми на слово, чтобы услышать его',
    'timo.words.lockedHint': 'Скажи это слово с Тимо, чтобы открыть его',
    'timo.words.empty': 'Пока нет слов',
    'timo.words.emptySub': 'Скажи слово дня вместе с Тимо, чтобы начать коллекцию!',
    'timo.words.close': 'Закрыть',
    'timo.words.locked': 'Ещё нет',
    'timo.recap.title': 'Сегодня с Тимо',
    'timo.recap.wordsLead': 'Слова, которые ваш ребёнок сказал сегодня',
    'timo.recap.noWords': 'Сегодня было много весёлого общения',
    'timo.recap.turnsLabel': 'маленьких разговоров',
    'timo.recap.streakLabel': 'дней подряд',
    'timo.recap.minutesLabel': 'мин вместе',
    'timo.recap.tipLead': 'Совет',
    'timo.recap.tip1': 'Попробуйте сказать одно из этих слов вместе за ужином сегодня.',
    'timo.recap.tip2': 'Каждый маленький разговор важен. Несколько минут в день быстро складываются.',
    'timo.recap.tip3': 'Попросите ребёнка научить вас тому, что сказал Тимо сегодня.',
    'timo.recap.tip4': 'Хвалите за старание, а не только за правильный ответ.',
    'timo.recap.dismiss': 'Закрыть',
    'timo.recap.historyTitle': 'На этой неделе с Тимо',
    'timo.recap.historyEmpty': 'Пока нет разговоров. Нажми на Тимо, чтобы начать!',
    'timo.talk.greetingNamed': 'Привет, {name}! Я так рад тебя видеть!',
    'timo.talk.greetingWord': 'Привет! Слово дня - {word}. Скажешь его?',
    'timo.talk.greetingWordNamed': 'Привет, {name}! Слово дня - {word}. Скажешь его?',
    'timo.onboarding.intro': 'Привет! Я Тимо. Я твой друг.',
    'timo.onboarding.askName': 'Как тебя зовут?',
    'timo.onboarding.heard': 'Я услышал {name}?',
    'timo.onboarding.confirmYes': 'Да!',
    'timo.onboarding.confirmNo': 'Ещё раз',
    'timo.onboarding.retry': 'Ой! Скажи своё имя ещё раз.',
    'timo.onboarding.typeInstead': 'Написать имя',
    'timo.onboarding.namePlaceholder': 'Твоё имя',
    'timo.onboarding.save': 'Сохранить',
    'timo.onboarding.skip': 'Пропустить',
    'timo.onboarding.welcome': 'Приятно познакомиться, {name}!',
    'timo.onboarding.micDenied': 'Я тебя не слышу. Ты можешь написать своё имя.',
    // Timo tells a story: UI chrome only. The story prose itself lives in
    // src/copy/story.en.js under the story.* keys, not here.
    'timo.story.tapToStart': 'Начать сказку',
    'timo.story.listening': 'Твоя очередь',
    'timo.story.narrating': 'Тимо рассказывает сказку',
    'timo.story.close': 'Готово',
    'timo.story.replay': 'Ещё раз',
    'timo.story.finished': 'Конец',
    'timo.story.next': 'Дальше',
    'parent.title': 'Прогресс',
    'parent.backAria': 'На главную',
    'parent.noKidName': 'Ваш ребёнок',
    'parent.subtitle': 'Прогресс в развитии речи',
    'parent.tierLabel': 'Уровень',
    'parent.statStreak': 'Дней подряд',
    'parent.statWords': 'Выучено слов',
    'parent.statStars': 'Получено звёзд',
    'parent.statDaysActive': 'Активных дней',
    'parent.statDaysActiveHint': 'За последние 30 дней',
    'parent.statLongest': 'Самая длинная серия',
    'parent.statWordsWeek': 'Новых слов за неделю',
    'parent.calendarTitle': 'Календарь занятий',
    'parent.calendarPrevAria': 'Предыдущий месяц',
    'parent.calendarNextAria': 'Следующий месяц',
    'parent.calendarLegendPracticed': 'Занимались',
    'parent.calendarLegendToday': 'Сегодня',
    'parent.calendarDayPracticed': 'занимались',
    'parent.calendarEmptyMonth': 'В этом месяце занятий пока не было.',
    'parent.timelineTitle': 'Выученные слова',
    'parent.timelineToday': 'Сегодня',
    'parent.timelineYesterday': 'Вчера',
    // Русское склонение числительных не даёт одной точной формы:
    // родительный падеж ("дней") подходит для большинства чисел (5-20, 11-14...), но не для 2-4 или 21.
    'parent.timelineDaysAgo': '{n} дней назад',
    'parent.timelineEmptyTitle': 'Здесь начинается путь',
    'parent.timelineEmptyBody': 'Каждое слово, которое ваш ребёнок выучит с Тимо, появится здесь. Даже одно слово в день быстро складывается в результат.',
    // Как и выше: форма «слов» подходит для большинства чисел, но не для 2-4 или 21.
    'parent.timelineWordCount': '{n} слов',
    'parent.timelineWordCountOne': '1 слово',
    'parent.printLabel': 'Печать',
    'parent.printAria': 'Распечатать эту страницу',
    'parent.footerNote': 'Прогресс сохраняется на этом устройстве и синхронизируется с вашим аккаунтом.',
    'timo.recap.today': 'Сегодня',
    'timo.recap.yesterday': 'Вчера',
    "iab.title": "Откройте в браузере",
    "iab.body": "Вход не работает внутри {source}.",
    "iab.openChrome": "Открыть в Chrome",
    "iab.openSafari": "Открыть в Safari",
    "iab.openBrowser": "Открыть в браузере",
    "iab.copyLink": "Скопировать ссылку",
    "iab.copied": "Скопировано",
    "iab.hintIos": "Или меню ⋯ → Открыть в Safari",
    "iab.hintAndroid": "Или меню ⋮ → Открыть в браузере",
    "iab.hintOther": "Или вставьте ссылку в браузер",
    "iab.iosCopyAndOpen": "Скопировать ссылку",
    "iab.iosLinkCopied": "Ссылка скопирована. Откройте Safari.",
    "iab.iosStep1": "Нажмите кнопку, чтобы скопировать ссылку.",
    "iab.iosStep2": "Откройте Safari (свайп вверх или индикатор Home).",
    "iab.iosStep3": "Вставьте ссылку в адресную строку.",
    "iab.continueAnyway": "Остаться здесь",
    "obp.successTitle": "Всё готово!",
    "obp.successBody": "Теперь вы в браузере. Здесь всё работает идеально, включая вход.",
    "obp.successCta": "Продолжить",
    "streak.popupTitle": "ЕЖЕДНЕВНАЯ СЕРИЯ ЧАТОВ УВЕЛИЧЕНА!",
    "streak.popupDayStreak": "ДНЕВНАЯ СЕРИЯ",
    "streak.popupGreatStart": "ОТЛИЧНОЕ НАЧАЛО!",
    "streak.popupOnFire": "ВЫ В ОГНЕ! 🔥",
    "profile.viewStreakDetails": "Посмотреть детали серии",
    "newsletter.heroTitle": "Time To Talk",
    "newsletter.heroSubtitle": "Ваш ИИ-компаньон для уверенных разговоров",
    "newsletter.description": "Подпишитесь на нашу рассылку, чтобы первыми узнавать о запуске нашего приложения. Получите ранний доступ, эксклюзивные обновления и полезные советы по общению.",
    "newsletter.emailPlaceholder": "Введите ваш адрес электронной почты",
    "newsletter.subscribe": "Подписаться",
    "newsletter.subscribing": "Подписка...",
    "newsletter.success": "Спасибо за подписку!",
    "newsletter.successMessage": "Проверьте свою электронную почту для подтверждения подписки.",
    "newsletter.error": "Что-то пошло не так. Пожалуйста, попробуйте еще раз.",
    "newsletter.emailInvalid": "Пожалуйста, введите действительный адрес электронной почты",
    "newsletter.emailRequired": "Электронная почта обязательна",
    "newsletter.features.title": "Что ожидать",
    "newsletter.features.earlyAccess": "Ранний доступ",
    "newsletter.features.earlyAccessDesc": "Будьте среди первых, кто попробует наше приложение",
    "newsletter.features.updates": "Эксклюзивные обновления",
    "newsletter.features.updatesDesc": "Получайте последние новости и функции",
    "newsletter.features.tips": "Советы по общению",
    "newsletter.features.tipsDesc": "Полезные руководства и стратегии",
    "newsletter.requestAccess": "Запросить доступ",
    "newsletter.requestAccessTitle": "Запросить доступ к сайту",
    "newsletter.requestAccessSuccess": "Запрос отправлен! Мы рассмотрим его и свяжемся с вами.",
    "newsletter.name": "Имя",
    "newsletter.namePlaceholder": "Ваше имя (необязательно)",
    "newsletter.reason": "Причина",
    "newsletter.reasonPlaceholder": "Почему вам нужен доступ? (необязательно)",
    "newsletter.submitRequest": "Отправить запрос",
    "newsletter.submitting": "Отправка...",
    "newsletter.beTheFirst": "Будьте первыми",
    "newsletter.beTheFirstDesc": "Получите ранний доступ и советы по общению, доставленные на вашу почту.",
    "newsletter.emailPlaceholderExample": "ваш@email.com",
    "newsletter.gettingAccess": "Получение доступа...",
    "newsletter.getEarlyAccess": "Получить ранний доступ",
    "newsletter.noSpam": "Без спама. Отписаться в любое время.",
    "newsletter.thankYouJoining": "Спасибо за присоединение! Мы будем держать вас в курсе.",
    "newsletter.learnMoreBelow": "Узнать больше ниже",
    "newsletter.downloadApp": "Скачать приложение",
    "newsletter.whyBuilding": "Почему мы строим это",
    "newsletter.whyBuildingDesc": "Социальные ситуации развиваются быстро. Нужные слова не приходят, когда они нужны. Мы строим это, потому что общение не должно казаться невозможным.",
    "newsletter.whoWeHelp": "Кому мы помогаем",
    "newsletter.whoWeHelpDesc": "Людям с социальной тревожностью, интровертам, с РАС и всем, кто хочет попробовать говорить и нуждается в помощи.",
    "newsletter.whatWeDo": "Что мы делаем",
    "newsletter.whatWeDoDesc": "ИИ-приложение, которое помогает вам понимать разговоры и отвечать. Мягко, ясно, без давления. Все сделано в игровой форме, чтобы практика была увлекательной.",
    "newsletter.nonVerbalSupport": "Поддержка неговорящих",
    "newsletter.nonVerbalSupportDesc": "Мы помогаем неговорящим людям и родителям неговорящих детей общаться. Наш режим «Говори» предоставляет инструменты для общения без принуждения к речи.",
    "newsletter.safe": "Безопасно",
    "newsletter.simple": "Просто",
    "newsletter.supportive": "Поддерживающе",
    "newsletter.reportBug": "сообщить об ошибке",
    "common.startVoice": "Начать голосовой ввод",
    "common.stopRecording": "Остановить запись",
    "common.close": "Закрыть",
    "common.help": "Помощь",
    "home.goodMorning": "Доброе утро",
    "home.goodAfternoon": "Добрый день",
    "home.goodEvening": "Добрый вечер",
    "home.needHelpTalking": "Нужна помощь в разговоре?",
    "home.suggestWhatToSay": "Я предложу, что сказать",
    "home.quickActions": "Быстрые действия",
    "home.nonVerbal": "Говори",
    "home.history": "История",
    "home.scripts": "Сценарии",
    "home.startTalking": "Начать разговор",
    "home.reportBug": "Сообщить об ошибке",
    "home.underConstruction": "В разработке",
    "home.stillBuilding": "Все еще строим! Некоторые вещи могут еще не работать.",
    "home.dontShowAgain": "Больше не показывать",
    "home.gotIt": "Понял!",
    "home.howToUse": "Как использовать",
    "home.settings": "Настройки",
    "home.talkModeBeta": "Бета",
    "home.talkModeUnderDevelopment": "Сейчас в разработке",
    "home.talk": "Говорить",
    "home.show": "Показать",
    "home.breathing": "Дыхание",
    "home.greeting.morning": "Доброе утро!",
    "home.greeting.afternoon": "Добрый день!",
    "home.greeting.evening": "Добрый вечер!",
    "home.timoHomeHint": "Нажми, заходи в гости!",
    "timo.home.title": "Дом Timo",
    "timo.home.back": "Назад",
    "timo.home.close": "Закрыть",
    // teacher-first-run: the help screen and its door on the landing screen. English for now, translate later.
    "timo.home.helpButton": "How to use",
    "help.metaTitle": "How to use Timo",
    "help.title": "How to use Timo",
    "help.intro": "Five short steps. It takes a minute to read.",
    "help.back": "Back",
    "help.langLabel": "Language",
    "help.teacher.title": "For teachers and therapists",
    "help.teacher.body": "The app says \"your child\". If you are a teacher, that means your student. Everything works the same, even if you signed up as a parent.",
    // school-use
    "help.school.title": "At school, with a student",
    "help.school.point1": "Use one account on the school tablet. Sign in once and it stays signed in.",
    "help.school.point2": "Hand the tablet to the child on the Timo screen. The child talks to Timo or taps the cards.",
    "help.school.point3": "Everything for grown-ups sits behind the Grown-ups button at the top: settings, progress and the subscription.",
    "help.school.point4": "Type the child's name under Grown-ups > Progress and the child's name. Then the cards and Timo use the child's name, not yours.",
    "help.school.point5": "Got a code from the school or an event? Tap “I have a code” on the start page, the sign-in screen, the payment page or in Settings.",
    "help.step1.title": "Start in Timo's room",
    "help.step1.body": "After you log in, you always land here. This is the start screen, and everything is one tap away.",
    "help.step1.alt": "Timo's room on a phone",
    "help.step2.title": "Tap Timo and talk",
    "help.step2.body": "Tap Timo or the Talk button and allow the microphone. The child speaks, Timo answers out loud.",
    "help.step2.alt": "The Talk button at the bottom of the screen",
    "help.step3.title": "Pictures when talking is hard",
    "help.step3.body": "The Pictures button opens picture cards. The child taps a card and the app says it out loud. No microphone needed, so it still works when the mic does not.",
    "help.step3.alt": "Picture cards",
    "help.step4.title": "Word of the day",
    "help.step4.body": "Every day Timo picks one new word. Tap the word card and say it together with the child.",
    "help.step4.alt": "The word of the day card",
    "help.step5.title": "For grown-ups",
    "help.step5.body": "The Grown-ups button at the top opens settings: language, voice and subscription. This guide is always right next to it.",
    "help.step5.alt": "The How to use and Grown-ups buttons at the top of the screen",
    "help.cta": "Go to Timo",
    "help.contact": "Questions? Email info@timetotalk.lt",
    // The paywall a teacher meets: this label had no key anywhere, so every language showed "per day".
    "pricing.perDayLabel": "в день",
    // Settings rows for what the hidden homes used to link: progress, profile, breathing.
    "settings.grownUps.title": "For grown-ups",
    "settings.grownUps.progress": "Progress and the child's name",
    "settings.grownUps.progressHint": "Words, streaks and the name Timo says",
    "settings.grownUps.profile": "Profile",
    "settings.grownUps.breathing": "Breathing exercise",
    "settings.grownUps.breathingHint": "Calm breathing together with the child",
    // Promo codes (MOKOMES and the rest): the landing confirmation and the banner on /timo.
    "promoGrant.accepted": "Code accepted: {days} free. Log in to activate it.",
    "promoGrant.acceptedUnlimited": "Code accepted: free unlimited access. Log in to activate it.",
    "promoGrant.continue": "Continue",
    "promoGrant.day.one": "day",
    "promoGrant.day.few": "days",
    "promoGrant.day.many": "days",
    "promoGrant.day.other": "days",
    "promoGrant.banner": "You have {days} of free access until {date}.",
    "promoGrant.bannerUnlimited": "You have free unlimited access.",
    "promoGrant.alreadyUsed": "The code {code} was already used, so it could not be activated again.",
    "promoGrant.close": "Close",
    // promo-codes-2: "I have a code" for signed-in people (/pricing, Settings) and the entry links. English for now.
    "promoCodes2.open": "I have a code",
    "promoCodes2.label": "Enter your code",
    "promoCodes2.submit": "Activate",
    "promoCodes2.checking": "Checking...",
    "promoCodes2.success": "Code accepted: {days} free, until {date}.",
    "promoCodes2.successUnlimited": "Code accepted: free unlimited access.",
    "promoCodes2.alreadyActive": "Your access is already active, no code needed.",
    "promoCodes2.err.empty": "Type the code first.",
    "promoCodes2.err.invalid": "That code does not exist. Check it and try again.",
    "promoCodes2.err.usedOnAccount": "This code was already used on your account.",
    "promoCodes2.err.usedOnNetwork": "This code was already used from this network. Email info@timetotalk.lt and we will help.",
    "promoCodes2.err.fullyClaimed": "This code has been fully claimed.",
    "promoCodes2.err.network": "Could not connect. Check the internet and try again.",
    "promoCodes2.err.error": "Could not activate the code. Try again.",
    "timo.home.dressTitle": "Одеть Timo",
    "timo.home.foodTitle": "Что Timo хочет?",
    "timo.home.action.feed": "Кормить",
    "timo.home.action.drink": "Пить",
    "timo.home.action.sleep": "Спать",
    "timo.home.action.walk": "Гулять",
    "timo.home.action.potty": "Туалет",
    "timo.home.action.cheer": "Радость",
    "timo.home.action.dress": "Одеть",
    "timo.home.sleep.notNight": "Тимо ещё не хочет спать",
    "timo.home.outfit.default": "Обычный",
    "timo.home.outfit.beanie": "Шапка",
    "timo.home.outfit.panama": "Шляпа",
    "timo.home.outfit.cool": "Очки",
    "timo.home.outfit.ai": "Timo будущего",
    "timo.home.outfit.yoga": "Йога-Timo",
    "timo.home.food.apple": "Яблоко",
    "timo.home.food.banana": "Банан",
    "timo.home.food.berries": "Ягоды",
    "timo.home.food.bread": "Хлеб",
    "timo.home.food.fish": "Рыба",
    "timo.home.food.acorn": "Жёлудь",
    "timo.home.food.cheese": "Сыр",
    "timo.home.food.cookie": "Печенье",
    "timo.talk.tapHint": "Нажми на меня, поговорим!",
    "timo.talk.greeting": "Привет! Я Тимо. О чём поговорим?",
    "timo.talk.tapToTalk": "Нажми и говори",
    "timo.talk.listening": "Я слушаю",
    "timo.talk.tapWhenDone": "Нажми, когда закончишь",
    "timo.talk.thinking": "Тимо думает",
    "timo.talk.speaking": "Тимо говорит",
    "timo.talk.emptyReprompt": "Я слушаю! Расскажи мне что-нибудь.",
    "timo.talk.llmErrorReply": "Мне нравится с тобой говорить! Какое твоё любимое животное?",
    "timo.talk.micDenied": "Тимо нужен твой микрофон",
    "timo.talk.micDeniedHelp": "Попроси взрослого разрешить микрофон в настройках браузера, а потом нажми ещё раз.",
    // mic-school-devices
    "mic.fail.blocked.title": "Микрофон заблокирован",
    "mic.fail.blocked.body": "Тимо не слышит, потому что браузеру не разрешено использовать микрофон. Разрешите его и нажмите «Попробовать снова».",
    "mic.fail.blocked.again": "Раньше нажали «Блокировать»? Браузер сам больше не спросит. Измените это в настройках и перезагрузите страницу.",
    "mic.fail.steps.ios": "iPad или iPhone: нажмите aA в адресной строке, затем «Настройки веб-сайта», затем «Микрофон»: «Разрешить». Или откройте «Настройки», «Safari», «Микрофон» и выберите «Разрешить».",
    "mic.fail.steps.chromebook": "Chromebook: нажмите на значок слева от адреса, включите микрофон и перезагрузите страницу. Если переключатель серый, микрофон заблокировала школа. Обратитесь к IT-администратору.",
    "mic.fail.steps.android": "Android: нажмите на значок слева от адреса, затем «Разрешения», затем «Микрофон»: «Разрешить». Перезагрузите страницу.",
    "mic.fail.steps.desktop": "Компьютер: нажмите на значок слева от адреса, для микрофона выберите «Разрешить» и перезагрузите страницу. Если не помогло, проверьте настройки конфиденциальности компьютера.",
    "mic.fail.steps.native": "В приложении Timo: откройте «Настройки» телефона, затем «Timo», и включите «Микрофон». Вернитесь и нажмите «Попробовать снова».",
    "mic.fail.no_device.title": "Микрофон не найден",
    "mic.fail.no_device.body": "На этом устройстве нет работающего микрофона. Подключите микрофон или гарнитуру и нажмите «Попробовать снова».",
    "mic.fail.in_use.title": "Микрофон занят",
    "mic.fail.in_use.body": "Микрофон использует другое приложение или вкладка. Закройте их, видеозвонки тоже, и нажмите «Попробовать снова».",
    "mic.fail.insecure_context.title": "По этой ссылке микрофон не работает",
    "mic.fail.insecure_context.body": "Страница открыта по небезопасному адресу, поэтому браузер скрывает микрофон. Откройте адрес, который начинается с https://.",
    "mic.fail.unsupported.title": "Этот браузер не может использовать микрофон",
    "mic.fail.unsupported.body": "Чтобы говорить, откройте Тимо в Chrome или Safari. Сейчас можно пользоваться карточками.",
    "mic.fail.in_app_browser.title": "Откройте Тимо в браузере",
    "mic.fail.in_app_browser.body": "Instagram, Facebook и похожие приложения открывают ссылки в своём окне, и там микрофон не работает. Откройте эту страницу в Chrome или Safari.",
    "mic.fail.inapp.ios": "Нажмите три точки (...) вверху и выберите открыть в браузере.",
    "mic.fail.inapp.android": "Нажмите три точки в углу и выберите открыть в Chrome.",
    "mic.fail.offline.title": "Нет интернета",
    "mic.fail.offline.body": "Чтобы Тимо слышал, нужен интернет. Подключитесь к Wi-Fi или мобильному интернету и нажмите «Попробовать снова».",
    "mic.fail.stt_unreachable.title": "Тимо не может связаться с сервисом распознавания речи",
    "mic.fail.stt_unreachable.body": "Микрофон работает, но сеть блокирует сервис распознавания речи. Так часто бывает в школьном Wi-Fi. Попробуйте снова или попросите IT-администратора разрешить api.deepgram.com и time-to-talk.onrender.com.",
    "mic.fail.stt_service_error.title": "Сервис распознавания речи сейчас сбоит",
    "mic.fail.stt_service_error.body": "Микрофон и интернет работают, но сервис распознавания речи ответил ошибкой. Подождите минуту и нажмите «Попробовать снова».",
    "mic.fail.signed_out.title": "Войдите снова",
    "mic.fail.signed_out.body": "Срок входа истёк, поэтому Тимо не может слушать. Войдите снова и нажмите «Попробовать снова».",
    "mic.fail.unknown.title": "Тимо сейчас не слышит",
    "mic.fail.unknown.body": "Что-то остановило микрофон. Нажмите «Попробовать снова». Если это повторяется, перезагрузите страницу.",
    "mic.fail.retry": "Попробовать снова",
    "mic.fail.tiles": "Использовать карточки",
    "mic.fail.openBrowser": "Открыть в браузере",
    "mic.fail.signIn": "Войти",
    "timo.talk.exit": "Готово",
    "timo.word.title": "Слово дня",
    "timo.word.sayIt": "Скажи!",
    "timo.word.listening": "Я слушаю",
    "timo.word.hearAgain": "Послушать ещё раз",
    "timo.word.tryAgain": "Скажем вместе?",
    "timo.word.great": "Молодец!",
    "timo.word.days": "дней подряд",
    "timo.word.open": "Слово дня",
    "timo.word.close": "Закрыть",
    "breathing.prototypeNotice":
      "Это пока прототип. Пока всё работает не так, как задумано - мы это исправляем.",
    "scripts.myScripts": "Мои сценарии",
    "scripts.searchPlaceholder": "Искать сценарии...",
    "scripts.usedTime": "Использован 1 раз",
    "scripts.usedTimes": "Использован {count} раз(а)",
    "scripts.use": "Использовать",
    "scripts.listen": "Слушать",
    "scripts.delete": "Удалить",
    "scripts.swipeToDelete": "← Смахните для удаления",
    "scripts.noScriptsYet": "Пока нет сценариев",
    "scripts.savePhrasesDesc": "Сохраняйте фразы для повторного использования 💬",
    "scripts.startTalking": "Начать разговор",
    "scripts.addScript": "Добавить сценарий",
    "scripts.chooseEmoji": "Выбрать эмодзи",
    "scripts.yourPhrase": "Ваша фраза",
    "scripts.phrasePlaceholder": "например, Спасибо за помощь",
    "scripts.cancel": "Отмена",
    "scripts.save": "Сохранить",
    "scripts.addNewScript": "Добавить новый сценарий",
    "scripts.noScriptsFound": "Сценарии не найдены по вашему запросу.",
    "scripts.copied": "Скопировано!",
    "scripts.copiedToClipboard": "Сценарий скопирован в буфер обмена",
    "scripts.deleted": "Удалено",
    "scripts.removedFromCollection": "Сценарий удален из вашей коллекции",
    "scripts.saved": "Сохранено!",
    "scripts.addedToCollection": "Сценарий добавлен в вашу коллекцию",
    "scripts.alreadyExists": "Уже существует",
    "scripts.alreadySaved": "Этот сценарий уже сохранен",
    "scripts.categoryAll": "Все",
    "scripts.categoryNonverbal": "Говори",
    "scripts.categoryChats": "Чаты",
    "profile.title": "Профиль",
    "profile.navSubscription": "Подписка",
    "profile.navAboutUs": "О нас",
    "profile.sessions": "Дни",
    "profile.trophies": "Трофеи",
    "profile.sent": "Отправлено",
    "profile.streak": "Серия",
    "profile.activity": "Активность",
    "profile.awards": "Награды",
    "profile.startChatting": "Начать общение",
    "profile.friend": "Друг",
    "profile.chat1": "1 чат",
    "profile.chat5": "5 чатов",
    "profile.chat10": "10 чатов",
    "profile.chat25": "25 чатов",
    "profile.chat50": "50 чатов",
    "profile.chat100": "100 чатов",
    "profile.less": "Меньше",
    "profile.more": "Больше",
    "profile.chats": "чатов",
    "profile.goBack": "Назад",
    "profile.reportBug": "Сообщить об ошибке",
    "profile.sendFeedback": "Отправить отзыв",
    "profile.feedbackTypeBug": "Сообщение об ошибке",
    "profile.feedbackTypeComment": "Комментарий",
    "profile.feedbackPlaceholderBug": "Опишите ошибку...",
    "profile.feedbackPlaceholderComment": "Поделитесь своими мыслями...",
    "profile.feedbackSend": "Отправить",
    "profile.feedbackCancel": "Отмена",
    "profile.feedbackSending": "Отправка...",
    "profile.feedbackSuccess": "Спасибо!",
    "profile.feedbackError": "Не удалось. Попробуйте еще раз.",
    "profile.editProfile": "Редактировать профиль",
    "profile.username": "Имя пользователя",
    "profile.enterName": "Введите ваше имя",
    "profile.borderColor": "Цвет рамки",
    "profile.cancel": "Отмена",
    "profile.save": "Сохранить",
    "profile.nameTooShort": "Имя должно быть не менее 3 символов",
    "profile.nameInappropriate": "Пожалуйста, выберите подходящее имя",
    "profile.logout": "Выйти",
    "profile.logoutConfirmTitle": "Вы уверены?",
    "profile.logoutConfirmText": "Вы выйдете из аккаунта и вернетесь на стартовую страницу.",
    "profile.logoutYes": "Да",
    "profile.logoutNo": "Нет",
    "profile.loggingOut": "Выход...",
    "login.welcome": "Добро пожаловать",
    "login.subtitle": "Пожалуйста, введите ваши данные, чтобы продолжить",
    "login.firstName": "Имя",
    "login.firstNamePlaceholder": "Введите ваше имя",
    "login.firstNameRequired": "Имя обязательно",
    "login.lastName": "Фамилия",
    "login.lastNamePlaceholder": "Введите вашу фамилию",
    "login.optional": "необязательно",
    "login.email": "Электронная почта",
    "login.emailPlaceholder": "Введите ваш адрес электронной почты",
    "login.emailRequired": "Электронная почта обязательна",
    "login.emailInvalid": "Пожалуйста, введите действительный адрес электронной почты",
    "login.error": "Что-то пошло не так. Пожалуйста, попробуйте еще раз.",
    "login.pleaseWait": "Пожалуйста, подождите...",
    "login.continue": "Продолжить",
    "login.disclaimer": "Эта информация может быть использована для продвижения нашего приложения после окончательной разработки.",
    
    // Common
    "common.startVoice": "Начать голосовой ввод",
    "common.stopRecording": "Остановить запись",
    "common.close": "Закрыть",
    "common.help": "Помощь",
    "common.back": "Назад",

    // Practice Chat
    "practice.pageTitle": "Практика Чата",
    "practice.greeting": "Привет! Готовы поговорить?",
    "practice.thinking": "Думаю...",
    "practice.fallback": "Понял!",
    "practice.end": "Завершить",
    "practice.me": "Я",
    "practice.other": "Другой",
    "practice.placeholder": "Напишите что-нибудь...",
    "practice.switchText": "Переключиться на текст",
    "practice.switchVoice": "Переключиться на голос",
    "practice.errorTitle": "Ошибка",
    "practice.errorDesc": "Не удалось получить ответ",

    "appName": "Time To Talk",
    "tagline": "Иногда самый большой шаг - это просто сказать «Привет»",
    "start": "Начать",
    "situations": "Ситуации",
    "chat": "Чат",
    "settings": "Настройки",
    "home": "Домой",
    "nav.home": "Домой",
    "nav.scripts": "Сценарии",
    "nav.settings": "Настройки",
    "nav.chat": "Чат",
    "nav.live": "В прямом эфире",
    "nav.profile": "Профиль",
    "nav.nonverbal": "Говори",
    "selectSituation": "Выбрать ситуацию",
    "store": "Магазин",
    "cafe": "Кафе",
    "bus": "Автобус",
    "hospital": "Больница",
    "school": "Школа",
    "party": "Вечеринка",
    "chatFriend": "ИИ-друг для чата",
    "typeMessage": "Напишите ваше сообщение...",
    "send": "Отправить",
    "playVoice": "Воспроизвести голос",
    "tts.ltPreviewTitle": "Голос - как прозвучит",
    "accessibilitySettings": "Настройки доступности",
    "hideImages": "Скрыть изображения",
    "showImages": "Показать изображения",
    "dyslexiaMode": "Режим для дислексиков",
    "textSize": "Размер текста",
    "backgroundMode": "Режим фона",
    "monochrome": "Монохромный",
    "colored": "Цветной",
    "resetDefaults": "Сбросить настройки",
    "language": "Язык",
    "english": "Английский",
    "lithuanian": "Литовский",
    "detailMode": "Подробный режим",
    "detailModeDescription": "Показать более подробные инструкции",
    "instructions": "Инструкции",
    "backToChat": "Назад в чат",
    "startChat": "Начать чат",
    "moreDetail": "Больше деталей",
    "lessDetail": "Меньше деталей",
    "addCustomSituation": "Добавить пользовательскую ситуацию",
    "createYourOwn": "Создайте свою собственную ситуацию",
    "situationName": "Название ситуации (например, Библиотека)",
    "situationIcon": "Значок ситуации (например, 📚)",
    "situationNameEn": "Название ситуации (английский)",
    "situationNameLt": "Название ситуации (литовский)",
    "steps": "Шаги",
    "addStep": "Добавить шаг",
    "step": "Шаг",
    "instructionSimpleEn": "Простая инструкция (английский)",
    "instructionDetailedEn": "Подробная инструкция (английский)",
    "instructionSimpleLt": "Простая инструкция (литовский)",
    "instructionDetailedLt": "Подробная инструкция (литовский)",
    "saveSituation": "Сохранить ситуацию",
    "delete": "Удалить",
    "stageName": "Название этапа",
    "stageNameEn": "Название этапа (английский)",
    "stageNameLt": "Название этапа (литовский)",
    "coachLine": "Реплика тренера",
    "icon": "Значок",
    "textEn": "Текст (английский)",
    "textLt": "Текст (литовский)",
    "removeStep": "Удалить шаг",
    "edit": "Редактировать",
    "awards": "Награды",
    "totalTrophies": "Всего трофеев",
    "colorThemes": "Цветовые темы",
    "situationRewards": "Статистика разговоров",
    "unlocksAt": "Разблокируется при",
    "trophies": "трофеев",
    "successfulInteractions": "Успешные взаимодействия",
    "applyTheme": "Применить тему",
    "applied": "Применено",
    "chimeSound": "Звук награды",
    "chimeSoundDescription": "Воспроизвести звук при получении награды",
    "settings.title": "Настройки",
    "settings.backAria": "Назад",
    "settings.appearance": "Внешний вид",
    "settings.sounds": "Звуки",
    "settings.background": "Фон",
    "settings.language": "Язык",
    "settings.account": "Аккаунт",
    "settings.voiceprint.title": "Распознавание голоса",
    "settings.voiceprint.description": "Time to Talk учится узнавать ваш голос на этом устройстве, чтобы определять, кто говорит в живом разговоре. Ваш голосовой профиль хранится локально и никогда не отправляется на наши серверы.",
    "settings.voiceprint.forget": "Забыть мой голос",
    "settings.voiceprint.forgetDesc": "Удалить сохранённый голосовой профиль и начать заново",
    "settings.voiceprint.forgotten": "Голосовой профиль очищен",
    "settings.voiceprint.forgottenDesc": "Time to Talk заново выучит ваш голос в следующей живой сессии.",
    "settings.theme": "Тема",
    "settings.dark": "Темная",
    "settings.light": "Светлая",
    "settings.textSize": "Размер текста",
    "settings.textSizeSmall": "A",
    "settings.textSizeMedium": "A+",
    "settings.textSizeLarge": "A++",
    "settings.reduceMotion": "Уменьшить движение",
    "settings.dyslexiaFont": "Шрифт для дислексиков",
    "settings.showImages": "Показать изображения",
    "settings.rewardSounds": "Звуки награды",
    "settings.rainAnimation": "Анимация дождя",
    "settings.rainSounds": "Звуки дождя",
    "settings.celebration": "Праздничные эффекты",
    "settings.partyModePhone": "Праздничные эффекты на телефоне",
    "settings.partyModeDesktop": "Праздничные эффекты на компьютере",
    "settings.forest": "Лес",
    "settings.city": "Город",
    "settings.beach": "Пляж",
    "settings.privacyPolicy": "Политика конфиденциальности",
    "settings.termsOfService": "Условия использования",
    "settings.helpSupport": "Помощь и поддержка",
    "settings.replayTutorial": "Повторить обучение",
    "settings.replayTutorialDescription": "Посмотреть еще раз пошаговое руководство по приложению",
    "settings.resetPermissions": "Сбросить разрешения",
    "settings.resetPermissionsDescription": "Запросить доступ к микрофону и устройству снова",
    "settings.resetToDefaults": "Сбросить к значениям по умолчанию",
    "settings.version": "Timo v1.0.0 • Сделано с ❤️",
    "settings.deleteAccount": "Удалить аккаунт",
    "settings.deleteAccountConfirmTitle": "Удалить ваш аккаунт?",
    "settings.deleteAccountConfirmBody": "Это навсегда удалит ваш аккаунт и все данные. Это действие нельзя отменить.",
    "settings.deleteAccountConfirm": "Да, удалить мой аккаунт",
    "settings.deleteAccountCancel": "Отмена",
    "settings.deleteAccountSuccess": "Аккаунт удален",
    "settings.deleteAccountError": "Не удалось удалить аккаунт. Попробуйте еще раз или обратитесь в поддержку.",
    "settings.voiceTitle": "Голос",
    "settings.voiceDescription": "Выберите голос",
    "settings.voiceChildishFemale": "Детский, женский",
    "settings.voiceAdultMale": "Более взрослый, мужской",
    "tutorial.skip": "Пропустить",
    "tutorial.next": "Далее",
    "tutorial.startApp": "Начать использовать приложение",
    "tutorial.welcome.title": "Добро пожаловать в Time To Talk! 🎉",
    "tutorial.welcome.subtitle": "Позвольте мне показать вам",
    "tutorial.welcome.description": "Я Тимо, ваш помощник по общению. Этот быстрый тур покажет вам все, что я могу для вас сделать!",
    "tutorial.welcome.timoMessage": "Готовы учиться? Вперед!",
    "tutorial.home.title": "Ваша домашняя база 🏠",
    "tutorial.home.subtitle": "Все начинается здесь",
    "tutorial.home.description": "На главном экране отображаются быстрые действия и основная кнопка для начала разговора. Вы можете получить доступ ко всем функциям отсюда.",
    "tutorial.home.timoMessage": "Здесь вы начинаете!",
    "tutorial.chat.title": "Поговори со мной 💬",
    "tutorial.chat.subtitle": "Ваш главный помощник",
    "tutorial.chat.description": "Нажмите кнопку Тимо (это я!) в центре меню, чтобы получить помощь в разговорах. Скажите мне, что сказал кто-то, и я предложу, что вы могли бы ответить.",
    "tutorial.chat.timoMessage": "Я всегда здесь, чтобы помочь!",
    "tutorial.chat.tip1": "Введите или используйте голос, чтобы рассказать мне, что произошло",
    "tutorial.chat.tip2": "Я предложу вам ответы, которые вы можете использовать",
    "tutorial.chat.tip3": "Нажмите на значок динамика, чтобы прослушать предложения",
    "tutorial.nonverbal.title": "Режим «Говори» 🗣️",
    "tutorial.nonverbal.subtitle": "Когда слова даются с трудом",
    "tutorial.nonverbal.description": "Иногда говорить сложно. Используйте режим «Говори», чтобы нажимать символы и строить предложения, которые я произнесу за вас.",
    "tutorial.nonverbal.timoMessage": "Здесь не нужно говорить!",
    "tutorial.nonverbal.tip1": "Нажимайте символы, чтобы построить свое сообщение",
    "tutorial.nonverbal.tip2": "Нажмите кнопку воспроизведения, чтобы произнести его вслух",
    "tutorial.nonverbal.tip3": "Отлично подходит, когда вам нужен перерыв от разговоров",
    "tutorial.scripts.title": "Ваши сценарии 📝",
    "tutorial.scripts.subtitle": "Сохраняйте любимые фразы",
    "tutorial.scripts.description": "Нашли понравившийся ответ? Сохраните его в «Сценарии»! Ваши сохраненные фразы всегда будут готовы, когда они вам понадобятся.",
    "tutorial.scripts.timoMessage": "Держите свои любимые под рукой!",
    "tutorial.scripts.tip1": "Нажмите +, чтобы добавить новую фразу",
    "tutorial.scripts.tip2": "Организуйте по категориям",
    "tutorial.scripts.tip3": "Нажмите, чтобы скопировать или произнести любой сценарий",
    "tutorial.settings.title": "Сделайте это своим ⚙️",
    "tutorial.settings.subtitle": "Настройте свой опыт",
    "tutorial.settings.description": "Измените тему, размер текста, звуки и многое другое. Сделайте приложение удобным для вас!",
    "tutorial.settings.timoMessage": "Настройте его по-своему!",
    "tutorial.settings.tip1": "Переключайтесь между светлым и темным режимами",
    "tutorial.settings.tip2": "Настройте размер текста для более легкого чтения",
    "tutorial.settings.tip3": "Включите или выключите звуки",
    "tutorial.settings.tip4": "Выберите свой любимый фон",
    "tutorial.profile.title": "Ваш профиль 📊",
    "tutorial.profile.subtitle": "Отслеживайте свои разговоры",
    "tutorial.profile.description": "Каждый разговор помогает вам расти! Проверьте свой профиль, чтобы увидеть свою историю и отслеживать свой прогресс.",
    "tutorial.profile.timoMessage": "Вы отлично справляетесь!",
    "tutorial.profile.tip1": "Просмотр истории разговоров",
    "tutorial.profile.tip2": "Просмотр истории разговоров",
    "tutorial.profile.tip3": "Отслеживайте свой прогресс со временем",
    "tutorial.complete.title": "Вы готовы! 🌟",
    "tutorial.complete.subtitle": "Давайте начнем говорить",
    "tutorial.complete.description": "Вот и все! Помните, я здесь, когда вам нужна помощь. Нет давления - идите в своем темпе.",
    "tutorial.complete.timoMessage": "Я верю в вас! 💚",
    "tour.skip": "Пропустить",
    "tour.next": "Далее",
    "tour.back": "Назад",
    "tour.finish": "Понял!",
    "tour.welcome.title": "Привет! 👋",
    "tour.welcome.message": "Я Тимо, ваш помощник по общению! Позвольте мне быстро показать вам приложение.",
    "tour.navbar.title": "Панель навигации",
    "tour.navbar.message": "Так вы перемещаетесь! Все основные функции находятся прямо здесь, внизу.",
    "tour.timoButton.title": "Поговори со мной!",
    "tour.timoButton.message": "Нажимайте на меня, когда вам нужна помощь в разговорах. Я предложу, что вы могли бы сказать!",
    "tour.homeTab.title": "Домой",
    "tour.homeTab.message": "Ваша отправная точка. Быстрый доступ ко всему и ваш ежедневный прогресс.",
    "tour.nonverbalTab.title": "Режим «Говори»",
    "tour.nonverbalTab.message": "Когда говорить сложно, нажмите здесь. Вы можете строить сообщения с помощью символов, и я произнесу их за вас!",
    "tour.scriptsTab.title": "Сценарии",
    "tour.scriptsTab.message": "Сохраняйте свои любимые фразы здесь. Быстрый доступ к ответам, которые вы часто используете!",
    "tour.settingsTab.title": "Настройки",
    "tour.settingsTab.message": "Сделайте приложение своим! Изменяйте цвета, размер текста, звуки и многое другое.",
    "tour.profileTab.title": "Профиль",
    "tour.profileTab.message": "Смотрите свой прогресс здесь. Каждый разговор помогает вам расти!",
    "tour.complete.title": "Вы готовы! 🎉",
    "tour.complete.message": "Вот и весь тур! Помните, просто нажмите на меня в любое время, когда вам нужна помощь. Без давления - идите в своем темпе!",
    "settings.resetToastTitle": "✅ Настройки сброшены",
    "settings.resetToastDescription": "Все настройки доступности были восстановлены по умолчанию.",
    "settings.metaDescription": "Настройте параметры доступности, включая режим для дислексиков, размер текста и предпочтения фона.",
    "settings.rainBackgroundTitle": "Анимированный фон дождя",
    "settings.rainBackgroundDescription": "Показать анимацию дождя",
    "settings.disableRainBackground": "Отключить фон дождя",
    "settings.enableRainBackground": "Включить фон дождя",
    "settings.rainSoundTitle": "Циклический звук дождя",
    "settings.rainSoundDescription": "Воспроизводить фоновый звук дождя",
    "settings.disableRainSound": "Отключить звук дождя",
    "settings.enableRainSound": "Включить звук дождя",
    "settings.volumeLabel": "Громкость",
    "settings.rainVolumeAria": "Громкость звука дождя",
    "settings.imagesDescription": "Переключение визуальных значков и изображений",
    "settings.openDyslexicTitle": "Шрифт OpenDyslexic",
    "settings.openDyslexicDescription": "Использует шрифт OpenDyslexic, чтобы буквы было легче различать.",
    "settings.openDyslexicAria": "Шрифт OpenDyslexic",
    "settings.textSizeTitle": "Размер текста",
    "settings.mediumFont": "Средний размер текста",
    "settings.largeFont": "Большой размер текста",
    "settings.xlargeFont": "Очень большой размер текста",
    "settings.ttsModelTitle": "Модель голоса",
    "settings.ttsModelDescription": "Выберите, какую модель голоса ИИ использовать для речи",
    "settings.ttsModelBrowser": "Робо",
    "settings.ttsModelElevenLabs": "Натт",
    "settings.ttsModelOpenAI": "Нова",
    "settings.ttsModelGemini": "Пак",
    "settings.themeIconsTitle": "Значки фона",
    "settings.themeIconsDescription": "Показывать плавающие значки эмодзи, соответствующие вашей теме",
    "settings.showImagesIcons": "Показать изображения и значки",
    "settings.soundTitle": "Звук",
    "settings.rewardSound": "Звук награды",
    "firstTimeGuide.title": "Как работает Time To Talk",
    "firstTimeGuide.step1": "Нажмите «Ваша ситуация».",
    "firstTimeGuide.step2": "Введите или используйте голос, чтобы рассказать, что произошло.",
    "firstTimeGuide.step3": "ИИ предложит, что вы могли бы сказать дальше",
    "firstTimeGuide.step4": "После разговора оцените свои ощущения.",
    "firstTimeGuide.step5": "Вы также можете практиковаться с ИИ, нажав «Инструкции».",
    "firstTimeGuide.reassurance": "Вы всегда контролируете ситуацию. Вы можете остановиться в любое время.",
    "firstTimeGuide.dontShowAgain": "Больше не показывать это руководство",
    "firstTimeGuide.startButton": "Начать использовать приложение",
    "newFeature.title": "Новая функция!",
    "newFeature.subtitle": "Мы добавили что-то новое, чтобы помочь вам общаться",
    "newFeature.feature1Title": "Режим «Говори»",
    "newFeature.feature1Desc": "Нажимайте символы, чтобы строить предложения и произносить их вслух",
    "newFeature.feature2Title": "Просто и спокойно",
    "newFeature.feature2Desc": "Разработано для простоты использования, когда слова даются с трудом",
    "newFeature.feedbackRequest": "Это новая функция - мы будем рады вашим отзывам! Сообщите нам, если найдете какие-либо ошибки или у вас есть предложения.",
    "newFeature.dontShowAgain": "Больше не показывать это",
    "newFeature.messageButton": "Написать нам",
    "newFeature.tryButton": "Попробовать сейчас",
    "home.feature1Title": "Помощь в реальном времени",
    "home.feature1Desc": "Получайте предложения во время разговора",
    "home.feature2Title": "Голосовая поддержка",
    "home.feature2Desc": "Говорите или пишите - ваш выбор",
    "home.feature3Title": "Прослушать снова",
    "home.feature3Desc": "Слушайте ответы вслух",
    "home.howItWorksTitle": "Как это работает",
    "home.howItWorksDesc": "Расскажите нам, что они сказали, и мы поможем вам найти нужные слова.",
    "home.step1": "Слушать",
    "home.step2": "Думать",
    "home.step3": "Ответить",
    "home.tryNow": "Попробовать сейчас",
    "home.reassurance": "Без осуждения. Без давления. Просто помощь, когда она нужна.",
    "home.reassuranceSub": "Тимо здесь для вас, в вашем собственном темпе.",
    "home.timoTitle": "Встречайте Тимо ИИ",
    "home.timoSubtitle": "Ваш спокойный гид по общению",
    "home.timoCard1Title": "Лесной посредник",
    "home.timoCard1Text": "Дипломатия выбрала Тимо. В его лесу все конфликты заканчивались тем, что он все улаживал.",
    "home.timoCard2Title": "Лесной хаос",
    "home.timoCard2Text": "До Тимо у всех животных были проблемы между собой. Белки против ворон (орехи пропадали каждый день), утки против буквально всех (они просто… агрессивно крякали). Но как только Тимо поселился, он уладил все проблемы, как будто это ничего не стоило.",
    "home.timoCard3Title": "Отличный слушатель",
    "home.timoCard3Text": "Не громкий и не властный. Тимо умеет по-настоящему слушать и помогать другим понимать друг друга.",
    "home.timoCard4Title": "Важное осознание",
    "home.timoCard4Text": "Конфликты возникают не из-за плохих намерений. Они возникают из-за незнания, как выразить себя.",
    "home.timoCard5Title": "Четкая миссия",
    "home.timoCard5Text": "Общение - это не о том, кто умнее или громче. Это о том, чтобы помочь другим понять вас.",
    "home.timoCard6Title": "Помощь людям",
    "home.timoCard6Text": "Когда Тимо услышал, что люди тоже испытывают трудности с разговорами aswell, он немедленно покинул свой лес, чтобы помочь.",
    "home.timoCard7Title": "Ваш гид",
    "home.timoCard7Text": "Терпеливый, наблюдательный, непредвзятый. Тимо дает вам нужные слова в нужный момент.",
    "home.drawerOpen": "Читать далее",
    "home.drawerClose": "Свернуть",
    "unknown.startConversation": "Начать разговор",
    "unknown.continueConversation": "Продолжить разговор",
    "unknown.askForHelp": "Попросить о помощи",
    "unknown.sayNoPolitely": "Вежливо сказать «нет»",
    "unknown.endConversation": "Завершить разговор",
    "unknown.metaTitle": "Ваша ситуация",
    "unknown.metaDescription": "Практикуйте разговор с ИИ, который понимает контекст.",
    "unknown.backAria": "Вернуться к «Вашей ситуации»",
    "unknown.title": "Ваша ситуация",
    "unknown.subtitle": "Введите, что сказали вы или другой человек. Тимо ИИ поймет и поможет.",
    "unknown.subtitleShort": "Введите, что сказал другой человек, чтобы Тимо ИИ мог помочь.",
    "unknown.helper": "Как Тимо ИИ может помочь?",
    "unknown.youCouldSay": "Вы также могли бы сказать…",
    "unknown.firstMessage": "Расскажите, что произошло или что они сказали.",
    "unknown.inputPlaceholder": "Попросите Тимо ИИ о помощи…",
    "unknown.inputAria": "Попросите Тимо ИИ о помощи",
    "unknown.sendAria": "Отправить сообщение",
    "unknown.finishAria": "Завершить разговор",
    "unknown.finishButton": "Завершить",
    "unknown.finishedNotice": "Разговор завершен",
    "unknown.startNewConversation": "Начать новый разговор",
    "unknown.finishToastTitle": "Разговор завершен",
    "unknown.finishToastDescription": "Разговор завершен. Вы можете начать новый.",
    "unknown.errorTitle": "Ошибка",
    "unknown.errorDescription": "Не удалось отправить сообщение. Пожалуйста, попробуйте еще раз.",
    "unknown.contextPlace": "Место",
    "unknown.contextRelationship": "Отношения",
    "unknown.contextGoal": "Цель",
    "unknown.emptyState": "Начните с того, что произошло или что было сказано!",
    "unknown.playVoiceAria": "Воспроизвести голос",
    "unknown.finishedTitle": "Вы завершили эту ситуацию!",
    "unknown.motivationalMessage": "Отличная работа за попытку.",
    "unknown.howDidItFeel": "Как это ощущалось на этот раз?",
    "unknown.itFeltGood": "Было хорошо",
    "unknown.itWasHard": "Было трудно на этот раз",
    "unknown.bothChoicesOkay": "Оба варианта в порядке - главное, что вы попробовали.",
    "unknown.goalSelectionTitle": "С чем вам нужна помощь?",
    "unknown.goalSelectionSubtitle": "Выберите вариант, который лучше всего подходит для вашей ситуации.",
    "unknown.goalHelpSpeaking": "Мне нужна помощь в разговоре",
    "unknown.goalHelpAsking": "Мне нужна помощь, чтобы что-то спросить",
    "unknown.goalLost": "Я не знаю, что сказать",
    "unknown.goalSayNo": "Я хочу вежливо сказать «нет»",
    "unknown.goalSkip": "Это не подходит моей ситуации",
    "unknown.goalBadgeHelpSpeaking": "Цель: Помощь в разговоре",
    "unknown.goalBadgeHelpAsking": "Цель: Помощь в вопросах",
    "unknown.goalBadgeLost": "Цель: Я не знаю, что сказать",
    "unknown.goalBadgeSayNo": "Цель: Вежливо сказать «нет»",
    "unknown.recordOtherSpeaker": "Записать, что они сказали",
    "unknown.recording": "Запись…",
    "unknown.otherPersonSaid": "Другой человек сказал:",
    "unknown.speakerLabel": "Вы могли бы сказать:",
    "unknown.timoAILabel": "Тимо ИИ:",
    "unknown.otherPersonLabel": "Другой человек:",
    "unknown.youLabel": "Вы:",
    "voice.unsupportedAlert": "Голосовой ввод не поддерживается в этом браузере. Пожалуйста, введите текст.",
    "voice.stopRecordingAria": "Остановить запись",
    "voice.startRecordingAria": "Записать голос",
    "voice.stopRecordingTooltip": "Остановить запись",
    "voice.startRecordingTooltip": "Запись",
    "voice.recordingIndicator": "● Запись",
    "about": "О нас",
    "about.pageTitle": "О нас - Time To Talk",
    "about.metaDescription": "Узнайте историю и миссию Time To Talk.",
    "about.intro1": "Time To Talk был создан из простого, значимого момента.",
    "about.intro2": "Брат нашего основателя, страдающий аутизмом, однажды спросил, может ли он сфотографировать луну - маленький вопрос, который вдохновил на большую идею: помогать людям, которые находят повседневные социальные ситуации запутанными или стрессовыми.",
    "about.founderImageAlt": "Основатель и его брат",
    "about.teamImageAlt": "Команда Time To Talk работает вместе",
    "about.missionTitle": "Наша миссия",
    "about.missionText": "Сделать общение более понятным, легким для практики и получения опыта. Time To Talk помогает пользователям узнавать, что говорить и делать, благодаря мягкому руководству ИИ, четким визуальным эффектам и спокойному дизайну.",
    "about.goalTitle": "Наша цель",
    "about.goalText": "Повышать уверенность, одну ситуацию за раз. Мы здесь для всех, кто нуждается в поддержке - людей с аутизмом, социальной тревожностью или всех, кто просто находит социальные моменты сложными.",
    "about.back": "Назад",
    "about.timo": "Тимо",
    "about.tagline": "Ваш компаньон по общению",
    "about.missionIntro": "Мы верим, что каждый заслуживает поддержки в своих ежедневных разговорах. Тимо создан для людей, которым иногда трудно общаться - будь то аутизм, тревога, интровертность или просто плохой день.",
    "about.missionSub": "Наша цель проста: дать вам уверенность, когда она вам нужна больше всего, без осуждения и давления.",
    "about.features": "Что делает Тимо",
    "about.feature.conversation": "Помощь в разговоре",
    "about.feature.conversationDesc": "Получайте предложения по ответам, когда не знаете, что сказать",
    "about.feature.voice": "Голосовой ввод",
    "about.feature.voiceDesc": "Говорите или печатайте - что вам удобнее",
    "about.feature.scripts": "Сохранять сценарии",
    "about.feature.scriptsDesc": "Храните свои любимые ответы для быстрого доступа",
    "about.feature.privacy": "Приватно и безопасно",
    "about.feature.privacyDesc": "Ваши разговоры остаются на вашем устройстве",
    "about.madeBy": "Сделано",
    "about.teamName": "Команда Time to Talk",
    "about.teamRole": "Создание инструментов для лучшего общения",
    "about.privacyPolicy": "Политика конфиденциальности",
    "about.terms": "Условия обслуживания",
    "about.contact": "Связаться с нами",
    "about.version": "Версия 1.0.0",
    "about.madeWith": "Сделано с ❤️ для лучших разговоров",
    "header.disableRainBg": "Выключить фон дождя",
    "header.enableRainBg": "Включить фон дождя",
    "header.disableRainSound": "Выключить звук дождя",
    "header.enableRainSound": "Включить звук дождя",
    "situations.metaDescription": "Выберите реальную ситуацию для отработки общения с помощью ИИ.",
    "situations.helperText": "Выберите ситуацию для практики или поговорите с ИИ Тимо",
    "situations.customTitle": "Ваша ситуация",
    "situations.customSubtitle": "Нажмите, чтобы начать, и Тимо ИИ поможет",
    "situations.recommended": "Рекомендуется",
    "situations.deleteConfirmTitle": "Вы уверены?",
    "situations.deleteConfirmDescription": "Это действие невозможно отменить.",
    "situations.history": "История",
    "situations.historySubtitle": "Просмотр прошлых разговоров",
    "situations.chooseWhereTitle": "Где ты сейчас?",
    "situations.chooseWhereSubtitle": "Выбери вариант или начни свободный чат",
    "situations.freeChat": "Свободный чат",
    "situations.liveModeBeta": "Live Mode - бета",
    "situations.backToHome": "На главную",
    "situations.accessCodeTitle": "Нужен код доступа",
    "situations.accessCodeHint": "Введите код доступа для Live Mode:",
    "situations.enterCodePlaceholder": "Введите код...",
    "situations.codeIncorrect": "Неверный код. Попробуйте снова.",
    "situations.accessLiveModeButton": "Войти в Live Mode",
    "chat.pageTitle": "Чат с Тимо",
    "chat.metaDescription": "Поговори с Тимо - поможем с тем, что сказать",
    "chat.backAria": "Назад",
    "chat.subtitle": "Твой ИИ-помощник",
    "chat.end": "Завершить",
    "chat.helpDefault": "Помощь",
    "chat.greeting": "Привет! С чем помочь - что сказать?",
    "chat.suggestionsTitle": "Что мне ответить?",
    "chat.suggestionsHint": "Нажми вариант - его прочитают и отправят",
    "chat.suggestionsUpdating": "Обновление...",
    "chat.noSuggestions": "Нет подсказок",
    "chat.thinking": "Думаю...",
    "chat.gettingSuggestions": "Подбираю варианты для тебя",
    "chat.quickRepliesLabel": "Быстрые ответы:",
    "chat.speaking": "Говорит:",
    "chat.speakerMe": "Я",
    "chat.speakerOther": "Другой",
    "chat.placeholder": "Напиши сообщение...",
    "chat.sendAria": "Отправить сообщение",
    "chat.getHelpAria": "Получить помощь",
    "chat.playTtsAria": "Воспроизвести речь",
    "chat.ariaHearTimo": "Прослушать сообщение Тимо",
    "chat.ariaHearIt": "Прослушать",
    "chat.ariaSaveScript": "Сохранить в сценарии",
    "chat.recordMicMe": "Удерживай, чтобы записать свой голос",
    "chat.recordMicOther": "Удерживай, чтобы записать, что сказали",
    "chat.recordingMe": "Записываю твой голос...",
    "chat.recordingOther": "Записываю, что сказали...",
    "chat.ttsWait": "Подожди {seconds} с... (осталось прослушиваний: {left})",
    "chat.youCan": "Можешь сказать:",
    "chat.timoSuggests": "Timo предлагает...",
    "chat.safetyTitle": "Предупреждение о безопасности",
    "chat.safetyBody": "Этот разговор может быть небезопасным. Если чувствуешь угрозу - уходи сразу.",
    "chat.fallbackAi": "Привет! С чем помочь - что сказать?",
    "chat.fallbackCoaching": "Сообщение отправлено! 👍 Нужна ещё помощь?",
    "chat.needMoreHelp": "Нужна ещё помощь?",
    "chat.praise1": "Класс!",
    "chat.praise2": "Отлично!",
    "chat.praise3": "Молодец!",
    "chat.toast.errorTitle": "Ошибка",
    "chat.toast.errorDesc": "Не удалось получить ответ. Попробуй ещё раз.",
    "chat.toast.ttsLimitTitle": "Лимит озвучки",
    "chat.toast.ttsLimitDesc": "Максимум 5 воспроизведений за сессию.",
    "chat.toast.savedTitle": "Сохранено!",
    "chat.toast.savedDesc": "Добавлено в сценарии.",
    "chat.toast.duplicateTitle": "Уже есть",
    "chat.toast.duplicateDesc": "Эта фраза уже сохранена.",
    "chat.toast.voiceTestTitle": "Проверка голоса",
    "chat.toast.voiceTestDesc": "Воспроизвожу пример...",
    "chat.toast.voiceFailTitle": "Ошибка проверки голоса",
    "chat.toast.voiceFailDesc": "Подробности в консоли.",
    "chat.toast.connectionTitle": "Проблема со связью",
    "chat.toast.connectionDesc": "Полный ответ не получен, но сообщение отличное!",
    "chat.testVoice.lt": "Sveiki, aš esu Timo, jūsų dirbtinis intelektas.",
    "chat.testVoice.en": "Hi, I'm Timo, your AI helper.",
    "chat.testVoice.ru": "Привет! Я Тимо, твой помощник на базе искусственного интеллекта.",
    "chat.qr.hey1": "Привет!",
    "chat.qr.hey2": "Здорово",
    "chat.qr.hey3": "Как дела?",
    "chat.qr.yes1": "Да",
    "chat.qr.yes2": "Нет",
    "chat.qr.yes3": "Может",
    "chat.qr.how1": "Хорошо!",
    "chat.qr.how2": "Нормально",
    "chat.qr.how3": "Ничего",
    "chat.qr.inv1": "Конечно!",
    "chat.qr.inv2": "Потом",
    "chat.qr.inv3": "Не могу, извини",
    "chat.qr.help1": "Да",
    "chat.qr.help2": "Что случилось?",
    "chat.qr.help3": "Чем помочь?",
    "chat.qr.thanks1": "Не за что!",
    "chat.qr.thanks2": "Всегда пожалуйста",
    "chat.qr.thanks3": "Пожалуйста",
    "chat.qr.comp1": "Спасибо!",
    "chat.qr.comp2": "Благодарю",
    "chat.qr.comp3": "😊",
    "chat.qr.sorry1": "Ничего страшного",
    "chat.qr.sorry2": "Всё ок",
    "chat.qr.sorry3": "Норм",
    "chat.qr.info1": "Правда?",
    "chat.qr.info2": "Расскажи",
    "chat.qr.info3": "Что?",
    "chat.qr.plan1": "Окей",
    "chat.qr.plan2": "Во сколько?",
    "chat.qr.plan3": "Может",
    "chat.qr.conf1": "Да",
    "chat.qr.conf2": "Точно",
    "chat.qr.conf3": "Согласен",
    "chat.qr.wq1": "Не уверен",
    "chat.qr.wq2": "Дай подумать",
    "chat.qr.wq3": "Проверю",
    "chat.qr.genq1": "Да",
    "chat.qr.genq2": "Нет",
    "chat.qr.genq3": "Может",
    "chat.qr.stat1": "Круто",
    "chat.qr.stat2": "Класс",
    "chat.qr.stat3": "Серьёзно?",
    "chat.qr.def1": "Окей",
    "chat.qr.def2": "Понял",
    "chat.qr.def3": "Ок",
    "history.title": "История разговоров",
    "history.empty": "Пока нет разговоров. Начните общаться, чтобы увидеть свою историю здесь!",
    "history.loading": "Загрузка разговоров...",
    "history.error": "Не удалось загрузить разговоры. Пожалуйста, попробуйте еще раз.",
    "history.deleteConfirm": "Удалить этот разговор?",
    "history.deleteError": "Не удалось удалить разговор. Пожалуйста, попробуйте еще раз.",
    "history.resume": "Продолжить",
    "history.view": "Просмотр",
    "history.delete": "Удалить",
    "history.noTitle": "Безымянный разговор",
    "history.lastUpdated": "Последнее обновление",
    "history.deleteAll": "Удалить все",
    "history.deleteAllConfirm": "Удалить все?",
    "history.deleteAllConfirmDesc": "Все разговоры будут удалены.",
    "history.deleteAllSuccess": "Успешно",
    "history.deleteAllSuccessDesc": "Все разговоры удалены",
    "history.justNow": "Только что",
    "common.cancel": "Отмена",
    "common.delete": "Удалить",
    "customSetup.intentStart": "Начать разговор",
    "customSetup.intentContinue": "Продолжить разговор",
    "customSetup.intentFinish": "Завершить разговор",
    "customSetup.metaTitle": "Пользовательская ситуация - Настройка",
    "customSetup.metaDescription": "Настройте собственный сценарий для отработки разговора.",
    "customSetup.title": "Пользовательская ситуация",
    "customSetup.subtitle": "Выберите, где вы находитесь и что хотите сделать.",
    "customSetup.situationLabel": "Ситуация",
    "customSetup.placeholder": "например, Вечеринка, Школа, Магазин, Автобус, Больница",
    "customSetup.examplesHint": "Или выберите пример ниже:",
    "customSetup.examples.party": "Вечеринка",
    "customSetup.examples.school": "Школа",
    "customSetup.examples.store": "Магазин",
    "customSetup.examples.bus": "Автобус",
    "customSetup.examples.hospital": "Больница",
    "customSetup.intentQuestion": "Что вы хотите сделать?",
    "customSetup.startButton": "Начать",
    "customChat.metaTitle": "Чат в пользовательской ситуации",
    "customChat.genericSituation": "ситуация",
    "customChat.metaDescriptionPrefix": "Практика разговора:",
    "customChat.backAria": "Вернуться к настройке",
    "customChat.inputPlaceholder": "Напишите ваше сообщение...",
    "customChat.inputAria": "Напишите ваше сообщение",
    "customChat.finishToastTitle": "Разговор завершен",
    "customChat.finishToastDescription": "Разговор завершен. Вы можете начать новый.",
    "customChat.errorTitle": "Ошибка",
    "customChat.errorDescription": "Не удалось отправить сообщение. Пожалуйста, попробуйте еще раз.",
    "customChat.finishFallbackShort": "До свидания!",
    "customChat.finishFallbackLong": "Мне пора идти, спасибо!",
    "customChat.finishedNotice": "Разговор завершен",
    "nonVerbalMode": "Говори",
    "nonVerbalSelectPrompt": "Нажимайте символы, чтобы построить свое предложение",
    "nonVerbalAIGrammar": "Исправление грамматики ИИ",
    "nv.speakModalTitle": "Я говорю:",
    "nv.speaking": "Говорю...",
    "nv.speak": "Озвучить",
    "nv.speakAgain": "Озвучить ещё раз",
    "nv.speakLoading": "Строю предложение...",
    "nv.imageAlt": "Изображение",
    "nv.sentenceBarAria": "Строка сообщения",
    "nv.tapSymbol": "Нажмите символ...",
    "nv.clearAll": "Очистить всё",
    "nv.deleteLast": "Удалить последний",
    "nv.speakSentence": "Озвучить фразу",
    "nv.kalbeti": "Говорить",
    "nv.clear": "✕ Очистить",
    "nv.backAria": "Назад",
    "nv.scriptsAria": "Сценарии",
    "nv.historyAria": "История",
    "nv.searchPlaceholder": "Поиск символа...",
    "nv.noResults": "Ничего не найдено",
    "nv.ttsFailed": "Звук не воспроизвёлся. Нажмите, чтобы повторить.",
    "nv.searchAria": "Поиск символа",
    "nv.loading": "Загрузка...",
    "nv.noPhotos": "Пока нет фото",
    "nv.addPhotosHint": "Добавьте свои фото для общения",
    "nv.addPhoto": "Добавить фото",
    "nv.add": "Добавить",
    "nv.showLess": "Свернуть",
    "nv.moreCount": "Ещё ({count})",
    "nv.comingSoon": "Скоро!",
    "nv.historyTitle": "История",
    "nv.historyEmpty": "Пока нет предложений. Нажимайте эмодзи и говорите.",
    "nv.useAgain": "Использовать снова",
    "nv.addToScripts": "В сценарии",
    "nv.savedToScripts": "Сохранено в сценарии!",
    "nv.clearHistory": "Очистить историю",
    "nv.customAddPhoto": "Добавить фото",
    "nv.customPreview": "Предпросмотр",
    "nv.customAddLabel": "Подпись",
    "nv.customTakePhoto": "Сделать фото",
    "nv.customUseCamera": "Использовать камеру",
    "nv.customFromGallery": "Выбрать из галереи",
    "nv.customFromDevice": "С компьютера или телефона",
    "nv.customWordOnly": "Просто слово",
    "nv.customWordOnlyHint": "Картинка не нужна",
    "nv.customChange": "Изменить",
    "nv.customContinue": "Далее",
    "nv.customHintLabels": "Добавьте текст, который будет показан и озвучен",
    "nv.customNameEn": "Название (английский)",
    "nv.customPlaceholderName": "например: «Мама», «Иван»",
    "nv.customNameLt": "Название на литовском",
    "nv.customNameRu": "Название на русском",
    "nv.customOptional": "необязательно",
    "nv.customCategory": "Категория",
    "nv.customBack": "Назад",
    "nv.customSave": "Сохранить",
    "nv.customSaving": "Сохранение...",
    "nv.customErrImage": "Выберите файл изображения",
    "nv.customErrSize": "Файл слишком большой (макс. 10 МБ)",
    "nv.customErrLabel": "Введите подпись",
    "nv.customErrSave": "Ошибка сохранения",
    "nv.manageTitle": "Мои фото",
    "nv.deleteConfirm": "Удалить «{name}»?",
    "nv.cancel": "Отмена",
    "nv.delete": "Удалить",
    "speak": "Говорить",
    "speaking": "Говорит...",
    "clear": "Очистить",
    "back": "Назад",
    "skip": "Пропустить",
    "continue": "Продолжить",
    "onboarding.welcomeTitle": "Привет, я Тимо",
    "onboarding.welcomeSubtitle": "Ваш спокойный компаньон для повседневных разговоров",
    "onboarding.welcomeDesc": "Я здесь, чтобы помочь, когда говорить трудно. Давайте настроим все за минуту.",
    "onboarding.getStarted": "Начать",
    "onboarding.languageTitle": "Выберите ваш язык",
    "onboarding.languageDesc": "Вы можете изменить это позже в настройках",
    "onboarding.accessibilityTitle": "Сделайте это комфортным",
    "onboarding.accessibilityDesc": "Настройте это в соответствии с вашими потребностями",
    "onboarding.reducedMotion": "Уменьшенное движение",
    "onboarding.reducedMotionDesc": "Более простые анимации для меньшего отвлечения",
    "onboarding.sounds": "Звуковые эффекты",
    "onboarding.soundsDesc": "Нежные перезвоны для обратной связи",
    "onboarding.showImages": "Показать изображения",
    "onboarding.showImagesDesc": "Отображать иллюстрации и значки",
    "onboarding.howItWorksTitle": "Как это работает",
    "onboarding.howItWorksDesc": "Три простых шага, чтобы помочь вам общаться",
    "onboarding.step1Title": "Они говорят",
    "onboarding.step1Desc": "Расскажите нам, что сказал другой человек",
    "onboarding.step2Title": "Мы помогаем",
    "onboarding.step2Desc": "Тимо предлагает, что вы могли бы сказать",
    "onboarding.step3Title": "Вы отвечаете",
    "onboarding.step3Desc": "Выберите предложение или скажите свое",
    "onboarding.readyTitle": "Вы готовы!",
    "onboarding.readyDesc": "Тимо готов помочь, когда вам понадобится.",
    "onboarding.readyTip": "Совет: Вы всегда можете получить доступ к настройкам позже, чтобы изменить предпочтения.",
    "onboarding.startUsing": "Начать использовать Time To Talk",
    "pushToTalk.title": "Помоги мне ответить",
    "pushToTalk.ready": "Готов, когда вы будете готовы",
    "pushToTalk.helpMeRespond": "Помоги мне ответить",
    "pushToTalk.tapToStart": "Нажмите, чтобы записать, что они сказали",
    "pushToTalk.recording": "Запись того, что они сказали...",
    "pushToTalk.done": "Готово",
    "pushToTalk.cancel": "Отмена",
    "pushToTalk.understanding": "Понимание...",
    "pushToTalk.theySaid": "Они сказали:",
    "pushToTalk.soundsLike": "Это звучит как",
    "pushToTalk.yesHelpMe": "Да, помогите мне ответить",
    "pushToTalk.notQuite": "Не совсем, попробуйте еще раз",
    "pushToTalk.startOver": "Начать сначала",
    "pushToTalk.findingResponses": "Поиск хороших ответов...",
    "pushToTalk.pickResponse": "Выберите ответ:",
    "pushToTalk.youllSay": "Вы скажете:",
    "pushToTalk.illSayIt": "Я скажу это",
    "pushToTalk.speakForMe": "Скажите за меня",
    "pushToTalk.chooseAnother": "Выбрать другой",
    "pushToTalk.differentOptions": "Различные варианты",
    "pushToTalk.speaking": "Говорит...",
    "pushToTalk.stop": "Стоп",
    "pushToTalk.responseReady": "Ответ готов!",
    "pushToTalk.needMoreHelp": "Нужна дополнительная помощь",
    "pushToTalk.imDone": "Я закончил",
    "pushToTalk.autoReset": "Вернется домой автоматически",
    "pushToTalk.stillThere": "Все еще здесь?",
    "pushToTalk.takeYourTime": "Не торопитесь, без спешки.",
    "pushToTalk.continue": "Продолжить",
    "pushToTalk.didntCatch": "Я не понял",
    "pushToTalk.tryAgainOrType": "Попробуйте еще раз или наберите текст",
    "pushToTalk.tryAgain": "Попробуйте еще раз",
    "pushToTalk.typeInstead": "Набрать текст",
    "pushToTalk.whatDidTheySay": "Что они сказали?",
    "pushToTalk.typeHere": "Напишите, что они сказали...",
    "pushToTalk.somethingWrong": "Что-то пошло не так",
    "pushToTalk.pleaseTryAgain": "Пожалуйста, попробуйте еще раз",
    "pushToTalk.panic": "Остановиться и вернуться",
    "live.title": "Прямой эфир",
    "live.back": "Назад",
    "live.endSession": "Завершить",
    "live.error": "Ошибка",
    "live.dismiss": "Отклонить",
    "live.status.ready": "Готово",
    "live.status.connecting": "Подключение...",
    "live.status.listening": "Прослушивание...",
    "live.tapToStart": "Начать",
    "live.tapToStop": "Остановить",
    "live.connecting": "Подключение...",
    "live.stats.totalMessages": "Всего",
    "live.stats.you": "Вы",
    "live.stats.otherPerson": "Другой",
    "live.conversation": "Разговор",
    "live.emptyState.listening": "Прослушивание...",
    "live.emptyState.startRecording": "Начать",
    "live.getAiHelp": "Помощь Тимо",
    "live.askAi": "Спросить Тимо",
    "live.theyreSpeaking": "Они говорят",
    "live.emptyState.instruction": "Нажмите кнопку микрофона, чтобы начать разговор",
    "live.betaWarning.title": "Режим Live - Бета",
    "live.betaWarning.description": "Эта функция находится в разработке. Чувствуйте себя свободно тестировать!",
    "live.betaWarning.note": "Лучше всего работает на английском языке",
    "live.betaWarning.close": "Понял",
    "rateLimit.title": "Вы достигли дневного лимита",
    "rateLimit.message": "Вы достигли своего дневного лимита. Пожалуйста, попробуйте еще раз завтра.",
    "rateLimit.ok": "ОК",
    "rateLimit.close": "Закрыть",
    // Landing copy lives in src/copy/landing.ru.js
    ...landingRu,
    ...storyRu,
    "login.title": "Вход",
    "login.startSubtitle": "Войдите через Google или электронную почту.",
    "login.fbBrowserWarning": "Вход через Google не работает в браузере Facebook. Используйте почту ниже или откройте страницу в Safari / Chrome.",
    "login.signUpPrompt": "Ещё нет аккаунта?",
    "login.signUpLink": "Зарегистрироваться ниже",
    "login.googleBtn": "Продолжить с Google",
    "login.facebookBtn": "Продолжить с Facebook",
    "login.appleBtn": "Продолжить с Apple",
    "login.openInBrowser": "Для входа через Google, Facebook или Apple откройте страницу в браузере (меню → «Открыть в браузере»). Или используйте e-mail ниже.",
    "login.emailBtn": "Продолжить с электронной почтой",
    "login.registerBtn": "Уже есть аккаунт?",
    "login.signInLink": "Войти",
    "login.signinTitle": "Войти",
    "login.signupTitle": "Зарегистрироваться",
    "login.signinSubtitle": "Войдите с вашей электронной почтой",
    "login.signupSubtitle": "Создайте свой аккаунт",
    "login.emailLabel": "Адрес электронной почты",
    "login.passwordLabel": "Пароль",
    "login.passwordSignupPlaceholder": "Пароль (мин. 6 символов)",
    "login.submitSignin": "Войти",
    "login.submitSignup": "Зарегистрироваться",
    "login.processing": "Обработка...",
    "login.noAccount": "Нет аккаунта? Зарегистрироваться",
    "login.haveAccount": "Уже есть аккаунт? Войти",
    "login.successSignin": "Вход выполнен успешно!",
    "login.successSignup": "Проверьте свою электронную почту для подтверждения!",

    // Landing v2 - direct-pay funnel
    "pricingCard.howManyMonths": "Сколько месяцев?",
    "pricingCard.fullAccess": "Полный доступ ко всем функциям",
    "pricingCard.offline": "Работает офлайн",
    "pricingCard.newFeatures": "Новые функции ежемесячно",
    "pricingCard.cancelAnytime": "Отменить в любое время",
    "pricingCard.tryBeforePay": "Попробуйте, прежде чем платить",
    "pricingCard.lockInPrice": "Зафиксировать цену",
    "footer.privacy": "Политика конфиденциальности",
    "footer.articles": "Статьи",
    "footer.terms": "Условия",
    "footer.contact": "Контакты",
    "footer.copyright": "© 2026 Time To Talk",
    "common.appName": "Time To Talk",
    "pricing.yourChildDeserves": "Ваш ребенок заслуживает быть услышанным.",
    "pricing.feature1": "Нажмите на картинку. Тимо говорит за них.",
    "pricing.feature2": "Практикуйте общение безопасно, в своем собственном темпе.",
    "pricing.feature3": "Помощь в реальных разговорах. В реальном времени.",
    "pricing.letsGo": "Поехали",
    "pricing.cancelBeforeDay7": "Отмените до 7-го дня. Вы ничего не платите.",
    "pricing.reminderTitle": "Мы напомним вам до окончания.",
    "pricing.today": "Сегодня",
    "pricing.day5": "День 5",
    "pricing.day5Desc": "Мы отправляем вам напоминание по электронной почте.",
    "pricing.day7": "День 7",
    "pricing.soundsGood": "Звучит хорошо",
    "pricing.controlIt": "Вы контролируете это. Отменить в любое время.",
    "pricing.choosePlan": "Выберите свой план.",
    "pricing.fullAccessBadge": "ПОЛНЫЙ ДОСТУП",
    "pricing.perMonthLabel": "в месяц",
    "pricing.fullAccessFromToday": "Все 3 режима доступны сегодня",
    "pricing.billedMonthlyCancelAnytime": "Списание раз в месяц. Отменить можно в любой момент.",
    "pricing.getAccessCta": "Получить доступ",
    "pricing.chargedTodayNote": "Оплата списывается сегодня. Отменить можно в любой момент: Профиль, затем Подписка.",
    "pricing.fullAccessSub": "Полный доступ ко всем 3 режимам. Отменить можно в любой момент.",
    "pricing.cancelAnytimeNote": "Отменить можно в любой момент: Профиль, затем Подписка.",
    "pricing.oldPrice": "€11.49/мес",
    "pricing.foundingRate": "Стартовая цена",
    "pricing.oneMonth": "1 месяц",
    "pricing.threeMonths": "3 месяца",
    "pricing.sixMonths": "6 месяцев",
    "pricing.monthlyPer": "/мес",
    "pricing.monthlyWeek": "€1.50/нед",
    "pricing.quarterlyPrice": "€5.83",
    "pricing.quarterlyPer": "/мес",
    "pricing.quarterlyWeek": "€1.35/нед",
    "pricing.popularBadge": "САМЫЙ ПОПУЛЯРНЫЙ",
    "pricing.saveQuarterly": "Экономия €16",
    "pricing.biannualPrice": "€5.00",
    "pricing.biannualPer": "/мес",
    "pricing.biannualWeek": "€1.15/нед",
    "pricing.bestValueBadge": "ЛУЧШАЯ ЦЕННОСТЬ",
    "pricing.saveBiannual": "Экономия €39",
    "pricing.switchesTo": "Переключается на план 6 месяцев",
    "pricing.families": "🌍 130+ семей уже используют Time To Talk",
    "pricing.monthlyLabel": "Месячный",
    "pricing.buyNowCta": "Получить полный доступ",
    "pricing.cancelBeforeDay30": "Отменить можно в любой момент: Профиль, затем Подписка.",
    "pricing.dueTodayLabel": "к оплате сегодня",
    "pricing.thenPerDayBilled": "затем {day}/день, списание {billed}/мес",
    "pricing.reassureTitle": "Сегодня вы платите 0",
    "pricing.reassureTodayLabel": "Сегодня",
    "pricing.reassureAfterDesc": "Только {day}/день, если останетесь, отмена в любое время",
    "pricing.reassureCheap": "Это меньше чашки кофе в месяц",
    "pricing.reassureCta": "Показать мой план",
    "pricing.secureCheckoutStripe": "Безопасная оплата через Stripe.",
    "pricing.offerPercentBadge": "Скидка {percent}%",
    "pricing.breakoutReminderCta": "Покажите, как",
    "pricing.founderName": "Гинтарас, основатель",
    "pricing.founderHeadline": "Хотите персональное предложение?",
    "pricing.founderBody": "Короткий 10-минутный разговор: узнать больше, получить помощь и, возможно, поделиться идеями, которые я воплощу в новых функциях.",
    "pricing.teacherHeadline": "Настройте «Time to Talk» для ваших учеников.",
    "pricing.teacherSub": "Полный доступ ко всем 3 режимам для вашего класса. Отменить можно в любой момент.",
    "pricing.teacherFeature1": "Используйте с каждым учеником, которому помогаете",
    "pricing.teacherFeature2": "Литовский и английский, голос встроен",
    "pricing.teacherFeature3": "Бесплатный звонок, чтобы адаптировать под ваш класс",
    "pricing.teacherFounderHeadline": "Помогу вам всё настроить",
    "pricing.teacherFounderBody": "Короткий 15-минутный разговор: помогу настроить «Time to Talk» для ваших учеников и отвечу на все вопросы.",
    "pricing.founderCtaPrimary": "Записаться на звонок с Гинтарасом",
    "pricing.founderSkip": "Продолжить без звонка",
    "pricing.day27": "День 27",
    "pricing.day27Desc": "Мы отправляем вам напоминание по электронной почте.",
    "landingPricing.oldPriceCurrency": "€11.49/мес",
    "landingPricing.oneMonth": "1 месяц",
    "landingPricing.threeMonths": "3 месяца",
    "landingPricing.sixMonths": "6 месяцев",
    "landingPricing.perMonth": "/мес",
    "landingPricing.week1": "€1.50/нед",
    "landingPricing.week3": "€1.35/нед",
    "landingPricing.week6": "€1.15/нед",
    "landingPricing.badgePopular": "САМЫЙ ПОПУЛЯРНЫЙ",
    "landingPricing.badgeBest": "ЛУЧШАЯ ЦЕНА",
    "landingPricing.save16": "Экономия €16",
    "landingPricing.save39": "Экономия €39",
    "login.failed": "Вход не удался. Пожалуйста, попробуйте еще раз.",
    "login.unknownError": "Неизвестная ошибка. Пожалуйста, попробуйте еще раз.",
    "login.registrationFailed": "Регистрация не удалась:",
    "login.confirmationEmail": "Проверьте свою электронную почту - мы отправили письмо с подтверждением.",
    "login.linkExpired": "Ссылка для входа истекла. Запросите новую.",
    "login.resendMagicLink": "Отправить новую ссылку на email",
    "login.magicLinkSent": "Проверьте почту - мы отправили новую ссылку для входа.",
    "login.loginSuccessful": "Вход выполнен успешно!",
    "login.devAccessNotAvailable": "Разработческий доступ недоступен",
    "login.invalidCode": "Неверный код",
    "login.accessPlaceholder": "доступ",
    "login.forgotPassword": "Забыли пароль?",
    "login.resetTitle": "Сброс пароля",
    "login.resetSubtitle": "Отправим вам ссылку для сброса.",
    "login.submitReset": "Отправить ссылку",
    "login.resetSent": "Проверьте почту - мы отправили ссылку для сброса пароля.",
    "login.resetRateLimited": "Письмо уже отправлено - подождите несколько минут перед повторной попыткой.",
    "login.resetWaitBtn": "Подождите {n}с",
    "login.newPasswordTitle": "Новый пароль",
    "login.newPasswordSubtitle": "Введите ваш новый пароль.",
    "login.newPasswordLabel": "Новый пароль (мин. 6 символов)",
    "login.submitNewPassword": "Установить пароль",
    "login.passwordUpdated": "Пароль обновлен! Выполняем вход...",
    "login.backToSignin": "Вернуться к входу",
    "login.fbEmailFallback": "Или войдите через email",
    "login.fbLinkCopied": "Ссылка скопирована - вставьте её в Chrome или Safari",

    "home.urgencyBanner": "Подписка не активна - откройте все функции",
    "home.urgencyBannerCta": "Смотреть планы",
    "subscription.choosePlanCta": "Выбрать план",
    "home.sessionsCompleted": "{n} сессий завершено",

    "login.languageLithuanian": "Литовский",
    "login.languageEnglish": "Английский",
    "pricing.noActiveSubscription": "Не найдена активная подписка. Если вы только что оплатили, подождите несколько минут.",
    "pricing.errorCheckingSubscription": "Ошибка при проверке подписки. Пожалуйста, попробуйте еще раз.",
    "pricing.checking": "Проверка...",
    "pricing.restorePurchase": "Восстановить покупку",
    "pricing.backToOnboarding": "Назад к онбордингу",
    "pricing.somethingWentWrong": "Что-то пошло не так. Пожалуйста, попробуйте ещё раз.",
    "pricing.promoErrorAlreadyAccount": "Промокод {code} уже использован на вашем аккаунте. Оформите подписку ниже, это одно касание.",
    "pricing.promoErrorAlreadyNetwork": "Промокод {code} уже был использован из вашей сети. Оформите подписку ниже, это одно касание.",
    "pricing.promoErrorGeneric": "Не удалось применить промокод {code}. Оформите подписку ниже или попробуйте позже.",
    "pricing.promoErrorDismiss": "Понятно",
    "pricing.terms": "Условия",
    "pricing.privacy": "Конфиденциальность",
    "success.badge": "Вы Премиум",
    "success.title": "Все готово.",
    "success.sub": "Все функции разблокированы и готовы.",
    "success.cta": "Поехали",
    "success.unlock1": "Все разблокировано",
    "success.unlock2": "Режимы чата, Live и «Говори» активны",
    "success.unlock3": "Ваша учетная запись готова на всех устройствах",
    "success.footer": "Все функции Premium активны в вашей учетной записи.",
    "onboarding.childSetup": "Давайте настроим приложение для вашего ребенка.",
    "onboarding.takesMinute": "Займет меньше минуты.",
    "onboarding.getStartedButton": "Начать",
    "onboarding.noPayment": "Без оплаты до 7-го дня",
    "onboarding.meetTimo": "Встречайте Тимо.",
    "onboarding.communicationBuddy": "Ваш компаньон по общению.",
    "onboarding.timoQuote": "Я помогу вашему ребенку обрести свой голос. Давайте все настроим вместе.",
    "onboarding.heyTimo": "Привет, Тимо!",
    "onboarding.nextButton": "Далее",
    "onboarding.canYourChildSpeak": "Ваш ребенок может говорить?",
    "onboarding.pickBestFit": "Выберите тот, который подходит лучше всего.",
    "onboarding.yesTheySpeak": "Да, они говорят",
    "onboarding.sometimesStruggles": "Но иногда испытывает трудности",
    "onboarding.sometimes": "Иногда",
    "onboarding.dependsOnDay": "Зависит от дня или ситуации",
    "onboarding.notYet": "Еще нет",
    "onboarding.littleNoVerbal": "Мало или совсем нет вербального общения",
    "onboarding.howOldChild": "Сколько лет вашему ребенку?",
    "onboarding.under3": "До 3 лет",
    "onboarding.3_6years": "3-6 лет",
    "onboarding.7_12years": "7-12 лет",
    "onboarding.13orOlder": "13 или старше",
    "onboarding.biggestChallenge": "В чем самая большая проблема?",
    "onboarding.pickMostFit": "Выберите тот, который подходит больше всего.",
    "onboarding.startingConversations": "Начинать разговоры",
    "onboarding.hardToInitiate": "Трудно инициировать",
    "onboarding.beingUnderstood": "Быть понятым",
    "onboarding.wordsDontComeOutRight": "Слова выходят не так",
    "onboarding.anxietyAroundSpeaking": "Тревожность при разговоре",
    "onboarding.freezesUpSocial": "Замирает в социальных ситуациях",
    "onboarding.allOfThese": "Все эти варианты",
    "onboarding.whereThisHappens": "Где это происходит чаще всего?",
    "onboarding.atHome": "Дома",
    "onboarding.atSchool": "В школе",
    "onboarding.everywhere": "Везде",
    "onboarding.allSituations": "Во всех ситуациях",
    "onboarding.triedOtherApps": "Вы пробовали другие приложения?",
    "onboarding.yesNothingWorked": "Да, ничего не сработало",
    "onboarding.searchingForWhile": "Мы искали некоторое время",
    "onboarding.speechTherapy": "Мы используем логопедическую терапию",
    "onboarding.extraSupport": "Ищем дополнительную поддержку",
    "onboarding.firstTry": "Это наша первая попытка",
    "onboarding.mainGoal": "Какова ваша основная цель?",
    "onboarding.dailyCommunication": "Ежедневное общение",
    "onboarding.expressBasicNeeds": "Помочь им выражать основные потребности",
    "onboarding.buildConfidence": "Повысить уверенность",
    "onboarding.reduceAnxiety": "Снизить тревожность при разговоре",
    "onboarding.supportTherapy": "Поддержать терапию",
    "onboarding.useAlongsideTreatment": "Использовать вместе с текущим лечением",
    "onboarding.whoUsesApp": "Кто будет использовать приложение с вашим ребенком?",
    "onboarding.parentCaregiver": "Родитель или опекун",
    "onboarding.teacherTherapist": "Учитель или терапевт",
    "onboarding.bothTogether": "Оба вместе",
    "onboarding.chooseLanguage": "Выберите язык.",
    "onboarding.personalizeTimo": "Выберите один, чтобы персонализировать Тимо.",
    "onboarding.languageLt": "Литовский",
    "onboarding.languageEn": "Английский",
    "onboarding.chooseTimoVoice": "Выберите голос Тимо.",
    "onboarding.tapToHearPreview": "Нажмите, чтобы услышать предварительный просмотр.",
    "onboarding.voiceFlagLt": "ЛТ",
    "onboarding.voiceFlagEn": "АНГЛ",
    "onboarding.voiceTimmy": "Тимми",
    "onboarding.voiceTimmyDescLt": "Детский, женский",
    "onboarding.voiceTimmyDescEn": "Детский, женский",
    "onboarding.voiceTimo": "Тимо",
    "onboarding.voiceTimoDescLt": "Взрослый, мужской",
    "onboarding.voiceTimoDescEn": "Взрослый, мужской",
    "onboarding.whatCallChild": "Как Тимо должен называть вашего ребенка?",
    "onboarding.optionalSkip": "Необязательно, вы можете пропустить.",
    "onboarding.childNamePlaceholder": "Имя ребенка...",
    "onboarding.continueWith": "Продолжить с {name}",
    "onboarding.continue": "Продолжить",
    "onboarding.skip": "Пропустить",
    "onboarding.understandingNeeds": "Понимание потребностей вашего ребенка...",
    "onboarding.pickingStyle": "Выбор правильного стиля общения...",
    "onboarding.gettingTimoReady": "Подготовка Тимо...",
    "onboarding.almostThere": "Почти готово...",
    "onboarding.settingUpTimeToTalk": "Настройка TimeToTalk",
    "onboarding.youreNotAlone": "Вы не одни.",
    "onboarding.familiesUseApp": "130+ семей уже используют TimeToTalk.",
    "onboarding.sonSaidMom": "Мой сын сказал мама впервые с помощью этого приложения. Я плакала весь день.",
    "onboarding.katrinaVilnius": "- Катрина С., Вильнюс",
    "onboarding.meetTimoArrow": "Встречайте Тимо →",
    "onboarding.readyLetsGo": "Готово, поехали!",
    "onboarding.timoReadyHelp": "Тимо готов помочь.",
    "onboarding.loading": "Загрузка...",
    "onboarding.letsStartArrow": "Начать →",
    "download.appInstalled": "Приложение установлено",
    "download.continuingOnboarding": "Продолжаем настройку...",
    "download.installApp": "Установить приложение",
    "download.bestExperience": "Лучший опыт в установленном приложении.",
    "download.apple": "Apple",
    "download.iphoneIpad": "iPhone / iPad",
    "download.android": "Android",
    "download.chromeInstall": "Установка через Chrome",
    "download.appleInstall": "Установка Apple",
    "download.homeScreenQuality": "Лучшее качество работы с главного экрана.",
    "download.openSafari1": "1. Откройте эту страницу в Safari.",
    "download.openSafari2": "2. В Safari нажмите «Поделиться».",
    "download.openSafari3": "3. Нажмите «Добавить на главный экран», затем «Добавить».",
    "download.copyLinkSafari": "Скопировать ссылку для Safari",
    "download.linkCopiedSafari": "Ссылка скопирована. Откройте Safari и вставьте ссылку.",
    "download.copyFailed": "Копирование не удалось. Пожалуйста, скопируйте URL вручную и откройте в Safari.",
    "download.tapShare1": "Нажмите «Поделиться» (квадрат + стрелка).",
    "download.tapShare2": "Нажмите «Добавить на главный экран».",
    "download.tapShare3": "Нажмите «Добавить».",
    "download.openShareMenu": "Открыть меню «Поделиться»",
    "download.inAppBrowserHint": "Если вы используете браузер Instagram/Facebook, откройте меню и нажмите «Открыть в Safari».",
    "download.androidInstall": "Установка Android",
    "download.otherDeviceTitle": "Хотите приложение на другом устройстве?",
    "download.otherDeviceBody": "Откройте браузер на том устройстве, перейдите на timohelps.com и войдите с теми же данными.",
    "download.otherDeviceHelp": "Возникли проблемы? Напишите нам:",
    "download.androidStep1": "Откройте меню Chrome (⋮ в правом верхнем углу)",
    "download.androidStep2": "Нажмите \"Добавить на главный экран\" или \"Установить приложение\"",
    "download.androidStep3": "Нажмите \"Установить\" для подтверждения",
    "download.promptAutoOpen": "Запрос на установку должен открыться автоматически.",
    "download.promptAutoOpenAndroid": "На Android (Chrome) окно установки может открыться автоматически.",
    "download.androidInstallOnlyNote":
      "Установка в один касание - для Android (Chrome). На iPhone и iPad используйте «На экран «Домой»» - см. ниже.",
    "download.iosInstallTitle": "iPhone и iPad",
    "download.iosInstallHint":
      "В Safari нажмите «Поделиться», затем «На экран «Домой»». Если не видите - сначала «Ещё» в листе, затем «На экран «Домой»», затем «Добавить».",
    "download.downloadApp": "Скачать приложение",
    "download.promptNotOpen": "Запрос на установку не открылся. Откройте меню браузера и нажмите «Установить приложение» или «Добавить на главный экран».",
    "download.desktopHint": "Для лучших результатов откройте это на iPhone/iPad/Android и установите приложение.",
    "download.backToLanding": "Назад на сайт",
    "download.continueWeb": "Продолжить в вебе",
    "download.webUseEverything": "Вы по-прежнему можете использовать все в вебе.",
    "download.windowsTitle": "Windows и компьютер",
    "download.windowsHint": "Нажмите значок установки в адресной строке браузера (рекомендуется Chrome или Edge).",
    "download.iosVideoSoon": "Видеогид скоро появится",
    "download.continueSetup": "Продолжить настройку",
    "download.installedSuccess": "Приложение успешно установлено",

    "cookie.title": "Файлы cookie",
    "cookie.body": "Мы используем файлы cookie для аналитики, а на страницах, куда вы переходите из нашей рекламы, также для оценки эффективности рекламы (Meta Pixel). Это помогает нам улучшать приложение. Мы не продаём ваши данные, и приложение полностью работает, если вы откажетесь.",
    "cookie.accept": "Принять",
    "cookie.decline": "Отклонить",
    "cookie.learnMore": "Политика конфиденциальности",

    // Реферальная страница
    'referral.pageTitle': 'Приглашайте друзей, получайте месяцы бесплатно',
    'referral.pageSubtitle': 'Поделитесь Time To Talk. Когда друг оплачивает первый месяц, вы получаете один бесплатно.',
    'referral.heroEarnedLabel': 'Вы заработали',
    'referral.heroMonths': '{n} месяцев',
    'referral.heroOneMonth': '1 месяц',
    'referral.heroNoMonths': '0 месяцев',
    'referral.heroFromConversions': 'из {n} приглашений',
    'referral.heroFromOneConversion': 'из 1 приглашения',
    'referral.heroFromZero': 'пока нет приглашений',
    'referral.heroCapUsed': '{used} из {total} в годовом лимите',
    'referral.heroFirstTime': 'Поделитесь ссылкой и заработайте свой первый бесплатный месяц.',
    'referral.codeLabel': 'Ваш код',
    'referral.linkLabel': 'Ваша ссылка',
    'referral.copy': 'Скопировать ссылку',
    'referral.copied': 'Скопировано!',
    'referral.share': 'Поделиться',
    'referral.shareNative': 'Поделиться',
    'referral.shareWhatsapp': 'WhatsApp',
    'referral.shareMessenger': 'Messenger',
    'referral.shareEmail': 'Эл. почта',
    'referral.shareSms': 'SMS',
    'referral.shareMessage': 'Я использую Timo Helps, чтобы помочь ребёнку тренировать речь. Посмотри: {link}',
    'referral.shareEmailSubject': 'Попробуй Time To Talk вместе со мной',
    'referral.howTitle': 'Как это работает',
    'referral.howStep1': 'Отправьте ссылку другу.',
    'referral.howStep2': 'Друг оформляет подписку по вашей ссылке.',
    'referral.howStep3': 'Когда друг оплачивает первый месяц, вы получаете 1 месяц бесплатно автоматически.',
    'referral.rules': 'Одно вознаграждение на друга. До 12 бесплатных месяцев в год. Самоприглашения и общие аккаунты не вознаграждаются.',
    'referral.errorLoad': 'Не удалось загрузить данные. Обновите страницу.',
    'referral.capReached': 'Вы достигли годового лимита в 12 бесплатных месяцев. Спасибо, что делитесь.',
    'referral.bannerInvited': 'Приглашены другом. Добро пожаловать в Timo Helps.',
    'referral.bannerInvitedShort': 'Приглашены другом.',
    'referral.announceTitle': 'Новое: 1 месяц бесплатно',
    'referral.announceBody': 'Пригласи друга в Time To Talk. Когда друг оплатит первый месяц, ты получишь один бесплатно.',
    'referral.announceCta': 'Узнать как',
    'referral.announceLater': 'Может позже',
    'referral.youGetLabel': 'Ты получаешь',
    'referral.youGetReward': '1 месяц бесплатно',
    'referral.friendGetsLabel': 'Друг получает',
    'referral.friendGetsReward': 'полный доступ сразу',
    'referral.linkOnlyNote': 'Только эта точная ссылка засчитывает приглашение. Просто отправить код недостаточно.',


    // --- Native iOS port (WS-2 auth, WS-3 purchases, WS-4 speech, WS-5 media,
    //     WS-6 install, WS-7 AI consent and content reporting). Merged from
    //     src/native/_i18n/*.strings.json. Additive: no existing key was changed.
    'native.auth.browserUnavailable': 'Не удалось открыть окно входа. Пожалуйста, попробуйте еще раз.',
    'native.auth.oauthCancelled': 'Вход отменён.',
    'native.auth.oauthFailed': 'Вход не был завершён. Пожалуйста, попробуйте еще раз.',
    'native.auth.passwordResetOpensBrowser': 'Смена пароля откроется на защищённой странице в браузере. Измените пароль там, затем вернитесь и войдите с новым паролем.',
    'native.auth.sessionFailed': 'Не удалось завершить вход. Пожалуйста, попробуйте еще раз.',
    'native.consent.agree': 'Принимаю',
    'native.consent.contact': 'Есть вопросы? Напишите нам:',
    'native.consent.declinedAgree': 'Всё-таки принимаю',
    'native.consent.declinedBody': 'Без этого Тимо не может ни слушать, ни отвечать. Вы по-прежнему можете пользоваться картинками, сохранёнными сценариями и всеми настройками. Когда будете готовы, включите это в настройках, в разделе «Конфиденциальность».',
    'native.consent.declinedContinue': 'Продолжить без голоса Тимо',
    'native.consent.declinedTitle': 'Пока Тимо помолчит',
    'native.consent.forLabel': 'Зачем:',
    'native.consent.getsLabel': 'Получает:',
    'native.consent.intro': 'Тимо пользуется услугами нескольких внешних компаний: они превращают речь в текст, составляют ответы и произносят их вслух. Значит, часть того, что вы говорите и пишете, уходит к ним. Вот кто это и что получает каждая из них.',
    'native.consent.notNow': 'Не сейчас',
    'native.consent.privacyLink': 'Читать политику конфиденциальности',
    'native.consent.proc.anthropic.purpose': 'Чтобы составлять ответы Тимо',
    'native.consent.proc.anthropic.receives': 'Текст вашего разговора с Тимо',
    'native.consent.proc.deepgram.purpose': 'Чтобы превратить речь в текст',
    'native.consent.proc.deepgram.receives': 'Ваш голос, пока включён микрофон',
    'native.consent.proc.elevenlabs.purpose': 'Чтобы озвучить этот текст голосом Тимо',
    'native.consent.proc.elevenlabs.receives': 'Текст, который Тимо собирается произнести',
    'native.consent.proc.google.purpose': 'Чтобы составлять ответы Тимо, когда работает Google',
    'native.consent.proc.google.receives': 'Текст вашего разговора с Тимо',
    'native.consent.proc.openai.purpose': 'Чтобы проверить литовскую грамматику',
    'native.consent.proc.openai.receives': 'Текст ответов Тимо на литовском языке',
    'native.consent.promise': 'Мы не продаём ваши данные и не используем их для рекламы. Вы можете отключить это в любой момент в настройках. Если отключить, Тимо не сможет ни слушать, ни отвечать, а всё остальное в приложении будет работать как прежде.',
    'native.consent.settings.agreedOn': 'Вы согласились',
    'native.consent.settings.confirmBody': 'Тимо перестанет слушать и отвечать. Всё остальное в приложении продолжит работать, и включить обратно можно в любой момент.',
    'native.consent.settings.confirmKeep': 'Оставить включённым',
    'native.consent.settings.confirmTitle': 'Выключить?',
    'native.consent.settings.confirmTurnOff': 'Выключить',
    'native.consent.settings.description': 'Позволяет Тимо отправлять речь и текст разговора компаниям из списка ниже, чтобы он мог слушать, отвечать и говорить.',
    'native.consent.settings.label': 'Передача данных ИИ-сервисам',
    'native.consent.settings.offNote': 'Пока это выключено, Тимо не может ни слушать, ни отвечать.',
    'native.consent.settings.section': 'Конфиденциальность',
    'native.consent.settings.whoGetsWhat': 'Кто и что получает',
    'native.consent.title': 'Прежде чем Тимо начнёт говорить',
    'native.install.alreadyInstalledBody': 'На этом устройстве вы уже пользуетесь приложением Timo, устанавливать ничего не нужно.',
    'native.install.alreadyInstalledTitle': 'Приложение уже установлено',
    'native.install.otherDevices': 'Хотите Timo и на другом устройстве? Войдите там в тот же аккаунт, и всё уже будет на месте.',
    'native.manage.appleBilled': 'Этой подпиской управляет Apple. Отменить её или сменить план можно в настройках подписок App Store.',
    'native.manage.cta': 'Управлять в App Store',
    'native.manage.failed': 'Не удалось открыть подписки App Store. Откройте «Настройки», нажмите своё имя и выберите «Подписки».',
    'native.mic.backgroundStopped': 'Прослушивание остановлено, потому что приложение ушло в фон. Нажмите, чтобы начать заново.',
    'native.mic.continueWithoutMic': 'Продолжить без микрофона',
    'native.mic.deniedBody': 'iPhone спрашивает только один раз. Откройте настройки и включите микрофон для Timo.',
    'native.mic.deniedTitle': 'Микрофон выключен',
    'native.mic.openSettings': 'Открыть настройки',
    'native.mic.primerAllow': 'Разрешить микрофон',
    'native.mic.primerBody': 'Чтобы Timo услышал, что сказал собеседник, и помог вам ответить.',
    'native.mic.primerNotNow': 'Не сейчас',
    'native.mic.primerPoint1': 'Голос используется только для того, чтобы превратить речь в текст.',
    'native.mic.primerPoint2': 'Запись идёт только во время реплики и никогда в фоне.',
    'native.mic.primerPoint3': 'Микрофон можно снова выключить в настройках.',
    'native.mic.primerTitle': 'Timo нужен ваш микрофон',
    'native.mic.unavailableBody': 'На этом устройстве нет микрофона, доступного Timo.',
    'native.mic.unavailableTitle': 'Микрофон не найден',
    'native.minors.affirmation': 'Нажимая «Принимаю», вы подтверждаете, что вы родитель или опекун либо что вам 16 лет или больше.',
    'native.minors.ageNote': 'В большинстве стран Европы согласие за тех, кому меньше 16, дают родители или опекуны. В Литве этот возраст составляет 14 лет, а в США он равен 13 годам.',
    'native.minors.askGrownUp': 'Попросите родителя или опекуна посмотреть это вместе с вами и нажать «Принимаю» за вас.',
    'native.minors.underAgeLink': 'Мне меньше 16',
    'native.personalVoice.allow': 'Разрешить личный голос',
    'native.personalVoice.denied': 'У Тимо нет разрешения использовать ваш личный голос. Включите «Разрешить приложениям запрашивать доступ»: Настройки, Универсальный доступ, Личный голос.',
    'native.personalVoice.description': 'Если вы записали личный голос на этом iPhone или iPad, Тимо может говорить им. Голос создаётся на устройстве, остаётся на нём и никуда не отправляется.',
    'native.personalVoice.languageUnavailable': 'Apple предлагает личный голос только на английском, испанском и китайском, поэтому на этом языке он пока говорить не может.',
    'native.personalVoice.none': 'На этом устройстве ещё не записан личный голос. Его можно создать: Настройки, Универсальный доступ, Личный голос.',
    'native.personalVoice.ready': 'Личный голос готов. Выберите его в списке голосов.',
    'native.personalVoice.speaking': 'Говорит вашим личным голосом',
    'native.personalVoice.title': 'Использовать личный голос',
    'native.personalVoice.unsupportedDevice': 'На этом устройстве нельзя создать личный голос. Нужен более новый iPhone или iPad.',
    'native.purchase.alreadyOwned': 'Этот план уже куплен. Нажмите «Восстановить покупку», чтобы вернуть доступ.',
    'native.purchase.failed': 'Не удалось завершить покупку. Попробуйте ещё раз или напишите нам, и мы поможем.',
    'native.purchase.network': 'Нет связи с App Store. Проверьте интернет и попробуйте снова.',
    'native.purchase.notAllowed': 'На этом устройстве покупки запрещены. Проверьте ограничения «Экранного времени» в настройках.',
    'native.purchase.pending': 'Покупка ожидает подтверждения. Как только её подтвердят, доступ откроется автоматически.',
    'native.purchase.signInFirst': 'Сначала войдите в аккаунт, чтобы подписка была привязана к нему.',
    'native.purchase.unavailable': 'App Store сейчас недоступен. Попробуйте через несколько минут.',
    'native.report.body': 'Спасибо, что сообщаете. Ответы Тимо составляет компьютер, поэтому он иногда ошибается. Напишите, что произошло, и это прочитает человек.',
    'native.report.cancel': 'Отмена',
    'native.report.done': 'Готово',
    'native.report.error': 'Не удалось отправить. Проверьте соединение и попробуйте ещё раз.',
    'native.report.noteLabel': 'Хотите что-то добавить? (необязательно)',
    'native.report.reason.language': 'Ответ был не на том языке',
    'native.report.reason.other': 'Что-то другое',
    'native.report.reason.unkind': 'Было грубо или обидно',
    'native.report.reason.unsafe': 'Было небезопасно для ребёнка',
    'native.report.reason.wrong': 'Ответ был неверный или запутанный',
    'native.report.safetyNote': 'Если кому-то прямо сейчас угрожает опасность, обратитесь в экстренные службы.',
    'native.report.send': 'Отправить жалобу',
    'native.report.sending': 'Отправляем...',
    'native.report.sentBody': 'Каждую жалобу читает человек. Если нужен ответ, напишите нам:',
    'native.report.sentTitle': 'Жалоба отправлена. Спасибо.',
    'native.report.stopConversation': 'Также завершить этот разговор',
    'native.report.title': 'Пожаловаться на этот ответ',
    'native.report.trigger': 'Пожаловаться на этот ответ',
    'native.restore.restored': 'Доступ восстановлен. С возвращением!',
    'native.speech.interrupted': 'Прослушивание остановилось из-за звонка или другого звука. Нажмите, чтобы начать снова.',
    'native.speech.languageNotSupported': 'Этот iPhone не распознаёт этот язык сам, поэтому Тимо слушает так же, как и раньше.',
    'native.speech.onDevice': 'Ваш голос остаётся на этом устройстве',
    'native.speech.permissionNeeded': 'Тимо нужны микрофон и распознавание речи, чтобы вас слышать. Их можно включить в настройках.',
    'native.voice.preview': 'Послушать этот голос',
    'native.voice.systemVoices': 'Голоса на этом устройстве',
    'native.voice.title': 'Голос Тимо',
    'pushToTalk.micBackgroundTitle': 'Прослушивание остановлено',
    'pushToTalk.micBlockedBody': 'Микрофон заблокирован, поэтому запись не велась. Разрешите доступ к микрофону или наберите текстом, что они сказали.',
    'pushToTalk.micBlockedTitle': 'Timo не слышит',
    'pushToTalk.micNotNowBody': 'Вы можете включить микрофон в любой момент. Пока наберите текстом, что они сказали.',
    'pushToTalk.micNotNowTitle': 'Микрофон выключен',
    'pushToTalk.micProblemBody': 'Прослушивание неожиданно прервалось, поэтому запись не велась. Попробуйте снова или наберите текстом, что они сказали.',
    'pushToTalk.micProblemTitle': 'Прослушивание остановлено',
    'pushToTalk.micUnavailableBody': 'На этом устройстве нет микрофона, доступного Timo. Вы можете набрать текстом, что они сказали.',
    'pushToTalk.micUnavailableTitle': 'Микрофон не найден',
    'pushToTalk.micUnsupportedBody': 'Здесь распознавание речи недоступно, поэтому запись не велась. Вы можете набрать текстом, что они сказали.',
    'pushToTalk.micUnsupportedTitle': 'Этот браузер не умеет слушать',
    'settings.microphone.checkDesc': 'Проверьте, слышит ли вас Timo, и исправьте, если нет',
    'settings.microphone.checkLabel': 'Проверить доступ к микрофону',
    'settings.microphone.denied': 'Микрофон заблокирован. Откройте настройки, чтобы разрешить его.',
    'settings.microphone.granted': 'Микрофон работает',
    'settings.microphone.title': 'Микрофон',
    'settings.microphone.unavailable': 'Микрофон на этом устройстве не найден',

    // --- merged from src/native/_i18n: WS-C, WS-F, PRIVACY ---
    // WS-C
    'chat.ariaGoBack': 'Назад',
    'chat.ariaInputMode': 'Способ ввода',
    'chat.ariaInputModeSpeak': 'Говорить',
    'chat.ariaInputModeType': 'Печатать',
    'chat.ariaPlayAloud': 'Прочитать вслух',
    'chat.ariaSendMessage': 'Отправить сообщение',
    'chat.ariaRecordMe': 'Записать мой голос',
    'chat.ariaRecordOther': 'Записать собеседника',
    'live.ariaFlipSpeakers': 'Поменять говорящих местами',
    'live.ariaClearConversation': 'Очистить разговор',
    'live.ariaCalibrationSettings': 'Настройки калибровки',
    'live.ariaClose': 'Закрыть',
    'live.whatShouldISay': 'Что мне сказать?',
    'live.manageScriptsHint': 'Сохранёнными текстами можно управлять в разделе Тексты.',
    'live.safetyTitle': 'Предупреждение о безопасности',
    'live.safetyBody': 'Этот разговор может быть небезопасным. Если вам угрожают, сразу уйдите.',
    'quickChoice.send': 'Отправить',
    'quickChoice.tellMeMorePlaceholder': 'Расскажи подробнее...',
    // WS-F
    'common.closeAria': 'Закрыть',
    'common.goBackAria': 'Назад',
    // PRIVACY
    'privacy.minors.heading': '5. Дети, несовершеннолетние и согласие родителей',
    'privacy.minors.s1.heading': '5.1 Для кого это приложение и кому принадлежит аккаунт',
    'privacy.minors.s1.p1': 'Time To Talk (приложение Timo) создано для детей с задержкой речи, для аутичных детей и взрослых и для всех, кому трудно говорить. Многие наши пользователи - дети.',
    'privacy.minors.s1.p2': 'Аккаунт принадлежит взрослому: родителю, опекуну, воспитателю, терапевту или учителю. Этот взрослый создаёт аккаунт, хранит данные для входа и оплачивает подписку. Ребёнок не регистрируется сам.',
    'privacy.minors.s1.p3': 'Но приложением пользуется именно ребёнок. Когда он им пользуется, приложение получает то, что он пишет, и, пока включён микрофон, то, что он говорит. Мы лучше скажем это прямо, чем будем утверждать, что никогда не слышим ребёнка.',
    'privacy.minors.s2.heading': '5.2 До какого возраста согласие должны дать родители или опекун',
    'privacy.minors.s2.intro': 'Если тот, кто пользуется приложением, младше возраста, указанного для вашей страны, до начала использования согласие должны дать родитель, опекун или воспитатель.',
    'privacy.minors.s2.col.where': 'Где вы находитесь',
    'privacy.minors.s2.col.age': 'Родитель или опекун должен дать согласие за тех, кому меньше',
    'privacy.minors.s2.col.rule': 'На каком правиле это основано',
    'privacy.minors.s2.lt.where': 'Литва',
    'privacy.minors.s2.lt.age': '14',
    'privacy.minors.s2.lt.rule': 'Статья 8 GDPR, возраст, установленный законом Литвы',
    'privacy.minors.s2.us.where': 'США',
    'privacy.minors.s2.us.age': '13',
    'privacy.minors.s2.us.rule': 'COPPA, Закон о защите конфиденциальности детей в интернете',
    'privacy.minors.s2.eu.where': 'Остальные страны ЕС и ЕЭЗ',
    'privacy.minors.s2.eu.age': '16, если ваша страна не установила более низкий возраст, который никогда не может быть меньше 13',
    'privacy.minors.s2.eu.rule': 'Статья 8 GDPR',
    'privacy.minors.s2.world.where': 'Все остальные страны',
    'privacy.minors.s2.world.age': '16',
    'privacy.minors.s2.world.rule': 'Наше собственное правило, которое мы применяем во всём мире',
    'privacy.minors.s2.p1': 'Литва - наша родная страна и основной рынок. Там этот возраст составляет 14 лет.',
    'privacy.minors.s2.p2': 'Прежде чем какой-либо разговор будет отправлен компаниям, перечисленным в пункте 5.4, приложение показывает экран, где названа каждая из них, и просит вашего согласия. Фраза над кнопкой «Принимаю» просит подтвердить, что вы родитель, опекун или воспитатель либо что вам 16 лет или больше. Если ребёнок нажмёт «Мне меньше 16», ничего плохого не произойдёт и никто его не отругает: приложение просто попросит позвать взрослого. Позже это согласие можно отозвать в настройках, в разделе «Конфиденциальность».',
    'privacy.minors.s2.p3': 'Мы никогда не спрашиваем дату рождения. Спросить означало бы собрать о ребёнке больше данных, а этот раздел как раз про обратное.',
    'privacy.minors.s3.heading': '5.3 Что мы собираем, когда приложением пользуется ребёнок',
    'privacy.minors.s3.intro': 'Три вещи:',
    'privacy.minors.s3.email': 'Адрес электронной почты, один раз, при регистрации. Это адрес взрослого владельца аккаунта. У ребёнка мы никогда не просим его собственный адрес.',
    'privacy.minors.s3.text': 'Текст разговора. То, что пишут или говорят Тимо, и то, что Тимо отвечает. Тренировочные разговоры сохраняются в аккаунте, чтобы их можно было открыть позже в разделе «История». Там каждый из них можно удалить.',
    'privacy.minors.s3.voice': 'Голос, только пока включён микрофон. Звук идёт с устройства напрямую в Deepgram, которая превращает его в текст. Мы не храним голосовые записи на своих серверах. Микрофон выключен, пока вы его не включите.',
    'privacy.minors.s3.p2': 'Мы не спрашиваем у ребёнка настоящее имя, домашний адрес, номер телефона, школу, фотографию, возраст или диагноз. Ничто в приложении их не требует. Если что-то из этого написано в разговоре, оно сохраняется вместе с разговором, и вы можете удалить его в разделе «История».',
    'privacy.minors.s4.heading': '5.4 Компании, которые получают эти данные',
    'privacy.minors.s4.intro': 'Тимо не может ни слушать, ни отвечать, ни говорить без помощи внешних компаний. Эти пять видят содержание разговора. Тот же список приложение показывает вам перед тем, как вы соглашаетесь.',
    'privacy.minors.s4.col.company': 'Компания',
    'privacy.minors.s4.col.receives': 'Что получает',
    'privacy.minors.s4.col.purpose': 'Зачем это нужно',
    'privacy.minors.s4.anthropic.receives': 'Текст вашего разговора с Тимо',
    'privacy.minors.s4.anthropic.purpose': 'Чтобы составлять ответы Тимо',
    'privacy.minors.s4.google.receives': 'Текст вашего разговора с Тимо',
    'privacy.minors.s4.google.purpose': 'Чтобы составлять ответы Тимо, когда работает Google',
    'privacy.minors.s4.openai.receives': 'Текст ответов Тимо на литовском языке',
    'privacy.minors.s4.openai.purpose': 'Чтобы проверить литовскую грамматику',
    'privacy.minors.s4.deepgram.receives': 'Ваш голос, пока включён микрофон',
    'privacy.minors.s4.deepgram.purpose': 'Чтобы превратить речь в текст',
    'privacy.minors.s4.elevenlabs.receives': 'Текст, который Тимо собирается произнести',
    'privacy.minors.s4.elevenlabs.purpose': 'Чтобы озвучить этот текст голосом Тимо',
    'privacy.minors.s4.note': 'Google получает текст разговора только тогда, когда Google является активным поставщиком модели. OpenAI используется только для литовского языка, чтобы исправить грамматику уже написанного ответа Тимо. Deepgram в нескольких языках служит также запасным голосом, и тогда она получает текст, который Тимо собирается произнести.',
    'privacy.minors.s4.others': 'Остальные компании, с которыми мы работаем и которые перечислены в разделе 7, отвечают за аккаунт, оплату, письма и аналитику, а не за сам разговор.',
    'privacy.minors.s4.noPermission': 'Ни одной из этих компаний не разрешено использовать данные ребёнка для собственной рекламы или для обучения своих моделей сверх того, что указано в их опубликованных политиках.',
    'privacy.minors.s5.heading': '5.5 Чего мы никогда не делаем с данными ребёнка',
    'privacy.minors.s5.item1': 'Мы никогда их не продаём. Никому, ни в каком виде и ни за какие деньги.',
    'privacy.minors.s5.item2': 'Мы никогда не используем их для рекламы и никогда не создаём рекламные профили детей.',
    'privacy.minors.s5.item3': 'Мы никогда не используем их для обучения моделей ИИ, ни своих, ни чужих.',
    'privacy.minors.s5.item4': 'Мы никогда не используем их для составления поведенческих, психологических, клинических или образовательных профилей ребёнка.',
    'privacy.minors.s5.item5': 'Мы никогда их не публикуем и никогда не показываем другим пользователям.',
    'privacy.minors.s5.pixel': 'На нашем сайте и на страницах приложения работает тег измерения рекламы Meta, описанный в разделе 12. Он считает просмотры страниц и регистрации, чтобы мы понимали, какая реклама работает. Он никогда не получает содержание разговоров, голос или то, что пишет ребёнок.',
    'privacy.minors.s6.heading': '5.6 О чём может попросить родитель или опекун',
    'privacy.minors.s6.intro': 'В любой момент вы можете:',
    'privacy.minors.s6.see': 'Посмотреть данные. Запросить копию всего, что мы храним об аккаунте.',
    'privacy.minors.s6.correct': 'Исправить данные. Попросить нас исправить то, что неверно.',
    'privacy.minors.s6.delete': 'Удалить данные. Удалять разговоры по одному в разделе «История» или удалить весь аккаунт.',
    'privacy.minors.s6.withdraw': 'Отозвать согласие. Отозвать согласие на ИИ в настройках, в разделе «Конфиденциальность». Тогда Тимо перестанет слушать и отвечать. Картинки, сохранённые сценарии и все настройки продолжат работать. Отзыв не отменяет обработку, которая уже произошла законно.',
    'privacy.minors.s6.deleteHeading': 'Удаление аккаунта. В настройках есть кнопка «Удалить аккаунт». Когда вы её нажимаете:',
    'privacy.minors.s6.step1': 'Сначала мы отменяем все ваши действующие подписки в Stripe, чтобы с вас больше не списывали деньги.',
    'privacy.minors.s6.step2': 'Если хотя бы одна отмена не удалась, мы останавливаемся и аккаунт не удаляем. Вы увидите сообщение об ошибке с просьбой связаться с нами, и мы завершим всё вручную. Лучше оставить вам доступ, чем оставить вас платить за аккаунт, в который вы уже не войдёте.',
    'privacy.minors.s6.step3': 'Если отмена прошла успешно, мы удаляем ваш вход и запись аккаунта из системы аутентификации: адрес электронной почты, пароль, а также хранящиеся вместе с ними настройки и записи о согласиях.',
    'privacy.minors.s6.step4': 'Мы отмечаем запись о подписке как отменённую и сохраняем небольшую запись об удалении: адрес электронной почты, дату и номер отменённой подписки. Она нужна, чтобы мы могли показать, когда аккаунт был удалён и что списания прекратились.',
    'privacy.minors.s6.step5': 'Записи о платежах и счетах остаются в Stripe столько, сколько требует литовский закон о бухгалтерском учёте, то есть десять лет. См. раздел 9. Раньше удалить их мы не можем.',
    'privacy.minors.s6.after': 'Если нужно удалить что-то ещё, чего кнопка не затрагивает, напишите нам, и мы сделаем это вручную.',
    'privacy.minors.s7.heading': '5.7 Как связаться с нами по поводу данных ребёнка',
    'privacy.minors.s7.p1': 'Пишите на info@timetotalk.lt. В теме письма укажите «Запрос о данных ребёнка» и сообщите адрес электронной почты аккаунта.',
    'privacy.minors.s7.p2': 'Мы отвечаем на каждый запрос. Мы подтвердим получение вашего запроса в течение 5 рабочих дней и выполним его в течение 30 дней, как требует GDPR. Если запрос сложный и нам нужно больше времени, мы сообщим об этом до истечения 30 дней и объясним почему. Сначала нам, возможно, придётся убедиться, что вы владелец аккаунта, ведь передать данные ребёнка не тому человеку было бы куда худшей ошибкой, чем медленный ответ.',
    'privacy.minors.s7.p3': 'Вы также можете подать жалобу в Государственную инспекцию по защите данных Литвы (Valstybine duomenu apsaugos inspekcija) на vdai.lrv.lt или ada@ada.lt либо в орган по защите данных вашей страны ЕЭЗ.',
    'privacy.minors.s8.heading': '5.8 Как долго мы храним данные ребёнка',
    'privacy.minors.s8.intro': 'В разделе 9 указаны сроки хранения для каждой категории данных. Коротко:',
    'privacy.minors.s8.voice': 'Голос: мы его вообще не храним.',
    'privacy.minors.s8.conversations': 'Разговоры: хранятся в аккаунте, пока вы не удалите их в разделе «История» или не удалите аккаунт.',
    'privacy.minors.s8.account': 'Данные аккаунта, включая адрес электронной почты: как указано в разделе 9.',
    'privacy.minors.s8.p2': 'Если вы считаете, что ребёнок зарегистрировался без ведома родителя или опекуна, напишите на info@timetotalk.lt. Проверив запрос, мы незамедлительно удалим аккаунт и его данные.',
  },
  lt: {
    // daily-words
    "dailyWords.row": "Mokomi žodžiai",
    "dailyWords.rowHint": "Įrašykite žodžius, kuriuos vaikas mokosi kasdien",
    "dailyWords.title": "Mokomi žodžiai",
    "dailyWords.intro": "Įrašykite žodžius, kuriuos vaikas dabar mokosi. Timo kasdien parodys vieną ir paprašys jį pasakyti.",
    "dailyWords.close": "Uždaryti",
    "dailyWords.modeTitle": "Kurie žodžiai rodomi",
    "dailyWords.modeMine": "Tik mano žodžiai",
    "dailyWords.modeMineHint": "Kasdien vienas jūsų žodis, sąrašo tvarka.",
    "dailyWords.modeMix": "Mano ir Timo žodžiai",
    "dailyWords.modeMixHint": "Vieną dieną jūsų žodis, kitą dieną Timo žodis.",
    "dailyWords.today": "Šiandienos žodis: {word}",
    "dailyWords.todayBadge": "Šiandien",
    "dailyWords.add": "Pridėti žodį",
    "dailyWords.inputLabel": "Žodis",
    "dailyWords.placeholder": "Pvz., obuolys",
    "dailyWords.pictureTitle": "Paveikslėlis (nebūtina)",
    "dailyWords.noPicture": "Be paveikslėlio",
    "dailyWords.photo": "Nuotrauka",
    "dailyWords.removePhoto": "Pašalinti nuotrauką",
    "dailyWords.listTitle": "Jūsų žodžiai",
    "dailyWords.empty": "Žodžių dar nėra. Kol sąrašas tuščias, Timo rodo savo žodžius.",
    "dailyWords.edit": "Keisti",
    "dailyWords.save": "Išsaugoti",
    "dailyWords.cancel": "Atšaukti",
    "dailyWords.delete": "Ištrinti",
    "dailyWords.deleteConfirm": "Ištrinti žodį „{word}“?",
    "dailyWords.listen": "Paklausyti",
    "dailyWords.moveUp": "Aukštyn",
    "dailyWords.moveDown": "Žemyn",
    "dailyWords.saved": "Išsaugota",
    "dailyWords.deviceOnly": "Žodžiai išsaugomi tik šiame įrenginyje. Kitame telefone ar planšetėje jų nebus.",
    "dailyWords.errEmpty": "Įrašykite žodį.",
    "dailyWords.errDuplicate": "Šis žodis jau yra sąraše.",
    "dailyWords.errFull": "Sąraše jau {max} žodžių. Ištrinkite vieną, kad galėtumėte pridėti naują.",
    "dailyWords.errSave": "Nepavyko išsaugoti. Įrenginio atmintis gali būti pilna. Pabandykite be nuotraukos.",
    "dailyWords.errImage": "Šios nuotraukos nepavyko atidaryti. Pasirinkite kitą.",
    // end daily-words
    'house.room.living': 'Svetainė',
    'house.room.talk': 'Telefono kambarys',
    'house.room.play': 'Žaidimų kambarys',
    'house.room.study': 'Mokymosi kampelis',
    'house.hotspot.couch': 'Pašokinėti ant sofos',
    'house.hotspot.window': 'Pažiūrėti pro langą',
    'house.hotspot.timo': 'Žaisti su Timu',
    'house.hotspot.pet': 'Žaisti su Timu',
    'house.hotspot.phone': 'Pasikalbėti telefonu',
    'house.hotspot.shelf': 'Atversti paveikslėlių korteles',
    'house.hotspot.toybox': 'Atidaryti žaislų dėžę',
    'house.hotspot.desk': 'Dienos žodis',
    'house.parent.settings': 'Suaugusiems',
    'house.parent.button': 'Suaugusiems',
    'house.nav.rooms': 'Kambariai',
    'house.nav.prev': 'Ankstesnis kambarys',
    'house.nav.next': 'Kitas kambarys',
    'house.badge.stars': 'Uždirbtos žvaigždutės',
    'house.hotspot.beanbag': 'Sėdmaišis',
    'house.hotspot.bookshelf': 'Knygų lentyna',
    'house.hotspot.curtain': 'Užuolaida',
    'house.hotspot.easel': 'Molbertas',
    'house.hotspot.lamp': 'Lempa',
    'house.hotspot.lights': 'Lemputės',
    'house.hotspot.pinboard': 'Skelbimų lenta',
    'house.hotspot.plant': 'Augalas',
    'house.hotspot.playwindow': 'Langas',
    'house.hotspot.rainbowrug': 'Vaivorykštės kilimėlis',
    'house.hotspot.rug': 'Kilimėlis',
    'house.hotspot.stool': 'Taburetė',
    'house.map.title': 'Namo žemėlapis',
    'house.map.close': 'Uždaryti žemėlapį',
    'house.map.here': 'Tu esi čia',
    'house.map.go': 'Eiti',
    'house.map.activity.talk': 'Kalbėti',
    'house.map.activity.cards': 'Kortelės',
    'house.map.activity.word': 'Žodis',
    'house.a11y.roomOf': '{n} kambarys iš {total}',
      // In-app browser overlay (Facebook / Instagram detection)
      'iab.title': 'Atidarykite naršyklėje',
      'iab.body': 'Prisijungimas neveiks {source} naršyklėje.',
      'iab.openChrome': 'Atidaryti Chrome',
      'iab.openSafari': 'Atidaryti Safari',
      'iab.openBrowser': 'Atidaryti naršyklėje',
      'iab.copyLink': 'Kopijuoti nuorodą',
      'iab.copied': 'Nukopijuota',
      'iab.hintIos': 'Arba meniu ⋯ → Atidaryti Safari',
      'iab.hintAndroid': 'Arba meniu ⋮ → Atidaryti naršyklėje',
      'iab.hintOther': 'Arba įklijuokite nuorodą į naršyklę',
      'iab.iosCopyAndOpen': 'Kopijuoti nuorodą',
      'iab.iosLinkCopied': 'Nuoroda nukopijuota. Atidarykite Safari.',
      'iab.iosStep1': 'Spauskite mygtuką, kad nukopijuotumėte nuorodą.',
      'iab.iosStep2': 'Atidarykite Safari (braukite aukštyn arba per Home).',
      'iab.iosStep3': 'Įklijuokite nuorodą į adreso juostą.',
      'iab.continueAnyway': 'Likti čia',
      'obp.successTitle': 'Viskas paruošta!',
      'obp.successBody': 'Dabar esate naršyklėje. Čia viskas veikia puikiai, įskaitant prisijungimą.',
      'obp.successCta': 'Tęsti',
      // Streak Popup
      'streak.popupTitle': 'DIENOS POKALBIO SERIJA PADIDĖJO!',
      'streak.popupDayStreak': 'DIENŲ SERIJA',
      'streak.popupGreatStart': 'PUIKI PRADŽIA!',
      'streak.popupOnFire': 'TU DEGI! 🔥',
      'profile.viewStreakDetails': 'Žiūrėti seriją',
    // Newsletter landing page
    'newsletter.heroTitle': 'Time To Talk',
    'newsletter.heroSubtitle': 'DI pagalbininkas realaus pokalbio metu',
    'newsletter.description': 'Prisijunkite prie mūsų naujienlaiškio, kad būtumėte pirmieji sužinoję apie programėlės paleidimą. Gaukite ankstyvą prieigą, išskirtinius atnaujinimus ir naudingus bendravimo patarimus.',
    'newsletter.emailPlaceholder': 'Įveskite savo el. pašto adresą',
    'newsletter.subscribe': 'Prenumeruoti',
    'newsletter.subscribing': 'Prenumeruojama...',
    'newsletter.success': 'Ačiū už prenumeratą!',
    'newsletter.successMessage': 'Patikrinkite el. paštą, kad patvirtintumėte prenumeratą.',
    'newsletter.error': 'Kažkas nutiko. Bandykite dar kartą.',
    'newsletter.emailInvalid': 'Įveskite teisingą el. pašto adresą',
    'newsletter.emailRequired': 'El. paštas yra privalomas',
    'newsletter.features.title': 'Ko Tikėtis',
    'newsletter.features.earlyAccess': 'Ankstyva Prieiga',
    'newsletter.features.earlyAccessDesc': 'Būkite tarp pirmųjų, kurie išbandys mūsų programėlę',
    'newsletter.features.updates': 'Išskirtiniai Atnaujinimai',
    'newsletter.features.updatesDesc': 'Gaukite naujausias naujienas ir funkcijas',
    'newsletter.features.tips': 'Bendravimo Patarimai',
    'newsletter.features.tipsDesc': 'Naudingi vadovai ir strategijos',
    'newsletter.requestAccess': 'Prašyti Prieigos',
    'newsletter.requestAccessTitle': 'Prašyti Svetainės Prieigos',
    'newsletter.requestAccessSuccess': 'Prašymas pateiktas! Peržiūrėsime ir susisieksime.',
    'newsletter.name': 'Vardas',
    'newsletter.namePlaceholder': 'Jūsų vardas (neprivaloma)',
    'newsletter.reason': 'Priežastis',
    'newsletter.reasonPlaceholder': 'Kodėl jums reikia prieigos? (neprivaloma)',
    'newsletter.submitRequest': 'Pateikti Prašymą',
    'newsletter.submitting': 'Pateikiama...',
    'newsletter.beTheFirst': 'Būkite Pirmieji',
    'newsletter.beTheFirstDesc': 'Gaukite ankstyvą prieigą ir bendravimo patarimus tiesiog į savo pašto dėžutę.',
    'newsletter.emailPlaceholderExample': 'vardas@pavyzdys.lt',
    'newsletter.gettingAccess': 'Gaunama Prieiga...',
    'newsletter.getEarlyAccess': 'Gauti Ankstyvą Prieigą',
    'newsletter.noSpam': 'Jokio šlamšto. Atsisakykite bet kada.',
    'newsletter.thankYouJoining': 'Ačiū, kad prisijungėte! Informuosime apie naujienas.',
    'newsletter.learnMoreBelow': 'Sužinokite daugiau žemiau',
    'newsletter.downloadApp': 'Atsisiųsti programėlę',
    'newsletter.whyBuilding': 'Kodėl Mes Tai Kuriame',
    'newsletter.whyBuildingDesc': 'Socialinės situacijos juda greitai. Tinkami žodžiai neateina, kai jų reikia. Mes tai kuriame, nes bendravimas neturėtų atrodyti neįmanomas.',
    'newsletter.whoWeHelp': 'Kam Padedame',
    'newsletter.whoWeHelpDesc': 'ASS turintiems, introvertams, bijantiems bendrauti, socialinį nerimą patiriantiems, nekalbantiems ir visiems, kas nori bandyti kalbėti ir reikia pagalbos.',
    'newsletter.whatWeDo': 'Ką Darome',
    'newsletter.whatWeDoDesc': 'DI programėlė, kuri padeda suprasti pokalbius ir atsakyti. Švelniai, aiškiai, be spaudimo. Viskas pateikta kaip žaidimas, kad praktika būtų linksma.',
    'newsletter.nonVerbalSupport': 'Pagalba Nekalbantiems',
    'newsletter.nonVerbalSupportDesc': 'Padedame nekalbantiems žmonėms ir nekalbančių vaikų tėvams bendrauti. Mūsų „Kalbėk“ režimas suteikia įrankius komunikuoti be kalbėjimo.',
    'newsletter.safe': 'Saugu',
    'newsletter.simple': 'Paprasta',
    'newsletter.supportive': 'Palaikanti',
    'newsletter.reportBug': 'Pranešti Apie Klaidą',

    // Common
    'common.startVoice': 'Pradėti balso įvestį',
    'common.stopRecording': 'Stabdyti įrašymą',
    'common.close': 'Uždaryti',
    'common.help': 'Pagalba',
    'common.back': 'Grįžti',

    // Practice Chat
    'practice.pageTitle': 'Praktikuoti Pokalbį',
    'practice.greeting': 'Sveiki! Pasiruošę kalbėtis?',
    'practice.thinking': 'Galvoju...',
    'practice.fallback': 'Supratau!',
    'practice.end': 'Baigti',
    'practice.me': 'Aš',
    'practice.other': 'Kitas',
    'practice.placeholder': 'Parašykite kažką...',
    'practice.switchText': 'Perjungti į tekstą',
    'practice.switchVoice': 'Perjungti į balsą',
    'practice.errorTitle': 'Klaida',
    'practice.errorDesc': 'Nepavyko gauti atsakymo',
    
    // Home page
    'home.goodMorning': 'Labas rytas',
    'home.goodAfternoon': 'Laba diena',
    'home.goodEvening': 'Labas vakaras',
    'home.needHelpTalking': 'Reikia pagalbos kalbėti?',
    'home.suggestWhatToSay': 'Parodysiu, ką galėtum pasakyti',
    'home.quickActions': 'Greiti Veiksmai',
    'home.nonVerbal': 'Kalbėk',
    'home.history': 'Istorija',
    'home.scripts': 'Frazės',
    'home.startTalking': 'Pradėti Pokalbį',
    'home.reportBug': 'Pranešti Apie Klaidą',
    'home.underConstruction': 'Kuriama',
    'home.stillBuilding': 'Dar kuriama! Ne viskas gali veikti.',
    'home.dontShowAgain': 'Nebekartoti',
    'home.gotIt': 'Supratau!',
    'home.howToUse': 'Kaip naudotis',
    'home.settings': 'Nustatymai',
    'home.talkModeBeta': 'Beta',
    'home.talkModeUnderDevelopment': 'Šiuo metu kuriama',
    'home.talk': 'Kalbėti',
    'home.show': 'Rodyti',
    'home.breathing': 'Kvėpavimas',
    'home.greeting.morning': 'Labas rytas!',
    'home.greeting.afternoon': 'Laba diena!',
    'home.greeting.evening': 'Labas vakaras!',
    'home.timoHomeHint': 'Bakstelėk ir užeik pas mane!',
    'timo.home.title': 'Timo namai',
    'timo.home.back': 'Atgal',
    'timo.home.close': 'Uždaryti',
    // teacher-first-run: the help screen and its door on the landing screen.
    "timo.home.helpButton": "Kaip naudotis",
    "help.metaTitle": "Kaip naudotis Timo",
    "help.title": "Kaip naudotis Timo",
    "help.intro": "Penki trumpi žingsniai. Perskaitysite per minutę.",
    "help.back": "Atgal",
    "help.langLabel": "Kalba",
    "help.teacher.title": "Mokytojams ir specialistams",
    "help.teacher.body": "Programėlėje rašoma „jūsų vaikas“. Jei esate mokytojas, tai jūsų mokinys. Viskas veikia taip pat, net jei registravotės kaip tėvai.",
    // school-use
    "help.school.title": "Mokykloje, su mokiniu",
    "help.school.point1": "Mokyklos planšetėje naudokite vieną paskyrą. Prisijunkite vieną kartą, ir ji liks prisijungusi.",
    "help.school.point2": "Paduokite planšetę vaikui, kai atidarytas Timo ekranas. Vaikas kalba su Timo arba spaudžia korteles.",
    "help.school.point3": "Viskas, kas skirta suaugusiems, yra už mygtuko „Suaugusiems“ viršuje: nustatymai, pažanga ir prenumerata.",
    "help.school.point4": "Vaiko vardą įrašykite čia: „Suaugusiems“ > „Vaiko pažanga ir vardas“. Tada kortelės ir Timo naudos vaiko vardą, o ne jūsų.",
    "help.school.point5": "Turite kodą iš mokyklos ar renginio? Spauskite „Turiu kodą“ pradžios puslapyje, prisijungimo ekrane, apmokėjimo puslapyje arba nustatymuose.",
    "help.step1.title": "Pradėkite Timo kambaryje",
    "help.step1.body": "Prisijungę visada atsiduriate čia. Tai pradžios ekranas, iš jo viskas pasiekiama vienu paspaudimu.",
    "help.step1.alt": "Timo kambarys telefone",
    "help.step2.title": "Paspauskite Timo ir kalbėkite",
    "help.step2.body": "Paspauskite Timo arba mygtuką „Kalbėti“ ir leiskite naudoti mikrofoną. Vaikas kalba, Timo atsako balsu.",
    "help.step2.alt": "Mygtukas „Kalbėti“ ekrano apačioje",
    "help.step3.title": "Kortelės, kai kalbėti sunku",
    "help.step3.body": "Mygtukas „Kortelės“ atidaro paveikslėlius. Vaikas paspaudžia kortelę, o programėlė ją pasako balsu. Mikrofono nereikia, todėl kortelės veikia ir tada, kai mikrofonas neveikia.",
    "help.step3.alt": "Paveikslėlių kortelės",
    "help.step4.title": "Dienos žodis",
    "help.step4.body": "Kasdien Timo parenka vieną naują žodį. Paspauskite žodžio kortelę ir pasakykite jį kartu su vaiku.",
    "help.step4.alt": "Dienos žodžio kortelė",
    "help.step5.title": "Suaugusiems",
    "help.step5.body": "Viršuje esantis mygtukas „Suaugusiems“ atidaro nustatymus: kalbą, balsą ir prenumeratą. Šalia jo visada rasite šį vadovą.",
    "help.step5.alt": "Mygtukai „Kaip naudotis“ ir „Suaugusiems“ ekrano viršuje",
    "help.cta": "Eiti pas Timo",
    "help.contact": "Klausimai? Rašykite info@timetotalk.lt",
    // The paywall a teacher meets: this label had no key anywhere, so every language showed "per day".
    "pricing.perDayLabel": "per dieną",
    // Settings rows for what the hidden homes used to link: progress, profile, breathing.
    "settings.grownUps.title": "Suaugusiems",
    "settings.grownUps.progress": "Vaiko pažanga ir vardas",
    "settings.grownUps.progressHint": "Žodžiai, serijos ir vardas, kurį sako Timo",
    "settings.grownUps.profile": "Profilis",
    "settings.grownUps.breathing": "Kvėpavimo pratimas",
    "settings.grownUps.breathingHint": "Ramus kvėpavimas kartu su vaiku",
    // Promo codes (MOKOMES and the rest): the landing confirmation and the banner on /timo.
    "promoGrant.accepted": "Kodas priimtas: {days} nemokamai. Prisijunkite, kad aktyvuotumėte.",
    "promoGrant.acceptedUnlimited": "Kodas priimtas: neribota nemokama prieiga. Prisijunkite, kad aktyvuotumėte.",
    "promoGrant.continue": "Tęsti",
    "promoGrant.day.one": "diena",
    "promoGrant.day.few": "dienos",
    "promoGrant.day.many": "dienos",
    "promoGrant.day.other": "dienų",
    "promoGrant.banner": "Jums suteikta {days} nemokama prieiga iki {date}.",
    "promoGrant.bannerUnlimited": "Jums suteikta neribota nemokama prieiga.",
    "promoGrant.alreadyUsed": "Kodas {code} jau buvo panaudotas, todėl antrą kartą jo aktyvuoti nepavyko.",
    "promoGrant.close": "Uždaryti",
    // promo-codes-2: "I have a code" for signed-in people (/pricing, Settings) and the entry links.
    "promoCodes2.open": "Turiu kodą",
    "promoCodes2.label": "Įveskite kodą",
    "promoCodes2.submit": "Aktyvuoti",
    "promoCodes2.checking": "Tikrinama...",
    "promoCodes2.success": "Kodas priimtas: {days} nemokamai, iki {date}.",
    "promoCodes2.successUnlimited": "Kodas priimtas: neribota nemokama prieiga.",
    "promoCodes2.alreadyActive": "Jūsų prieiga jau aktyvi, kodo nereikia.",
    "promoCodes2.err.empty": "Pirmiausia įveskite kodą.",
    "promoCodes2.err.invalid": "Tokio kodo nėra. Patikrinkite ir bandykite dar kartą.",
    "promoCodes2.err.usedOnAccount": "Šis kodas jau panaudotas jūsų paskyroje.",
    "promoCodes2.err.usedOnNetwork": "Šis kodas jau panaudotas iš šio tinklo. Parašykite info@timetotalk.lt ir padėsime.",
    "promoCodes2.err.fullyClaimed": "Šio kodo vietos jau užimtos.",
    "promoCodes2.err.network": "Nepavyko susisiekti. Patikrinkite internetą ir bandykite dar kartą.",
    "promoCodes2.err.error": "Nepavyko aktyvuoti kodo. Bandykite dar kartą.",
    'timo.home.dressTitle': 'Aprenk Timo',
    'timo.home.foodTitle': 'Ko Timo nori?',
    'timo.home.action.feed': 'Maitinti',
    'timo.home.action.drink': 'Gerti',
    'timo.home.action.sleep': 'Miegoti',
    'timo.home.action.walk': 'Vaikščioti',
    'timo.home.action.potty': 'Tualetas',
    'timo.home.action.cheer': 'Linksmintis',
    'timo.home.action.dress': 'Aprengti',
    'timo.home.sleep.notNight': 'Timo dar nenori miego',
    'timo.home.outfit.default': 'Įprastas',
    'timo.home.outfit.beanie': 'Kepurė',
    'timo.home.outfit.panama': 'Panama',
    'timo.home.outfit.cool': 'Akiniai',
    'timo.home.outfit.ai': 'Ateities Timo',
    'timo.home.outfit.yoga': 'Jogos Timo',
    'timo.home.food.apple': 'Obuolys',
    'timo.home.food.banana': 'Bananas',
    'timo.home.food.berries': 'Uogos',
    'timo.home.food.bread': 'Duona',
    'timo.home.food.fish': 'Žuvis',
    'timo.home.food.acorn': 'Gilė',
    'timo.home.food.cheese': 'Sūris',
    'timo.home.food.cookie': 'Sausainis',
    'timo.talk.tapHint': 'Paliesk mane, pasikalbėkim!',
    'timo.talk.greeting': 'Labas! Aš Timo. Apie ką norėtum pasikalbėti?',
    'timo.talk.tapToTalk': 'Paliesk ir kalbėk',
    'timo.talk.listening': 'Aš klausau',
    'timo.talk.tapWhenDone': 'Paliesk, kai baigsi',
    'timo.talk.thinking': 'Timo galvoja',
    'timo.talk.speaking': 'Timo kalba',
    'timo.talk.emptyReprompt': 'Aš klausau! Papasakok man ką nors.',
    'timo.talk.llmErrorReply': 'Man labai patinka su tavimi kalbėtis! Koks tavo mėgstamiausias gyvūnas?',
    'timo.talk.micDenied': 'Timo reikia tavo mikrofono',
    'timo.talk.micDeniedHelp': 'Paprašyk suaugusiojo leisti mikrofoną naršyklės nustatymuose, tada bandyk dar kartą.',
    // mic-school-devices
    'mic.fail.blocked.title': 'Mikrofonas užblokuotas',
    'mic.fail.blocked.body': 'Timo negirdi, nes šiai naršyklei neleista naudoti mikrofono. Leiskite jį ir paspauskite „Bandyti dar kartą“.',
    'mic.fail.blocked.again': 'Anksčiau paspaudėte „Blokuoti“? Naršyklė pati nebeklaus. Pakeiskite tai nustatymuose ir perkraukite puslapį.',
    'mic.fail.steps.ios': 'iPad ar iPhone: adreso juostoje paspauskite aA, tada „Svetainės nustatymai“, tada „Mikrofonas“: „Leisti“. Arba atidarykite „Nustatymai“, „Safari“, „Mikrofonas“ ir pasirinkite „Leisti“.',
    'mic.fail.steps.chromebook': 'Chromebook: spustelėkite piktogramą kairėje nuo adreso, įjunkite mikrofoną ir perkraukite puslapį. Jei jungiklis pilkas, mikrofoną užblokavo mokykla. Kreipkitės į IT administratorių.',
    'mic.fail.steps.android': 'Android: paspauskite piktogramą kairėje nuo adreso, tada „Leidimai“, tada „Mikrofonas“: „Leisti“. Perkraukite puslapį.',
    'mic.fail.steps.desktop': 'Kompiuteris: spustelėkite piktogramą kairėje nuo adreso, mikrofonui pasirinkite „Leisti“ ir perkraukite puslapį. Jei nepadeda, patikrinkite kompiuterio privatumo nustatymus.',
    'mic.fail.steps.native': 'Programėlėje Timo: atidarykite telefono „Nustatymai“, tada „Timo“, ir įjunkite „Mikrofonas“. Grįžkite ir paspauskite „Bandyti dar kartą“.',
    'mic.fail.no_device.title': 'Mikrofonas nerastas',
    'mic.fail.no_device.body': 'Šiame įrenginyje nėra veikiančio mikrofono. Prijunkite mikrofoną ar ausines su mikrofonu ir paspauskite „Bandyti dar kartą“.',
    'mic.fail.in_use.title': 'Mikrofonas užimtas',
    'mic.fail.in_use.body': 'Mikrofoną naudoja kita programa ar skirtukas. Uždarykite ją, ir vaizdo skambučius, tada paspauskite „Bandyti dar kartą“.',
    'mic.fail.insecure_context.title': 'Per šią nuorodą mikrofonas neveikia',
    'mic.fail.insecure_context.body': 'Puslapis atidarytas nesaugiu adresu, todėl naršyklė slepia mikrofoną. Atidarykite adresą, kuris prasideda https://.',
    'mic.fail.unsupported.title': 'Ši naršyklė negali naudoti mikrofono',
    'mic.fail.unsupported.body': 'Norėdami kalbėtis, atidarykite Timo naršyklėje Chrome arba Safari. Kol kas galite naudoti korteles.',
    'mic.fail.in_app_browser.title': 'Atidarykite Timo naršyklėje',
    'mic.fail.in_app_browser.body': 'Instagram, Facebook ir panašios programėlės nuorodas atidaro savo lange, o jame mikrofonas neveikia. Atidarykite šį puslapį naršyklėje Chrome arba Safari.',
    'mic.fail.inapp.ios': 'Paspauskite tris taškus (...) viršuje ir pasirinkite atidaryti naršyklėje.',
    'mic.fail.inapp.android': 'Paspauskite tris taškus kampe ir pasirinkite atidaryti naršyklėje Chrome.',
    'mic.fail.offline.title': 'Nėra interneto',
    'mic.fail.offline.body': 'Kad Timo girdėtų, reikia interneto. Prisijunkite prie Wi-Fi ar mobiliojo interneto ir paspauskite „Bandyti dar kartą“.',
    'mic.fail.stt_unreachable.title': 'Timo nepasiekia klausymo paslaugos',
    'mic.fail.stt_unreachable.body': 'Mikrofonas veikia, bet tinklas blokuoja kalbos atpažinimo paslaugą. Taip dažnai būna mokyklos Wi-Fi tinkle. Bandykite dar kartą arba paprašykite IT administratoriaus leisti api.deepgram.com ir time-to-talk.onrender.com.',
    'mic.fail.stt_service_error.title': 'Klausymo paslauga šiuo metu sutrikusi',
    'mic.fail.stt_service_error.body': 'Mikrofonas ir internetas veikia, bet kalbos atpažinimo paslauga atsakė klaida. Palaukite minutę ir paspauskite „Bandyti dar kartą“.',
    'mic.fail.signed_out.title': 'Prisijunkite iš naujo',
    'mic.fail.signed_out.body': 'Jūsų prisijungimas baigėsi, todėl Timo negali klausytis. Prisijunkite iš naujo ir paspauskite „Bandyti dar kartą“.',
    'mic.fail.unknown.title': 'Timo dabar negirdi',
    'mic.fail.unknown.body': 'Kažkas sustabdė mikrofoną. Paspauskite „Bandyti dar kartą“. Jei tai kartojasi, perkraukite puslapį.',
    'mic.fail.retry': 'Bandyti dar kartą',
    'mic.fail.tiles': 'Naudoti korteles',
    'mic.fail.openBrowser': 'Atidaryti naršyklėje',
    'mic.fail.signIn': 'Prisijungti',
    'timo.talk.exit': 'Baigta',
    'timo.word.title': 'Dienos žodis',
    'timo.word.sayIt': 'Pasakyk!',
    'timo.word.listening': 'Aš klausau',
    'timo.word.hearAgain': 'Paklausyti dar kartą',
    'timo.word.tryAgain': 'Pasakykim kartu?',
    'timo.word.great': 'Šaunuolis!',
    'timo.word.days': 'dienų iš eilės',
    'timo.word.open': 'Dienos žodis',
    'timo.word.close': 'Uždaryti',
    'timo.word.newWordSoon': 'Naujas žodis rytoj!',
    'timo.talk.waiting': 'Timo galvoja...',
    'timo.talk.youSaid': 'Tu pasakei:',
    'timo.talk.voiceResting': 'Didysis Timo balsas ilsisi, todėl šis skamba kaip roboto.',
    'timo.teach.remember': 'Įsimink',
    'timo.teach.hearIt': 'Paklausyk',
    'timo.teach.gotIt': 'Supratau!',
    'timo.reward.earned': 'Uždirbai {amount} žvaigždučių!',
    'timo.words.title': 'Mano žodžiai',
    'timo.words.wordSingular': 'žodis',
    'timo.words.wordPlural': 'žodžiai',
    'timo.words.tapHint': 'Palytėk žodį, kad jį išgirstum',
    'timo.words.lockedHint': 'Pasakyk šį žodį su Timo, kad jį atrakintum',
    'timo.words.empty': 'Kol kas žodžių nėra',
    'timo.words.emptySub': 'Pasakyk dienos žodį su Timo ir pradėk savo kolekciją!',
    'timo.words.close': 'Uždaryti',
    'timo.words.locked': 'Dar ne',
    'timo.recap.title': 'Šiandien su Timo',
    'timo.recap.wordsLead': 'Žodžiai, kuriuos jūsų vaikas pasakė šiandien',
    'timo.recap.noWords': 'Šiandien daug linksmo kalbėjimo',
    'timo.recap.turnsLabel': 'mažų pokalbių',
    'timo.recap.streakLabel': 'dienų iš eilės',
    'timo.recap.minutesLabel': 'min kartu',
    'timo.recap.tipLead': 'Patarimas',
    'timo.recap.tip1': 'Pabandykite šįvakar per vakarienę kartu pasakyti vieną iš šių žodžių.',
    'timo.recap.tip2': 'Kiekvienas mažas pokalbis svarbus. Kelios minutės per dieną greitai susikaupia.',
    'timo.recap.tip3': 'Paprašykite vaiko išmokyti jus to, ką Timo pasakė šiandien.',
    'timo.recap.tip4': 'Girkite už pastangas, o ne tik už teisingą atsakymą.',
    'timo.recap.dismiss': 'Uždaryti',
    'timo.recap.historyTitle': 'Šią savaitę su Timo',
    'timo.recap.historyEmpty': 'Kol kas pokalbių nėra. Palytėk Timo ir pradėk!',
    'timo.talk.greetingNamed': 'Labas, {name}! Labai džiaugiuosi tave matydamas!',
    'timo.talk.greetingWord': 'Labas! Šiandienos žodis - {word}. Ar gali jį pasakyti?',
    'timo.talk.greetingWordNamed': 'Labas, {name}! Šiandienos žodis - {word}. Ar gali jį pasakyti?',
    'timo.onboarding.intro': 'Labas! Aš Timo. Aš tavo draugas.',
    'timo.onboarding.askName': 'Kuo tu vardu?',
    'timo.onboarding.heard': 'Ar išgirdau {name}?',
    'timo.onboarding.confirmYes': 'Taip!',
    'timo.onboarding.confirmNo': 'Bandyti dar kartą',
    'timo.onboarding.retry': 'Ups! Pasakyk savo vardą dar kartą.',
    'timo.onboarding.typeInstead': 'Parašyti vardą',
    'timo.onboarding.namePlaceholder': 'Tavo vardas',
    'timo.onboarding.save': 'Išsaugoti',
    'timo.onboarding.skip': 'Praleisti',
    'timo.onboarding.welcome': 'Malonu susipažinti, {name}!',
    'timo.onboarding.micDenied': 'Negirdžiu tavęs. Gali parašyti savo vardą.',
    // Timo tells a story: UI chrome only. The story prose itself lives in
    // src/copy/story.en.js under the story.* keys, not here.
    'timo.story.tapToStart': 'Pradėti pasaką',
    'timo.story.listening': 'Tavo eilė',
    'timo.story.narrating': 'Timo seka pasaką',
    'timo.story.close': 'Baigta',
    'timo.story.replay': 'Dar kartą',
    'timo.story.finished': 'Pabaiga',
    'timo.story.next': 'Toliau',
    'parent.title': 'Pažanga',
    'parent.backAria': 'Grįžti į pradžią',
    'parent.noKidName': 'Jūsų vaikas',
    'parent.subtitle': 'Kalbos pratybų pažanga',
    'parent.tierLabel': 'Lygis',
    'parent.statStreak': 'Dienų iš eilės',
    'parent.statWords': 'Išmokta žodžių',
    'parent.statStars': 'Surinkta žvaigždučių',
    'parent.statDaysActive': 'Aktyvių dienų',
    'parent.statDaysActiveHint': 'Per pastarąsias 30 dienų',
    'parent.statLongest': 'Ilgiausia serija',
    'parent.statWordsWeek': 'Nauji žodžiai šią savaitę',
    'parent.calendarTitle': 'Pratybų kalendorius',
    'parent.calendarPrevAria': 'Ankstesnis mėnuo',
    'parent.calendarNextAria': 'Kitas mėnuo',
    'parent.calendarLegendPracticed': 'Buvo pratybų',
    'parent.calendarLegendToday': 'Šiandien',
    'parent.calendarDayPracticed': 'buvo pratybų',
    'parent.calendarEmptyMonth': 'Šį mėnesį pratybų dar nebuvo.',
    'parent.timelineTitle': 'Išmokti žodžiai',
    'parent.timelineToday': 'Šiandien',
    'parent.timelineYesterday': 'Vakar',
    // Lietuvių k. skaitvardžių linksniavimas neleidžia vienos tikslios formos:
    // kilmininkas ("dienų") tinka daugumai skaičių (11-19, 20, 100...), bet ne 2-9 ar 21.
    'parent.timelineDaysAgo': 'prieš {n} dienų',
    'parent.timelineEmptyTitle': 'Kelionė prasideda čia',
    'parent.timelineEmptyBody': 'Kiekvienas žodis, kurį jūsų vaikas išmoks su Timo, atsiras čia. Net vienas žodis per dieną greitai virsta dideliu pokyčiu.',
    // Kaip ir aukščiau: kilmininko forma "žodžių" tinka daugumai skaičių, bet ne 2-9 ar 21.
    'parent.timelineWordCount': '{n} žodžių',
    'parent.timelineWordCountOne': '1 žodis',
    'parent.printLabel': 'Spausdinti',
    'parent.printAria': 'Spausdinti šį puslapį',
    'parent.footerNote': 'Pažanga išsaugoma šiame įrenginyje ir sinchronizuojama su jūsų paskyra.',
    'timo.recap.today': 'Šiandien',
    'timo.recap.yesterday': 'Vakar',
    'breathing.prototypeNotice':
      'Tai dar tik prototipas. Kol kas neveikia taip, kaip suplanuota - taisome ir tobuliname.',
    
    // Scripts page
    'scripts.myScripts': 'Mano Frazės',
    'scripts.searchPlaceholder': 'Ieškoti frazių...',
    'scripts.usedTime': 'Paleista 1 kartą',
    'scripts.usedTimes': 'Paleista {count} kartus',
    'scripts.use': 'Naudoti',
    'scripts.listen': 'Klausyti',
    'scripts.delete': 'Ištrinti',
    'scripts.swipeToDelete': '← Stumkite, kad ištrintumėte',
    'scripts.noScriptsYet': 'Dar nėra frazių',
    'scripts.savePhrasesDesc': 'Išsaugokite frazes, kad vėliau galėtumėte naudoti 💬',
    'scripts.startTalking': 'Pradėti Pokalbį',
    'scripts.addScript': 'Pridėti Frazę',
    'scripts.chooseEmoji': 'Pasirinkite emoji',
    'scripts.yourPhrase': 'Jūsų frazė',
    'scripts.phrasePlaceholder': 'pvz., Ačiū už pagalbą',
    'scripts.cancel': 'Atšaukti',
    'scripts.save': 'Išsaugoti',
    'scripts.addNewScript': 'Pridėti naują frazę',
    'scripts.noScriptsFound': 'Nerasta frazių, atitinkančių jūsų paiešką.',
    'scripts.copied': 'Nukopijuota!',
    'scripts.copiedToClipboard': 'Frazė nukopijuota į iškarpinę',
    'scripts.deleted': 'Ištrinta',
    'scripts.removedFromCollection': 'Frazė pašalinta iš jūsų kolekcijos',
    'scripts.saved': 'Išsaugota!',
    'scripts.addedToCollection': 'Frazė pridėta į jūsų kolekciją',
    'scripts.alreadyExists': 'Jau egzistuoja',
    'scripts.alreadySaved': 'Jūs jau turite šią frazę išsaugotą',
    'scripts.categoryAll': 'Viskas',
    'scripts.categoryNonverbal': 'Kalbėk',
    'scripts.categoryChats': 'Pokalbiai',
    
    // Profile page
    'profile.title': 'Profilis',
    'profile.navSubscription': 'Prenumerata',
    'profile.navAboutUs': 'Apie mus',
    'profile.sessions': 'Dienos',
    'profile.trophies': 'Trofėjai',
    'profile.sent': 'Išsiųsta',
    'profile.streak': 'Dienos',
    'profile.activity': 'Veikla',
    'profile.awards': 'Apdovanojimai',
    'profile.startChatting': 'Pradėti Pokalbį',
    'profile.friend': 'Draugas',
    'profile.chat1': '1 pokalbis',
    'profile.chat5': '5 pokalbiai',
    'profile.chat10': '10 pokalbių',
    'profile.chat25': '25 pokalbiai',
    'profile.chat50': '50 pokalbių',
    'profile.chat100': '100 pokalbių',
    'profile.less': 'Mažiau',
    'profile.more': 'Daugiau',
    'profile.chats': 'pokalbiai',
    'profile.goBack': 'Grįžti atgal',
    'profile.reportBug': 'Pranešti apie klaidą',
    'profile.sendFeedback': 'Siųsti atsiliepimą',
    'profile.feedbackTypeBug': 'Klaida',
    'profile.feedbackTypeComment': 'Komentaras',
    'profile.feedbackPlaceholderBug': 'Aprašykite klaidą...',
    'profile.feedbackPlaceholderComment': 'Pasidalinkite mintimis...',
    'profile.feedbackSend': 'Siųsti',
    'profile.feedbackCancel': 'Atšaukti',
    'profile.feedbackSending': 'Siunčiama...',
    'profile.feedbackSuccess': 'Ačiū!',
    'profile.feedbackError': 'Nepavyko. Bandykite dar kartą.',
    'profile.editProfile': 'Redaguoti Profilį',
    'profile.username': 'Vardas',
    'profile.enterName': 'Įveskite savo vardą',
    'profile.borderColor': 'Rėmelio Spalva',
    'profile.cancel': 'Atšaukti',
    'profile.save': 'Išsaugoti',
    'profile.nameTooShort': 'Vardas turi būti bent 3 simbolių',
    'profile.nameInappropriate': 'Pasirinkite tinkamą vardą',
    'profile.logout': 'Atsijungti',
    'profile.logoutConfirmTitle': 'Ar tikrai?',
    'profile.logoutConfirmText': 'Būsite atjungti ir grįšite į pradžios puslapį.',
    'profile.logoutYes': 'Taip',
    'profile.logoutNo': 'Ne',
    'profile.loggingOut': 'Atsijungiama...',
    
    // Login page
    'login.welcome': 'Sveiki',
    'login.subtitle': 'Įveskite savo duomenis, kad galėtumėte tęsti',
    'login.firstName': 'Vardas',
    'login.firstNamePlaceholder': 'Įveskite savo vardą',
    'login.firstNameRequired': 'Vardas yra privalomas',
    'login.lastName': 'Pavardė',
    'login.lastNamePlaceholder': 'Įveskite savo pavardę',
    'login.optional': 'neprivaloma',
    'login.email': 'El. paštas',
    'login.emailPlaceholder': 'Įveskite savo el. paštą',
    'login.emailRequired': 'El. paštas yra privalomas',
    'login.emailInvalid': 'Įveskite teisingą el. pašto adresą',
    'login.error': 'Kažkas nutiko. Bandykite dar kartą.',
    'login.pleaseWait': 'Palaukite...',
    'login.continue': 'Tęsti',
    'login.disclaimer': 'Ši informacija gali būti naudojama programėlės reklamai po galutinio kūrimo.',
    
    appName: 'Laikas Kalbėti',
    tagline: 'Kartais didžiausias žingsnis tai pirmas pasisveikinimas',
    start: 'Pradėti',
    situations: 'Situacijos',
    chat: 'Pokalbis',
    settings: 'Nustatymai',
    home: 'Pradžia',
    
    // Navigation
    'nav.home': 'Pradžia',
    'nav.scripts': 'Scenarijai',
    'nav.settings': 'Nustatymai',
    'nav.chat': 'Pokalbis',
    'nav.live': 'Live',
    'nav.profile': 'Profilis',
    'nav.nonverbal': 'Kalbėk',
    selectSituation: 'Pasirinkite Situaciją',
    store: 'Parduotuvė',
    cafe: 'Kavinė',
    bus: 'Autobusas',
    hospital: 'Ligoninė',
    school: 'Mokykla',
    party: 'Vakarėlis',
    chatFriend: 'DI Pokalbių Draugas',
    typeMessage: 'Įveskite žinutę...',
    send: 'Siųsti',
    playVoice: 'Leisti Balsą',
    'tts.ltPreviewTitle': 'Balsas - kaip bus ištarta',
    accessibilitySettings: 'Nustatymai',
    hideImages: 'Slėpti Paveikslėlius',
    showImages: 'Rodyti Paveikslėlius',
    dyslexiaMode: 'Disleksijos Fontas',
    textSize: 'Teksto Dydis',
    backgroundMode: 'Fono stilius',
    monochrome: 'Vienspalvis',
    colored: 'Spalvotas',
    resetDefaults: 'Atstatyti Numatytuosius',
    language: 'Kalba',
    english: 'Anglų',
    lithuanian: 'Lietuvių',
    detailMode: 'Išsamus Režimas',
    detailModeDescription: 'Rodyti detalesnes instrukcijas',
    instructions: 'Instrukcijos',
    backToChat: 'Grįžti į Pokalbį',
    startChat: 'Pradėti Pokalbį',
    moreDetail: 'Daugiau Detalių',
    lessDetail: 'Mažiau Detalių',
    addCustomSituation: "Pridėti Savo Situaciją",
    createYourOwn: "Sukurkite Savo Situaciją",
    situationName: "Situacijos Pavadinimas (pvz., Biblioteka)",
    situationIcon: "Situacijos Ikonėlė (pvz., 📚)",
    situationNameEn: "Situacijos Pavadinimas (angliškai)",
    situationNameLt: "Situacijos Pavadinimas (lietuviškai)",
    steps: "Žingsniai",
    addStep: "Pridėti Žingsnį",
    step: "Žingsnis",
    instructionSimpleEn: "Paprasta Instrukcija (angliškai)",
    instructionDetailedEn: "Detali Instrukcija (angliškai)",
    instructionSimpleLt: "Paprasta Instrukcija (lietuviškai)",
    instructionDetailedLt: "Detali Instrukcija (lietuviškai)",
    saveSituation: "Išsaugoti Situaciją",
    delete: "Ištrinti",
    stageName: "Etapo Pavadinimas",
    stageNameEn: "Etapo Pavadinimas (angliškai)",
    stageNameLt: "Etapo Pavadinimas (lietuviškai)",
    coachLine: "Patarėjo Eilutė",
    icon: "Ikonėlė",
    textEn: "Tekstas (angliškai)",
    textLt: "Tekstas (lietuviškai)",
    removeStep: "Pašalinti Žingsnį",
    edit: "Redaguoti",
    awards: "Apdovanojimai",
    totalTrophies: "Iš viso trofėjų",
    colorThemes: "Spalvų Temos",
    situationRewards: "Pokalbių Statistika",
    unlocksAt: "Atrakinama su",
    trophies: "trofėjais",
    successfulInteractions: "Sėkmingi pokalbiai",
    applyTheme: "Pritaikyti Temą",
    applied: "Pritaikyta",
    chimeSound: "Apdovanojimo Garsas",
    chimeSoundDescription: "Leisti garsą atrakinant apdovanojimą",
    // Settings Page
    'settings.title': 'Nustatymai',
    'settings.backAria': 'Grįžti atgal',
    'settings.appearance': 'Išvaizda',
    'settings.sounds': 'Garsai',
    'settings.background': 'Fonas',
    'settings.language': 'Kalba',
    'settings.account': 'Paskyra',
    'settings.voiceprint.title': 'Balso atpažinimas',
    'settings.voiceprint.description': 'Time to Talk šiame įrenginyje išmoksta atpažinti jūsų balsą, kad galėtų pažymėti, kas kalba tiesioginėje sesijoje. Jūsų balso profilis saugomas tik šiame įrenginyje ir niekada nesiunčiamas į mūsų serverius.',
    'settings.voiceprint.forget': 'Pamiršti mano balsą',
    'settings.voiceprint.forgetDesc': 'Išvalyti išsaugotą balso profilį ir pradėti iš naujo',
    'settings.voiceprint.forgotten': 'Balso profilis išvalytas',
    'settings.voiceprint.forgottenDesc': 'Kitoje tiesioginėje sesijoje Time to Talk vėl išmoks jūsų balsą.',
    'settings.theme': 'Tema',
    'settings.dark': 'Tamsi',
    'settings.light': 'Šviesi',
    'settings.textSize': 'Teksto Dydis',
    'settings.textSizeSmall': 'A',
    'settings.textSizeMedium': 'A+',
    'settings.textSizeLarge': 'A++',
    'settings.reduceMotion': 'Sumažinti Animacijas',
    'settings.dyslexiaFont': 'Disleksijos Šriftas',
    'settings.showImages': 'Rodyti Paveikslėlius',
    'settings.rewardSounds': 'Apdovanojimų Garsai',
    'settings.rainAnimation': 'Lietaus Animacija',
    'settings.rainSounds': 'Lietaus Garsai',
    'settings.celebration': 'Šventės Efektai',
    'settings.partyModePhone': 'Šventės efektai telefone',
    'settings.partyModeDesktop': 'Šventės efektai kompiuteryje',
    'settings.forest': 'Miškas',
    'settings.city': 'Miestas',
    'settings.beach': 'Paplūdimys',
    // ...existing code...
    'settings.privacyPolicy': 'Privatumo Politika',
    'settings.termsOfService': 'Paslaugų Sąlygos',
    'settings.helpSupport': 'Pagalba ir Palaikymas',
    'settings.replayTutorial': 'Pakartoti Pamoką',
    'settings.replayTutorialDescription': 'Peržiūrėti programėlės apžvalgą',
    'settings.resetPermissions': 'Atnaujinti leidimus',
    'settings.resetPermissionsDescription': 'Pakartotinai prašyti mikrofono ir įrenginio prieigos',
    'settings.resetToDefaults': 'Atkurti į Numatytuosius',
    'settings.followUs': 'Sek mus',
    'settings.version': 'Timo v1.0.0 • Sukurta su ❤️',
    'settings.deleteAccount': 'Ištrinti paskyrą',
    'settings.deleteAccountConfirmTitle': 'Ištrinti savo paskyrą?',
    'settings.deleteAccountConfirmBody': 'Tai negrįžtamai ištrins jūsų paskyrą ir visus duomenis. Šio veiksmo negalima atšaukti.',
    'settings.deleteAccountConfirm': 'Taip, ištrinti mano paskyrą',
    'settings.deleteAccountCancel': 'Atšaukti',
    'settings.deleteAccountSuccess': 'Paskyra ištrinta',
    'settings.deleteAccountError': 'Nepavyko ištrinti paskyros. Bandykite dar kartą arba susisiekite su palaikymo komanda.',
    'settings.voiceTitle': 'Balsas',
    'settings.voiceDescription': 'Pasirink balsą',
    'settings.voiceChildishFemale': 'Vaikiskas, moteriski',
    'settings.voiceAdultMale': 'Suauge, vyrisko',
    
    // Tutorial translations - Lithuanian
    'tutorial.skip': 'Praleisti',
    'tutorial.next': 'Toliau',
    'tutorial.startApp': 'Pradėti Naudotis',
    
    'tutorial.welcome.title': 'Sveiki atvykę į Time To Talk! 🎉',
    'tutorial.welcome.subtitle': 'Leisk man parodyti',
    'tutorial.welcome.description': 'Aš esu Timo, tavo bendravimo pagalbininkas. Ši trumpa apžvalga parodys viską, ką galiu tau padaryti!',
    'tutorial.welcome.timoMessage': 'Pasiruošei mokytis? Pirmyn!',
    
    'tutorial.home.title': 'Tavo Pradžios Puslapis 🏠',
    'tutorial.home.subtitle': 'Viskas prasideda čia',
    'tutorial.home.description': 'Pradžios ekranas rodo tavo greituosius veiksmus ir pagrindinį mygtuką pradėti kalbėti. Iš čia gali pasiekti visas funkcijas.',
    'tutorial.home.timoMessage': 'Čia tu pradedi!',
    
    'tutorial.chat.title': 'Pokalbis Su Manimi 💬',
    'tutorial.chat.subtitle': 'Tavo pagrindinis pagalbininkas',
    'tutorial.chat.description': 'Paspausk Timo mygtuką (tai aš!) meniu centre, kad gautum pagalbos pokalbiuose. Pasakyk man, ką kažkas pasakė, ir aš pasiūlysiu, ką galėtum atsakyti.',
    'tutorial.chat.timoMessage': 'Aš visada čia padėti!',
    'tutorial.chat.tip1': 'Rašyk arba naudok balsą papasakoti, kas nutiko',
    'tutorial.chat.tip2': 'Pasiūlysiu atsakymus, kuriuos gali naudoti',
    'tutorial.chat.tip3': 'Paspausk garsiakalbio piktogramą išgirsti pasiūlymus garsiai',
    
    'tutorial.nonverbal.title': '„Kalbėk“ režimas 🗣️',
    'tutorial.nonverbal.subtitle': 'Kai žodžiai sunkūs',
    'tutorial.nonverbal.description': 'Kartais kalbėti sunku. Naudok „Kalbėk“ režimą: spausk simbolius ir kurk sakinius, kuriuos aš ištarsiu už tave.',
    'tutorial.nonverbal.timoMessage': 'Čia kalbėti nereikia!',
    'tutorial.nonverbal.tip1': 'Spausk simbolius sukurti žinutę',
    'tutorial.nonverbal.tip2': 'Spausk grojimo mygtuką ištarti garsiai',
    'tutorial.nonverbal.tip3': 'Puiku, kai reikia pertraukos nuo kalbėjimo',
    
    'tutorial.scripts.title': 'Tavo Scenarijai 📝',
    'tutorial.scripts.subtitle': 'Išsaugok mėgstamas frazes',
    'tutorial.scripts.description': 'Radai atsakymą, kuris patinka? Išsaugok jį Scenarijuose! Tavo išsaugotos frazės visada paruoštos, kai jų reikia.',
    'tutorial.scripts.timoMessage': 'Laikyk mėgstamiausius po ranka!',
    'tutorial.scripts.tip1': 'Spausk + pridėti naują frazę',
    'tutorial.scripts.tip2': 'Grupuok pagal kategoriją',
    'tutorial.scripts.tip3': 'Spausk kopijuoti arba ištarti bet kurį scenarijų',
    
    'tutorial.settings.title': 'Pritaikyk Sau ⚙️',
    'tutorial.settings.subtitle': 'Suasmenink savo patirtį',
    'tutorial.settings.description': 'Keisk temą, teksto dydį, garsus ir daugiau. Padaryk programėlę patogią tau!',
    'tutorial.settings.timoMessage': 'Nustatyk savaip!',
    'tutorial.settings.tip1': 'Perjunk tarp šviesaus ir tamsaus režimo',
    'tutorial.settings.tip2': 'Koreguok teksto dydį lengvesniam skaitymui',
    'tutorial.settings.tip3': 'Įjunk arba išjunk garsus',
    'tutorial.settings.tip4': 'Pasirink mėgstamą foną',
    
    'tutorial.profile.title': 'Tavo Profilis 📊',
    'tutorial.profile.subtitle': 'Sek savo pokalbius',
    'tutorial.profile.description': 'Kiekvienas pokalbis padeda tau augti! Patikrink savo profilį pamatyti istoriją ir sekti progresą.',
    'tutorial.profile.timoMessage': 'Tau puikiai sekasi!',
    'tutorial.profile.tip1': 'Peržiūrėk pokalbių istoriją',
    'tutorial.profile.tip2': 'Matyk savo pokalbių istoriją',
    'tutorial.profile.tip3': 'Sek savo progresą laikui bėgant',
    
    'tutorial.complete.title': 'Tu Pasiruošęs! 🌟',
    'tutorial.complete.subtitle': 'Pradėkim kalbėti',
    'tutorial.complete.description': 'Tai viskas! Atmink, aš čia, kai tik tau reikia pagalbos. Nėra jokio spaudimo - eik savo tempu.',
    'tutorial.complete.timoMessage': 'Aš tikiu tavimi! 💚',
    
    // Guided Tour translations - Lithuanian
    'tour.skip': 'Praleisti',
    'tour.next': 'Toliau',
    'tour.back': 'Atgal',
    'tour.finish': 'Supratau!',
    
    'tour.welcome.title': 'Labas! 👋',
    'tour.welcome.message': 'Aš esu Timo, tavo bendravimo pagalbininkas! Leisk greitai parodyti, kaip veikia programėlė.',
    
    'tour.navbar.title': 'Naršymo Juosta',
    'tour.navbar.message': 'Taip naršai! Visos pagrindinės funkcijos yra čia apačioje.',
    
    'tour.timoButton.title': 'Kalbėk Su Manimi!',
    'tour.timoButton.message': 'Spausk mane, kai reikia pagalbos pokalbiuose. Pasiūlysiu, ką galėtum pasakyti!',
    
    'tour.homeTab.title': 'Pradžia',
    'tour.homeTab.message': 'Tavo pradžios taškas. Greita prieiga prie visko ir tavo dienos progresas.',
    
    'tour.nonverbalTab.title': '„Kalbėk“ režimas',
    'tour.nonverbalTab.message': 'Kai kalbėti sunku, spausk čia. Gali kurti žinutes su simboliais ir aš ištarsiu už tave!',
    
    'tour.scriptsTab.title': 'Scenarijai',
    'tour.scriptsTab.message': 'Išsaugok mėgstamas frazes čia. Greita prieiga prie atsakymų, kuriuos dažnai naudoji!',
    
    'tour.settingsTab.title': 'Nustatymai',
    'tour.settingsTab.message': 'Padaryk programėlę sava! Keisk spalvas, teksto dydį, garsus ir daugiau.',
    
    'tour.profileTab.title': 'Profilis',
    'tour.profileTab.message': 'Čia matyk savo progresą. Kiekvienas pokalbis padeda tau augti!',
    
    'tour.complete.title': 'Viskas paruošta! 🎉',
    'tour.complete.message': 'Tai buvo apžvalga! Atmink, tiesiog spausk mane bet kada, kai reikia pagalbos. Jokio spaudimo - eik savo tempu!',
    
    'settings.resetToastTitle': '✅ Nustatymai atkurti',
    'settings.resetToastDescription': 'Visi prieinamumo nustatymai grąžinti į numatytuosius.',
    'settings.metaDescription': 'Tvarkyk disleksijos šriftą, teksto dydį ir foną pagal savo poreikius.',
    'settings.rainBackgroundTitle': 'Animuotas lietaus fonas',
    'settings.rainBackgroundDescription': 'Rodyti lietaus animaciją',
    'settings.disableRainBackground': 'Išjungti lietaus foną',
    'settings.enableRainBackground': 'Įjungti lietaus foną',
    'settings.rainSoundTitle': 'Lietaus garsas',
    'settings.rainSoundDescription': 'Leisti lietaus garsą fone',
    'settings.disableRainSound': 'Išjungti lietaus garsą',
    'settings.enableRainSound': 'Įjungti lietaus garsą',
    'settings.volumeLabel': 'Garsumas',
    'settings.rainVolumeAria': 'Lietaus garso garsumas',
    'settings.imagesDescription': 'Perjungti piktogramas ir paveikslėlius',
    'settings.openDyslexicTitle': 'OpenDyslexic šriftas',
    'settings.openDyslexicDescription': 'Naudoja OpenDyslexic šriftą, kad raidės būtų aiškesnės.',
    'settings.openDyslexicAria': 'OpenDyslexic šriftas',
    'settings.textSizeTitle': 'Teksto dydis',
    'settings.mediumFont': 'Vidutinis teksto dydis',
    'settings.largeFont': 'Didelis teksto dydis',
    'settings.xlargeFont': 'Didžiausias teksto dydis',
    'settings.ttsModelTitle': 'Balso modelis',
    'settings.ttsModelDescription': 'Pasirinkite, kurį DI balso modelį naudoti kalbai',
    'settings.ttsModelBrowser': 'Robo',
    'settings.ttsModelElevenLabs': 'Natt',
    'settings.ttsModelOpenAI': 'Nova',
    'settings.ttsModelGemini': 'Puck',
    'settings.themeIconsTitle': 'Fono ikonos',
    'settings.themeIconsDescription': 'Rodyti plaukiojančias emoji ikonas, atitinkančias temą',
    'settings.showImagesIcons': 'Rodyti paveikslėlius ir ikonas',
    'settings.soundTitle': 'Garsas',
    'settings.rewardSound': 'Apdovanojimo garsas',
    'firstTimeGuide.title': 'Kaip veikia Laikas Kalbėti',
    'firstTimeGuide.step1': 'Spausk "Jūsų situacija".',
    'firstTimeGuide.step2': 'Įrašyk arba pasakyk balsu, kas nutiko.',
    'firstTimeGuide.step3': 'DI pasiūlys, ką gali pasakyti toliau',
    'firstTimeGuide.step4': 'Po pokalbio įvertink, kaip jauteisi.',
    'firstTimeGuide.step5': 'Taip pat gali praktikuotis su DI spausdamas "Instrukcijos".',
    'firstTimeGuide.reassurance': 'Tu visada turi kontrolę. Gali sustoti bet kada.',
    'firstTimeGuide.dontShowAgain': 'Daugiau nerodyti šio vadovo',
    'firstTimeGuide.startButton': 'Pradėti naudotis programa',
    'newFeature.title': 'Nauja funkcija!',
    'newFeature.subtitle': 'Pridėjome kažką naujo, kas padės tau bendrauti',
    'newFeature.feature1Title': '„Kalbėk“ režimas',
    'newFeature.feature1Desc': 'Spausk simbolius, kad sukurtum sakinius ir juos ištartum garsiai',
    'newFeature.feature2Title': 'Paprasta ir ramu',
    'newFeature.feature2Desc': 'Sukurta taip, kad būtų lengva naudoti, kai žodžiai sunkūs',
    'newFeature.feedbackRequest': 'Tai nauja funkcija - mums svarbi tavo nuomonė! Pranešk, jei rasi klaidų ar turėsi pasiūlymų.',
    'newFeature.dontShowAgain': 'Daugiau nerodyti',
    'newFeature.messageButton': 'Parašyk mums',
    'newFeature.tryButton': 'Išbandyti',
    // Home page - New design
    'home.feature1Title': 'Pagalba realiu laiku',
    'home.feature1Desc': 'Gauk pasiūlymus kol kalbi',
    'home.feature2Title': 'Balso palaikymas',
    'home.feature2Desc': 'Kalbėk arba rašyk - tavo pasirinkimas',
    'home.feature3Title': 'Klausyk atgal',
    'home.feature3Desc': 'Išgirsk atsakymus garsiai',
    'home.howItWorksTitle': 'Kaip tai veikia',
    'home.howItWorksDesc': 'Pasakyk, ką jie pasakė, ir mes padėsime rasti tinkamus žodžius.',
    'home.step1': 'Klausyk',
    'home.step2': 'Galvok',
    'home.step3': 'Atsakyk',
    'home.tryNow': 'Išbandyk dabar',
    'home.reassurance': 'Be vertinimų. Be spaudimo. Tiesiog pagalba, kai jos reikia.',
    'home.reassuranceSub': 'Timo čia dėl tavęs, tavo tempu.',
    // Home page - Legacy (kept for backward compatibility)
    'home.timoTitle': 'Susipažink su Timo DI',
    'home.timoSubtitle': 'Tavo ramus komunikacijos patarėjas',
    'home.timoCard1Title': 'Miško patarėjas',
    'home.timoCard1Text': 'Timo miške visi konfliktai baigdavosi tuo, kad jis viską išspręsdavo.',
    'home.timoCard2Title': 'Miško chaosas',
    'home.timoCard2Text': 'Be Timo visi gyvūnai nuolat pyko vieni ant kitų. Voverės prieš varnas (riešutai dingdavo kasdien), antys prieš visus be išimties (jos tiesiog… agresyviai kvaksėdavo). Bet kai atsirado Timo, jis išspręsdavo kiekvieną problemą lyg nieko nebūtų buvę.',
    'home.timoCard3Title': 'Puikus klausytojas',
    'home.timoCard3Text': 'Nerėkia, ne aiškina. Timo galėjo puikiai klausytis ir padėti visiems suprasti vienas kitą.',
    'home.timoCard4Title': 'Svarbi įžvalga',
    'home.timoCard4Text': 'Konfliktai atsiranda ne dėl blogų ketinimų, o todėl, kad nežinome, kaip pasakyti tai, ką jaučiame.',
    'home.timoCard5Title': 'Aiški misija',
    'home.timoCard5Text': 'Komunikacija nėra apie tai, kas protingiausias ar garsiausias. Ji apie tai, kaip padėti kitiems suprasti aiškiai.',
    'home.timoCard6Title': 'Padėti žmonėms',
    'home.timoCard6Text': 'Kai Timo sužinojo, kad žmonės kovoja su pokalbiais, jis tučtuojau paliko mišką, kad jiems padėtų.',
    'home.timoCard7Title': 'Tavo patarėjas',
    'home.timoCard7Text': '„Kantrus ir stebintis. Timo pasiūlo tinkamus žodžius tinkamu metu.',
    'home.drawerOpen': 'Skaityti daugiau',
    'home.drawerClose': 'Skaityti mažiau',
    'unknown.startConversation': 'Pradėti pokalbį',
    'unknown.continueConversation': 'Tęsti pokalbį',
    'unknown.askForHelp': 'Prašyti pagalbos',
    'unknown.sayNoPolitely': 'Mandagiai atsisakyti',
    'unknown.endConversation': 'Baigti pokalbį',
    'unknown.metaTitle': 'Jūsų situacija',
    'unknown.metaDescription': 'Praktikuok pokalbį - Timo DI išsiaiškins situaciją ir padės.',
    'unknown.backAria': 'Grįžti atgal',
    'unknown.title': 'Jūsų situacija',
    'unknown.subtitle': 'Parašyk, ką tu ar kitas žmogus pasakė. Timo DI padės suprasti ir atsakyti.',
    'unknown.subtitleShort': 'Parašyk, ką pasakė kitas žmogus, kad Timo DI galėtų padėti.',
    'unknown.helper': 'Kaip Timo DI gali padėti?',
    'unknown.youCouldSay': 'Galėtum taip pat pasakyti…',
    'unknown.firstMessage': 'Pasakyk, kas nutiko arba kas buvo pasakyta.',
    'unknown.inputPlaceholder': 'Parašyk, kas buvo pasakyta...',
    'unknown.inputAria': 'Parašyk, kas buvo pasakyta',
    'unknown.sendAria': 'Siųsti žinutę',
    'unknown.finishAria': 'Baigti pokalbį',
    'unknown.finishButton': 'Baigti',
    'unknown.finishedNotice': 'Pokalbis baigtas',
    'unknown.startNewConversation': 'Pradėti naują pokalbį',
    'unknown.finishToastTitle': 'Pokalbis baigtas',
    'unknown.finishToastDescription': 'Pokalbis baigėsi. Gali pradėti naują.',
    'unknown.errorTitle': 'Klaida',
    'unknown.errorDescription': 'Nepavyko išsiųsti žinutės. Bandyk dar kartą.',
    'unknown.contextPlace': 'Vieta',
    'unknown.contextRelationship': 'Santykis',
    'unknown.contextGoal': 'Tikslas',
    'unknown.emptyState': 'Pradėk parašydamas, kas įvyko ar kas buvo pasakyta!',
    'unknown.playVoiceAria': 'Paleisti balsą',
    'unknown.finishedTitle': 'Baigei šią situaciją!',
    'unknown.motivationalMessage': 'Gražus darbas, kad pabandei.',
    'unknown.howDidItFeel': 'Kaip jaučiuosi šį kartą?',
    'unknown.itFeltGood': 'Jautuosi gerai',
    'unknown.itWasHard': 'Šį kartą buvo sunku',
    'unknown.bothChoicesOkay': 'Abu atsakymai yra teisingi - svarbiausia, kad pabandei.',
    'unknown.goalSelectionTitle': 'Ko jums reikia pagalbos?',
    'unknown.goalSelectionSubtitle': 'Pasirinkite tai, kas geriausiai atitinka jūsų situaciją.',
    'unknown.goalHelpSpeaking': 'Man reikia pagalbos kalbant',
    'unknown.goalHelpAsking': 'Man reikia pagalbos prašyti',
    'unknown.goalLost': 'Nežinau, ką pasakyti',
    'unknown.goalSayNo': 'Noriu mandagiai atsakyti „ne"',
    'unknown.goalSkip': 'Tai netinka mano situacijai',
    'unknown.goalBadgeHelpSpeaking': 'Tikslas: Pagalba kalbant',
    'unknown.goalBadgeHelpAsking': 'Tikslas: Pagalba prašyti',
    'unknown.goalBadgeLost': 'Tikslas: Nežinau, ką pasakyti',
    'unknown.goalBadgeSayNo': 'Tikslas: Mandagiai pasakyti „ne"',
    'unknown.recordOtherSpeaker': 'Įrašyti, ką jis/ji pasakė',
    'unknown.recording': 'Įrašoma...',
    'unknown.otherPersonSaid': 'Jis/ji pasakė:',
    'unknown.speakerLabel': 'Galėtumėte pasakyti:',
    'unknown.timoAILabel': 'Timo DI:',
    'unknown.otherPersonLabel': 'Jis/ji:',
    'unknown.youLabel': 'Jūs:',
    'voice.unsupportedAlert': 'Ši naršyklė nepalaiko balso įvedimo. Įrašyk tekstą.',
    'voice.stopRecordingAria': 'Sustabdyti įrašymą',
    'voice.startRecordingAria': 'Įrašyti balsą',
    'voice.stopRecordingTooltip': 'Sustabdyti įrašymą',
    'voice.startRecordingTooltip': 'Įrašyti',
    'voice.recordingIndicator': '● Įraš.',
    about: 'Apie',
    'about.pageTitle': 'Apie mus - Time To Talk',
    'about.metaDescription': 'Sužinokite apie Time To Talk istoriją ir misiją.',
    'about.intro1': 'Time To Talk gimė iš paprastos, bet prasmingos akimirkos.',
    'about.intro2': 'Mūsų įkūrėjo brolis, turintis autizmą, kartą paklausė, ar gali nufotografuoti mėnulį - mažas klausimas, kuris įkvėpė didelę idėją: padėti žmonėms, kuriems kasdienės socialinės situacijos kelia stresą.',
    'about.founderImageAlt': 'Įkūrėjas ir jo brolis',
    'about.teamImageAlt': 'Time To Talk komanda dirba kartu',
    'about.missionTitle': 'Mūsų misija',
    'about.missionText': 'Supaprastinti bendravimą - padaryti jį lengviau suprantamą, išmokstamą ir patiriamą. Time To Talk padeda vartotojams išmokti, ką sakyti ir kaip elgtis, pasitelkiant švelnų dirbtinio intelekto palydėjimą, aiškius vizualus ir raminantį dizainą.',
    'about.goalTitle': 'Mūsų tikslas',
    'about.goalText': 'Kurti pasitikėjimą savimi, po vieną situaciją. Mes esame čia visiems, kuriems reikia palaikymo - žmonėms su autizmu, socialine fobija ar tiesiog tiems, kuriems socialiniai momentai yra sudėtingi.',
    'about.back': 'Atgal',
    'about.timo': 'Timo',
    'about.tagline': 'Tavo pokalbių palydovas',
    'about.missionIntro': 'Tikime, kad kiekvienas nusipelno palaikymo kasdieniuose pokalbiuose. Timo sukurtas žmonėms, kuriems kartais socialinės sąveikos kelia iššūkių - nesvarbu, ar esi autistas, jauti nerimą, esi introvertas, ar tiesiog turi sunkią dieną.',
    'about.missionSub': 'Mūsų tikslas paprastas: suteikti pasitikėjimą, kai jo labiausiai reikia, be vertinimo ar spaudimo.',
    'about.features': 'Ką Timo Daro',
    'about.feature.conversation': 'Pokalbių pagalba',
    'about.feature.conversationDesc': 'Gauk atsakymų pasiūlymus, kai nežinai ką pasakyti',
    'about.feature.voice': 'Balso įvestis',
    'about.feature.voiceDesc': 'Kalbėk arba rašyk - kas tau patogiau',
    'about.feature.scripts': 'Išsaugoti scenarijai',
    'about.feature.scriptsDesc': 'Saugok mėgstamus atsakymus greitam pasiekimui',
    'about.feature.privacy': 'Privatu ir saugu',
    'about.feature.privacyDesc': 'Tavo pokalbiai lieka tavo įrenginyje',
    'about.madeBy': 'Sukūrė',
    'about.teamName': 'Time to Talk komanda',
    'about.teamRole': 'Kuriame įrankius geresniam bendravimui',
    'about.privacyPolicy': 'Privatumo politika',
    'about.terms': 'Naudojimo sąlygos',
    'about.contact': 'Susisiekite',
    'about.version': 'Versija 1.0.0',
    'about.madeWith': 'Sukurta su ❤️ geresniems pokalbiams',
    'header.disableRainBg': 'Išjungti lietaus foną',
    'header.enableRainBg': 'Įjungti lietaus foną',
    'header.disableRainSound': 'Išjungti lietaus garsą',
    'header.enableRainSound': 'Įjungti lietaus garsą',
    'situations.metaDescription': 'Pasirink situaciją ir praktikuok tikro pokalbio įgūdžius su DI pagalba.',
    'situations.helperText': 'Pasirink situaciją kurią nori praktikuotis ar bendrauk su Timo DI pagalba',
    'situations.customTitle': 'Jūsų situacija',
    'situations.customSubtitle': 'Dalyvauk pokalbyje ir Timo DI tau padės',
    'situations.recommended': 'Rekomenduojama',
    'situations.deleteConfirmTitle': 'Ar esi tikras?',
    'situations.deleteConfirmDescription': 'Tai negrįžtama.',
    'situations.history': 'Istorija',
    'situations.historySubtitle': 'Peržiūrėk savo ankstesnius pokalbius',
    'situations.chooseWhereTitle': 'Kur tu dabar?',
    'situations.chooseWhereSubtitle': 'Pasirink arba pradėk laisvą pokalbį',
    'situations.freeChat': 'Laisvas pokalbis',
    'situations.liveModeBeta': 'Live Mode - Beta',
    'situations.backToHome': 'Grįžti į pradžią',
    'situations.accessCodeTitle': 'Reikalingas prieigos kodas',
    'situations.accessCodeHint': 'Įveskite prieigos kodą Live Mode:',
    'situations.enterCodePlaceholder': 'Įveskite kodą...',
    'situations.codeIncorrect': 'Neteisingas kodas. Bandykite dar kartą.',
    'situations.accessLiveModeButton': 'Įeiti į Live Mode',
    'chat.pageTitle': 'Pokalbis su Timo',
    'chat.metaDescription': 'Kalbėkis su Timo - padėsime su tuo, ką pasakyti',
    'chat.backAria': 'Atgal',
    'chat.subtitle': 'Tavo DI pagalbininkas',
    'chat.end': 'Baigti',
    'chat.helpDefault': 'Pagalba',
    'chat.greeting': 'Labas! Ką reikia pasakyti?',
    'chat.suggestionsTitle': 'Ką man pasakyti?',
    'chat.suggestionsHint': 'Paspausk variantą - bus perskaityta ir išsiųsta',
    'chat.suggestionsUpdating': 'Atnaujinama...',
    'chat.noSuggestions': 'Nėra pasiūlymų',
    'chat.thinking': 'Galvoju...',
    'chat.gettingSuggestions': 'Renku pasiūlymus tau',
    'chat.quickRepliesLabel': 'Greiti atsakymai:',
    'chat.speaking': 'Kalba:',
    'chat.speakerMe': 'Aš',
    'chat.speakerOther': 'Kitas',
    'chat.placeholder': 'Rašyk žinutę...',
    'chat.sendAria': 'Siųsti žinutę',
    'chat.getHelpAria': 'Gauti pagalbą',
    'chat.playTtsAria': 'Leisti balsą',
    'chat.ariaHearTimo': 'Klausyti Timo žinutės',
    'chat.ariaHearIt': 'Klausyti',
    'chat.ariaSaveScript': 'Išsaugoti į frazes',
    'chat.recordMicMe': 'Laikyk, kad įrašytum savo balsą',
    'chat.recordMicOther': 'Laikyk, kad įrašytum, ką jie sakė',
    'chat.recordingMe': 'Įrašau tavo balsą...',
    'chat.recordingOther': 'Įrašau, ką jie sakė...',
    'chat.ttsWait': 'Palauk {seconds} s... (liko {left} perklausų)',
    'chat.youCan': 'Galėtum pasakyti:',
    'chat.timoSuggests': 'Timo siūlo...',
    'chat.safetyTitle': 'Saugumo įspėjimas',
    'chat.safetyBody': 'Šis pokalbis gali būti nesaugus. Jei jautiesi grėsmėje - išeik nedelsiant.',
    'chat.fallbackAi': 'Labas! Ką reikia pasakyti?',
    'chat.fallbackCoaching': 'Žinutė išsiųsta sėkmingai! 👍 Reikia dar ko nors?',
    'chat.needMoreHelp': 'Reikia dar pagalbos?',
    'chat.praise1': 'Puiku!',
    'chat.praise2': 'Super!',
    'chat.praise3': 'Šaunu!',
    'chat.toast.errorTitle': 'Klaida',
    'chat.toast.errorDesc': 'Nepavyko gauti atsakymo. Bandyk dar kartą.',
    'chat.toast.ttsLimitTitle': 'Pasiektas TTS limitas',
    'chat.toast.ttsLimitDesc': 'Daugiausia 5 perklausos per sesiją.',
    'chat.toast.savedTitle': 'Išsaugota!',
    'chat.toast.savedDesc': 'Pridėta į frazes.',
    'chat.toast.duplicateTitle': 'Jau yra',
    'chat.toast.duplicateDesc': 'Ši frazė jau išsaugota.',
    'chat.toast.voiceTestTitle': 'Balso testas',
    'chat.toast.voiceTestDesc': 'Leidžiu pavyzdį...',
    'chat.toast.voiceFailTitle': 'Balso testas nepavyko',
    'chat.toast.voiceFailDesc': 'Žiūrėk konsolę.',
    'chat.toast.connectionTitle': 'Ryšio problema',
    'chat.toast.connectionDesc': 'Pilnas atsakymas negautas, bet žinutė puiki!',
    'chat.testVoice.lt': 'Sveiki, aš esu Timo, jūsų dirbtinis intelektas.',
    'chat.testVoice.en': "Hi, I'm Timo, your AI helper.",
    'chat.testVoice.ru': 'Привет! Я Тимо, твой помощник на базе искусственного интеллекта.',
    'chat.qr.hey1': 'Labas!',
    'chat.qr.hey2': 'Sveikas',
    'chat.qr.hey3': 'Kaip sekasi?',
    'chat.qr.yes1': 'Taip',
    'chat.qr.yes2': 'Ne',
    'chat.qr.yes3': 'Gal',
    'chat.qr.how1': 'Gerai!',
    'chat.qr.how2': 'Neblogai',
    'chat.qr.how3': 'Viskas ok',
    'chat.qr.inv1': 'Žinoma!',
    'chat.qr.inv2': 'Vėliau gal',
    'chat.qr.inv3': 'Negaliu, atsiprašau',
    'chat.qr.help1': 'Taip',
    'chat.qr.help2': 'Kas nutiko?',
    'chat.qr.help3': 'Kaip galiu padėti?',
    'chat.qr.thanks1': 'Nėra už ką!',
    'chat.qr.thanks2': 'Visada',
    'chat.qr.thanks3': 'Prašom',
    'chat.qr.comp1': 'Ačiū!',
    'chat.qr.comp2': 'Dėkingas',
    'chat.qr.comp3': '😊',
    'chat.qr.sorry1': 'Jokių problemų',
    'chat.qr.sorry2': 'Viskas gerai',
    'chat.qr.sorry3': 'Gerai',
    'chat.qr.info1': 'Tikrai?',
    'chat.qr.info2': 'Pasakyk',
    'chat.qr.info3': 'Ką?',
    'chat.qr.plan1': 'Skamba gerai',
    'chat.qr.plan2': 'Kada?',
    'chat.qr.plan3': 'Gal',
    'chat.qr.conf1': 'Taip',
    'chat.qr.conf2': 'Tikrai',
    'chat.qr.conf3': 'Sutinku',
    'chat.qr.wq1': 'Nežinau',
    'chat.qr.wq2': 'Leisk pagalvoti',
    'chat.qr.wq3': 'Patikrinsiu',
    'chat.qr.genq1': 'Taip',
    'chat.qr.genq2': 'Ne',
    'chat.qr.genq3': 'Gal',
    'chat.qr.stat1': 'Faina',
    'chat.qr.stat2': 'Gerai',
    'chat.qr.stat3': 'Rimtai?',
    'chat.qr.def1': 'Gerai',
    'chat.qr.def2': 'Supratau',
    'chat.qr.def3': 'Ok',
    'history.title': 'Pokalbių istorija',
    'history.empty': 'Dar nėra pokalbių. Pradėk pokalbį, kad čia matytum istoriją!',
    'history.loading': 'Įkeliami pokalbiai...',
    'history.error': 'Nepavyko įkelti pokalbių. Bandyk dar kartą.',
    'history.deleteConfirm': 'Ištrinti šį pokalbį?',
    'history.deleteError': 'Nepavyko ištrinti pokalbio. Bandyk dar kartą.',
    'history.resume': 'Tęsti',
    'history.view': 'Peržiūrėti',
    'history.delete': 'Ištrinti',
    'history.noTitle': 'Pokalbis be pavadinimo',
    'history.lastUpdated': 'Paskutinį kartą atnaujinta',
    'history.deleteAll': 'Ištrinti viską',
    'history.deleteAllConfirm': 'Ištrinti viską?',
    'history.deleteAllConfirmDesc': 'Visi pokalbiai bus pašalinti.',
    'history.deleteAllSuccess': 'Pavyko',
    'history.deleteAllSuccessDesc': 'Visi pokalbiai ištrinti',
    'history.justNow': 'Ką tik',
    'common.cancel': 'Atšaukti',
    'common.delete': 'Ištrinti',
    'customSetup.intentStart': 'Pradėti pokalbį',
    'customSetup.intentContinue': 'Tęsti pokalbį',
    'customSetup.intentFinish': 'Baigti pokalbį',
    'customSetup.metaTitle': 'Pasirinkta situacija - paruošimas',
    'customSetup.metaDescription': 'Susikurk savo pokalbio situaciją.',
    'customSetup.title': 'Pasirinkta situacija',
    'customSetup.subtitle': 'Pasirink vietą ir tikslą, kurio sieki.',
    'customSetup.situationLabel': 'Situacija',
    'customSetup.placeholder': 'pvz., Vakarėlis, Mokykla, Parduotuvė, Autobusas, Ligoninė',
    'customSetup.examplesHint': 'Arba spausk pavyzdį apačioje:',
    'customSetup.examples.party': 'Vakarėlis',
    'customSetup.examples.school': 'Mokykla',
    'customSetup.examples.store': 'Parduotuvė',
    'customSetup.examples.bus': 'Autobusas',
    'customSetup.examples.hospital': 'Ligoninė',
    'customSetup.intentQuestion': 'Ką nori padaryti?',
    'customSetup.startButton': 'Pradėti',
    'customChat.metaTitle': 'Pasirinktos situacijos pokalbis',
    'customChat.genericSituation': 'situacija',
    'customChat.metaDescriptionPrefix': 'Praktikuok pokalbį:',
    'customChat.backAria': 'Grįžti į paruošimą',
    'customChat.inputPlaceholder': 'Įrašyk savo žinutę...',
    'customChat.inputAria': 'Įrašyk savo žinutę',
    'customChat.finishToastTitle': 'Pokalbis baigtas',
    'customChat.finishToastDescription': 'Pokalbis baigėsi. Gali pradėti naują.',
    'customChat.errorTitle': 'Klaida',
    'customChat.errorDescription': 'Nepavyko išsiųsti žinutės. Bandyk dar kartą.',
    'customChat.finishFallbackShort': 'Viso gero!',
    'customChat.finishFallbackLong': 'Man jau reikia eiti, ačiū!',
    'customChat.finishedNotice': 'Pokalbis baigtas',
    // Non-verbal Mode
    'nonVerbalMode': 'Kalbėk',
    'nonVerbalSelectPrompt': 'Paspausk simbolius, kad sudarytum sakinį',
    'nonVerbalAIGrammar': 'DI gramatikos taisymas',
    'nv.speakModalTitle': 'Aš sakau:',
    'nv.speaking': 'Kalba...',
    'nv.speak': 'Kalbėti',
    'nv.speakAgain': 'Kalbėti dar kartą',
    'nv.speakLoading': 'Sudaromas sakinys...',
    'nv.imageAlt': 'Paveikslėlis',
    'nv.sentenceBarAria': 'Sakinio juosta',
    'nv.tapSymbol': 'Paspausk simbolį...',
    'nv.clearAll': 'Išvalyti viską',
    'nv.deleteLast': 'Ištrinti paskutinį',
    'nv.speakSentence': 'Kalbėti sakinį',
    'nv.kalbeti': 'Kalbėti',
    'nv.clear': '✕ Išvalyti',
    'nv.backAria': 'Atgal',
    'nv.scriptsAria': 'Scenariai',
    'nv.historyAria': 'Istorija',
    'nv.searchPlaceholder': 'Ieškoti simbolio...',
    'nv.noResults': 'Nieko nerasta',
    'nv.ttsFailed': 'Garso nepavyko paleisti. Bakstelėkite dar kartą.',
    'nv.searchAria': 'Ieškoti simbolio',
    'nv.loading': 'Kraunama...',
    'nv.noPhotos': 'Dar nėra nuotraukų',
    'nv.addPhotosHint': 'Pridėkite savo nuotraukas bendravimui',
    'nv.addPhoto': 'Pridėti nuotrauką',
    'nv.add': 'Pridėti',
    'nv.showLess': 'Rodyti mažiau',
    'nv.moreCount': 'Daugiau ({count})',
    'nv.comingSoon': 'Atsiras netrukus',
    'nv.historyTitle': 'Istorija',
    'nv.historyEmpty': 'Dar nėra sakinių. Spauskite emocijas ir kalbėkite.',
    'nv.useAgain': 'Naudoti dar kartą',
    'nv.addToScripts': 'Į scenarijus',
    'nv.savedToScripts': 'Išsaugota į scenarijus!',
    'nv.clearHistory': 'Išvalyti istoriją',
    'nv.customAddPhoto': 'Pridėti nuotrauką',
    'nv.customPreview': 'Peržiūra',
    'nv.customAddLabel': 'Pridėti tekstą',
    'nv.customTakePhoto': 'Fotografuoti',
    'nv.customUseCamera': 'Naudoti kamerą',
    'nv.customFromGallery': 'Pasirinkti iš galerijos',
    'nv.customFromDevice': 'Iš kompiuterio ar telefono',
    'nv.customWordOnly': 'Tik žodis',
    'nv.customWordOnlyHint': 'Nuotraukos nereikia',
    'nv.customChange': 'Keisti',
    'nv.customContinue': 'Tęsti',
    'nv.customHintLabels': 'Pridėkite tekstą, kuris bus rodomas ir tariamas',
    'nv.customNameEn': 'Pavadinimas (anglų k.)',
    'nv.customPlaceholderName': 'pvz., „Mama“, „Jonas“',
    'nv.customNameLt': 'Pavadinimas lietuviškai',
    'nv.customNameRu': 'Pavadinimas rusų k.',
    'nv.customOptional': 'neprivaloma',
    'nv.customCategory': 'Kategorija',
    'nv.customBack': 'Atgal',
    'nv.customSave': 'Išsaugoti',
    'nv.customSaving': 'Saugoma...',
    'nv.customErrImage': 'Pasirinkite paveikslėlį',
    'nv.customErrSize': 'Failas per didelis (max 10MB)',
    'nv.customErrLabel': 'Įveskite pavadinimą',
    'nv.customErrSave': 'Klaida išsaugant',
    'nv.manageTitle': 'Mano nuotraukos',
    'nv.deleteConfirm': 'Ištrinti „{name}“?',
    'nv.cancel': 'Atšaukti',
    'nv.delete': 'Ištrinti',
    'speak': 'Kalbėti',
    'speaking': 'Kalba...',
    'clear': 'Išvalyti',
    'back': 'Atgal',
    'skip': 'Praleisti',
    'continue': 'Tęsti',
    // Onboarding
    'onboarding.welcomeTitle': 'Sveiki, aš Timo',
    'onboarding.welcomeSubtitle': 'Tavo ramus palydovas kasdieniniams pokalbiams',
    'onboarding.welcomeDesc': 'Esu čia padėti, kai kalbėti sudėtinga. Pasiruoškime per minutę.',
    'onboarding.getStarted': 'Pradėkime',
    'onboarding.languageTitle': 'Pasirink kalbą',
    'onboarding.languageDesc': 'Galėsi pakeisti nustatymuose vėliau',
    'onboarding.accessibilityTitle': 'Padaryk patogiau',
    'onboarding.accessibilityDesc': 'Pritaikyk pagal savo poreikius',
    'onboarding.reducedMotion': 'Sumažintas judėjimas',
    'onboarding.reducedMotionDesc': 'Paprastesnės animacijos be blaškymosi',
    'onboarding.sounds': 'Garso efektai',
    'onboarding.soundsDesc': 'Švelnūs garsai grįžtamajam ryšiui',
    'onboarding.showImages': 'Rodyti paveikslėlius',
    'onboarding.showImagesDesc': 'Iliustracijos ir piktogramos',
    'onboarding.howItWorksTitle': 'Kaip tai veikia',
    'onboarding.howItWorksDesc': 'Trys paprasti žingsniai bendravimui',
    'onboarding.step1Title': 'Jie kalba',
    'onboarding.step1Desc': 'Pasakyk, ką pasakė kitas žmogus',
    'onboarding.step2Title': 'Mes padedame',
    'onboarding.step2Desc': 'Timo pasiūlo, ką galėtum atsakyti',
    'onboarding.step3Title': 'Tu atsaki',
    'onboarding.step3Desc': 'Pasirink pasiūlymą arba sakyk savaip',
    'onboarding.readyTitle': 'Viskas paruošta!',
    'onboarding.readyDesc': 'Timo pasiruošęs padėti, kai tik prireiks.',
    'onboarding.readyTip': 'Patarimas: Nustatymuose visada galėsi pakeisti parinktis.',
    'onboarding.startUsing': 'Pradėti naudoti Time To Talk',
    
    // Push to Talk (State Machine UI)
    'pushToTalk.title': 'Padėk Atsakyti',
    'pushToTalk.ready': 'Pasiruošęs, kai tu',
    'pushToTalk.helpMeRespond': 'Padėk atsakyti',
    'pushToTalk.tapToStart': 'Paspausk, kad įrašytum, ką jie pasakė',
    'pushToTalk.recording': 'Įrašau, ką jie pasakė...',
    'pushToTalk.done': 'Baigta',
    'pushToTalk.cancel': 'Atšaukti',
    'pushToTalk.understanding': 'Suprantu...',
    'pushToTalk.theySaid': 'Jie pasakė:',
    'pushToTalk.soundsLike': 'Tai skamba kaip',
    'pushToTalk.yesHelpMe': 'Taip, padėk atsakyti',
    'pushToTalk.notQuite': 'Ne visai, bandyk dar',
    'pushToTalk.startOver': 'Pradėti iš naujo',
    'pushToTalk.findingResponses': 'Ieškau gerų atsakymų...',
    'pushToTalk.pickResponse': 'Pasirink atsakymą:',
    'pushToTalk.youllSay': 'Tu pasakysi:',
    'pushToTalk.illSayIt': 'Pasakysiu pats',
    'pushToTalk.speakForMe': 'Kalbėk už mane',
    'pushToTalk.chooseAnother': 'Pasirinkti kitą',
    'pushToTalk.differentOptions': 'Kiti variantai',
    'pushToTalk.speaking': 'Kalbu...',
    'pushToTalk.stop': 'Stop',
    'pushToTalk.responseReady': 'Atsakymas paruoštas!',
    'pushToTalk.needMoreHelp': 'Reikia daugiau pagalbos',
    'pushToTalk.imDone': 'Baigiau',
    'pushToTalk.autoReset': 'Grįš į pradžią automatiškai',
    'pushToTalk.stillThere': 'Ar dar čia?',
    'pushToTalk.takeYourTime': 'Neskubėk.',
    'pushToTalk.continue': 'Tęsti',
    'pushToTalk.didntCatch': 'Nesupratau',
    'pushToTalk.tryAgainOrType': 'Bandyk dar arba rašyk',
    'pushToTalk.tryAgain': 'Bandyti dar',
    'pushToTalk.typeInstead': 'Rašyti vietoj to',
    'pushToTalk.whatDidTheySay': 'Ką jie pasakė?',
    'pushToTalk.typeHere': 'Parašyk, ką jie pasakė...',
    'pushToTalk.somethingWrong': 'Kažkas nutiko',
    'pushToTalk.pleaseTryAgain': 'Pabandyk dar kartą',
    'pushToTalk.panic': 'Sustoti ir grįžti',
    
    // Live Mode
    'live.title': 'Tiesioginė Veiksena',
    'live.back': 'Atgal',
    'live.endSession': 'Baigti',
    'live.error': 'Klaida',
    'live.dismiss': 'Uždaryti',
    'live.status.ready': 'Paruošta',
    'live.status.connecting': 'Jungiamasi...',
    'live.status.listening': 'Klausoma...',
    'live.tapToStart': 'Pradėti',
    'live.tapToStop': 'Sustoti',
    'live.connecting': 'Jungiamasi...',
    'live.stats.totalMessages': 'Iš viso',
    'live.stats.you': 'Tu',
    'live.stats.otherPerson': 'Kitas',
    'live.conversation': 'Pokalbis',
    'live.emptyState.listening': 'Klausoma...',
    'live.emptyState.startRecording': 'Pradėti',
    'live.getAiHelp': 'Timo Pagalba',
    'live.askAi': 'Klausti Timo',
    'live.theyreSpeaking': 'Jie kalba',
    'live.emptyState.instruction': 'Spustelėkite mikrofono mygtuką, kad pradėtumėte pokalbį',
    'live.betaWarning.title': 'Tiesioginė Veiksena - Beta',
    'live.betaWarning.description': 'Ši funkcija dar kuriama. Drausmingai testuokite!',
    'live.betaWarning.note': 'Geriausiai veikia anglų kalba',
    'live.betaWarning.close': 'Supratau',
    
    // Rate Limit
    'rateLimit.title': 'Pasiekėte šios dienos limitą',
    'rateLimit.message': 'Pasiekėte dienos limitą. Bandykite dar kartą rytoj.',
    'rateLimit.ok': 'Gerai',
    'rateLimit.close': 'Uždaryti',

    // New Landing Page
    // Landing copy lives in src/copy/landing.lt.js
    ...landingLt,
    ...storyLt,
    'login.title': 'Prisijungti',
    'login.startSubtitle': 'Prisijunkite su Google arba el. paštu.',
    'login.fbBrowserWarning': 'Google prisijungimas neveikia Facebook naršykleje. Naudokite el. pasta zemiau arba atidarykite puslapi Safari / Chrome naršykleje.',
    'login.signUpPrompt': 'Dar neturite paskyros?',
    'login.signUpLink': 'Registruokitės žemiau',
    'login.googleBtn': 'Tęsti su Google',
    'login.facebookBtn': 'Tęsti su Facebook',
    'login.appleBtn': 'Tęsti su Apple',
    'login.openInBrowser': 'Norėdami prisijungti per Google, Facebook ar Apple, atidarykite puslapį naršyklėje (naršyklės meniu → „Atidaryti naršyklėje"). Arba naudokite el. paštą žemiau.',
    'login.emailBtn': 'Tęsti su el. paštu',
    'login.registerBtn': 'Jau turite paskyrą?',
    'login.signInLink': 'Prisijungti',
    'login.signinTitle': 'Prisijungti',
    'login.signupTitle': 'Registruotis',
    'login.signinSubtitle': 'Prisijunkite su el. paštu',
    'login.signupSubtitle': 'Sukurkite savo paskyrą',
    'login.emailLabel': 'El. pašto adresas',
    'login.passwordLabel': 'Slaptažodis',
    'login.passwordSignupPlaceholder': 'Slaptažodis (min. 6)',
    'login.submitSignin': 'Prisijungti',
    'login.submitSignup': 'Registruotis',
    'login.processing': 'Apdorojama...',
    'login.noAccount': 'Neturite paskyros? Registruokitės',
    'login.haveAccount': 'Jau turite paskyrą? Prisijunkite',
    'login.successSignin': 'Prisijungimas sėkmingas!',
    'login.successSignup': 'Patikrinkite el. paštą patvirtinimui!',
    'login.failed': 'Prisijungimas nepavyko. Bandykite dar kartą.',
    'login.unknownError': 'Nežinoma klaida. Bandykite dar kartą.',
    'login.registrationFailed': 'Registracija nepavyko:',
    'login.confirmationEmail': 'Patikrinkite el. paštą - išsiuntėme patvirtinimo laišką.',
    'login.linkExpired': 'Jūsų prisijungimo nuoroda nebegalioja. Paprašykite naujos.',
    'login.resendMagicLink': 'Siųsti naują prisijungimo nuorodą el. paštu',
    'login.magicLinkSent': 'Patikrinkite el. paštą - išsiuntėme naują prisijungimo nuorodą.',
    'login.loginSuccessful': 'Prisijungimas sėkmingas!',
    'login.devAccessNotAvailable': 'Kūrėjo prieiga negalima',
    'login.invalidCode': 'Neteisingas kodas',
    'login.accessPlaceholder': 'prieiga',
    'login.forgotPassword': 'Pamiršote slaptažodį?',
    'login.resetTitle': 'Slaptažodžio keitimas',
    'login.resetSubtitle': 'Atsiųsime jums keitimo nuorodą.',
    'login.submitReset': 'Siųsti nuorodą',
    'login.resetSent': 'Patikrinkite el. paštą - išsiuntėme keitimo nuorodą.',
    'login.resetRateLimited': 'El. laiškas jau išsiųstas - palaukite kelias minutes prieš bandydami dar kartą.',
    'login.resetWaitBtn': 'Palaukite {n}s',
    'login.newPasswordTitle': 'Naujas slaptažodis',
    'login.newPasswordSubtitle': 'Įveskite naują slaptažodį.',
    'login.newPasswordLabel': 'Naujas slaptažodis (min. 6)',
    'login.submitNewPassword': 'Nustatyti slaptažodį',
    'login.passwordUpdated': 'Slaptažodis pakeistas! Jungiamės...',
    'login.backToSignin': 'Atgal į prisijungimą',
    'login.fbEmailFallback': 'Arba prisijunkite el. paštu',
    'login.fbLinkCopied': 'Nuoroda nukopijuota - įklijuokite ją į Chrome arba Safari',

    'home.urgencyBanner': 'Prenumerata neaktyvi - atrakinkite visas funkcijas',
    'home.urgencyBannerCta': 'Žiūrėti planus',
    'subscription.choosePlanCta': 'Pasirinkti planą',
    'home.sessionsCompleted': '{n} sesijų atlikta',

    // Landing Page - Localization keys

    // Landing v2 - direct-pay funnel
    
    // Pricing Card
    'pricingCard.howManyMonths': 'Kiek mėnesių?',
    'pricingCard.fullAccess': 'Pilna prieiga prie visų funkcijų',
    'pricingCard.offline': 'Veikia be interneto',
    'pricingCard.newFeatures': 'Naujos funkcijos kas mėnesį',
    'pricingCard.cancelAnytime': 'Atšaukite bet kada',
    'pricingCard.tryBeforePay': 'Išbandykite prieš mokėdami',
    'pricingCard.lockInPrice': 'Nustatyti kainą',
    
    // Footer
    'footer.privacy': 'Privatumo politika',
    'footer.articles': 'Straipsniai',
    'footer.terms': 'Taisyklės',
    'footer.contact': 'Kontaktai',
    'footer.copyright': '© 2026 Time To Talk',
    'common.appName': 'Time To Talk',
    
    // Pricing Page
    'pricing.yourChildDeserves': 'Jūsų vaikas nusipelno būti išgirstas.',
    'pricing.feature1': 'Palieskite nuotrauką. Timo ją ištaria garsiai.',
    'pricing.feature2': 'Praktikuokite kalbas saugiai, savo tempu.',
    'pricing.feature3': 'Padėkite realiais pokalbiais. Realiuoju laiku.',
    'pricing.letsGo': 'Pradėkime',
    'pricing.cancelBeforeDay7': 'Atšaukite prieš 7-ą dieną. Nieko nemokite.',
    'pricing.reminderTitle': 'Jūs prisiminsite prieš jam pasibaigiant.',
    'pricing.today': 'Šiandien',
    'pricing.day5': '5 diena',
    'pricing.day5Desc': 'Jums siunčiame priminimo laišką.',
    'pricing.day7': '7 diena',
    'pricing.soundsGood': 'Gerai skamba',
    'pricing.controlIt': 'Jūs kontroliuojate. Atšaukite bet kada.',
    'pricing.choosePlan': 'Pasirinkite planą.',
    'pricing.fullAccessBadge': 'PILNA PRIEIGA',
    'pricing.perMonthLabel': 'per mėnesį',
    'pricing.fullAccessFromToday': 'Visi 3 režimai atveriami šiandien',
    'pricing.billedMonthlyCancelAnytime': 'Sąskaita kas mėnesį. Atšaukti galite bet kada.',
    'pricing.getAccessCta': 'Gauti prieigą',
    'pricing.chargedTodayNote': 'Mokestis nuskaitomas šiandien. Atšaukti galite bet kada: Profilis, tada Prenumerata.',
    'pricing.fullAccessSub': 'Pilna prieiga prie visų 3 režimų. Atšaukti galite bet kada.',
    'pricing.cancelAnytimeNote': 'Atšaukti galite bet kada: Profilis, tada Prenumerata.',
    'pricing.oldPrice': '€11.49/mėn',
    'pricing.foundingRate': 'Steigėjo kaina',
    'pricing.oneMonth': '1 Mėnuo',
    'pricing.threeMonths': '3 Mėnesiai',
    'pricing.sixMonths': '6 Mėnesiai',
    'pricing.monthlyPer': '/mėn',
    'pricing.monthlyWeek': '€1.50/savaitę',
    'pricing.quarterlyPrice': '€5.83',
    'pricing.quarterlyPer': '/mėn',
    'pricing.quarterlyWeek': '€1.35/savaitę',
    'pricing.popularBadge': 'POPULIARIAUSIA',
    'pricing.saveQuarterly': 'Sutaupykite €16',
    'pricing.biannualPrice': '€5.00',
    'pricing.biannualPer': '/mėn',
    'pricing.biannualWeek': '€1.15/savaitę',
    'pricing.bestValueBadge': 'GERIAUSIAS KURSAS',
    'pricing.saveBiannual': 'Sutaupykite €39',
    'pricing.switchesTo': 'Keičiasi į 6 mėnesių planą',
    'pricing.families': '🌍 130+ šeimų jau naudoja Time To Talk',
    'pricing.monthlyLabel': 'Mėnesinis',
    'pricing.buyNowCta': 'Gauti prieigą',
    'pricing.cancelBeforeDay30': 'Atšaukti galite bet kada: Profilis, tada Prenumerata.',
    'pricing.dueTodayLabel': 'šiandien',
    'pricing.thenPerDayBilled': 'vėliau {day}/dieną, sąskaita {billed}/mėn',
    'pricing.reassureTitle': 'Šiandien mokate 0',
    'pricing.reassureTodayLabel': 'Šiandien',
    'pricing.reassureAfterDesc': 'Tik {day}/dieną, jei liksite, atšaukti bet kada',
    'pricing.reassureCheap': 'Tai mažiau nei kavos puodelis per mėnesį',
    'pricing.reassureCta': 'Rodyti mano planą',
    'pricing.secureCheckoutStripe': 'Saugus mokėjimas per Stripe.',
    'pricing.offerPercentBadge': '{percent}% nuolaida',
    'pricing.breakoutReminderCta': 'Parodyti kaip',
    'pricing.founderName': 'Gintaras, įkūrėjas',
    'pricing.founderHeadline': 'Norite asmeninio pasiūlymo?',
    'pricing.founderBody': 'Trumpas 10 min pokalbis: sužinoti daugiau, padėti ir gal net gauti įžvalgų naujoms funkcijoms jums.',
    'pricing.teacherHeadline': 'Paruoškite „Time to Talk“ savo mokiniams.',
    'pricing.teacherSub': 'Pilna prieiga prie visų 3 režimų jūsų klasei. Atšaukti galite bet kada.',
    'pricing.teacherFeature1': 'Naudokite su kiekvienu mokiniu, kuriam padedate',
    'pricing.teacherFeature2': 'Lietuvių ir anglų kalbos, balsas įdiegtas',
    'pricing.teacherFeature3': 'Nemokamas pokalbis, kad pritaikytume jūsų klasei',
    'pricing.teacherFounderHeadline': 'Padėsiu jums viską paruošti',
    'pricing.teacherFounderBody': 'Trumpas 15 min pokalbis: padėsiu paruošti „Time to Talk" jūsų mokiniams ir atsakysiu į visus klausimus.',
    'pricing.founderCtaPrimary': 'Rezervuoti pokalbį su Gintaru',
    'pricing.founderSkip': 'Tęsti be pokalbio',
    'pricing.day27': '27 diena',
    'pricing.day27Desc': 'Jums siunčiame priminimo laišką.',
    'pricing.noActiveSubscription': 'Nerastas aktyvus prenumeratos planas. Jei ką tik sumokėjote, palaukite kelias minutes.',
    'pricing.errorCheckingSubscription': 'Klaida tikrinant prenumeratą. Bandykite dar kartą.',
    'pricing.checking': 'Tikrinama...',
    'pricing.restorePurchase': 'Atkurti pirkimą',
    'pricing.backToOnboarding': 'Atgal į onboarding',
    'pricing.somethingWentWrong': 'Kažkas nutiko. Bandykite dar kartą.',
    'pricing.promoErrorAlreadyAccount': 'Promo kodą {code} jau panaudojai. Užsisakyk žemiau, prenumerata aktyvuojama vienu paspaudimu.',
    'pricing.promoErrorAlreadyNetwork': 'Promo kodas {code} jau buvo panaudotas iš tavo tinklo. Užsisakyk žemiau, prenumerata aktyvuojama vienu paspaudimu.',
    'pricing.promoErrorGeneric': 'Nepavyko pritaikyti promo kodo {code}. Užsisakyk žemiau arba bandyk vėliau.',
    'pricing.promoErrorDismiss': 'Supratau',
    'pricing.terms': 'Sąlygos',
    'pricing.privacy': 'Privatumas',
    'success.badge': 'Jūs esate Premium',
    'success.title': 'Viskas paruošta.',
    'success.sub': 'Visos funkcijos atblokuotos ir paruoštos.',
    'success.cta': 'Pradėkime',
    'success.unlock1': 'Viskas atrakinta',
    'success.unlock2': 'Chat, Live ir „Kalbėk“ režimai aktyvūs',
    'success.unlock3': 'Jūsų paskyra paruošta visuose įrenginiuose',
    'success.footer': 'Visos Premium funkcijos aktyvios jūsų paskyroje.',
    'download.appInstalled': 'Programėlė įdiegta',
    'download.continuingOnboarding': 'Tęsiame įvedimą...',
    'download.installApp': 'Įdiegti programėlę',
    'download.bestExperience': 'Geriausia patirtis naudojant įdiegtą programėlę.',
    'download.apple': 'Apple',
    'download.iphoneIpad': 'iPhone / iPad',
    'download.android': 'Android',
    'download.chromeInstall': 'Chrome diegimas',
    'download.appleInstall': 'Apple diegimas',
    'download.homeScreenQuality': 'Geriausia patirtis iš pradžios ekrano.',
    'download.openSafari1': '1. Atidarykite šį puslapį Safari naršyklėje.',
    'download.openSafari2': '2. Safari paspauskite Share.',
    'download.openSafari3': '3. Spauskite Add to Home Screen, tada Add.',
    'download.copyLinkSafari': 'Kopijuoti nuorodą Safari',
    'download.linkCopiedSafari': 'Nuoroda nukopijuota. Atidarykite Safari ir įklijuokite nuorodą.',
    'download.copyFailed': 'Kopijuoti nepavyko. Nukopijuokite URL ranka ir atidarykite Safari.',
    'download.tapShare1': 'Paspauskite Share (kvadratas su rodykle).',
    'download.tapShare2': 'Paspauskite Add to Home Screen.',
    'download.tapShare3': 'Paspauskite Add.',
    'download.openShareMenu': 'Atidaryti Share meniu',
    'download.inAppBrowserHint': 'Jei esate Instagram/Facebook naršyklėje, atidarykite meniu ir spauskite Open in Safari.',
    'download.androidInstall': 'Android diegimas',
    'download.otherDeviceTitle': 'Norite programėlės kitame įrenginyje?',
    'download.otherDeviceBody': 'Atidarykite naršyklę tame įrenginyje, eikite į timohelps.com ir prisijunkite su tais pačiais duomenimis.',
    'download.otherDeviceHelp': 'Kilo problemų? Parašykite mums:',
    'download.androidStep1': 'Atidarykite Chrome meniu (⋮ viršutiniame dešiniajame kampe)',
    'download.androidStep2': 'Paspauskite "Pridėti į pagrindinį ekraną" arba "Įdiegti programėlę"',
    'download.androidStep3': 'Paspauskite "Įdiegti" patvirtinimui',
    'download.promptAutoOpen': 'Diegimo langas turėtų atsidaryti automatiškai.',
    'download.promptAutoOpenAndroid': 'Android (Chrome) diegimo langas gali atsidaryti automatiškai.',
    'download.androidInstallOnlyNote':
      'Vieno paspaudimo diegimas skirtas Android (Chrome). „iPhone“ ir „iPad“ naudokite „Add to Home Screen“ - žemiau.',
    'download.iosInstallTitle': 'iPhone ir iPad',
    'download.iosInstallHint':
      'Safari: Share → Add to Home Screen. Jei nematote - Share lape paspauskite „More“, tada Add to Home Screen, tada Add.',
    'download.downloadApp': 'Atsisiųsti programėlę',
    'download.promptNotOpen': 'Diegimo langas neatsidarė. Atidarykite naršyklės meniu ir pasirinkite "Install app" arba "Add to Home screen".',
    'download.desktopHint': 'Geriausiam rezultatui atidarykite šiame iPhone/iPad/Android įrenginyje ir įdiekite programėlę.',
    'download.backToLanding': 'Atgal į svetainę',
    'download.continueWeb': 'Tęsti naršyklėje',
    'download.webUseEverything': 'Vis tiek galite naudoti visas funkcijas naršyklėje.',
    'download.windowsTitle': 'Windows ir kompiuteris',
    'download.windowsHint': 'Naršyklės adreso juostoje paspauskite diegimo piktogramą (rekomenduojama Chrome arba Edge).',
    'download.iosVideoSoon': 'Video gidas netrukus',
    'download.continueSetup': 'Testi nustatymus',
    'download.installedSuccess': 'Programele sekmingai idiegta',
    'landingPricing.oldPriceCurrency': '€11.49/mėn',
    'landingPricing.oneMonth': '1 mėnuo',
    'landingPricing.threeMonths': '3 mėnesiai',
    'landingPricing.sixMonths': '6 mėnesiai',
    'landingPricing.perMonth': '/mėn',
    'landingPricing.week1': '€1.50/sav',
    'landingPricing.week3': '€1.35/sav',
    'landingPricing.week6': '€1.15/sav',
    'landingPricing.badgePopular': 'POPULIARIAUSIAS',
    'landingPricing.badgeBest': 'GERIAUSIA KAINA',
    'landingPricing.save16': 'Sutaupote €16',
    'landingPricing.save39': 'Sutaupote €39',

    'cookie.title': 'Slapukai',
    'cookie.body': 'Naudojame slapukus analitikai, o puslapiuose, į kuriuos patenkate iš mūsų reklamos, - reklamos veiksmingumui matuoti (Meta Pixel). Tai padeda tobulinti programą. Niekada neparduodame jūsų duomenų, o programa pilnai veikia ir jei atsisakysite.',
    'cookie.accept': 'Sutinku',
    'cookie.decline': 'Atsisakau',
    'cookie.learnMore': 'Privatumo politika',

    // Pakvietimo puslapis
    'referral.pageTitle': 'Pakviesk draugus, gauk nemokamų mėnesių',
    'referral.pageSubtitle': 'Pasidalink Time To Talk. Kai draugas sumoka už pirmą mėnesį, tu gauni vieną mėnesį nemokamai.',
    'referral.heroEarnedLabel': 'Tu uždirbai',
    'referral.heroMonths': '{n} mėnesių',
    'referral.heroOneMonth': '1 mėnesį',
    'referral.heroNoMonths': '0 mėnesių',
    'referral.heroFromConversions': 'iš {n} pakvietimų',
    'referral.heroFromOneConversion': 'iš 1 pakvietimo',
    'referral.heroFromZero': 'kol kas nėra pakvietimų',
    'referral.heroCapUsed': '{used} iš {total} metinio limito',
    'referral.heroFirstTime': 'Pasidalink nuoroda ir uždirbk savo pirmą nemokamą mėnesį.',
    'referral.codeLabel': 'Tavo kodas',
    'referral.linkLabel': 'Tavo nuoroda',
    'referral.copy': 'Kopijuoti nuorodą',
    'referral.copied': 'Nukopijuota!',
    'referral.share': 'Dalintis',
    'referral.shareNative': 'Dalintis',
    'referral.shareWhatsapp': 'WhatsApp',
    'referral.shareMessenger': 'Messenger',
    'referral.shareEmail': 'El. paštas',
    'referral.shareSms': 'SMS',
    'referral.shareMessage': 'Naudoju Timo Helps, kad padėčiau vaikui mokytis kalbėti garsiai. Pažiūrėk: {link}',
    'referral.shareEmailSubject': 'Išbandyk Time To Talk su manimi',
    'referral.howTitle': 'Kaip tai veikia',
    'referral.howStep1': 'Nusiųsk savo nuorodą draugui.',
    'referral.howStep2': 'Draugas užsiprenumeruoja per tavo nuorodą.',
    'referral.howStep3': 'Kai draugas sumoka už pirmą mėnesį, tu automatiškai gauni 1 mėnesį nemokamai.',
    'referral.rules': 'Vienas atlygis už draugą. Iki 12 nemokamų mėnesių per metus. Saviapgaulė ir bendros paskyros neatlyginamos.',
    'referral.errorLoad': 'Nepavyko įkelti pakvietimo informacijos. Atnaujink puslapį.',
    'referral.capReached': 'Šiais metais pasiekei 12 nemokamų mėnesių limitą. Ačiū, kad dalinies.',
    'referral.bannerInvited': 'Pakviestas draugo. Sveiki atvykę į Timo Helps.',
    'referral.bannerInvitedShort': 'Pakviestas draugo.',
    'referral.announceTitle': 'Naujiena: 1 mėnuo nemokamai',
    'referral.announceBody': 'Pakviesk draugą į Time To Talk. Kai draugas sumoka už pirmą mėnesį, tu gauni vieną nemokamai.',
    'referral.announceCta': 'Sužinok daugiau',
    'referral.announceLater': 'Gal vėliau',
    'referral.youGetLabel': 'Tu gauni',
    'referral.youGetReward': '1 mėnesį nemokamai',
    'referral.friendGetsLabel': 'Draugas gauna',
    'referral.friendGetsReward': 'visą prieigą iškart',
    'referral.linkOnlyNote': 'Tik ši tiksli nuoroda užskaitys pakvietimą. Vien kodo nusiuntimas neveiks.',


    // --- Native iOS port (WS-2 auth, WS-3 purchases, WS-4 speech, WS-5 media,
    //     WS-6 install, WS-7 AI consent and content reporting). Merged from
    //     src/native/_i18n/*.strings.json. Additive: no existing key was changed.
    'native.auth.browserUnavailable': 'Nepavyko atidaryti prisijungimo lango. Bandykite dar kartą.',
    'native.auth.oauthCancelled': 'Prisijungimas atšauktas.',
    'native.auth.oauthFailed': 'Prisijungimas nebuvo užbaigtas. Bandykite dar kartą.',
    'native.auth.passwordResetOpensBrowser': 'Slaptažodžio keitimas atsidarys saugiame naršyklės puslapyje. Pasikeitę slaptažodį grįžkite čia ir prisijunkite su nauju.',
    'native.auth.sessionFailed': 'Nepavyko užbaigti prisijungimo. Bandykite dar kartą.',
    'native.consent.agree': 'Sutinku',
    'native.consent.contact': 'Turite klausimų? Rašykite:',
    'native.consent.declinedAgree': 'Persigalvojau, sutinku',
    'native.consent.declinedBody': 'Be šio sutikimo Timo negali nei klausytis, nei atsakyti. Toliau galėsite naudotis paveikslėliais, išsaugotais scenarijais ir visais nustatymais. Kai būsite pasiruošę, įjunkite tai nustatymuose, skiltyje Privatumas.',
    'native.consent.declinedContinue': 'Tęsti be Timo balso',
    'native.consent.declinedTitle': 'Kol kas Timo tylės',
    'native.consent.forLabel': 'Kam:',
    'native.consent.getsLabel': 'Gauna:',
    'native.consent.intro': 'Timo pasitelkia kelias išorines įmones: jos paverčia kalbą tekstu, sukuria atsakymus ir juos ištaria. Vadinasi, dalis to, ką pasakote ar parašote, keliauja pas jas. Štai kas jos yra ir ką kiekviena gauna.',
    'native.consent.notNow': 'Ne dabar',
    'native.consent.privacyLink': 'Skaityti privatumo politiką',
    'native.consent.proc.anthropic.purpose': 'Timo atsakymams kurti',
    'native.consent.proc.anthropic.receives': 'Jūsų pokalbio su Timo tekstas',
    'native.consent.proc.deepgram.purpose': 'Kalbai paversti tekstu',
    'native.consent.proc.deepgram.receives': 'Jūsų balsas, kol įjungtas mikrofonas',
    'native.consent.proc.elevenlabs.purpose': 'Tam tekstui paversti Timo balsu',
    'native.consent.proc.elevenlabs.receives': 'Tekstas, kurį Timo ruošiasi ištarti',
    'native.consent.proc.google.purpose': 'Timo atsakymams kurti, kai dirba Google',
    'native.consent.proc.google.receives': 'Jūsų pokalbio su Timo tekstas',
    'native.consent.proc.openai.purpose': 'Lietuvių kalbos gramatikai patikrinti',
    'native.consent.proc.openai.receives': 'Timo atsakymų tekstas lietuvių kalba',
    'native.consent.promise': 'Mes neparduodame jūsų duomenų ir nenaudojame jų reklamai. Bet kada galite tai išjungti nustatymuose. Išjungus Timo nebegalės nei klausytis, nei atsakyti, o visa kita programėlėje veiks kaip anksčiau.',
    'native.consent.settings.agreedOn': 'Sutikote',
    'native.consent.settings.confirmBody': 'Timo nustos klausytis ir atsakyti. Visa kita programėlėje veiks kaip anksčiau, o įjungti galėsite bet kada.',
    'native.consent.settings.confirmKeep': 'Palikti įjungtą',
    'native.consent.settings.confirmTitle': 'Išjungti?',
    'native.consent.settings.confirmTurnOff': 'Išjungti',
    'native.consent.settings.description': 'Leidžia Timo siųsti kalbą ir pokalbio tekstą žemiau išvardytoms įmonėms, kad jis galėtų klausytis, atsakyti ir kalbėti.',
    'native.consent.settings.label': 'Dalytis su DI paslaugomis',
    'native.consent.settings.offNote': 'Kol tai išjungta, Timo negali nei klausytis, nei atsakyti.',
    'native.consent.settings.section': 'Privatumas',
    'native.consent.settings.whoGetsWhat': 'Kas ką gauna',
    'native.consent.title': 'Prieš pradedant kalbėtis su Timo',
    'native.install.alreadyInstalledBody': 'Šiame įrenginyje jau naudojatės Timo programėle, todėl nieko diegti nereikia.',
    'native.install.alreadyInstalledTitle': 'Programėlę jau turite',
    'native.install.otherDevices': 'Norite Timo ir kitame įrenginyje? Prisijunkite ten su ta pačia paskyra ir viskas jūsų jau lauks.',
    'native.manage.appleBilled': 'Šią prenumeratą tvarko „Apple“. Atšaukti ar pakeisti planą galite „App Store“ prenumeratų nustatymuose.',
    'native.manage.cta': 'Tvarkyti „App Store“',
    'native.manage.failed': 'Nepavyko atidaryti „App Store“ prenumeratų. Atidarykite „Nustatymai“, palieskite savo vardą ir pasirinkite „Prenumeratos“.',
    'native.mic.backgroundStopped': 'Klausymas nutrūko, nes programa persijungė į foną. Bakstelėkite ir pradėkite iš naujo.',
    'native.mic.continueWithoutMic': 'Tęsti be mikrofono',
    'native.mic.deniedBody': '„iPhone“ paklausia tik vieną kartą. Atidarykite nustatymus ir įjunkite mikrofoną Timo programai.',
    'native.mic.deniedTitle': 'Mikrofonas išjungtas',
    'native.mic.openSettings': 'Atidaryti nustatymus',
    'native.mic.primerAllow': 'Leisti naudoti mikrofoną',
    'native.mic.primerBody': 'Kad Timo išgirstų, ką pasakė kitas žmogus, ir padėtų jums atsakyti.',
    'native.mic.primerNotNow': 'Ne dabar',
    'native.mic.primerPoint1': 'Balsas naudojamas tik tam, kad kalba būtų paversta tekstu.',
    'native.mic.primerPoint2': 'Įrašoma tik tuo metu, kai vyksta pokalbio eilė, niekada fone.',
    'native.mic.primerPoint3': 'Mikrofoną bet kada galite vėl išjungti nustatymuose.',
    'native.mic.primerTitle': 'Timo reikia jūsų mikrofono',
    'native.mic.unavailableBody': 'Šiame įrenginyje Timo neranda mikrofono.',
    'native.mic.unavailableTitle': 'Mikrofono nerasta',
    'native.minors.affirmation': 'Paspausdami „Sutinku“ patvirtinate, kad esate vienas iš tėvų ar globėjas arba kad jums yra 16 metų ar daugiau.',
    'native.minors.ageNote': 'Daugumoje Europos šalių už jaunesnius nei 16 metų sutikimą duoda tėvai ar globėjai. Lietuvoje ši riba yra 14 metų, o Jungtinėse Valstijose ji siekia 13 metų.',
    'native.minors.askGrownUp': 'Paprašykite tėvų ar globėjo peržiūrėti tai kartu su jumis ir paspausti „Sutinku“ už jus.',
    'native.minors.underAgeLink': 'Man mažiau nei 16 metų',
    'native.personalVoice.allow': 'Leisti asmeninį balsą',
    'native.personalVoice.denied': 'Timo neturi leidimo naudoti jūsų asmeninį balsą. Įjunkite „Leisti programėlėms prašyti naudoti“: Nustatymai, Pritaikymas neįgaliesiems, Asmeninis balsas.',
    'native.personalVoice.description': 'Jei šiame „iPhone“ ar „iPad“ įrašėte asmeninį balsą, Timo gali juo kalbėti. Balsas sukuriamas įrenginyje, jame ir lieka, ir niekur nesiunčiamas.',
    'native.personalVoice.languageUnavailable': '„Apple“ asmeninį balsą siūlo tik anglų, ispanų ir kinų kalbomis, todėl šia kalba jis dar kalbėti negali.',
    'native.personalVoice.none': 'Šiame įrenginyje asmeninis balsas dar neįrašytas. Galite jį sukurti: Nustatymai, Pritaikymas neįgaliesiems, Asmeninis balsas.',
    'native.personalVoice.ready': 'Asmeninis balsas paruoštas. Pasirinkite jį balsų sąraše.',
    'native.personalVoice.speaking': 'Kalba jūsų asmeniniu balsu',
    'native.personalVoice.title': 'Naudoti asmeninį balsą',
    'native.personalVoice.unsupportedDevice': 'Šiame įrenginyje asmeninio balso sukurti negalima. Reikia naujesnio „iPhone“ ar „iPad“.',
    'native.purchase.alreadyOwned': 'Šis planas jau nupirktas. Paspauskite „Atkurti pirkimą“, kad prieiga grįžtų.',
    'native.purchase.failed': 'Nepavyko užbaigti pirkimo. Bandykite dar kartą arba parašykite mums ir mes padėsime.',
    'native.purchase.network': 'Nėra ryšio su „App Store“. Patikrinkite interneto ryšį ir bandykite dar kartą.',
    'native.purchase.notAllowed': 'Šiame įrenginyje pirkimai išjungti. Patikrinkite „Ekrano laiko“ apribojimus nustatymuose.',
    'native.purchase.pending': 'Pirkimas laukia patvirtinimo. Kai jis bus patvirtintas, prieiga atsidarys automatiškai.',
    'native.purchase.signInFirst': 'Pirmiausia prisijunkite, kad prenumerata būtų susieta su jūsų paskyra.',
    'native.purchase.unavailable': '„App Store“ dabar nepasiekiama. Pabandykite po kelių minučių.',
    'native.report.body': 'Ačiū, kad pranešate. Timo atsakymus kuria kompiuteris, todėl jis kartais suklysta. Parašykite, kas nutiko, ir tai perskaitys žmogus.',
    'native.report.cancel': 'Atšaukti',
    'native.report.done': 'Gerai',
    'native.report.error': 'Pranešimo išsiųsti nepavyko. Patikrinkite ryšį ir bandykite dar kartą.',
    'native.report.noteLabel': 'Jei norite, parašykite plačiau (nebūtina)',
    'native.report.reason.language': 'Atsakymas buvo ne ta kalba',
    'native.report.reason.other': 'Kas kita',
    'native.report.reason.unkind': 'Buvo nemandagu arba įžeidu',
    'native.report.reason.unsafe': 'Buvo nesaugu vaikui',
    'native.report.reason.wrong': 'Atsakymas buvo klaidingas arba painus',
    'native.report.safetyNote': 'Jei kam nors dabar gresia pavojus, kreipkitės į pagalbos tarnybas numeriu 112.',
    'native.report.send': 'Siųsti pranešimą',
    'native.report.sending': 'Siunčiama...',
    'native.report.sentBody': 'Kiekvieną pranešimą perskaito žmogus. Jei norite atsakymo, rašykite:',
    'native.report.sentTitle': 'Pranešimas išsiųstas. Ačiū.',
    'native.report.stopConversation': 'Taip pat baigti šį pokalbį',
    'native.report.title': 'Pranešti apie šį atsakymą',
    'native.report.trigger': 'Pranešti apie šį atsakymą',
    'native.restore.restored': 'Prieiga atkurta. Sveiki sugrįžę!',
    'native.speech.interrupted': 'Klausymas sustojo dėl skambučio ar kito garso. Bakstelėkite, kad pradėtumėte iš naujo.',
    'native.speech.languageNotSupported': 'Šis „iPhone“ pats šios kalbos neatpažįsta, todėl Timo klauso taip, kaip visada.',
    'native.speech.onDevice': 'Jūsų balsas lieka šiame įrenginyje',
    'native.speech.permissionNeeded': 'Timo reikia mikrofono ir kalbos atpažinimo, kad jus išgirstų. Juos galite įjungti nustatymuose.',
    'native.voice.preview': 'Išgirsti šį balsą',
    'native.voice.systemVoices': 'Balsai šiame įrenginyje',
    'native.voice.title': 'Timo balsas',
    'pushToTalk.micBackgroundTitle': 'Klausymas nutrūko',
    'pushToTalk.micBlockedBody': 'Mikrofonas užblokuotas, todėl nieko neįrašėme. Leiskite naudoti mikrofoną arba parašykite, ką jie pasakė.',
    'pushToTalk.micBlockedTitle': 'Timo negirdi',
    'pushToTalk.micNotNowBody': 'Mikrofoną galite įjungti bet kada. Kol kas parašykite, ką jie pasakė.',
    'pushToTalk.micNotNowTitle': 'Mikrofonas išjungtas',
    'pushToTalk.micProblemBody': 'Klausymas netikėtai nutrūko, todėl nieko neįrašėme. Bandykite dar kartą arba parašykite, ką jie pasakė.',
    'pushToTalk.micProblemTitle': 'Klausymas nutrūko',
    'pushToTalk.micUnavailableBody': 'Šiame įrenginyje Timo neranda mikrofono. Galite parašyti, ką jie pasakė.',
    'pushToTalk.micUnavailableTitle': 'Mikrofono nerasta',
    'pushToTalk.micUnsupportedBody': 'Čia kalbos atpažinimas neveikia, todėl nieko neįrašėme. Galite parašyti, ką jie pasakė.',
    'pushToTalk.micUnsupportedTitle': 'Ši naršyklė negali klausytis',
    'settings.microphone.checkDesc': 'Sužinokite, ar Timo jus girdi, ir pataisykite, jei ne',
    'settings.microphone.checkLabel': 'Patikrinti mikrofono prieigą',
    'settings.microphone.denied': 'Mikrofonas užblokuotas. Atidarykite nustatymus ir jį leiskite.',
    'settings.microphone.granted': 'Mikrofonas veikia',
    'settings.microphone.title': 'Mikrofonas',
    'settings.microphone.unavailable': 'Šiame įrenginyje mikrofono nerasta',

    // --- merged from src/native/_i18n: WS-C, WS-F, PRIVACY ---
    // WS-C
    'chat.ariaGoBack': 'Grįžti atgal',
    'chat.ariaInputMode': 'Įvesties būdas',
    'chat.ariaInputModeSpeak': 'Kalbėti',
    'chat.ariaInputModeType': 'Rašyti',
    'chat.ariaPlayAloud': 'Perskaityti balsu',
    'chat.ariaSendMessage': 'Siųsti žinutę',
    'chat.ariaRecordMe': 'Įrašyti mano balsą',
    'chat.ariaRecordOther': 'Įrašyti kitą žmogų',
    'live.ariaFlipSpeakers': 'Sukeisti kalbėtojus',
    'live.ariaClearConversation': 'Išvalyti pokalbį',
    'live.ariaCalibrationSettings': 'Kalibravimo nustatymai',
    'live.ariaClose': 'Uždaryti',
    'live.whatShouldISay': 'Ką man pasakyti?',
    'live.manageScriptsHint': 'Išsaugotus tekstus galite tvarkyti skiltyje Tekstai.',
    'live.safetyTitle': 'Saugumo įspėjimas',
    'live.safetyBody': 'Šis pokalbis gali būti nesaugus. Jei jaučiatės grasinami, iš karto pasitraukite.',
    'quickChoice.send': 'Siųsti',
    'quickChoice.tellMeMorePlaceholder': 'Papasakok daugiau...',
    // WS-F
    'common.closeAria': 'Uždaryti',
    'common.goBackAria': 'Grįžti atgal',
    // PRIVACY
    'privacy.minors.heading': '5. Vaikai, nepilnamečiai ir tėvų sutikimas',
    'privacy.minors.s1.heading': '5.1 Kam skirta ši programėlė ir kam priklauso paskyra',
    'privacy.minors.s1.p1': '„Time To Talk“ (programėlė „Timo“) sukurta vaikams, kurių kalba vėluoja, autistiškiems vaikams ir suaugusiesiems bei visiems, kuriems kalbėti sunku. Daugelis mūsų naudotojų yra vaikai.',
    'privacy.minors.s1.p2': 'Paskyra priklauso suaugusiajam: vienam iš tėvų, globėjui, slaugytojui, terapeutui ar mokytojui. Tas suaugusysis sukuria paskyrą, turi prisijungimo duomenis ir moka už prenumeratą. Vaikas pats neužsiregistruoja.',
    'privacy.minors.s1.p3': 'Vis dėlto programėle naudojasi vaikas. Kai jis ja naudojasi, programėlė gauna tai, ką jis rašo, o kol įjungtas mikrofonas, ir tai, ką jis sako. Verčiau pasakome tai atvirai, nei teigtume, kad iš vaikų negauname nieko.',
    'privacy.minors.s2.heading': '5.2 Nuo kokio amžiaus sutikimą turi duoti tėvai ar globėjas',
    'privacy.minors.s2.intro': 'Jei programėle besinaudojantis asmuo yra jaunesnis nei jūsų šaliai nurodytas amžius, prieš pradedant ja naudotis sutikimą turi duoti vienas iš tėvų, globėjas ar slaugytojas.',
    'privacy.minors.s2.col.where': 'Kur esate',
    'privacy.minors.s2.col.age': 'Tėvai ar globėjas turi duoti sutikimą už jaunesnius nei',
    'privacy.minors.s2.col.rule': 'Kokia taisyklė tai nustato',
    'privacy.minors.s2.lt.where': 'Lietuva',
    'privacy.minors.s2.lt.age': '14',
    'privacy.minors.s2.lt.rule': 'BDAR 8 straipsnis ir Lietuvos teisėje nustatytas amžius',
    'privacy.minors.s2.us.where': 'Jungtinės Valstijos',
    'privacy.minors.s2.us.age': '13',
    'privacy.minors.s2.us.rule': 'COPPA, Vaikų privatumo internete apsaugos aktas',
    'privacy.minors.s2.eu.where': 'Kitos ES ir EEE šalys',
    'privacy.minors.s2.eu.age': '16, nebent jūsų šalis nustatė mažesnį amžių, kuris niekada negali būti mažesnis nei 13',
    'privacy.minors.s2.eu.rule': 'BDAR 8 straipsnis',
    'privacy.minors.s2.world.where': 'Visos kitos šalys',
    'privacy.minors.s2.world.age': '16',
    'privacy.minors.s2.world.rule': 'Mūsų pačių taisyklė, taikoma visame pasaulyje',
    'privacy.minors.s2.p1': 'Lietuva yra mūsų gimtoji šalis ir pagrindinė rinka. Čia ši riba yra 14 metų.',
    'privacy.minors.s2.p2': 'Prieš siunčiant bet kokį pokalbį 5.4 punkte išvardytoms įmonėms, programėlė parodo langą, kuriame įvardija kiekvieną iš jų ir paprašo sutikimo. Sakinys virš mygtuko „Sutinku“ prašo patvirtinti, kad esate vienas iš tėvų, globėjas ar slaugytojas arba kad jums yra 16 metų ar daugiau. Jei vaikas paspaudžia „Man mažiau nei 16 metų“, nieko blogo neįvyksta ir niekas nebarama: programėlė tiesiog paprašo pasikviesti suaugusįjį. Vėliau šį sutikimą galite atšaukti nustatymuose, skiltyje Privatumas.',
    'privacy.minors.s2.p3': 'Mes niekada neklausiame gimimo datos. Klausdami rinktume daugiau informacijos apie vaiką, o šis skyrius yra kaip tik apie priešingą dalyką.',
    'privacy.minors.s3.heading': '5.3 Ką renkame, kai programėle naudojasi vaikas',
    'privacy.minors.s3.intro': 'Tris dalykus:',
    'privacy.minors.s3.email': 'El. pašto adresą, vieną kartą, registruojantis. Tai suaugusio paskyros savininko adresas. Vaiko niekada neprašome jo paties el. pašto adreso.',
    'privacy.minors.s3.text': 'Pokalbio tekstą. Tai, kas parašoma ar pasakoma Timo, ir tai, ką Timo atsako. Praktikos pokalbiai išsaugomi paskyroje, kad vėliau juos būtų galima atsiversti skiltyje Istorija. Ten kiekvieną iš jų galima ištrinti.',
    'privacy.minors.s3.voice': 'Balsą, tik kol įjungtas mikrofonas. Garso įrašas iš įrenginio keliauja tiesiai į „Deepgram“, kuri paverčia jį tekstu. Balso įrašų savo serveriuose nesaugome. Mikrofonas išjungtas, kol jo neįjungiate.',
    'privacy.minors.s3.p2': 'Vaiko neklausiame nei tikro vardo, nei namų adreso, nei telefono numerio, nei mokyklos, nei nuotraukos, nei amžiaus, nei diagnozės. Nė vienas programėlės veiksmas jų nereikalauja. Jei kas nors iš to parašoma pokalbyje, tai išsaugoma kartu su pokalbiu ir galite tai ištrinti skiltyje Istorija.',
    'privacy.minors.s4.heading': '5.4 Įmonės, kurios gauna šiuos duomenis',
    'privacy.minors.s4.intro': 'Timo negali nei klausytis, nei atsakyti, nei kalbėti be išorinių įmonių pagalbos. Šios penkios mato pokalbio turinį. Tą patį sąrašą programėlė parodo prieš jums sutinkant.',
    'privacy.minors.s4.col.company': 'Įmonė',
    'privacy.minors.s4.col.receives': 'Ką gauna',
    'privacy.minors.s4.col.purpose': 'Kam tai reikalinga',
    'privacy.minors.s4.anthropic.receives': 'Jūsų pokalbio su Timo tekstas',
    'privacy.minors.s4.anthropic.purpose': 'Timo atsakymams kurti',
    'privacy.minors.s4.google.receives': 'Jūsų pokalbio su Timo tekstas',
    'privacy.minors.s4.google.purpose': 'Timo atsakymams kurti, kai dirba Google',
    'privacy.minors.s4.openai.receives': 'Timo atsakymų tekstas lietuvių kalba',
    'privacy.minors.s4.openai.purpose': 'Lietuvių kalbos gramatikai patikrinti',
    'privacy.minors.s4.deepgram.receives': 'Jūsų balsas, kol įjungtas mikrofonas',
    'privacy.minors.s4.deepgram.purpose': 'Kalbai paversti tekstu',
    'privacy.minors.s4.elevenlabs.receives': 'Tekstas, kurį Timo ruošiasi ištarti',
    'privacy.minors.s4.elevenlabs.purpose': 'Tam tekstui paversti Timo balsu',
    'privacy.minors.s4.note': '„Google“ gauna pokalbio tekstą tik tada, kai ji yra aktyvi modelio tiekėja. „OpenAI“ naudojama tik lietuvių kalbai, kad pataisytų jau parašyto Timo atsakymo gramatiką. „Deepgram“ kai kuriomis kalbomis naudojama ir kaip atsarginis balsas, ir tada ji gauna tekstą, kurį Timo ruošiasi ištarti.',
    'privacy.minors.s4.others': 'Kitos įmonės, su kuriomis dirbame ir kurios išvardytos 7 skyriuje, tvarko paskyros, mokėjimų, el. laiškų ir analitikos dalį, o ne patį pokalbį.',
    'privacy.minors.s4.noPermission': 'Nė vienai iš šių įmonių neleidžiama naudoti vaiko duomenų savo reklamai ar savo modeliams mokyti daugiau, nei nurodyta jų paskelbtose taisyklėse.',
    'privacy.minors.s5.heading': '5.5 Ko su vaiko duomenimis niekada nedarome',
    'privacy.minors.s5.item1': 'Niekada jų neparduodame. Niekam, jokia forma ir už jokią kainą.',
    'privacy.minors.s5.item2': 'Niekada jų nenaudojame reklamai ir niekada nekuriame vaikų reklaminių profilių.',
    'privacy.minors.s5.item3': 'Niekada jų nenaudojame dirbtinio intelekto modeliams mokyti, nei savo, nei kieno nors kito.',
    'privacy.minors.s5.item4': 'Niekada jų nenaudojame vaiko elgesio, psichologiniams, klinikiniams ar ugdymo profiliams kurti.',
    'privacy.minors.s5.item5': 'Niekada jų neskelbiame ir niekada nerodome kitiems naudotojams.',
    'privacy.minors.s5.pixel': 'Mūsų viešoje svetainėje ir programėlės puslapiuose veikia 12 skyriuje aprašyta „Meta“ reklamos matavimo žymė. Ji skaičiuoja puslapių peržiūras ir registracijas, kad žinotume, kurios reklamos veikia. Ji niekada negauna pokalbių turinio, balso ar to, ką vaikas rašo.',
    'privacy.minors.s6.heading': '5.6 Ko gali paprašyti tėvai ar globėjas',
    'privacy.minors.s6.intro': 'Bet kada galite:',
    'privacy.minors.s6.see': 'Pamatyti duomenis. Paprašyti visos apie paskyrą turimos informacijos kopijos.',
    'privacy.minors.s6.correct': 'Ištaisyti duomenis. Paprašyti pataisyti tai, kas neteisinga.',
    'privacy.minors.s6.delete': 'Ištrinti duomenis. Trinti pokalbius po vieną skiltyje Istorija arba ištrinti visą paskyrą.',
    'privacy.minors.s6.withdraw': 'Atšaukti sutikimą. Atšaukti dirbtinio intelekto sutikimą nustatymuose, skiltyje Privatumas. Tada Timo nustos klausytis ir atsakinėti. Paveikslėliai, išsaugoti scenarijai ir visi nustatymai veiks toliau. Atšaukimas nepanaikina anksčiau teisėtai atlikto duomenų tvarkymo.',
    'privacy.minors.s6.deleteHeading': 'Paskyros ištrynimas. Nustatymuose yra mygtukas „Ištrinti paskyrą“. Kai jį paspaudžiate:',
    'privacy.minors.s6.step1': 'Pirmiausia atšaukiame visas jūsų galiojančias prenumeratas „Stripe“ sistemoje, kad daugiau nebūtumėte apmokestinti.',
    'privacy.minors.s6.step2': 'Jei bent vieno atšaukimo nepavyksta atlikti, sustojame ir paskyros neištriname. Pamatysite klaidos pranešimą su prašymu susisiekti, o mes darbą užbaigsime rankiniu būdu. Geriau palikti jus prisijungusius, nei palikti mokančius už paskyrą, kurios nebepasiekiate.',
    'privacy.minors.s6.step3': 'Jei atšaukti pavyksta, iš savo autentifikavimo sistemos ištriname jūsų prisijungimą ir paskyros įrašą: el. pašto adresą, slaptažodį bei kartu saugomus nustatymų ir sutikimų įrašus.',
    'privacy.minors.s6.step4': 'Jūsų prenumeratos įrašą pažymime kaip atšauktą ir išsaugome nedidelį ištrynimo įrašą: el. pašto adresą, datą ir atšauktos prenumeratos numerį. Jis reikalingas tam, kad galėtume parodyti, kada paskyra buvo ištrinta ir kad mokėjimai sustabdyti.',
    'privacy.minors.s6.step5': 'Mokėjimų ir sąskaitų įrašai lieka „Stripe“ tiek, kiek reikalauja Lietuvos buhalterinės apskaitos teisė, tai yra dešimt metų. Žr. 9 skyrių. Anksčiau jų ištrinti negalime.',
    'privacy.minors.s6.after': 'Jei norite, kad būtų pašalinta dar kas nors, ko mygtukas nepasiekia, parašykite mums ir mes tai padarysime rankiniu būdu.',
    'privacy.minors.s7.heading': '5.7 Kaip su mumis susisiekti dėl vaiko duomenų',
    'privacy.minors.s7.p1': 'Rašykite info@timetotalk.lt. Laiško temoje nurodykite „Vaiko duomenų prašymas“ ir parašykite paskyros el. pašto adresą.',
    'privacy.minors.s7.p2': 'Atsakome į kiekvieną prašymą. Jūsų prašymo gavimą patvirtinsime per 5 darbo dienas, o patį prašymą įvykdysime per 30 dienų, kaip nustato BDAR. Jei prašymas sudėtingas ir mums reikia daugiau laiko, pranešime apie tai dar nepasibaigus 30 dienų ir paaiškinsime kodėl. Pirmiausia galime turėti įsitikinti, kad esate paskyros savininkas, nes atiduoti vaiko duomenis ne tam žmogui būtų daug didesnė klaida nei lėtas atsakymas.',
    'privacy.minors.s7.p3': 'Taip pat galite pateikti skundą Valstybinei duomenų apsaugos inspekcijai (vdai.lrv.lt arba ada@ada.lt) arba savo EEE šalies duomenų apsaugos institucijai.',
    'privacy.minors.s8.heading': '5.8 Kiek laiko saugome vaiko duomenis',
    'privacy.minors.s8.intro': '9 skyriuje nurodyti visų duomenų kategorijų saugojimo terminai. Trumpai:',
    'privacy.minors.s8.voice': 'Balsas: jo visai nesaugome.',
    'privacy.minors.s8.conversations': 'Pokalbiai: saugomi paskyroje, kol juos ištrinate skiltyje Istorija arba ištrinate paskyrą.',
    'privacy.minors.s8.account': 'Paskyros duomenys, įskaitant el. pašto adresą: kaip nurodyta 9 skyriuje.',
    'privacy.minors.s8.p2': 'Jei manote, kad vaikas užsiregistravo tėvams ar globėjui apie tai nežinant, rašykite info@timetotalk.lt. Patikrinę prašymą, paskyrą ir jos duomenis nedelsdami ištrinsime.',
  },

  de: {
    // daily-words
    "dailyWords.row": "Lernwörter",
    "dailyWords.rowHint": "Die Wörter, die Ihr Kind jeden Tag lernt",
    "dailyWords.title": "Lernwörter",
    "dailyWords.intro": "Tragen Sie die Wörter ein, die Ihr Kind gerade lernt. Timo zeigt jeden Tag eines und bittet Ihr Kind, es zu sagen.",
    "dailyWords.close": "Schließen",
    "dailyWords.modeTitle": "Welche Wörter Timo zeigt",
    "dailyWords.modeMine": "Nur meine Wörter",
    "dailyWords.modeMineHint": "Jeden Tag eines Ihrer Wörter, in der Reihenfolge der Liste.",
    "dailyWords.modeMix": "Meine Wörter und Timos",
    "dailyWords.modeMixHint": "Einen Tag Ihr Wort, am nächsten Tag eines von Timo.",
    "dailyWords.today": "Wort des Tages: {word}",
    "dailyWords.todayBadge": "Heute",
    "dailyWords.add": "Wort hinzufügen",
    "dailyWords.inputLabel": "Wort",
    "dailyWords.placeholder": "Zum Beispiel: Apfel",
    "dailyWords.pictureTitle": "Bild (optional)",
    "dailyWords.noPicture": "Kein Bild",
    "dailyWords.photo": "Foto",
    "dailyWords.removePhoto": "Foto entfernen",
    "dailyWords.listTitle": "Ihre Wörter",
    "dailyWords.empty": "Noch keine Wörter. Solange die Liste leer ist, zeigt Timo seine eigenen Wörter.",
    "dailyWords.edit": "Ändern",
    "dailyWords.save": "Speichern",
    "dailyWords.cancel": "Abbrechen",
    "dailyWords.delete": "Löschen",
    "dailyWords.deleteConfirm": "„{word}“ löschen?",
    "dailyWords.listen": "Anhören",
    "dailyWords.moveUp": "Nach oben",
    "dailyWords.moveDown": "Nach unten",
    "dailyWords.saved": "Gespeichert",
    "dailyWords.deviceOnly": "Die Wörter werden nur auf diesem Gerät gespeichert. Auf einem anderen Telefon oder Tablet fehlen sie.",
    "dailyWords.errEmpty": "Bitte zuerst ein Wort eintragen.",
    "dailyWords.errDuplicate": "Dieses Wort steht schon auf der Liste.",
    "dailyWords.errFull": "Die Liste hat schon {max} Wörter. Löschen Sie eines, um ein neues hinzuzufügen.",
    "dailyWords.errSave": "Speichern fehlgeschlagen. Der Gerätespeicher ist vielleicht voll. Versuchen Sie es ohne Foto.",
    "dailyWords.errImage": "Dieses Foto ließ sich nicht öffnen. Wählen Sie ein anderes.",
    // end daily-words
    // Story copy lives in src/copy/story.de.js so it can be edited on its own.
    ...storyDe,
    'house.room.living': 'Wohnzimmer',
    'house.room.talk': 'Telefonzimmer',
    'house.room.play': 'Spielzimmer',
    'house.room.study': 'Lernecke',
    'house.hotspot.couch': 'Auf dem Sofa hüpfen',
    'house.hotspot.window': 'Aus dem Fenster schauen',
    'house.hotspot.timo': 'Mit Timo spielen',
    'house.hotspot.pet': 'Mit Timo spielen',
    'house.hotspot.phone': 'Am Telefon sprechen',
    'house.hotspot.shelf': 'Die Bildkarten öffnen',
    'house.hotspot.toybox': 'Die Spielzeugkiste öffnen',
    'house.hotspot.desk': 'Wort des Tages',
    'house.parent.settings': 'Für Erwachsene',
    'house.parent.button': 'Für Erwachsene',
    'house.nav.rooms': 'Zimmer',
    'house.nav.prev': 'Vorheriges Zimmer',
    'house.nav.next': 'Nächstes Zimmer',
    'house.badge.stars': 'Verdiente Sterne',
    'house.hotspot.beanbag': 'Sitzsack',
    'house.hotspot.bookshelf': 'Bücherregal',
    'house.hotspot.curtain': 'Vorhang',
    'house.hotspot.easel': 'Staffelei',
    'house.hotspot.lamp': 'Lampe',
    'house.hotspot.lights': 'Lichter',
    'house.hotspot.pinboard': 'Pinnwand',
    'house.hotspot.plant': 'Pflanze',
    'house.hotspot.playwindow': 'Fenster',
    'house.hotspot.rainbowrug': 'Regenbogenteppich',
    'house.hotspot.rug': 'Teppich',
    'house.hotspot.stool': 'Hocker',
    'house.map.title': 'Hausplan',
    'house.map.close': 'Karte schließen',
    'house.map.here': 'Du bist hier',
    'house.map.go': 'Los',
    'house.map.activity.talk': 'Sprechen',
    'house.map.activity.cards': 'Karten',
    'house.map.activity.word': 'Wort',
    'house.a11y.roomOf': 'Zimmer {n} von {total}',
    'download.downloadApp': 'App herunterladen',
    'download.installApp': 'App installieren',
    'download.bestExperience': 'Die beste Erfahrung bietet die installierte App.',
    'download.iosInstallTitle': 'iPhone & iPad',
    'download.tapShare1': 'Tippen Sie auf Teilen (Quadrat mit Pfeil).',
    'download.tapShare2': 'Tippen Sie auf "Zum Home-Bildschirm".',
    'download.tapShare3': 'Tippen Sie auf "Hinzufügen".',
    'download.androidInstall': 'Android-Installation',
    'download.androidStep1': 'Öffnen Sie das Chrome-Menü (⋮ oben rechts)',
    'download.androidStep2': 'Tippen Sie auf "Zum Startbildschirm hinzufügen" oder "App installieren"',
    'download.androidStep3': 'Tippen Sie zur Bestätigung auf "Installieren"',
    'download.promptNotOpen': 'Das Installationsfenster hat sich nicht geöffnet. Öffnen Sie das Browser-Menü und tippen Sie auf "App installieren" oder "Zum Startbildschirm hinzufügen".',
    'download.desktopHint': 'Am besten öffnen Sie dies auf einem iPhone/iPad/Android und installieren die App.',
    'download.windowsTitle': 'Windows & Desktop',
    'download.windowsHint': 'Klicken Sie auf das Installationssymbol in der Adressleiste Ihres Browsers (Chrome oder Edge empfohlen).',
    'download.installedSuccess': 'App erfolgreich installiert',
    'download.otherDeviceTitle': 'Möchten Sie die App auf einem anderen Gerät?',
    'download.otherDeviceBody': 'Öffnen Sie auf dem Gerät einen Browser, gehen Sie zu timohelps.com und melden Sie sich mit denselben Daten an.',
    'download.otherDeviceHelp': 'Probleme? Schreiben Sie uns:',
    // In-app browser overlay (Facebook / Instagram detection)
    'iab.title': 'Im Browser öffnen',
    'iab.body': 'Anmeldung funktioniert nicht in {source}.',
    'iab.openChrome': 'In Chrome öffnen',
    'iab.openSafari': 'In Safari öffnen',
    'iab.openBrowser': 'Im Browser öffnen',
    'iab.copyLink': 'Link kopieren',
    'iab.copied': 'Kopiert',
    'iab.hintIos': 'Oder ⋯ Menü → In Safari öffnen',
    'iab.hintAndroid': 'Oder ⋮ Menü → Im Browser öffnen',
    'iab.hintOther': 'Oder Link in den Browser einfügen',
    'iab.iosCopyAndOpen': 'Link kopieren',
    'iab.iosLinkCopied': 'Link kopiert. Safari öffnen.',
    'iab.iosStep1': 'Tippe, um den Link zu kopieren.',
    'iab.iosStep2': 'Öffne Safari (wische nach oben oder über Home).',
    'iab.iosStep3': 'Füge den Link in die Adresszeile ein.',
    'iab.continueAnyway': 'Hier bleiben',
    'obp.successTitle': 'Alles bereit!',
    'obp.successBody': 'Du bist jetzt im Browser. Hier funktioniert alles einwandfrei, auch die Anmeldung.',
    'obp.successCta': 'Weiter',
    // Common
    'common.startVoice': 'Spracheingabe starten',
    'common.stopRecording': 'Aufnahme stoppen',
    'common.close': 'Schließen',
    'common.help': 'Hilfe',
    'common.back': 'Zurück',
    'common.cancel': 'Abbrechen',
    'common.delete': 'Löschen',
    'common.appName': 'Time To Talk',
    'appName': 'Time To Talk',
    'nonVerbalMode': 'Sprechen',

    // Home
    'home.goodMorning': 'Guten Morgen',
    'home.goodAfternoon': 'Guten Tag',
    'home.goodEvening': 'Guten Abend',
    'home.needHelpTalking': 'Brauchst du Hilfe beim Reden?',
    'home.suggestWhatToSay': 'Ich schlage dir vor, was du sagen kannst',
    'home.quickActions': 'Schnellzugriff',
    'home.nonVerbal': 'Sprechen',
    'home.history': 'Verlauf',
    'home.scripts': 'Skripte',
    'home.startTalking': 'Gespräch starten',
    'home.reportBug': 'Fehler melden',
    'home.underConstruction': 'In Entwicklung',
    'home.stillBuilding': 'Noch in Arbeit! Manches funktioniert vielleicht noch nicht.',
    'home.dontShowAgain': 'Nicht mehr anzeigen',
    'home.gotIt': 'Verstanden!',
    'home.howToUse': 'So funktioniert es',
    'home.settings': 'Einstellungen',
    'home.talkModeBeta': 'Beta',
    'home.talkModeUnderDevelopment': 'Derzeit in Entwicklung',
    'home.talk': 'Reden',
    'home.show': 'Zeigen',
    'home.breathing': 'Atmen',
    'home.greeting.morning': 'Guten Morgen!',
    'home.greeting.afternoon': 'Guten Tag!',
    'home.greeting.evening': 'Guten Abend!',
    'home.timoHomeHint': 'Tipp mich an und komm rein!',
    'timo.home.title': 'Timos Zuhause',
    'timo.home.back': 'Zurück',
    'timo.home.close': 'Schließen',
    // teacher-first-run: the help screen and its door on the landing screen. English for now, translate later.
    "timo.home.helpButton": "How to use",
    "help.metaTitle": "How to use Timo",
    "help.title": "How to use Timo",
    "help.intro": "Five short steps. It takes a minute to read.",
    "help.back": "Back",
    "help.langLabel": "Language",
    "help.teacher.title": "For teachers and therapists",
    "help.teacher.body": "The app says \"your child\". If you are a teacher, that means your student. Everything works the same, even if you signed up as a parent.",
    // school-use
    "help.school.title": "At school, with a student",
    "help.school.point1": "Use one account on the school tablet. Sign in once and it stays signed in.",
    "help.school.point2": "Hand the tablet to the child on the Timo screen. The child talks to Timo or taps the cards.",
    "help.school.point3": "Everything for grown-ups sits behind the Grown-ups button at the top: settings, progress and the subscription.",
    "help.school.point4": "Type the child's name under Grown-ups > Progress and the child's name. Then the cards and Timo use the child's name, not yours.",
    "help.school.point5": "Got a code from the school or an event? Tap “I have a code” on the start page, the sign-in screen, the payment page or in Settings.",
    "help.step1.title": "Start in Timo's room",
    "help.step1.body": "After you log in, you always land here. This is the start screen, and everything is one tap away.",
    "help.step1.alt": "Timo's room on a phone",
    "help.step2.title": "Tap Timo and talk",
    "help.step2.body": "Tap Timo or the Talk button and allow the microphone. The child speaks, Timo answers out loud.",
    "help.step2.alt": "The Talk button at the bottom of the screen",
    "help.step3.title": "Pictures when talking is hard",
    "help.step3.body": "The Pictures button opens picture cards. The child taps a card and the app says it out loud. No microphone needed, so it still works when the mic does not.",
    "help.step3.alt": "Picture cards",
    "help.step4.title": "Word of the day",
    "help.step4.body": "Every day Timo picks one new word. Tap the word card and say it together with the child.",
    "help.step4.alt": "The word of the day card",
    "help.step5.title": "For grown-ups",
    "help.step5.body": "The Grown-ups button at the top opens settings: language, voice and subscription. This guide is always right next to it.",
    "help.step5.alt": "The How to use and Grown-ups buttons at the top of the screen",
    "help.cta": "Go to Timo",
    "help.contact": "Questions? Email info@timetotalk.lt",
    // The paywall a teacher meets: this label had no key anywhere, so every language showed "per day".
    "pricing.perDayLabel": "pro Tag",
    // Settings rows for what the hidden homes used to link: progress, profile, breathing.
    "settings.grownUps.title": "For grown-ups",
    "settings.grownUps.progress": "Progress and the child's name",
    "settings.grownUps.progressHint": "Words, streaks and the name Timo says",
    "settings.grownUps.profile": "Profile",
    "settings.grownUps.breathing": "Breathing exercise",
    "settings.grownUps.breathingHint": "Calm breathing together with the child",
    // Promo codes (MOKOMES and the rest): the landing confirmation and the banner on /timo.
    "promoGrant.accepted": "Code accepted: {days} free. Log in to activate it.",
    "promoGrant.acceptedUnlimited": "Code accepted: free unlimited access. Log in to activate it.",
    "promoGrant.continue": "Continue",
    "promoGrant.day.one": "day",
    "promoGrant.day.few": "days",
    "promoGrant.day.many": "days",
    "promoGrant.day.other": "days",
    "promoGrant.banner": "You have {days} of free access until {date}.",
    "promoGrant.bannerUnlimited": "You have free unlimited access.",
    "promoGrant.alreadyUsed": "The code {code} was already used, so it could not be activated again.",
    "promoGrant.close": "Close",
    // promo-codes-2: "I have a code" for signed-in people (/pricing, Settings) and the entry links. English for now.
    "promoCodes2.open": "I have a code",
    "promoCodes2.label": "Enter your code",
    "promoCodes2.submit": "Activate",
    "promoCodes2.checking": "Checking...",
    "promoCodes2.success": "Code accepted: {days} free, until {date}.",
    "promoCodes2.successUnlimited": "Code accepted: free unlimited access.",
    "promoCodes2.alreadyActive": "Your access is already active, no code needed.",
    "promoCodes2.err.empty": "Type the code first.",
    "promoCodes2.err.invalid": "That code does not exist. Check it and try again.",
    "promoCodes2.err.usedOnAccount": "This code was already used on your account.",
    "promoCodes2.err.usedOnNetwork": "This code was already used from this network. Email info@timetotalk.lt and we will help.",
    "promoCodes2.err.fullyClaimed": "This code has been fully claimed.",
    "promoCodes2.err.network": "Could not connect. Check the internet and try again.",
    "promoCodes2.err.error": "Could not activate the code. Try again.",
    'timo.home.dressTitle': 'Timo anziehen',
    'timo.home.foodTitle': 'Was möchte Timo?',
    'timo.home.action.feed': 'Füttern',
    'timo.home.action.drink': 'Trinken',
    'timo.home.action.sleep': 'Schlafen',
    'timo.home.action.walk': 'Spazieren',
    'timo.home.action.potty': 'Töpfchen',
    'timo.home.action.cheer': 'Jubeln',
    'timo.home.action.dress': 'Anziehen',
    'timo.home.sleep.notNight': 'Timo ist noch nicht müde',
    'timo.home.outfit.default': 'Normal',
    'timo.home.outfit.beanie': 'Mütze',
    'timo.home.outfit.panama': 'Panamahut',
    'timo.home.outfit.cool': 'Sonnenbrille',
    'timo.home.outfit.ai': 'Zukunfts-Timo',
    'timo.home.outfit.yoga': 'Yoga-Timo',
    'timo.home.food.apple': 'Apfel',
    'timo.home.food.banana': 'Banane',
    'timo.home.food.berries': 'Beeren',
    'timo.home.food.bread': 'Brot',
    'timo.home.food.fish': 'Fisch',
    'timo.home.food.acorn': 'Eichel',
    'timo.home.food.cheese': 'Käse',
    'timo.home.food.cookie': 'Keks',
    'timo.talk.tapHint': 'Tipp mich an, lass uns reden!',
    'timo.talk.greeting': 'Hallo! Ich bin Timo. Worüber möchtest du reden?',
    'timo.talk.tapToTalk': 'Antippen und sprechen',
    'timo.talk.listening': 'Ich höre zu',
    'timo.talk.tapWhenDone': 'Tippe, wenn du fertig bist',
    'timo.talk.thinking': 'Timo denkt nach',
    'timo.talk.speaking': 'Timo spricht',
    'timo.talk.emptyReprompt': 'Ich höre zu! Erzähl mir etwas.',
    'timo.talk.llmErrorReply': 'Ich rede so gern mit dir! Was ist dein Lieblingstier?',
    'timo.talk.micDenied': 'Timo braucht dein Mikrofon',
    'timo.talk.micDeniedHelp': 'Bitte einen Erwachsenen, das Mikrofon in den Browsereinstellungen zu erlauben, und tippe dann noch einmal.',
    // mic-school-devices
    'mic.fail.blocked.title': 'The microphone is blocked',
    'mic.fail.blocked.body': 'Timo cannot hear because this browser is not allowed to use the microphone. Allow it, then tap Try again.',
    'mic.fail.blocked.again': 'Tapped Block before? The browser will not ask again on its own. Change it in the settings, then reload the page.',
    'mic.fail.steps.ios': 'iPad or iPhone: tap aA in the address bar, then Website Settings, then set Microphone to Allow. Or open Settings, then Safari, then Microphone, and choose Allow.',
    'mic.fail.steps.chromebook': 'Chromebook: click the icon left of the web address, turn Microphone on, then reload the page. If the switch is grey, the school has blocked it. Ask your IT admin.',
    'mic.fail.steps.android': 'Android: tap the icon left of the web address, then Permissions, then set Microphone to Allow. Reload the page.',
    'mic.fail.steps.desktop': 'Computer: click the icon left of the web address, set Microphone to Allow, then reload the page. If it still does not work, check the privacy settings of the computer.',
    'mic.fail.steps.native': 'In the Timo app: open your phone Settings, then Timo, and turn Microphone on. Come back and tap Try again.',
    'mic.fail.no_device.title': 'No microphone found',
    'mic.fail.no_device.body': 'This device has no working microphone. Plug in a microphone or a headset, then tap Try again.',
    'mic.fail.in_use.title': 'The microphone is busy',
    'mic.fail.in_use.body': 'Another app or tab is using the microphone. Close it, video calls too, then tap Try again.',
    'mic.fail.insecure_context.title': 'This link cannot use the microphone',
    'mic.fail.insecure_context.body': 'The page is not on a secure address, so the browser hides the microphone. Open the address that starts with https://.',
    'mic.fail.unsupported.title': 'This browser cannot use the microphone',
    'mic.fail.unsupported.body': 'Open Timo in Chrome or Safari to talk. You can use the picture cards now.',
    'mic.fail.in_app_browser.title': 'Open Timo in your browser',
    'mic.fail.in_app_browser.body': 'Instagram, Facebook and similar apps open links in their own window, and the microphone does not work there. Open this page in Chrome or Safari.',
    'mic.fail.inapp.ios': 'Tap the three dots (...) at the top, then choose to open in the browser.',
    'mic.fail.inapp.android': 'Tap the three dots in the corner, then choose Open in Chrome.',
    'mic.fail.offline.title': 'No internet',
    'mic.fail.offline.body': 'Timo needs the internet to hear. Connect to Wi-Fi or mobile data, then tap Try again.',
    'mic.fail.stt_unreachable.title': 'Timo cannot reach his listening service',
    'mic.fail.stt_unreachable.body': 'The microphone works, but the network is blocking the speech service. This often happens on school Wi-Fi. Tap Try again, or ask your IT admin to allow api.deepgram.com and time-to-talk.onrender.com.',
    'mic.fail.stt_service_error.title': 'The listening service is having trouble',
    'mic.fail.stt_service_error.body': 'The microphone and the internet work, but the speech service answered with an error. Wait a minute, then tap Try again.',
    'mic.fail.signed_out.title': 'Please sign in again',
    'mic.fail.signed_out.body': 'Your sign-in has run out, so Timo cannot listen. Sign in again, then tap Try again.',
    'mic.fail.unknown.title': 'Timo cannot hear right now',
    'mic.fail.unknown.body': 'Something stopped the microphone. Tap Try again. If it keeps happening, reload the page.',
    'mic.fail.retry': 'Try again',
    'mic.fail.tiles': 'Use picture cards',
    'mic.fail.openBrowser': 'Open in browser',
    'mic.fail.signIn': 'Sign in',
    'timo.talk.exit': 'Fertig',
    'timo.word.title': 'Wort des Tages',
    'timo.word.sayIt': 'Sag es!',
    'timo.word.listening': 'Ich höre zu',
    'timo.word.hearAgain': 'Noch einmal hören',
    'timo.word.tryAgain': 'Sagen wir es zusammen?',
    'timo.word.great': 'Super gemacht!',
    'timo.word.days': 'Tage in Folge',
    'timo.word.open': 'Wort des Tages',
    'timo.word.close': 'Schließen',
    'timo.word.newWordSoon': 'Morgen ein neues Wort!',
    'timo.talk.waiting': 'Timo denkt nach...',
    'timo.talk.youSaid': 'Du hast gesagt:',
    'timo.talk.voiceResting': 'Timos große Stimme ruht sich aus, darum klingt diese wie ein Roboter.',
    'timo.teach.remember': 'Merk es dir',
    'timo.teach.hearIt': 'Anhören',
    'timo.teach.gotIt': 'Verstanden!',
    'timo.reward.earned': 'Du hast {amount} Sterne verdient!',
    'timo.words.title': 'Meine Wörter',
    'timo.words.wordSingular': 'Wort',
    'timo.words.wordPlural': 'Wörter',
    'timo.words.tapHint': 'Tippe auf ein Wort, um es zu hören',
    'timo.words.lockedHint': 'Sag dieses Wort mit Timo, um es freizuschalten',
    'timo.words.empty': 'Noch keine Wörter',
    'timo.words.emptySub': 'Sag das Wort des Tages mit Timo, um deine Sammlung zu starten!',
    'timo.words.close': 'Schließen',
    'timo.words.locked': 'Noch nicht',
    'timo.recap.title': 'Heute mit Timo',
    'timo.recap.wordsLead': 'Wörter, die dein Kind heute gesagt hat',
    'timo.recap.noWords': 'Heute wurde viel fröhlich geplaudert',
    'timo.recap.turnsLabel': 'kleine Gespräche',
    'timo.recap.streakLabel': 'Tage in Folge',
    'timo.recap.minutesLabel': 'Min zusammen',
    'timo.recap.tipLead': 'Tipp',
    'timo.recap.tip1': 'Versucht heute beim Abendessen, eines dieser Wörter gemeinsam zu sagen.',
    'timo.recap.tip2': 'Jedes kleine Gespräch zählt. Ein paar Minuten am Tag summieren sich schnell.',
    'timo.recap.tip3': 'Bitte dein Kind, dir beizubringen, was Timo heute gesagt hat.',
    'timo.recap.tip4': 'Lobe das Versuchen, nicht nur das Richtigmachen.',
    'timo.recap.dismiss': 'Schließen',
    'timo.recap.historyTitle': 'Diese Woche mit Timo',
    'timo.recap.historyEmpty': 'Noch keine Gespräche. Tippe auf Timo, um eines zu starten!',
    'timo.talk.greetingNamed': 'Hallo, {name}! Schön, dich zu sehen!',
    'timo.talk.greetingWord': 'Hallo! Das Wort von heute ist {word}. Kannst du es sagen?',
    'timo.talk.greetingWordNamed': 'Hallo, {name}! Das Wort von heute ist {word}. Kannst du es sagen?',
    'timo.onboarding.intro': 'Hallo! Ich bin Timo. Ich bin dein Freund.',
    'timo.onboarding.askName': 'Wie heißt du?',
    'timo.onboarding.heard': 'Habe ich {name} gehört?',
    'timo.onboarding.confirmYes': 'Ja!',
    'timo.onboarding.confirmNo': 'Nochmal',
    'timo.onboarding.retry': 'Hoppla! Sag deinen Namen nochmal.',
    'timo.onboarding.typeInstead': 'Namen tippen',
    'timo.onboarding.namePlaceholder': 'Dein Name',
    'timo.onboarding.save': 'Speichern',
    'timo.onboarding.skip': 'Überspringen',
    'timo.onboarding.welcome': 'Schön dich kennenzulernen, {name}!',
    'timo.onboarding.micDenied': 'Ich kann dich nicht hören. Du kannst deinen Namen tippen.',
    // Timo tells a story: UI chrome only. The story prose itself lives in
    // src/copy/story.en.js under the story.* keys, not here.
    'timo.story.tapToStart': 'Geschichte starten',
    'timo.story.listening': 'Du bist dran',
    'timo.story.narrating': 'Timo erzählt die Geschichte',
    'timo.story.close': 'Fertig',
    'timo.story.replay': 'Noch einmal',
    'timo.story.finished': 'Ende',
    'timo.story.next': 'Weiter',
    'parent.title': 'Fortschritt',
    'parent.backAria': 'Zurück zur Startseite',
    'parent.noKidName': 'Ihr Kind',
    'parent.subtitle': 'Fortschritt beim Sprachtraining',
    'parent.tierLabel': 'Stufe',
    'parent.statStreak': 'Tage in Folge',
    'parent.statWords': 'Wörter gelernt',
    'parent.statStars': 'Sterne gesammelt',
    'parent.statDaysActive': 'Aktive Tage',
    'parent.statDaysActiveHint': 'Letzte 30 Tage',
    'parent.statLongest': 'Längste Serie',
    'parent.statWordsWeek': 'Neue Wörter diese Woche',
    'parent.calendarTitle': 'Übungskalender',
    'parent.calendarPrevAria': 'Vorheriger Monat',
    'parent.calendarNextAria': 'Nächster Monat',
    'parent.calendarLegendPracticed': 'Geübt',
    'parent.calendarLegendToday': 'Heute',
    'parent.calendarDayPracticed': 'geübt',
    'parent.calendarEmptyMonth': 'In diesem Monat wurde noch nicht geübt.',
    'parent.timelineTitle': 'Gelernte Wörter',
    'parent.timelineToday': 'Heute',
    'parent.timelineYesterday': 'Gestern',
    'parent.timelineDaysAgo': 'vor {n} Tagen',
    'parent.timelineEmptyTitle': 'Hier beginnt die Reise',
    'parent.timelineEmptyBody': 'Jedes Wort, das Ihr Kind mit Timo lernt, erscheint hier. Schon ein Wort pro Tag summiert sich schnell.',
    'parent.timelineWordCount': '{n} Wörter',
    'parent.timelineWordCountOne': '1 Wort',
    'parent.printLabel': 'Drucken',
    'parent.printAria': 'Diese Seite drucken',
    'parent.footerNote': 'Der Fortschritt wird auf diesem Gerät gespeichert und mit Ihrem Konto synchronisiert.',
    'timo.recap.today': 'Heute',
    'timo.recap.yesterday': 'Gestern',
    'home.urgencyBanner': 'Dein Abo ist nicht aktiv, schalte alle Funktionen frei',
    'home.urgencyBannerCta': 'Pläne ansehen',
    'subscription.choosePlanCta': 'Plan wählen',
    'home.sessionsCompleted': '{n} Sitzungen abgeschlossen',

    // Settings
    'settings.title': 'Einstellungen',
    'settings.backAria': 'Zurück',
    'settings.appearance': 'Darstellung',
    'settings.sounds': 'Töne',
    'settings.background': 'Hintergrund',
    'settings.language': 'Sprache',
    'settings.account': 'Konto',
    'settings.voiceprint.title': 'Stimmerkennung',
    'settings.voiceprint.description': 'Time to Talk lernt deine Stimme auf diesem Gerät, damit es erkennt, wer in einem Live-Gespräch spricht. Dein Stimmprofil bleibt lokal und wird nie an unsere Server gesendet.',
    'settings.voiceprint.forget': 'Stimme vergessen',
    'settings.voiceprint.forgetDesc': 'Gespeichertes Stimmprofil löschen und neu beginnen',
    'settings.voiceprint.forgotten': 'Stimmprofil gelöscht',
    'settings.voiceprint.forgottenDesc': 'Time to Talk lernt deine Stimme in der nächsten Live-Sitzung erneut.',
    'settings.theme': 'Design',
    'settings.dark': 'Dunkel',
    'settings.light': 'Hell',
    'settings.textSize': 'Schriftgröße',
    'settings.textSizeSmall': 'A',
    'settings.textSizeMedium': 'A+',
    'settings.textSizeLarge': 'A++',
    'settings.reduceMotion': 'Bewegung reduzieren',
    'settings.dyslexiaFont': 'Legasthenie-Schrift',
    'settings.showImages': 'Bilder zeigen',
    'settings.rewardSounds': 'Belohnungstöne',
    'settings.rainAnimation': 'Regen-Animation',
    'settings.rainSounds': 'Regen-Geräusche',
    'settings.celebration': 'Feier-Effekte',
    'settings.partyModePhone': 'Feier-Effekte am Handy',
    'settings.partyModeDesktop': 'Feier-Effekte am Computer',
    'settings.forest': 'Wald',
    'settings.city': 'Stadt',
    'settings.beach': 'Strand',
    'settings.privacyPolicy': 'Datenschutz',
    'settings.termsOfService': 'Nutzungsbedingungen',
    'settings.helpSupport': 'Hilfe & Support',
    'settings.replayTutorial': 'Tutorial neu starten',
    'settings.replayTutorialDescription': 'App-Einführung erneut ansehen',
    'settings.resetPermissions': 'Berechtigungen zurücksetzen',
    'settings.resetPermissionsDescription': 'Erneut Mikrofon- und Gerätezugriff anfragen',
    'settings.resetToDefaults': 'Auf Standard zurücksetzen',
    'settings.followUs': 'Folge uns',
    'settings.version': 'Timo v1.0.0 • Mit ❤️ gemacht',
    'profile.navSubscription': 'Abonnement',
    'profile.logout': 'Abmelden',
    'profile.logoutConfirmTitle': 'Bist du sicher?',
    'profile.logoutConfirmText': 'Du wirst abgemeldet und zur Startseite zurückgebracht.',
    'profile.logoutYes': 'Ja',
    'profile.logoutNo': 'Nein',
    'settings.deleteAccount': 'Konto löschen',
    'settings.deleteAccountConfirmTitle': 'Konto löschen?',
    'settings.deleteAccountConfirmBody': 'Damit werden dein Konto und alle Daten dauerhaft gelöscht. Das kann nicht rückgängig gemacht werden.',
    'settings.deleteAccountConfirm': 'Ja, mein Konto löschen',
    'settings.deleteAccountCancel': 'Abbrechen',
    'settings.deleteAccountSuccess': 'Konto gelöscht',
    'settings.deleteAccountError': 'Konto konnte nicht gelöscht werden. Bitte erneut versuchen oder Support kontaktieren.',
    'settings.voiceTitle': 'Stimme',
    'settings.voiceDescription': 'Stimme wählen',
    'settings.voiceChildishFemale': 'Kindlich, weiblich',
    'settings.voiceAdultMale': 'Erwachsen, männlich',
    'settings.resetToastTitle': '✅ Einstellungen zurückgesetzt',
    'settings.resetToastDescription': 'Alle Bedienungshilfen wurden auf Standard zurückgesetzt.',
    'settings.metaDescription': 'Passe Bedienungshilfen wie Legasthenie-Modus, Schriftgröße und Hintergrund an.',
    'settings.rainBackgroundTitle': 'Animierter Regen-Hintergrund',
    'settings.rainBackgroundDescription': 'Regen-Animation anzeigen',
    'settings.disableRainBackground': 'Regen-Hintergrund deaktivieren',
    'settings.enableRainBackground': 'Regen-Hintergrund aktivieren',
    'settings.rainSoundTitle': 'Endloser Regen-Sound',
    'settings.rainSoundDescription': 'Regen-Geräusch im Hintergrund abspielen',
    'settings.disableRainSound': 'Regen-Sound deaktivieren',
    'settings.enableRainSound': 'Regen-Sound aktivieren',
    'settings.volumeLabel': 'Lautstärke',
    'settings.rainVolumeAria': 'Lautstärke Regen-Sound',
    'settings.imagesDescription': 'Symbole und Bilder umschalten',
    'settings.openDyslexicTitle': 'OpenDyslexic-Schrift',
    'settings.openDyslexicDescription': 'Verwendet OpenDyslexic, damit Buchstaben leichter zu unterscheiden sind.',
    'settings.openDyslexicAria': 'OpenDyslexic-Schrift',
    'settings.textSizeTitle': 'Schriftgröße',
    'settings.mediumFont': 'Mittlere Schriftgröße',
    'settings.largeFont': 'Große Schriftgröße',
    'settings.xlargeFont': 'Sehr große Schriftgröße',
    'settings.ttsModelTitle': 'Stimm-Modell',
    'settings.ttsModelDescription': 'Welches KI-Stimm-Modell für Sprache verwendet wird',
    'settings.ttsModelBrowser': 'Robo',
    'settings.ttsModelElevenLabs': 'Natt',
    'settings.ttsModelOpenAI': 'Nova',
    'settings.ttsModelGemini': 'Puck',
    'settings.themeIconsTitle': 'Hintergrund-Symbole',
    'settings.themeIconsDescription': 'Schwebende Emoji-Symbole passend zum Design anzeigen',
    'settings.showImagesIcons': 'Bilder und Symbole zeigen',
    'settings.soundTitle': 'Ton',
    'settings.rewardSound': 'Belohnungston',

    // Non-verbal (nv.*)
    'nv.speakModalTitle': 'Ich sage:',
    'nv.speaking': 'Spricht...',
    'nv.speak': 'Sprechen',
    'nv.speakAgain': 'Nochmal sprechen',
    'nv.speakLoading': 'Satz wird gebaut...',
    'nv.imageAlt': 'Bild',
    'nv.sentenceBarAria': 'Satzleiste',
    'nv.tapSymbol': 'Tippe ein Symbol an...',
    'nv.clearAll': 'Alles löschen',
    'nv.deleteLast': 'Letztes löschen',
    'nv.speakSentence': 'Satz sprechen',
    'nv.kalbeti': 'Sprechen',
    'nv.clear': '✕ Löschen',
    'nv.backAria': 'Zurück',
    'nv.scriptsAria': 'Skripte',
    'nv.historyAria': 'Verlauf',
    'nv.searchPlaceholder': 'Symbol suchen...',
    'nv.noResults': 'Nichts gefunden',
    'nv.ttsFailed': 'Kein Ton. Zum erneuten Versuch tippen.',
    'nv.searchAria': 'Symbol suchen',
    'nv.loading': 'Wird geladen...',
    'nv.noPhotos': 'Noch keine Fotos',
    'nv.addPhotosHint': 'Eigene Fotos für die Kommunikation hinzufügen',
    'nv.addPhoto': 'Foto hinzufügen',
    'nv.add': 'Hinzufügen',
    'nv.showLess': 'Weniger zeigen',
    'nv.moreCount': 'Mehr ({count})',
    'nv.comingSoon': 'Bald verfügbar!',
    'nv.historyTitle': 'Verlauf',
    'nv.historyEmpty': 'Noch keine Sätze. Tippe Emojis an und sprich, um Verlauf zu erstellen.',
    'nv.useAgain': 'Erneut verwenden',
    'nv.addToScripts': 'Zu Skripten hinzufügen',
    'nv.savedToScripts': 'In Skripten gespeichert!',
    'nv.clearHistory': 'Verlauf löschen',
    'nv.customAddPhoto': 'Foto hinzufügen',
    'nv.customPreview': 'Vorschau',
    'nv.customAddLabel': 'Beschriftung hinzufügen',
    'nv.customTakePhoto': 'Foto aufnehmen',
    'nv.customUseCamera': 'Kamera verwenden',
    'nv.customFromGallery': 'Aus Galerie wählen',
    'nv.customFromDevice': 'Vom Gerät',
    'nv.customWordOnly': 'Nur ein Wort',
    'nv.customWordOnlyHint': 'Kein Bild nötig',
    'nv.customChange': 'Ändern',
    'nv.customContinue': 'Weiter',
    'nv.customHintLabels': 'Text, der angezeigt und gesprochen wird',
    'nv.customNameEn': 'Name (Englisch)',
    'nv.customPlaceholderName': 'z.B. "Mama", "Anna"',
    'nv.customNameLt': 'Name auf Litauisch',
    'nv.customNameRu': 'Name auf Russisch',
    'nv.customOptional': 'optional',
    'nv.customCategory': 'Kategorie',
    'nv.customBack': 'Zurück',
    'nv.customSave': 'Speichern',
    'nv.customSaving': 'Wird gespeichert...',
    'nv.customErrImage': 'Bitte eine Bilddatei wählen',
    'nv.customErrSize': 'Datei zu groß (max. 10 MB)',
    'nv.customErrLabel': 'Bitte eine Beschriftung eingeben',
    'nv.customErrSave': 'Fehler beim Speichern',
    'nv.manageTitle': 'Meine Fotos',
    'nv.deleteConfirm': '"{name}" löschen?',
    'nv.cancel': 'Abbrechen',
    'nv.delete': 'Löschen',

    // Unknown Situation (unknown.*)
    'unknown.startConversation': 'Gespräch starten',
    'unknown.continueConversation': 'Gespräch fortsetzen',
    'unknown.askForHelp': 'Um Hilfe bitten',
    'unknown.sayNoPolitely': 'Höflich Nein sagen',
    'unknown.endConversation': 'Gespräch beenden',
    'unknown.metaTitle': 'Deine Situation',
    'unknown.metaDescription': 'Übe Gespräche mit der KI, die den Kontext erkennt.',
    'unknown.backAria': 'Zurück zu "Deine Situation"',
    'unknown.title': 'Deine Situation',
    'unknown.subtitle': 'Schreib, was du oder die andere Person gesagt habt. Timo KI versteht und hilft.',
    'unknown.subtitleShort': 'Schreib, was die andere Person gesagt hat, damit Timo KI helfen kann.',
    'unknown.helper': 'Wobei kann Timo KI helfen?',
    'unknown.youCouldSay': 'Du könntest auch sagen...',
    'unknown.firstMessage': 'Erzähl mir, was passiert ist oder was sie gesagt haben.',
    'unknown.inputPlaceholder': 'Timo KI um Hilfe bitten...',
    'unknown.inputAria': 'Timo KI um Hilfe bitten',
    'unknown.sendAria': 'Nachricht senden',
    'unknown.finishAria': 'Gespräch beenden',
    'unknown.finishButton': 'Fertig',
    'unknown.finishedNotice': 'Gespräch beendet',
    'unknown.startNewConversation': 'Neues Gespräch starten',
    'unknown.finishToastTitle': 'Gespräch beendet',
    'unknown.finishToastDescription': 'Das Gespräch ist zu Ende. Du kannst ein neues starten.',
    'unknown.errorTitle': 'Fehler',
    'unknown.errorDescription': 'Nachricht konnte nicht gesendet werden. Bitte erneut versuchen.',
    'unknown.contextPlace': 'Ort',
    'unknown.contextRelationship': 'Beziehung',
    'unknown.contextGoal': 'Ziel',
    'unknown.emptyState': 'Tippe ein, was passiert ist oder gesagt wurde!',
    'unknown.playVoiceAria': 'Stimme abspielen',
    'unknown.finishedTitle': 'Du hast diese Situation geschafft!',
    'unknown.motivationalMessage': 'Schön, dass du es versucht hast.',
    'unknown.howDidItFeel': 'Wie hat es sich diesmal angefühlt?',
    'unknown.itFeltGood': 'Es war gut',
    'unknown.itWasHard': 'Es war diesmal schwer',
    'unknown.bothChoicesOkay': 'Beide Antworten sind okay, wichtig ist, dass du es versucht hast.',
    'unknown.goalSelectionTitle': 'Wobei brauchst du Hilfe?',
    'unknown.goalSelectionSubtitle': 'Wähle die Option, die am besten zu deiner Situation passt.',
    'unknown.goalHelpSpeaking': 'Ich brauche Hilfe beim Sprechen',
    'unknown.goalHelpAsking': 'Ich brauche Hilfe beim Fragen',
    'unknown.goalLost': 'Ich weiß nicht, was ich sagen soll',
    'unknown.goalSayNo': 'Ich möchte höflich Nein sagen',
    'unknown.goalSkip': 'Das passt nicht zu meiner Situation',
    'unknown.goalBadgeHelpSpeaking': 'Ziel: Hilfe beim Sprechen',
    'unknown.goalBadgeHelpAsking': 'Ziel: Hilfe beim Fragen',
    'unknown.goalBadgeLost': 'Ziel: Ich weiß nicht, was ich sagen soll',
    'unknown.goalBadgeSayNo': 'Ziel: Höflich Nein sagen',
    'unknown.recordOtherSpeaker': 'Aufnehmen, was sie gesagt haben',
    'unknown.recording': 'Aufnahme läuft...',
    'unknown.otherPersonSaid': 'Die andere Person sagte:',
    'unknown.speakerLabel': 'Du könntest sagen:',
    'unknown.timoAILabel': 'Timo KI:',
    'unknown.otherPersonLabel': 'Andere Person:',
    'unknown.youLabel': 'Du:',

    // Custom Situation setup
    'customSetup.intentStart': 'Gespräch starten',
    'customSetup.intentContinue': 'Gespräch fortsetzen',
    'customSetup.intentFinish': 'Gespräch beenden',
    'customSetup.metaTitle': 'Eigene Situation, Einrichtung',
    'customSetup.metaDescription': 'Eine eigene Gesprächs-Übung einrichten.',
    'customSetup.title': 'Eigene Situation',
    'customSetup.subtitle': 'Wähle, wo du bist und was du tun willst.',
    'customSetup.situationLabel': 'Situation',
    'customSetup.placeholder': 'z.B. Party, Schule, Laden, Bus, Krankenhaus',
    'customSetup.examplesHint': 'Oder klicke auf ein Beispiel unten:',
    'customSetup.examples.party': 'Party',
    'customSetup.examples.school': 'Schule',
    'customSetup.examples.store': 'Laden',
    'customSetup.examples.bus': 'Bus',
    'customSetup.examples.hospital': 'Krankenhaus',
    'customSetup.intentQuestion': 'Was möchtest du tun?',
    'customSetup.startButton': 'Starten',

    // Custom Situation chat
    'customChat.metaTitle': 'Eigene Situation, Chat',
    'customChat.genericSituation': 'Situation',
    'customChat.metaDescriptionPrefix': 'Gesprächs-Übung:',
    'customChat.backAria': 'Zurück zur Einrichtung',
    'customChat.inputPlaceholder': 'Nachricht eingeben...',
    'customChat.inputAria': 'Nachricht eingeben',
    'customChat.finishToastTitle': 'Gespräch beendet',
    'customChat.finishToastDescription': 'Das Gespräch ist zu Ende. Du kannst ein neues starten.',
    'customChat.errorTitle': 'Fehler',
    'customChat.errorDescription': 'Nachricht konnte nicht gesendet werden. Bitte erneut versuchen.',
    'customChat.finishFallbackShort': 'Auf Wiedersehen!',
    'customChat.finishFallbackLong': 'Ich muss jetzt los, danke!',
    'customChat.finishedNotice': 'Gespräch beendet',
    'customChat.fallback': 'Verstanden.',

    // Chat (UnknownSituation chat surface uses chat.* keys)
    'chat.pageTitle': 'Chat mit Timo',
    'chat.metaDescription': 'Rede mit Timo, hol dir Hilfe, was du sagen kannst',
    'chat.backAria': 'Zurück',
    'chat.subtitle': 'Dein KI-Helfer',
    'chat.end': 'Beenden',
    'chat.helpDefault': 'Hilfe',
    'chat.greeting': 'Hey! Wobei brauchst du Hilfe?',
    'chat.suggestionsTitle': 'Was soll ich sagen?',
    'chat.suggestionsHint': 'Tippe eine Option an, sie wird vorgelesen und gesendet',
    'chat.suggestionsUpdating': 'Wird aktualisiert...',
    'chat.noSuggestions': 'Keine Vorschläge verfügbar',
    'chat.thinking': 'Denkt nach...',
    'chat.gettingSuggestions': 'Vorschläge werden geholt',
    'chat.quickRepliesLabel': 'Schnellantworten:',
    'chat.speaking': 'Spricht:',
    'chat.speakerMe': 'Ich',
    'chat.speakerOther': 'Andere',
    'chat.placeholder': 'Nachricht eingeben...',
    'chat.sendAria': 'Nachricht senden',
    'chat.getHelpAria': 'Hilfe holen',
    'chat.playTtsAria': 'Vorlesen lassen',
    'chat.ariaHearTimo': 'Timos Nachricht hören',
    'chat.ariaHearIt': 'Anhören',
    'chat.ariaSaveScript': 'In Skripten speichern',
    'chat.recordMicMe': 'Gedrückt halten, um deine Stimme aufzunehmen',
    'chat.recordMicOther': 'Gedrückt halten, um aufzunehmen, was sie gesagt haben',
    'chat.recordingMe': 'Deine Stimme wird aufgenommen...',
    'chat.recordingOther': 'Wird aufgenommen, was sie gesagt haben...',
    'chat.ttsWait': 'Warte {seconds}s... (noch {left})',
    'chat.youCan': 'Du kannst sagen:',
    'chat.timoSuggests': 'Timo schlägt vor...',
    'chat.safetyTitle': 'Sicherheitshinweis',
    'chat.safetyBody': 'Dieses Gespräch könnte unsicher sein. Wenn du dich bedroht fühlst, geh sofort weg.',
    'chat.fallbackAi': 'Hey! Wobei brauchst du Hilfe?',
    'chat.fallbackCoaching': 'Nachricht erfolgreich gesendet! 👍 Brauchst du noch etwas?',
    'chat.needMoreHelp': 'Brauchst du noch bei etwas Hilfe?',
    'chat.praise1': 'Schön!',
    'chat.praise2': 'Klasse!',
    'chat.praise3': 'Super gemacht!',
    'chat.toast.errorTitle': 'Fehler',
    'chat.toast.errorDesc': 'Antwort konnte nicht geholt werden. Bitte erneut versuchen.',
    'chat.toast.ttsLimitTitle': 'Vorlesen-Limit erreicht',
    'chat.toast.ttsLimitDesc': 'Maximal 5 Wiedergaben pro Sitzung, um Ressourcen zu schonen.',
    'chat.toast.savedTitle': 'Gespeichert!',
    'chat.toast.savedDesc': 'Zu deinen Skripten hinzugefügt.',
    'chat.toast.duplicateTitle': 'Schon gespeichert',
    'chat.toast.duplicateDesc': 'Diesen Satz hast du bereits.',
    'chat.toast.voiceTestTitle': 'Stimmtest',
    'chat.toast.voiceTestDesc': 'Beispiel-Audio wird abgespielt...',
    'chat.toast.voiceFailTitle': 'Stimmtest fehlgeschlagen',
    'chat.toast.voiceFailDesc': 'Details in der Konsole.',
    'chat.toast.connectionTitle': 'Verbindungsproblem',
    'chat.toast.connectionDesc': 'Die ganze Antwort kam nicht durch, aber deine Nachricht war super!',
    'chat.testVoice.lt': 'Sveiki, aš esu Timo, jūsų dirbtinis intelektas.',
    'chat.testVoice.en': "Hi, I'm Timo, your AI helper.",
    'chat.testVoice.ru': 'Привет! Я Тимо, твой помощник на базе искусственного интеллекта.',
    'chat.qr.hey1': 'Hey!',
    'chat.qr.hey2': 'Hallo',
    'chat.qr.hey3': 'Was geht?',
    'chat.qr.yes1': 'Ja',
    'chat.qr.yes2': 'Nein',
    'chat.qr.yes3': 'Vielleicht',
    'chat.qr.how1': 'Gut!',
    'chat.qr.how2': 'Geht so',
    'chat.qr.how3': 'Mir geht es okay',
    'chat.qr.inv1': 'Klar!',
    'chat.qr.inv2': 'Vielleicht später',
    'chat.qr.inv3': 'Geht leider nicht',
    'chat.qr.help1': 'Klar',
    'chat.qr.help2': 'Was ist los?',
    'chat.qr.help3': 'Wie kann ich helfen?',
    'chat.qr.thanks1': 'Kein Problem!',
    'chat.qr.thanks2': 'Jederzeit',
    'chat.qr.thanks3': 'Gern geschehen',
    'chat.qr.comp1': 'Danke!',
    'chat.qr.comp2': 'Lieb von dir',
    'chat.qr.comp3': '😊',
    'chat.qr.sorry1': 'Kein Ding',
    'chat.qr.sorry2': 'Schon okay',
    'chat.qr.sorry3': 'Alles gut',
    'chat.qr.info1': 'Echt?',
    'chat.qr.info2': 'Erzähl',
    'chat.qr.info3': 'Was?',
    'chat.qr.plan1': 'Klingt gut',
    'chat.qr.plan2': 'Wann?',
    'chat.qr.plan3': 'Vielleicht',
    'chat.qr.conf1': 'Jep',
    'chat.qr.conf2': 'Genau',
    'chat.qr.conf3': 'Auf jeden Fall',
    'chat.qr.wq1': 'Nicht sicher',
    'chat.qr.wq2': 'Lass mich überlegen',
    'chat.qr.wq3': 'Ich schaue nach',
    'chat.qr.genq1': 'Ja',
    'chat.qr.genq2': 'Nee',
    'chat.qr.genq3': 'Vielleicht',
    'chat.qr.stat1': 'Cool',
    'chat.qr.stat2': 'Schön',
    'chat.qr.stat3': 'Echt jetzt?',
    'chat.qr.def1': 'Okay',
    'chat.qr.def2': 'Verstanden',
    'chat.qr.def3': 'Cool',

    // Push to talk
    'pushToTalk.title': 'Hilf mir zu antworten',
    'pushToTalk.ready': 'Bereit, wenn du es bist',
    'pushToTalk.helpMeRespond': 'Hilf mir zu antworten',
    'pushToTalk.tapToStart': 'Tippe an, um aufzunehmen, was sie gesagt haben',
    'pushToTalk.recording': 'Wird aufgenommen, was sie gesagt haben...',
    'pushToTalk.done': 'Fertig',
    'pushToTalk.cancel': 'Abbrechen',
    'pushToTalk.understanding': 'Verstehe...',
    'pushToTalk.theySaid': 'Sie sagten:',
    'pushToTalk.soundsLike': 'Das klingt nach',
    'pushToTalk.yesHelpMe': 'Ja, hilf mir zu antworten',
    'pushToTalk.notQuite': 'Nicht ganz, nochmal',
    'pushToTalk.startOver': 'Neu starten',
    'pushToTalk.findingResponses': 'Gute Antworten werden gesucht...',
    'pushToTalk.pickResponse': 'Wähle eine Antwort:',
    'pushToTalk.youllSay': 'Du sagst:',
    'pushToTalk.illSayIt': 'Ich sage es',
    'pushToTalk.speakForMe': 'Für mich sprechen',
    'pushToTalk.chooseAnother': 'Andere wählen',
    'pushToTalk.differentOptions': 'Andere Optionen',
    'pushToTalk.speaking': 'Spricht...',
    'pushToTalk.stop': 'Stopp',
    'pushToTalk.responseReady': 'Antwort bereit!',
    'pushToTalk.needMoreHelp': 'Mehr Hilfe',
    'pushToTalk.imDone': 'Ich bin fertig',
    'pushToTalk.autoReset': 'Kehrt automatisch zurück',
    'pushToTalk.stillThere': 'Bist du noch da?',
    'pushToTalk.takeYourTime': 'Lass dir Zeit, keine Eile.',
    'pushToTalk.continue': 'Weiter',
    'pushToTalk.didntCatch': 'Habe ich nicht verstanden',
    'pushToTalk.tryAgainOrType': 'Nochmal versuchen oder tippen',
    'pushToTalk.tryAgain': 'Nochmal',
    'pushToTalk.typeInstead': 'Stattdessen tippen',
    'pushToTalk.whatDidTheySay': 'Was haben sie gesagt?',
    'pushToTalk.typeHere': 'Tippe, was sie gesagt haben...',
    'pushToTalk.somethingWrong': 'Etwas ist schiefgelaufen',
    'pushToTalk.pleaseTryAgain': 'Bitte erneut versuchen',
    'pushToTalk.panic': 'Stoppen und zurück',

    // --- Native iOS port (WS-2 auth, WS-3 purchases, WS-4 speech, WS-5 media,
    //     WS-6 install, WS-7 AI consent and content reporting). Merged from
    //     src/native/_i18n/*.strings.json. Additive: no existing key was changed.
    'native.auth.browserUnavailable': 'Das Anmeldefenster konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.',
    'native.auth.oauthCancelled': 'Die Anmeldung wurde abgebrochen.',
    'native.auth.oauthFailed': 'Die Anmeldung wurde nicht abgeschlossen. Bitte versuchen Sie es erneut.',
    'native.auth.passwordResetOpensBrowser': 'Das Zurücksetzen des Passworts öffnet eine sichere Seite im Browser. Ändern Sie dort Ihr Passwort und melden Sie sich danach hier mit dem neuen Passwort an.',
    'native.auth.sessionFailed': 'Wir konnten die Anmeldung nicht abschließen. Bitte versuchen Sie es erneut.',
    'native.consent.agree': 'Ich stimme zu',
    'native.consent.contact': 'Fragen? Schreiben Sie uns:',
    'native.consent.declinedAgree': 'Ich habe es mir anders überlegt, ich stimme zu',
    'native.consent.declinedBody': 'Ohne diese Zustimmung kann Timo weder zuhören noch antworten. Bilder, gespeicherte Skripte und alle Einstellungen können Sie weiterhin nutzen. Wenn Sie so weit sind, schalten Sie es in den Einstellungen unter Datenschutz ein.',
    'native.consent.declinedContinue': 'Ohne Timos Stimme fortfahren',
    'native.consent.declinedTitle': 'Timo bleibt vorerst still',
    'native.consent.forLabel': 'Wofür:',
    'native.consent.getsLabel': 'Bekommt:',
    'native.consent.intro': 'Timo nutzt einige externe Unternehmen: Sie wandeln Sprache in Text um, schreiben seine Antworten und sprechen sie vor. Ein Teil dessen, was Sie sagen und schreiben, geht also an sie. Hier steht genau, wer das ist und was jedes Unternehmen bekommt.',
    'native.consent.notNow': 'Jetzt nicht',
    'native.consent.privacyLink': 'Datenschutzerklärung lesen',
    'native.consent.proc.anthropic.purpose': 'Um Timos Antworten zu schreiben',
    'native.consent.proc.anthropic.receives': 'Ihr Gespräch mit Timo als Text',
    'native.consent.proc.deepgram.purpose': 'Um Sprache in Text umzuwandeln',
    'native.consent.proc.deepgram.receives': 'Ihre Stimme, solange das Mikrofon an ist',
    'native.consent.proc.elevenlabs.purpose': 'Um diesen Text mit Timos Stimme zu sprechen',
    'native.consent.proc.elevenlabs.receives': 'Der Text, den Timo gleich sagt',
    'native.consent.proc.google.purpose': 'Um Timos Antworten zu schreiben, wenn Google aktiv ist',
    'native.consent.proc.google.receives': 'Ihr Gespräch mit Timo als Text',
    'native.consent.proc.openai.purpose': 'Um die litauische Grammatik zu prüfen',
    'native.consent.proc.openai.receives': 'Timos litauische Antworten als Text',
    'native.consent.promise': 'Wir verkaufen Ihre Daten nicht und nutzen sie nicht für Werbung. Sie können das jederzeit in den Einstellungen ausschalten. Dann kann Timo weder zuhören noch antworten, alles andere in der App funktioniert weiter.',
    'native.consent.settings.agreedOn': 'Zugestimmt am',
    'native.consent.settings.confirmBody': 'Timo hört dann nicht mehr zu und antwortet nicht mehr. Alles andere in der App funktioniert weiter, und Sie können es jederzeit wieder einschalten.',
    'native.consent.settings.confirmKeep': 'Eingeschaltet lassen',
    'native.consent.settings.confirmTitle': 'Wirklich ausschalten?',
    'native.consent.settings.confirmTurnOff': 'Ausschalten',
    'native.consent.settings.description': 'Erlaubt Timo, Sprache und Gesprächstext an die unten genannten Unternehmen zu senden, damit er zuhören, antworten und sprechen kann.',
    'native.consent.settings.label': 'Weitergabe an KI-Dienste',
    'native.consent.settings.offNote': 'Solange das aus ist, kann Timo weder zuhören noch antworten.',
    'native.consent.settings.section': 'Datenschutz',
    'native.consent.settings.whoGetsWhat': 'Wer was bekommt',
    'native.consent.title': 'Bevor Timo zu sprechen beginnt',
    'native.install.alreadyInstalledBody': 'Auf diesem Gerät nutzt du die Timo App bereits, es muss nichts installiert werden.',
    'native.install.alreadyInstalledTitle': 'Du hast die App schon',
    'native.install.otherDevices': 'Timo auch auf einem anderen Gerät? Melde dich dort mit demselben Konto an, dann ist alles schon da.',
    'native.manage.appleBilled': 'Dieses Abo wird von Apple verwaltet. Kündigen oder wechseln können Sie es in den Abo-Einstellungen des App Store.',
    'native.manage.cta': 'Im App Store verwalten',
    'native.manage.failed': 'Die App-Store-Abos konnten nicht geöffnet werden. Öffnen Sie „Einstellungen“, tippen Sie auf Ihren Namen und dann auf „Abonnements“.',
    'native.mic.backgroundStopped': 'Das Zuhören wurde gestoppt, weil die App in den Hintergrund ging. Tippe, um neu zu starten.',
    'native.mic.continueWithoutMic': 'Ohne Mikrofon fortfahren',
    'native.mic.deniedBody': 'Das iPhone fragt nur einmal. Öffne die Einstellungen und schalte das Mikrofon für Timo ein.',
    'native.mic.deniedTitle': 'Mikrofon ist ausgeschaltet',
    'native.mic.openSettings': 'Einstellungen öffnen',
    'native.mic.primerAllow': 'Mikrofon erlauben',
    'native.mic.primerBody': 'Damit Timo hört, was die andere Person gesagt hat, und dir beim Antworten hilft.',
    'native.mic.primerNotNow': 'Jetzt nicht',
    'native.mic.primerPoint1': 'Deine Stimme wird nur benutzt, um Sprache in Text umzuwandeln.',
    'native.mic.primerPoint2': 'Aufgenommen wird nur während eines Gesprächszugs, nie im Hintergrund.',
    'native.mic.primerPoint3': 'Du kannst das Mikrofon in den Einstellungen wieder ausschalten.',
    'native.mic.primerTitle': 'Timo braucht dein Mikrofon',
    'native.mic.unavailableBody': 'Auf diesem Gerät findet Timo kein Mikrofon.',
    'native.mic.unavailableTitle': 'Kein Mikrofon gefunden',
    'native.minors.affirmation': 'Mit dem Tippen auf „Ich stimme zu“ bestätigen Sie, dass Sie ein Elternteil oder Erziehungsberechtigter sind oder dass Sie 16 Jahre oder älter sind.',
    'native.minors.ageNote': 'In den meisten Ländern Europas müssen Eltern oder Erziehungsberechtigte für alle unter 16 zustimmen. In Litauen liegt diese Grenze bei 14 Jahren, in den USA bei 13 Jahren.',
    'native.minors.askGrownUp': 'Bitte schau dir das zusammen mit einem Elternteil oder Erziehungsberechtigten an und lass die Person für dich auf „Ich stimme zu“ tippen.',
    'native.minors.underAgeLink': 'Ich bin unter 16',
    'native.personalVoice.allow': 'Persönliche Stimme erlauben',
    'native.personalVoice.denied': 'Timo hat keine Berechtigung für deine persönliche Stimme. Aktiviere Apps das Anfragen erlauben unter Einstellungen, Bedienungshilfen, Persönliche Stimme.',
    'native.personalVoice.description': 'Wenn du auf diesem iPhone oder iPad eine persönliche Stimme aufgenommen hast, kann Timo mit ihr sprechen. Die Stimme entsteht auf dem Gerät, bleibt dort und wird nirgendwohin gesendet.',
    'native.personalVoice.languageUnavailable': 'Apple bietet die persönliche Stimme nur auf Englisch, Spanisch und Chinesisch an, sie kann diese Sprache also noch nicht sprechen.',
    'native.personalVoice.none': 'Auf diesem Gerät wurde noch keine persönliche Stimme aufgenommen. Du kannst eine erstellen unter Einstellungen, Bedienungshilfen, Persönliche Stimme.',
    'native.personalVoice.ready': 'Die persönliche Stimme ist bereit. Wähle sie in der Stimmenliste aus.',
    'native.personalVoice.speaking': 'Spricht mit deiner persönlichen Stimme',
    'native.personalVoice.title': 'Persönliche Stimme verwenden',
    'native.personalVoice.unsupportedDevice': 'Auf diesem Gerät lässt sich keine persönliche Stimme erstellen. Dafür ist ein neueres iPhone oder iPad nötig.',
    'native.purchase.alreadyOwned': 'Sie haben diesen Plan bereits. Tippen Sie auf „Kauf wiederherstellen“, um Ihren Zugang zurückzubekommen.',
    'native.purchase.failed': 'Der Kauf konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut oder schreiben Sie uns.',
    'native.purchase.network': 'Keine Verbindung zum App Store. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
    'native.purchase.notAllowed': 'Auf diesem Gerät sind Käufe nicht erlaubt. Prüfen Sie die Bildschirmzeit-Einschränkungen in den Einstellungen.',
    'native.purchase.pending': 'Ihr Kauf wartet auf eine Freigabe. Sobald er freigegeben ist, wird Ihr Zugang automatisch geöffnet.',
    'native.purchase.signInFirst': 'Bitte melden Sie sich zuerst an, damit das Abo mit Ihrem Konto verknüpft wird.',
    'native.purchase.unavailable': 'Der App Store ist gerade nicht erreichbar. Bitte versuchen Sie es in ein paar Minuten erneut.',
    'native.report.body': 'Danke, dass Sie uns Bescheid geben. Timos Antworten schreibt ein Computer, deshalb liegt er manchmal daneben. Schreiben Sie uns, was passiert ist, ein Mensch liest es.',
    'native.report.cancel': 'Abbrechen',
    'native.report.done': 'Fertig',
    'native.report.error': 'Die Meldung konnte nicht gesendet werden. Prüfen Sie die Verbindung und versuchen Sie es erneut.',
    'native.report.noteLabel': 'Möchten Sie etwas ergänzen? (optional)',
    'native.report.reason.language': 'Es war in der falschen Sprache',
    'native.report.reason.other': 'Etwas anderes',
    'native.report.reason.unkind': 'Es war unhöflich oder verletzend',
    'native.report.reason.unsafe': 'Es war nicht sicher für ein Kind',
    'native.report.reason.wrong': 'Es war falsch oder verwirrend',
    'native.report.safetyNote': 'Wenn jemand gerade in Gefahr ist, wenden Sie sich an den Notruf.',
    'native.report.send': 'Meldung senden',
    'native.report.sending': 'Wird gesendet...',
    'native.report.sentBody': 'Jede Meldung wird von einem Menschen gelesen. Wenn Sie eine Antwort möchten, schreiben Sie uns:',
    'native.report.sentTitle': 'Meldung gesendet. Danke.',
    'native.report.stopConversation': 'Dieses Gespräch auch beenden',
    'native.report.title': 'Diese Antwort melden',
    'native.report.trigger': 'Diese Antwort melden',
    'native.restore.restored': 'Ihr Zugang ist wieder da. Willkommen zurück!',
    'native.speech.interrupted': 'Das Zuhören wurde durch einen Anruf oder ein anderes Geräusch unterbrochen. Tippe, um neu zu starten.',
    'native.speech.languageNotSupported': 'Dieses iPhone erkennt diese Sprache nicht selbst, deshalb hört Timo so zu wie immer.',
    'native.speech.onDevice': 'Deine Stimme bleibt auf diesem Gerät',
    'native.speech.permissionNeeded': 'Timo braucht Mikrofon und Spracherkennung, um dich zu hören. Du kannst beides in den Einstellungen einschalten.',
    'native.voice.preview': 'Diese Stimme anhören',
    'native.voice.systemVoices': 'Stimmen auf diesem Gerät',
    'native.voice.title': 'Timos Stimme',
    'pushToTalk.micBackgroundTitle': 'Zuhören gestoppt',
    'pushToTalk.micBlockedBody': 'Das Mikrofon ist blockiert, es wurde nichts aufgenommen. Erlaube das Mikrofon oder tippe, was gesagt wurde.',
    'pushToTalk.micBlockedTitle': 'Timo kann nichts hören',
    'pushToTalk.micNotNowBody': 'Du kannst das Mikrofon jederzeit einschalten. Tippe vorerst, was gesagt wurde.',
    'pushToTalk.micNotNowTitle': 'Mikrofon ist aus',
    'pushToTalk.micProblemBody': 'Das Zuhören ist unerwartet abgebrochen, es wurde nichts aufgenommen. Versuche es noch einmal oder tippe, was gesagt wurde.',
    'pushToTalk.micProblemTitle': 'Zuhören gestoppt',
    'pushToTalk.micUnavailableBody': 'Auf diesem Gerät findet Timo kein Mikrofon. Du kannst stattdessen tippen, was gesagt wurde.',
    'pushToTalk.micUnavailableTitle': 'Kein Mikrofon gefunden',
    'pushToTalk.micUnsupportedBody': 'Spracherkennung ist hier nicht verfügbar, es wurde nichts aufgenommen. Du kannst stattdessen tippen, was gesagt wurde.',
    'pushToTalk.micUnsupportedTitle': 'Dieser Browser kann nicht zuhören',
    'settings.microphone.checkDesc': 'Sieh nach, ob Timo dich hört, und behebe es sonst',
    'settings.microphone.checkLabel': 'Mikrofonzugriff prüfen',
    'settings.microphone.denied': 'Das Mikrofon ist blockiert. Öffne die Einstellungen, um es zu erlauben.',
    'settings.microphone.granted': 'Das Mikrofon funktioniert',
    'settings.microphone.title': 'Mikrofon',
    'settings.microphone.unavailable': 'Auf diesem Gerät wurde kein Mikrofon gefunden',

    // --- merged from src/native/_i18n: WS-C, WS-F, PRIVACY ---
    // WS-C
    'chat.ariaGoBack': 'Zurück',
    'chat.ariaInputMode': 'Eingabemodus',
    'chat.ariaInputModeSpeak': 'Sprechen',
    'chat.ariaInputModeType': 'Tippen',
    'chat.ariaPlayAloud': 'Vorlesen',
    'chat.ariaSendMessage': 'Nachricht senden',
    'chat.ariaRecordMe': 'Meine Stimme aufnehmen',
    'chat.ariaRecordOther': 'Die andere Person aufnehmen',
    'live.ariaFlipSpeakers': 'Sprecher tauschen',
    'live.ariaClearConversation': 'Unterhaltung löschen',
    'live.ariaCalibrationSettings': 'Kalibrierungseinstellungen',
    'live.ariaClose': 'Schließen',
    'live.whatShouldISay': 'Was soll ich sagen?',
    'live.manageScriptsHint': 'Deine gespeicherten Texte kannst du im Bereich Texte verwalten.',
    'live.safetyTitle': 'Sicherheitshinweis',
    'live.safetyBody': 'Dieses Gespräch ist womöglich nicht sicher. Wenn du dich bedroht fühlst, geh sofort weg.',
    'quickChoice.send': 'Senden',
    'quickChoice.tellMeMorePlaceholder': 'Erzähl mir mehr...',
    // WS-F
    'common.closeAria': 'Schließen',
    'common.goBackAria': 'Zurück',
    // PRIVACY
    'privacy.minors.heading': '5. Kinder, Minderjährige und die Zustimmung der Eltern',
    'privacy.minors.s1.heading': '5.1 Für wen diese App ist und wem das Konto gehört',
    'privacy.minors.s1.p1': 'Time To Talk (die Timo-App) ist für Kinder mit Sprachentwicklungsverzögerung, für autistische Kinder und Erwachsene und für alle, denen das Sprechen schwerfällt. Viele unserer Nutzer sind Kinder.',
    'privacy.minors.s1.p2': 'Das Konto gehört einer erwachsenen Person: einem Elternteil, einer erziehungsberechtigten Person, einer Betreuungsperson, einer Therapeutin oder einer Lehrkraft. Diese Person legt das Konto an, hat die Zugangsdaten und bezahlt das Abo. Ein Kind meldet sich nicht selbst an.',
    'privacy.minors.s1.p3': 'Genutzt wird die App aber vom Kind. Dabei erhält die App, was das Kind tippt, und, solange das Mikrofon an ist, auch was es sagt. Das schreiben wir lieber offen, als zu behaupten, wir bekämen nie etwas von einem Kind.',
    'privacy.minors.s2.heading': '5.2 Ab welchem Alter Eltern oder Erziehungsberechtigte zustimmen müssen',
    'privacy.minors.s2.intro': 'Wenn die Person, die die App nutzt, jünger ist als das für Ihr Land genannte Alter, muss ein Elternteil, eine erziehungsberechtigte Person oder eine Betreuungsperson vor der Nutzung zustimmen.',
    'privacy.minors.s2.col.where': 'Wo Sie sind',
    'privacy.minors.s2.col.age': 'Eltern oder Erziehungsberechtigte müssen zustimmen für alle unter',
    'privacy.minors.s2.col.rule': 'Die Regel dahinter',
    'privacy.minors.s2.lt.where': 'Litauen',
    'privacy.minors.s2.lt.age': '14',
    'privacy.minors.s2.lt.rule': 'DSGVO Artikel 8, mit dem im litauischen Recht festgelegten Alter',
    'privacy.minors.s2.us.where': 'Vereinigte Staaten',
    'privacy.minors.s2.us.age': '13',
    'privacy.minors.s2.us.rule': 'COPPA, das US-Gesetz zum Schutz der Privatsphäre von Kindern im Internet',
    'privacy.minors.s2.eu.where': 'Übrige EU und EWR',
    'privacy.minors.s2.eu.age': '16, sofern Ihr Land kein niedrigeres Alter festgelegt hat, das nie unter 13 liegen darf',
    'privacy.minors.s2.eu.rule': 'DSGVO Artikel 8',
    'privacy.minors.s2.world.where': 'Überall sonst',
    'privacy.minors.s2.world.age': '16',
    'privacy.minors.s2.world.rule': 'Unser eigener Mindeststandard, den wir weltweit anwenden',
    'privacy.minors.s2.p1': 'Litauen ist unser Heimatland und unser Hauptmarkt. Dort liegt das Alter bei 14.',
    'privacy.minors.s2.p2': 'Bevor ein Gespräch an die in 5.4 genannten Unternehmen geht, zeigt die App einen Bildschirm, der jedes einzelne von ihnen nennt und um Ihre Zustimmung bittet. Der Satz über der Schaltfläche "Ich stimme zu" bittet Sie zu bestätigen, dass Sie ein Elternteil, erziehungsberechtigt oder Betreuungsperson sind oder dass Sie 16 Jahre oder älter sind. Tippt ein Kind auf "Ich bin unter 16", passiert nichts Schlimmes und niemand wird getadelt: Die App bittet es einfach, eine erwachsene Person zu holen. Sie können die Zustimmung später in den Einstellungen unter Datenschutz widerrufen.',
    'privacy.minors.s2.p3': 'Wir fragen nie nach einem Geburtsdatum. Danach zu fragen hieße, mehr Daten über ein Kind zu sammeln, und dieser Abschnitt steht für das Gegenteil.',
    'privacy.minors.s3.heading': '5.3 Was wir erheben, wenn ein Kind die App nutzt',
    'privacy.minors.s3.intro': 'Drei Dinge:',
    'privacy.minors.s3.email': 'Eine E-Mail-Adresse, einmalig bei der Anmeldung. Es ist die Adresse der erwachsenen Person, der das Konto gehört. Ein Kind fragen wir nie nach einer eigenen E-Mail-Adresse.',
    'privacy.minors.s3.text': 'Gesprächstext. Was Timo geschrieben oder gesagt wird und was Timo antwortet. Übungsgespräche werden im Konto gespeichert, damit sie später im Verlauf wieder geöffnet werden können. Dort lässt sich jedes einzelne löschen.',
    'privacy.minors.s3.voice': 'Die Stimme, nur solange das Mikrofon an ist. Das Audio geht vom Gerät direkt an Deepgram, das daraus Text macht. Wir speichern keine Sprachaufnahmen auf unseren Servern. Das Mikrofon bleibt aus, bis Sie es einschalten.',
    'privacy.minors.s3.p2': 'Wir fragen ein Kind nicht nach echtem Namen, Wohnadresse, Telefonnummer, Schule, Foto, Alter oder Diagnose. Nichts in der App verlangt das. Wird so etwas in ein Gespräch getippt, wird es mit diesem Gespräch gespeichert, und Sie können es im Verlauf löschen.',
    'privacy.minors.s4.heading': '5.4 Die Unternehmen, die diese Daten erhalten',
    'privacy.minors.s4.intro': 'Timo kann ohne Hilfe externer Unternehmen weder zuhören noch antworten oder sprechen. Diese fünf sehen Gesprächsinhalte. Es ist dieselbe Liste, die die App Ihnen vor Ihrer Zustimmung zeigt.',
    'privacy.minors.s4.col.company': 'Unternehmen',
    'privacy.minors.s4.col.receives': 'Was es erhält',
    'privacy.minors.s4.col.purpose': 'Wofür',
    'privacy.minors.s4.anthropic.receives': 'Ihr Gespräch mit Timo als Text',
    'privacy.minors.s4.anthropic.purpose': 'Um Timos Antworten zu schreiben',
    'privacy.minors.s4.google.receives': 'Ihr Gespräch mit Timo als Text',
    'privacy.minors.s4.google.purpose': 'Um Timos Antworten zu schreiben, wenn Google aktiv ist',
    'privacy.minors.s4.openai.receives': 'Timos litauische Antworten als Text',
    'privacy.minors.s4.openai.purpose': 'Um die litauische Grammatik zu prüfen',
    'privacy.minors.s4.deepgram.receives': 'Ihre Stimme, solange das Mikrofon an ist',
    'privacy.minors.s4.deepgram.purpose': 'Um Sprache in Text umzuwandeln',
    'privacy.minors.s4.elevenlabs.receives': 'Der Text, den Timo gleich sagt',
    'privacy.minors.s4.elevenlabs.purpose': 'Um diesen Text mit Timos Stimme zu sprechen',
    'privacy.minors.s4.note': 'Google erhält Gesprächstext nur dann, wenn Google der aktive Modellanbieter ist. OpenAI wird nur für Litauisch genutzt, um die Grammatik einer bereits geschriebenen Antwort von Timo zu korrigieren. Deepgram dient in einigen Sprachen auch als Ersatzstimme, und dann erhält es den Text, den Timo gleich sagt.',
    'privacy.minors.s4.others': 'Die übrigen Unternehmen, mit denen wir arbeiten und die in Abschnitt 7 stehen, kümmern sich um Konto, Zahlung, E-Mail und Analyse, nicht um das Gespräch selbst.',
    'privacy.minors.s4.noPermission': 'Keines dieser Unternehmen darf die Daten eines Kindes für eigene Werbung nutzen oder damit eigene Modelle trainieren, über das hinaus, was in seinen veröffentlichten Richtlinien steht.',
    'privacy.minors.s5.heading': '5.5 Was wir mit den Daten eines Kindes niemals tun',
    'privacy.minors.s5.item1': 'Wir verkaufen sie nie. An niemanden, in keiner Form, zu keinem Preis.',
    'privacy.minors.s5.item2': 'Wir nutzen sie nie für Werbung und erstellen nie Werbeprofile von Kindern.',
    'privacy.minors.s5.item3': 'Wir nutzen sie nie, um KI-Modelle zu trainieren, weder unsere noch die anderer.',
    'privacy.minors.s5.item4': 'Wir nutzen sie nie, um Verhaltens-, psychologische, klinische oder pädagogische Profile eines Kindes zu erstellen.',
    'privacy.minors.s5.item5': 'Wir veröffentlichen sie nie und zeigen sie nie anderen Nutzern.',
    'privacy.minors.s5.pixel': 'Unsere öffentliche Website und die App-Seiten enthalten das in Abschnitt 12 beschriebene Meta-Tag zur Werbemessung. Es zählt Seitenaufrufe und Anmeldungen, damit wir wissen, welche Anzeigen wirken. Es erhält nie Gesprächsinhalte, Stimme oder das, was ein Kind tippt.',
    'privacy.minors.s6.heading': '5.6 Was Eltern oder Erziehungsberechtigte verlangen können',
    'privacy.minors.s6.intro': 'Jederzeit können Sie:',
    'privacy.minors.s6.see': 'Sie einsehen. Eine Kopie von allem anfordern, was wir zum Konto gespeichert haben.',
    'privacy.minors.s6.correct': 'Sie berichtigen. Uns bitten, alles Falsche zu korrigieren.',
    'privacy.minors.s6.delete': 'Sie löschen. Gespräche einzeln im Verlauf löschen oder das ganze Konto löschen.',
    'privacy.minors.s6.withdraw': 'Ihre Zustimmung zurücknehmen. Die KI-Einwilligung in den Einstellungen unter Datenschutz widerrufen. Timo hört dann nicht mehr zu und antwortet nicht mehr. Bilder, gespeicherte Skripte und alle Einstellungen funktionieren weiter. Der Widerruf macht eine bereits rechtmäßig erfolgte Verarbeitung nicht rückgängig.',
    'privacy.minors.s6.deleteHeading': 'Konto löschen. In den Einstellungen gibt es die Schaltfläche "Konto löschen". Wenn Sie sie nutzen:',
    'privacy.minors.s6.step1': 'Wir kündigen zuerst jedes offene Abo bei Stripe, damit Ihnen nichts mehr berechnet wird.',
    'privacy.minors.s6.step2': 'Schlägt eine dieser Kündigungen fehl, brechen wir ab und Ihr Konto wird nicht gelöscht. Sie sehen eine Fehlermeldung mit der Bitte, uns zu kontaktieren, und wir erledigen es von Hand. Sie eingeloggt zu lassen ist besser, als Sie für ein Konto zahlen zu lassen, das Sie nicht mehr erreichen.',
    'privacy.minors.s6.step3': 'Gelingt die Kündigung, löschen wir Ihren Zugang und den Kontodatensatz aus unserem Authentifizierungssystem: die E-Mail-Adresse, das Passwort sowie die dort gespeicherten Einstellungen und Einwilligungsnachweise.',
    'privacy.minors.s6.step4': 'Wir markieren Ihren Abo-Datensatz als gekündigt und behalten einen kleinen Löschvermerk: E-Mail-Adresse, Datum und die Referenz des gekündigten Abos. Damit können wir belegen, wann das Konto gelöscht wurde und dass die Abrechnung endete.',
    'privacy.minors.s6.step5': 'Zahlungs- und Rechnungsdaten bleiben so lange bei Stripe, wie das litauische Buchhaltungsrecht es verlangt, also zehn Jahre. Siehe Abschnitt 9. Früher können wir sie nicht löschen.',
    'privacy.minors.s6.after': 'Wenn Sie noch etwas gelöscht haben möchten, das die Schaltfläche nicht erfasst, schreiben Sie uns, und wir erledigen es von Hand.',
    'privacy.minors.s7.heading': '5.7 Wie Sie uns wegen der Daten eines Kindes erreichen',
    'privacy.minors.s7.p1': 'Schreiben Sie an info@timetotalk.lt. Setzen Sie "Anfrage zu Kinderdaten" in den Betreff und nennen Sie uns die E-Mail-Adresse des Kontos.',
    'privacy.minors.s7.p2': 'Wir beantworten jede Anfrage. Wir bestätigen Ihre Anfrage innerhalb von 5 Werktagen und erledigen sie innerhalb von 30 Tagen, der von der DSGVO gesetzten Frist. Ist eine Anfrage kompliziert und brauchen wir länger, sagen wir Ihnen das vor Ablauf der 30 Tage und erklären warum. Möglicherweise müssen wir zuerst prüfen, ob Sie die Kontoinhaberin oder der Kontoinhaber sind, denn die Daten eines Kindes der falschen Person zu geben wäre ein weit schlimmerer Fehler als eine langsame Antwort.',
    'privacy.minors.s7.p3': 'Sie können sich auch bei der staatlichen Datenschutzaufsicht Litauens (Valstybine duomenu apsaugos inspekcija) unter vdai.lrv.lt oder ada@ada.lt beschweren oder bei der Datenschutzbehörde Ihres EWR-Landes.',
    'privacy.minors.s8.heading': '5.8 Wie lange wir die Daten eines Kindes aufbewahren',
    'privacy.minors.s8.intro': 'Abschnitt 9 nennt die Aufbewahrungsfrist für jede Datenkategorie. Kurz gesagt:',
    'privacy.minors.s8.voice': 'Stimme: Wir speichern sie überhaupt nicht.',
    'privacy.minors.s8.conversations': 'Gespräche: bleiben im Konto, bis Sie sie im Verlauf löschen oder das Konto löschen.',
    'privacy.minors.s8.account': 'Kontodaten, einschließlich der E-Mail-Adresse: wie in Abschnitt 9 beschrieben.',
    'privacy.minors.s8.p2': 'Wenn Sie glauben, dass ein Kind sich ohne Wissen der Eltern oder Erziehungsberechtigten angemeldet hat, schreiben Sie an info@timetotalk.lt. Nach Prüfung der Anfrage löschen wir das Konto und seine Daten unverzüglich.',
  },

  no: {
    // daily-words
    "dailyWords.row": "Øveord",
    "dailyWords.rowHint": "Ordene barnet ditt lærer hver dag",
    "dailyWords.title": "Øveord",
    "dailyWords.intro": "Skriv inn ordene barnet ditt lærer nå. Timo viser ett hver dag og ber barnet si det.",
    "dailyWords.close": "Lukk",
    "dailyWords.modeTitle": "Hvilke ord Timo viser",
    "dailyWords.modeMine": "Bare mine ord",
    "dailyWords.modeMineHint": "Ett av ordene dine hver dag, i listens rekkefølge.",
    "dailyWords.modeMix": "Mine ord og Timos",
    "dailyWords.modeMixHint": "Én dag ditt ord, neste dag et av Timos.",
    "dailyWords.today": "Dagens ord: {word}",
    "dailyWords.todayBadge": "I dag",
    "dailyWords.add": "Legg til ord",
    "dailyWords.inputLabel": "Ord",
    "dailyWords.placeholder": "For eksempel: eple",
    "dailyWords.pictureTitle": "Bilde (valgfritt)",
    "dailyWords.noPicture": "Uten bilde",
    "dailyWords.photo": "Foto",
    "dailyWords.removePhoto": "Fjern foto",
    "dailyWords.listTitle": "Dine ord",
    "dailyWords.empty": "Ingen ord ennå. Så lenge listen er tom, viser Timo sine egne ord.",
    "dailyWords.edit": "Endre",
    "dailyWords.save": "Lagre",
    "dailyWords.cancel": "Avbryt",
    "dailyWords.delete": "Slett",
    "dailyWords.deleteConfirm": "Slette «{word}»?",
    "dailyWords.listen": "Lytt",
    "dailyWords.moveUp": "Flytt opp",
    "dailyWords.moveDown": "Flytt ned",
    "dailyWords.saved": "Lagret",
    "dailyWords.deviceOnly": "Ordene lagres bare på denne enheten. En annen telefon eller et annet nettbrett har dem ikke.",
    "dailyWords.errEmpty": "Skriv inn et ord først.",
    "dailyWords.errDuplicate": "Det ordet står allerede på listen.",
    "dailyWords.errFull": "Listen har allerede {max} ord. Slett ett for å legge til et nytt.",
    "dailyWords.errSave": "Kunne ikke lagre. Lagringsplassen kan være full. Prøv uten foto.",
    "dailyWords.errImage": "Dette fotoet kunne ikke åpnes. Velg et annet.",
    // end daily-words
    // Story copy lives in src/copy/story.no.js so it can be edited on its own.
    ...storyNo,
    'house.room.living': 'Stue',
    'house.room.talk': 'Telefonrom',
    'house.room.play': 'Lekerom',
    'house.room.study': 'Lesekrok',
    'house.hotspot.couch': 'Hoppe i sofaen',
    'house.hotspot.window': 'Se ut av vinduet',
    'house.hotspot.timo': 'Leke med Timo',
    'house.hotspot.pet': 'Leke med Timo',
    'house.hotspot.phone': 'Snakke i telefonen',
    'house.hotspot.shelf': 'Åpne bildekortene',
    'house.hotspot.toybox': 'Åpne lekekassen',
    'house.hotspot.desk': 'Dagens ord',
    'house.parent.settings': 'For voksne',
    'house.parent.button': 'For voksne',
    'house.nav.rooms': 'Rom',
    'house.nav.prev': 'Forrige rom',
    'house.nav.next': 'Neste rom',
    'house.badge.stars': 'Opptjente stjerner',
    'house.hotspot.beanbag': 'Sakkosekk',
    'house.hotspot.bookshelf': 'Bokhylle',
    'house.hotspot.curtain': 'Gardin',
    'house.hotspot.easel': 'Staffeli',
    'house.hotspot.lamp': 'Lampe',
    'house.hotspot.lights': 'Lyslenke',
    'house.hotspot.pinboard': 'Oppslagstavle',
    'house.hotspot.plant': 'Plante',
    'house.hotspot.playwindow': 'Vindu',
    'house.hotspot.rainbowrug': 'Regnbueteppe',
    'house.hotspot.rug': 'Teppe',
    'house.hotspot.stool': 'Krakk',
    'house.map.title': 'Huskart',
    'house.map.close': 'Lukk kart',
    'house.map.here': 'Du er her',
    'house.map.go': 'Gå',
    'house.map.activity.talk': 'Snakke',
    'house.map.activity.cards': 'Kort',
    'house.map.activity.word': 'Ord',
    'house.a11y.roomOf': 'Rom {n} av {total}',
    'download.downloadApp': 'Last ned appen',
    'download.installApp': 'Installer appen',
    'download.bestExperience': 'Best opplevelse får du i den installerte appen.',
    'download.iosInstallTitle': 'iPhone og iPad',
    'download.tapShare1': 'Trykk på Del (firkant med pil).',
    'download.tapShare2': 'Trykk på "Legg til på Hjem-skjerm".',
    'download.tapShare3': 'Trykk på "Legg til".',
    'download.androidInstall': 'Android-installasjon',
    'download.androidStep1': 'Åpne Chrome-menyen (⋮ øverst til høyre)',
    'download.androidStep2': 'Trykk på "Legg til på startskjermen" eller "Installer app"',
    'download.androidStep3': 'Trykk på "Installer" for å bekrefte',
    'download.promptNotOpen': 'Installasjonsvinduet åpnet seg ikke. Åpne nettlesermenyen og trykk på "Installer app" eller "Legg til på startskjermen".',
    'download.desktopHint': 'For best resultat, åpne dette på iPhone/iPad/Android og installer appen.',
    'download.windowsTitle': 'Windows og datamaskin',
    'download.windowsHint': 'Klikk på installasjonsikonet i adressefeltet i nettleseren (Chrome eller Edge anbefales).',
    'download.installedSuccess': 'Appen ble installert',
    'download.otherDeviceTitle': 'Vil du ha appen på en annen enhet?',
    'download.otherDeviceBody': 'Åpne en nettleser på enheten, gå til timohelps.com og logg inn med samme informasjon.',
    'download.otherDeviceHelp': 'Problemer? Send oss en melding:',
    // In-app browser overlay (Facebook / Instagram detection)
    'iab.title': 'Åpne i nettleser',
    'iab.body': 'Innlogging fungerer ikke i {source}.',
    'iab.openChrome': 'Åpne i Chrome',
    'iab.openSafari': 'Åpne i Safari',
    'iab.openBrowser': 'Åpne i nettleser',
    'iab.copyLink': 'Kopier lenke',
    'iab.copied': 'Kopiert',
    'iab.hintIos': 'Eller ⋯ meny → Åpne i Safari',
    'iab.hintAndroid': 'Eller ⋮ meny → Åpne i nettleser',
    'iab.hintOther': 'Eller lim lenken i nettleseren',
    'iab.iosCopyAndOpen': 'Kopier lenke',
    'iab.iosLinkCopied': 'Lenke kopiert. Åpne Safari.',
    'iab.iosStep1': 'Trykk for å kopiere lenken.',
    'iab.iosStep2': 'Åpne Safari (sveip opp eller hjem-indikator).',
    'iab.iosStep3': 'Lim lenken inn i adressefeltet.',
    'iab.continueAnyway': 'Bli her',
    'obp.successTitle': 'Alt klart!',
    'obp.successBody': 'Du er i nettleseren nå. Her fungerer alt perfekt, inkludert innlogging.',
    'obp.successCta': 'Fortsett',
    // Common
    'common.startVoice': 'Start taleinntasting',
    'common.stopRecording': 'Stopp opptak',
    'common.close': 'Lukk',
    'common.help': 'Hjelp',
    'common.back': 'Tilbake',
    'common.cancel': 'Avbryt',
    'common.delete': 'Slett',
    'common.appName': 'Time To Talk',
    'appName': 'Time To Talk',
    'nonVerbalMode': 'Snakk',

    // Home
    'home.goodMorning': 'God morgen',
    'home.goodAfternoon': 'God dag',
    'home.goodEvening': 'God kveld',
    'home.needHelpTalking': 'Trenger du hjelp til å snakke?',
    'home.suggestWhatToSay': 'Jeg foreslår hva du kan si',
    'home.quickActions': 'Hurtigvalg',
    'home.nonVerbal': 'Snakk',
    'home.history': 'Historikk',
    'home.scripts': 'Skript',
    'home.startTalking': 'Begynn å snakke',
    'home.reportBug': 'Meld feil',
    'home.underConstruction': 'Under utvikling',
    'home.stillBuilding': 'Fortsatt under bygging! Noe virker kanskje ikke ennå.',
    'home.dontShowAgain': 'Ikke vis igjen',
    'home.gotIt': 'Greit!',
    'home.howToUse': 'Slik bruker du appen',
    'home.settings': 'Innstillinger',
    'home.talkModeBeta': 'Beta',
    'home.talkModeUnderDevelopment': 'Under utvikling',
    'home.talk': 'Snakk',
    'home.show': 'Vis',
    'home.breathing': 'Pust',
    'home.greeting.morning': 'God morgen!',
    'home.greeting.afternoon': 'God dag!',
    'home.greeting.evening': 'God kveld!',
    'home.timoHomeHint': 'Trykk og kom inn til meg!',
    'timo.home.title': 'Timos hjem',
    'timo.home.back': 'Tilbake',
    'timo.home.close': 'Lukk',
    // teacher-first-run: the help screen and its door on the landing screen. English for now, translate later.
    "timo.home.helpButton": "How to use",
    "help.metaTitle": "How to use Timo",
    "help.title": "How to use Timo",
    "help.intro": "Five short steps. It takes a minute to read.",
    "help.back": "Back",
    "help.langLabel": "Language",
    "help.teacher.title": "For teachers and therapists",
    "help.teacher.body": "The app says \"your child\". If you are a teacher, that means your student. Everything works the same, even if you signed up as a parent.",
    // school-use
    "help.school.title": "At school, with a student",
    "help.school.point1": "Use one account on the school tablet. Sign in once and it stays signed in.",
    "help.school.point2": "Hand the tablet to the child on the Timo screen. The child talks to Timo or taps the cards.",
    "help.school.point3": "Everything for grown-ups sits behind the Grown-ups button at the top: settings, progress and the subscription.",
    "help.school.point4": "Type the child's name under Grown-ups > Progress and the child's name. Then the cards and Timo use the child's name, not yours.",
    "help.school.point5": "Got a code from the school or an event? Tap “I have a code” on the start page, the sign-in screen, the payment page or in Settings.",
    "help.step1.title": "Start in Timo's room",
    "help.step1.body": "After you log in, you always land here. This is the start screen, and everything is one tap away.",
    "help.step1.alt": "Timo's room on a phone",
    "help.step2.title": "Tap Timo and talk",
    "help.step2.body": "Tap Timo or the Talk button and allow the microphone. The child speaks, Timo answers out loud.",
    "help.step2.alt": "The Talk button at the bottom of the screen",
    "help.step3.title": "Pictures when talking is hard",
    "help.step3.body": "The Pictures button opens picture cards. The child taps a card and the app says it out loud. No microphone needed, so it still works when the mic does not.",
    "help.step3.alt": "Picture cards",
    "help.step4.title": "Word of the day",
    "help.step4.body": "Every day Timo picks one new word. Tap the word card and say it together with the child.",
    "help.step4.alt": "The word of the day card",
    "help.step5.title": "For grown-ups",
    "help.step5.body": "The Grown-ups button at the top opens settings: language, voice and subscription. This guide is always right next to it.",
    "help.step5.alt": "The How to use and Grown-ups buttons at the top of the screen",
    "help.cta": "Go to Timo",
    "help.contact": "Questions? Email info@timetotalk.lt",
    // The paywall a teacher meets: this label had no key anywhere, so every language showed "per day".
    "pricing.perDayLabel": "per dag",
    // Settings rows for what the hidden homes used to link: progress, profile, breathing.
    "settings.grownUps.title": "For grown-ups",
    "settings.grownUps.progress": "Progress and the child's name",
    "settings.grownUps.progressHint": "Words, streaks and the name Timo says",
    "settings.grownUps.profile": "Profile",
    "settings.grownUps.breathing": "Breathing exercise",
    "settings.grownUps.breathingHint": "Calm breathing together with the child",
    // Promo codes (MOKOMES and the rest): the landing confirmation and the banner on /timo.
    "promoGrant.accepted": "Code accepted: {days} free. Log in to activate it.",
    "promoGrant.acceptedUnlimited": "Code accepted: free unlimited access. Log in to activate it.",
    "promoGrant.continue": "Continue",
    "promoGrant.day.one": "day",
    "promoGrant.day.few": "days",
    "promoGrant.day.many": "days",
    "promoGrant.day.other": "days",
    "promoGrant.banner": "You have {days} of free access until {date}.",
    "promoGrant.bannerUnlimited": "You have free unlimited access.",
    "promoGrant.alreadyUsed": "The code {code} was already used, so it could not be activated again.",
    "promoGrant.close": "Close",
    // promo-codes-2: "I have a code" for signed-in people (/pricing, Settings) and the entry links. English for now.
    "promoCodes2.open": "I have a code",
    "promoCodes2.label": "Enter your code",
    "promoCodes2.submit": "Activate",
    "promoCodes2.checking": "Checking...",
    "promoCodes2.success": "Code accepted: {days} free, until {date}.",
    "promoCodes2.successUnlimited": "Code accepted: free unlimited access.",
    "promoCodes2.alreadyActive": "Your access is already active, no code needed.",
    "promoCodes2.err.empty": "Type the code first.",
    "promoCodes2.err.invalid": "That code does not exist. Check it and try again.",
    "promoCodes2.err.usedOnAccount": "This code was already used on your account.",
    "promoCodes2.err.usedOnNetwork": "This code was already used from this network. Email info@timetotalk.lt and we will help.",
    "promoCodes2.err.fullyClaimed": "This code has been fully claimed.",
    "promoCodes2.err.network": "Could not connect. Check the internet and try again.",
    "promoCodes2.err.error": "Could not activate the code. Try again.",
    'timo.home.dressTitle': 'Kle på Timo',
    'timo.home.foodTitle': 'Hva vil Timo ha?',
    'timo.home.action.feed': 'Mate',
    'timo.home.action.drink': 'Drikke',
    'timo.home.action.sleep': 'Sove',
    'timo.home.action.walk': 'Gå tur',
    'timo.home.action.potty': 'Potte',
    'timo.home.action.cheer': 'Hurra',
    'timo.home.action.dress': 'Kle på',
    'timo.home.sleep.notNight': 'Timo er ikke trøtt ennå',
    'timo.home.outfit.default': 'Vanlig',
    'timo.home.outfit.beanie': 'Lue',
    'timo.home.outfit.panama': 'Panamahatt',
    'timo.home.outfit.cool': 'Solbriller',
    'timo.home.outfit.ai': 'Fremtids-Timo',
    'timo.home.outfit.yoga': 'Yoga-Timo',
    'timo.home.food.apple': 'Eple',
    'timo.home.food.banana': 'Banan',
    'timo.home.food.berries': 'Bær',
    'timo.home.food.bread': 'Brød',
    'timo.home.food.fish': 'Fisk',
    'timo.home.food.acorn': 'Eikenøtt',
    'timo.home.food.cheese': 'Ost',
    'timo.home.food.cookie': 'Kjeks',
    'timo.talk.tapHint': 'Trykk på meg, la oss prate!',
    'timo.talk.greeting': 'Hei! Jeg er Timo. Hva vil du prate om?',
    'timo.talk.tapToTalk': 'Trykk og snakk',
    'timo.talk.listening': 'Jeg hører etter',
    'timo.talk.tapWhenDone': 'Trykk når du er ferdig',
    'timo.talk.thinking': 'Timo tenker',
    'timo.talk.speaking': 'Timo snakker',
    'timo.talk.emptyReprompt': 'Jeg hører etter! Fortell meg noe.',
    'timo.talk.llmErrorReply': 'Jeg elsker å prate med deg! Hva er favorittdyret ditt?',
    'timo.talk.micDenied': 'Timo trenger mikrofonen din',
    'timo.talk.micDeniedHelp': 'Be en voksen om å tillate mikrofonen i nettleserinnstillingene, og trykk så på nytt.',
    // mic-school-devices
    'mic.fail.blocked.title': 'The microphone is blocked',
    'mic.fail.blocked.body': 'Timo cannot hear because this browser is not allowed to use the microphone. Allow it, then tap Try again.',
    'mic.fail.blocked.again': 'Tapped Block before? The browser will not ask again on its own. Change it in the settings, then reload the page.',
    'mic.fail.steps.ios': 'iPad or iPhone: tap aA in the address bar, then Website Settings, then set Microphone to Allow. Or open Settings, then Safari, then Microphone, and choose Allow.',
    'mic.fail.steps.chromebook': 'Chromebook: click the icon left of the web address, turn Microphone on, then reload the page. If the switch is grey, the school has blocked it. Ask your IT admin.',
    'mic.fail.steps.android': 'Android: tap the icon left of the web address, then Permissions, then set Microphone to Allow. Reload the page.',
    'mic.fail.steps.desktop': 'Computer: click the icon left of the web address, set Microphone to Allow, then reload the page. If it still does not work, check the privacy settings of the computer.',
    'mic.fail.steps.native': 'In the Timo app: open your phone Settings, then Timo, and turn Microphone on. Come back and tap Try again.',
    'mic.fail.no_device.title': 'No microphone found',
    'mic.fail.no_device.body': 'This device has no working microphone. Plug in a microphone or a headset, then tap Try again.',
    'mic.fail.in_use.title': 'The microphone is busy',
    'mic.fail.in_use.body': 'Another app or tab is using the microphone. Close it, video calls too, then tap Try again.',
    'mic.fail.insecure_context.title': 'This link cannot use the microphone',
    'mic.fail.insecure_context.body': 'The page is not on a secure address, so the browser hides the microphone. Open the address that starts with https://.',
    'mic.fail.unsupported.title': 'This browser cannot use the microphone',
    'mic.fail.unsupported.body': 'Open Timo in Chrome or Safari to talk. You can use the picture cards now.',
    'mic.fail.in_app_browser.title': 'Open Timo in your browser',
    'mic.fail.in_app_browser.body': 'Instagram, Facebook and similar apps open links in their own window, and the microphone does not work there. Open this page in Chrome or Safari.',
    'mic.fail.inapp.ios': 'Tap the three dots (...) at the top, then choose to open in the browser.',
    'mic.fail.inapp.android': 'Tap the three dots in the corner, then choose Open in Chrome.',
    'mic.fail.offline.title': 'No internet',
    'mic.fail.offline.body': 'Timo needs the internet to hear. Connect to Wi-Fi or mobile data, then tap Try again.',
    'mic.fail.stt_unreachable.title': 'Timo cannot reach his listening service',
    'mic.fail.stt_unreachable.body': 'The microphone works, but the network is blocking the speech service. This often happens on school Wi-Fi. Tap Try again, or ask your IT admin to allow api.deepgram.com and time-to-talk.onrender.com.',
    'mic.fail.stt_service_error.title': 'The listening service is having trouble',
    'mic.fail.stt_service_error.body': 'The microphone and the internet work, but the speech service answered with an error. Wait a minute, then tap Try again.',
    'mic.fail.signed_out.title': 'Please sign in again',
    'mic.fail.signed_out.body': 'Your sign-in has run out, so Timo cannot listen. Sign in again, then tap Try again.',
    'mic.fail.unknown.title': 'Timo cannot hear right now',
    'mic.fail.unknown.body': 'Something stopped the microphone. Tap Try again. If it keeps happening, reload the page.',
    'mic.fail.retry': 'Try again',
    'mic.fail.tiles': 'Use picture cards',
    'mic.fail.openBrowser': 'Open in browser',
    'mic.fail.signIn': 'Sign in',
    'timo.talk.exit': 'Ferdig',
    'timo.word.title': 'Dagens ord',
    'timo.word.sayIt': 'Si det!',
    'timo.word.listening': 'Jeg hører etter',
    'timo.word.hearAgain': 'Hør det igjen',
    'timo.word.tryAgain': 'Skal vi si det sammen?',
    'timo.word.great': 'Kjempebra!',
    'timo.word.days': 'dager på rad',
    'timo.word.open': 'Dagens ord',
    'timo.word.close': 'Lukk',
    'timo.word.newWordSoon': 'Nytt ord i morgen!',
    'timo.talk.waiting': 'Timo tenker...',
    'timo.talk.youSaid': 'Du sa:',
    'timo.talk.voiceResting': 'Timos store stemme hviler, så denne høres ut som en robot.',
    'timo.teach.remember': 'Husk det',
    'timo.teach.hearIt': 'Hør det',
    'timo.teach.gotIt': 'Skjønner!',
    'timo.reward.earned': 'Du fikk {amount} stjerner!',
    'timo.words.title': 'Mine ord',
    'timo.words.wordSingular': 'ord',
    'timo.words.wordPlural': 'ord',
    'timo.words.tapHint': 'Trykk på et ord for å høre det',
    'timo.words.lockedHint': 'Si dette ordet med Timo for å låse det opp',
    'timo.words.empty': 'Ingen ord ennå',
    'timo.words.emptySub': 'Si dagens ord med Timo for å starte samlingen din!',
    'timo.words.close': 'Lukk',
    'timo.words.locked': 'Ikke ennå',
    'timo.recap.title': 'I dag med Timo',
    'timo.recap.wordsLead': 'Ord barnet ditt sa i dag',
    'timo.recap.noWords': 'Mye glad prating i dag',
    'timo.recap.turnsLabel': 'små samtaler',
    'timo.recap.streakLabel': 'dager på rad',
    'timo.recap.minutesLabel': 'min sammen',
    'timo.recap.tipLead': 'Tips',
    'timo.recap.tip1': 'Prøv å si ett av disse ordene sammen ved middagen i kveld.',
    'timo.recap.tip2': 'Hver liten prat teller. Noen få minutter om dagen blir fort mye.',
    'timo.recap.tip3': 'Be barnet ditt lære deg hva Timo sa i dag.',
    'timo.recap.tip4': 'Ros forsøket, ikke bare det å få det riktig.',
    'timo.recap.dismiss': 'Lukk',
    'timo.recap.historyTitle': 'Denne uken med Timo',
    'timo.recap.historyEmpty': 'Ingen samtaler ennå. Trykk på Timo for å starte en!',
    'timo.talk.greetingNamed': 'Hei, {name}! Så fint å se deg!',
    'timo.talk.greetingWord': 'Hei! Dagens ord er {word}. Kan du si det?',
    'timo.talk.greetingWordNamed': 'Hei, {name}! Dagens ord er {word}. Kan du si det?',
    'timo.onboarding.intro': 'Hei! Jeg er Timo. Jeg er vennen din.',
    'timo.onboarding.askName': 'Hva heter du?',
    'timo.onboarding.heard': 'Hørte jeg {name}?',
    'timo.onboarding.confirmYes': 'Ja!',
    'timo.onboarding.confirmNo': 'Prøv igjen',
    'timo.onboarding.retry': 'Oi! Si navnet ditt en gang til.',
    'timo.onboarding.typeInstead': 'Skriv navnet mitt',
    'timo.onboarding.namePlaceholder': 'Navnet ditt',
    'timo.onboarding.save': 'Lagre',
    'timo.onboarding.skip': 'Hopp over',
    'timo.onboarding.welcome': 'Hyggelig å møte deg, {name}!',
    'timo.onboarding.micDenied': 'Jeg kan ikke høre deg. Du kan skrive navnet ditt.',
    // Timo tells a story: UI chrome only. The story prose itself lives in
    // src/copy/story.en.js under the story.* keys, not here.
    'timo.story.tapToStart': 'Start historien',
    'timo.story.listening': 'Din tur',
    'timo.story.narrating': 'Timo forteller historien',
    'timo.story.close': 'Ferdig',
    'timo.story.replay': 'En gang til',
    'timo.story.finished': 'Slutt',
    'timo.story.next': 'Videre',
    'parent.title': 'Fremgang',
    'parent.backAria': 'Tilbake til start',
    'parent.noKidName': 'Barnet ditt',
    'parent.subtitle': 'Fremgang i taletreningen',
    'parent.tierLabel': 'Nivå',
    'parent.statStreak': 'Dager på rad',
    'parent.statWords': 'Ord lært',
    'parent.statStars': 'Stjerner samlet',
    'parent.statDaysActive': 'Aktive dager',
    'parent.statDaysActiveHint': 'Siste 30 dager',
    'parent.statLongest': 'Lengste rekke',
    'parent.statWordsWeek': 'Nye ord denne uken',
    'parent.calendarTitle': 'Øvingskalender',
    'parent.calendarPrevAria': 'Forrige måned',
    'parent.calendarNextAria': 'Neste måned',
    'parent.calendarLegendPracticed': 'Øvd',
    'parent.calendarLegendToday': 'I dag',
    'parent.calendarDayPracticed': 'øvd',
    'parent.calendarEmptyMonth': 'Ingen øving registrert denne måneden ennå.',
    'parent.timelineTitle': 'Lærte ord',
    'parent.timelineToday': 'I dag',
    'parent.timelineYesterday': 'I går',
    'parent.timelineDaysAgo': 'for {n} dager siden',
    'parent.timelineEmptyTitle': 'Reisen starter her',
    'parent.timelineEmptyBody': 'Hvert ord barnet ditt lærer med Timo, dukker opp her. Selv ett ord om dagen blir fort til mye.',
    'parent.timelineWordCount': '{n} ord',
    'parent.timelineWordCountOne': '1 ord',
    'parent.printLabel': 'Skriv ut',
    'parent.printAria': 'Skriv ut denne siden',
    'parent.footerNote': 'Fremgangen lagres på denne enheten og synkroniseres med kontoen din.',
    'timo.recap.today': 'I dag',
    'timo.recap.yesterday': 'I går',
    'home.urgencyBanner': 'Abonnementet er ikke aktivt, lås opp alle funksjoner',
    'home.urgencyBannerCta': 'Se planer',
    'subscription.choosePlanCta': 'Velg en plan',
    'home.sessionsCompleted': '{n} økter fullført',

    // Settings
    'settings.title': 'Innstillinger',
    'settings.backAria': 'Tilbake',
    'settings.appearance': 'Utseende',
    'settings.sounds': 'Lyder',
    'settings.background': 'Bakgrunn',
    'settings.language': 'Språk',
    'settings.account': 'Konto',
    'settings.voiceprint.title': 'Stemmegjenkjenning',
    'settings.voiceprint.description': 'Time to Talk lærer stemmen din på denne enheten, slik at den ser hvem som snakker i en direkteøkt. Stemmeprofilen lagres lokalt og sendes aldri til serverne våre.',
    'settings.voiceprint.forget': 'Glem stemmen min',
    'settings.voiceprint.forgetDesc': 'Slett lagret stemmeprofil og start på nytt',
    'settings.voiceprint.forgotten': 'Stemmeprofil slettet',
    'settings.voiceprint.forgottenDesc': 'Time to Talk lærer stemmen din på nytt i neste direkteøkt.',
    'settings.theme': 'Tema',
    'settings.dark': 'Mørk',
    'settings.light': 'Lys',
    'settings.textSize': 'Tekststørrelse',
    'settings.textSizeSmall': 'A',
    'settings.textSizeMedium': 'A+',
    'settings.textSizeLarge': 'A++',
    'settings.reduceMotion': 'Reduser bevegelse',
    'settings.dyslexiaFont': 'Dyslexi-skrift',
    'settings.showImages': 'Vis bilder',
    'settings.rewardSounds': 'Belønningslyder',
    'settings.rainAnimation': 'Regn-animasjon',
    'settings.rainSounds': 'Regnlyder',
    'settings.celebration': 'Feiringseffekter',
    'settings.partyModePhone': 'Feiringseffekter på telefon',
    'settings.partyModeDesktop': 'Feiringseffekter på datamaskin',
    'settings.forest': 'Skog',
    'settings.city': 'By',
    'settings.beach': 'Strand',
    'settings.privacyPolicy': 'Personvern',
    'settings.termsOfService': 'Vilkår',
    'settings.helpSupport': 'Hjelp og støtte',
    'settings.replayTutorial': 'Spill av veiledning igjen',
    'settings.replayTutorialDescription': 'Se gjennomgangen av appen igjen',
    'settings.resetPermissions': 'Tilbakestill tillatelser',
    'settings.resetPermissionsDescription': 'Be om mikrofon- og enhetstilgang igjen',
    'settings.resetToDefaults': 'Tilbakestill til standard',
    'settings.followUs': 'Følg oss',
    'settings.version': 'Timo v1.0.0 • Laget med ❤️',
    'profile.navSubscription': 'Abonnement',
    'profile.logout': 'Logg ut',
    'profile.logoutConfirmTitle': 'Er du sikker?',
    'profile.logoutConfirmText': 'Du blir logget ut og sendt tilbake til forsiden.',
    'profile.logoutYes': 'Ja',
    'profile.logoutNo': 'Nei',
    'settings.deleteAccount': 'Slett konto',
    'settings.deleteAccountConfirmTitle': 'Slette kontoen din?',
    'settings.deleteAccountConfirmBody': 'Dette sletter kontoen din og alle data permanent. Det kan ikke angres.',
    'settings.deleteAccountConfirm': 'Ja, slett kontoen min',
    'settings.deleteAccountCancel': 'Avbryt',
    'settings.deleteAccountSuccess': 'Konto slettet',
    'settings.deleteAccountError': 'Kunne ikke slette kontoen. Prøv igjen eller kontakt support.',
    'settings.voiceTitle': 'Stemme',
    'settings.voiceDescription': 'Velg en stemme',
    'settings.voiceChildishFemale': 'Barnlig, kvinnelig',
    'settings.voiceAdultMale': 'Voksen, mannlig',
    'settings.resetToastTitle': '✅ Innstillinger tilbakestilt',
    'settings.resetToastDescription': 'Alle tilgjengelighetsinnstillinger er tilbakestilt til standard.',
    'settings.metaDescription': 'Tilpass tilgjengelighet som dyslexi-modus, tekststørrelse og bakgrunn.',
    'settings.rainBackgroundTitle': 'Animert regn-bakgrunn',
    'settings.rainBackgroundDescription': 'Vis regn-animasjon',
    'settings.disableRainBackground': 'Skru av regn-bakgrunn',
    'settings.enableRainBackground': 'Skru på regn-bakgrunn',
    'settings.rainSoundTitle': 'Loopet regnlyd',
    'settings.rainSoundDescription': 'Spill regnlyd i bakgrunnen',
    'settings.disableRainSound': 'Skru av regnlyd',
    'settings.enableRainSound': 'Skru på regnlyd',
    'settings.volumeLabel': 'Volum',
    'settings.rainVolumeAria': 'Volum på regnlyd',
    'settings.imagesDescription': 'Slå av/på ikoner og bilder',
    'settings.openDyslexicTitle': 'OpenDyslexic-skrift',
    'settings.openDyslexicDescription': 'Bruker OpenDyslexic for å gjøre bokstavene lettere å skille.',
    'settings.openDyslexicAria': 'OpenDyslexic-skrift',
    'settings.textSizeTitle': 'Tekststørrelse',
    'settings.mediumFont': 'Middels tekststørrelse',
    'settings.largeFont': 'Stor tekststørrelse',
    'settings.xlargeFont': 'Ekstra stor tekststørrelse',
    'settings.ttsModelTitle': 'Stemmemodell',
    'settings.ttsModelDescription': 'Velg hvilken KI-stemmemodell som brukes',
    'settings.ttsModelBrowser': 'Robo',
    'settings.ttsModelElevenLabs': 'Natt',
    'settings.ttsModelOpenAI': 'Nova',
    'settings.ttsModelGemini': 'Puck',
    'settings.themeIconsTitle': 'Bakgrunns-ikoner',
    'settings.themeIconsDescription': 'Vis svevende emoji-ikoner som passer temaet',
    'settings.showImagesIcons': 'Vis bilder og ikoner',
    'settings.soundTitle': 'Lyd',
    'settings.rewardSound': 'Belønningslyd',

    // Non-verbal (nv.*)
    'nv.speakModalTitle': 'Jeg sier:',
    'nv.speaking': 'Snakker...',
    'nv.speak': 'Snakk',
    'nv.speakAgain': 'Snakk igjen',
    'nv.speakLoading': 'Bygger setning...',
    'nv.imageAlt': 'Bilde',
    'nv.sentenceBarAria': 'Setningsfelt',
    'nv.tapSymbol': 'Trykk på et symbol...',
    'nv.clearAll': 'Tøm alt',
    'nv.deleteLast': 'Slett siste',
    'nv.speakSentence': 'Si setningen',
    'nv.kalbeti': 'Snakk',
    'nv.clear': '✕ Tøm',
    'nv.backAria': 'Tilbake',
    'nv.scriptsAria': 'Skript',
    'nv.historyAria': 'Historikk',
    'nv.searchPlaceholder': 'Søk symbol...',
    'nv.noResults': 'Ingen treff',
    'nv.ttsFailed': 'Ingen lyd. Trykk for å prøve igjen.',
    'nv.searchAria': 'Søk symbol',
    'nv.loading': 'Laster...',
    'nv.noPhotos': 'Ingen bilder enda',
    'nv.addPhotosHint': 'Legg til egne bilder for kommunikasjon',
    'nv.addPhoto': 'Legg til bilde',
    'nv.add': 'Legg til',
    'nv.showLess': 'Vis mindre',
    'nv.moreCount': 'Flere ({count})',
    'nv.comingSoon': 'Kommer snart!',
    'nv.historyTitle': 'Historikk',
    'nv.historyEmpty': 'Ingen setninger ennå. Trykk på emojier og snakk for å bygge historikk.',
    'nv.useAgain': 'Bruk igjen',
    'nv.addToScripts': 'Legg til i skript',
    'nv.savedToScripts': 'Lagret i skript!',
    'nv.clearHistory': 'Tøm historikk',
    'nv.customAddPhoto': 'Legg til bilde',
    'nv.customPreview': 'Forhåndsvisning',
    'nv.customAddLabel': 'Legg til etikett',
    'nv.customTakePhoto': 'Ta bilde',
    'nv.customUseCamera': 'Bruk kamera',
    'nv.customFromGallery': 'Velg fra galleri',
    'nv.customFromDevice': 'Fra enheten',
    'nv.customWordOnly': 'Bare et ord',
    'nv.customWordOnlyHint': 'Ingen bilde nødvendig',
    'nv.customChange': 'Endre',
    'nv.customContinue': 'Fortsett',
    'nv.customHintLabels': 'Tekst som vises og sies',
    'nv.customNameEn': 'Navn (engelsk)',
    'nv.customPlaceholderName': 'f.eks. "Mamma", "Per"',
    'nv.customNameLt': 'Navn på litauisk',
    'nv.customNameRu': 'Navn på russisk',
    'nv.customOptional': 'valgfritt',
    'nv.customCategory': 'Kategori',
    'nv.customBack': 'Tilbake',
    'nv.customSave': 'Lagre',
    'nv.customSaving': 'Lagrer...',
    'nv.customErrImage': 'Velg en bildefil',
    'nv.customErrSize': 'Filen er for stor (maks 10 MB)',
    'nv.customErrLabel': 'Skriv inn en etikett',
    'nv.customErrSave': 'Feil ved lagring',
    'nv.manageTitle': 'Mine bilder',
    'nv.deleteConfirm': 'Slette "{name}"?',
    'nv.cancel': 'Avbryt',
    'nv.delete': 'Slett',

    // Unknown Situation
    'unknown.startConversation': 'Start samtale',
    'unknown.continueConversation': 'Fortsett samtalen',
    'unknown.askForHelp': 'Be om hjelp',
    'unknown.sayNoPolitely': 'Si nei høflig',
    'unknown.endConversation': 'Avslutt samtalen',
    'unknown.metaTitle': 'Din situasjon',
    'unknown.metaDescription': 'Øv på samtaler med KI som forstår konteksten.',
    'unknown.backAria': 'Tilbake til "Din situasjon"',
    'unknown.title': 'Din situasjon',
    'unknown.subtitle': 'Skriv hva du eller den andre sa. Timo KI skjønner situasjonen og hjelper.',
    'unknown.subtitleShort': 'Skriv hva den andre sa, så Timo KI kan hjelpe.',
    'unknown.helper': 'Hva kan Timo KI hjelpe med?',
    'unknown.youCouldSay': 'Du kan også si...',
    'unknown.firstMessage': 'Fortell hva som skjedde eller hva de sa.',
    'unknown.inputPlaceholder': 'Be Timo KI om hjelp...',
    'unknown.inputAria': 'Be Timo KI om hjelp',
    'unknown.sendAria': 'Send melding',
    'unknown.finishAria': 'Avslutt samtalen',
    'unknown.finishButton': 'Ferdig',
    'unknown.finishedNotice': 'Samtalen er ferdig',
    'unknown.startNewConversation': 'Start ny samtale',
    'unknown.finishToastTitle': 'Samtalen er ferdig',
    'unknown.finishToastDescription': 'Samtalen er avsluttet. Du kan starte en ny.',
    'unknown.errorTitle': 'Feil',
    'unknown.errorDescription': 'Kunne ikke sende meldingen. Prøv igjen.',
    'unknown.contextPlace': 'Sted',
    'unknown.contextRelationship': 'Relasjon',
    'unknown.contextGoal': 'Mål',
    'unknown.emptyState': 'Begynn med å skrive hva som skjedde eller hva som ble sagt!',
    'unknown.playVoiceAria': 'Spill av stemme',
    'unknown.finishedTitle': 'Du fullførte denne situasjonen!',
    'unknown.motivationalMessage': 'Bra at du prøvde.',
    'unknown.howDidItFeel': 'Hvordan føltes det denne gangen?',
    'unknown.itFeltGood': 'Det føltes bra',
    'unknown.itWasHard': 'Det var vanskelig denne gangen',
    'unknown.bothChoicesOkay': 'Begge svar er ok, det viktigste er at du prøvde.',
    'unknown.goalSelectionTitle': 'Hva trenger du hjelp med?',
    'unknown.goalSelectionSubtitle': 'Velg det alternativet som passer best til situasjonen din.',
    'unknown.goalHelpSpeaking': 'Jeg trenger hjelp til å snakke',
    'unknown.goalHelpAsking': 'Jeg trenger hjelp til å spørre om noe',
    'unknown.goalLost': 'Jeg vet ikke hva jeg skal si',
    'unknown.goalSayNo': 'Jeg vil si nei på en høflig måte',
    'unknown.goalSkip': 'Dette passer ikke til situasjonen min',
    'unknown.goalBadgeHelpSpeaking': 'Mål: Hjelp til å snakke',
    'unknown.goalBadgeHelpAsking': 'Mål: Hjelp til å spørre',
    'unknown.goalBadgeLost': 'Mål: Jeg vet ikke hva jeg skal si',
    'unknown.goalBadgeSayNo': 'Mål: Si nei høflig',
    'unknown.recordOtherSpeaker': 'Ta opp hva de sa',
    'unknown.recording': 'Tar opp...',
    'unknown.otherPersonSaid': 'Den andre sa:',
    'unknown.speakerLabel': 'Du kan si:',
    'unknown.timoAILabel': 'Timo KI:',
    'unknown.otherPersonLabel': 'Den andre:',
    'unknown.youLabel': 'Du:',

    // Custom Situation setup
    'customSetup.intentStart': 'Start samtale',
    'customSetup.intentContinue': 'Fortsett samtalen',
    'customSetup.intentFinish': 'Avslutt samtalen',
    'customSetup.metaTitle': 'Egen situasjon, oppsett',
    'customSetup.metaDescription': 'Sett opp en egen samtaleøvelse.',
    'customSetup.title': 'Egen situasjon',
    'customSetup.subtitle': 'Velg hvor du er og hva du vil gjøre.',
    'customSetup.situationLabel': 'Situasjon',
    'customSetup.placeholder': 'f.eks. fest, skole, butikk, buss, sykehus',
    'customSetup.examplesHint': 'Eller trykk på et eksempel under:',
    'customSetup.examples.party': 'Fest',
    'customSetup.examples.school': 'Skole',
    'customSetup.examples.store': 'Butikk',
    'customSetup.examples.bus': 'Buss',
    'customSetup.examples.hospital': 'Sykehus',
    'customSetup.intentQuestion': 'Hva vil du gjøre?',
    'customSetup.startButton': 'Start',

    // Custom Situation chat
    'customChat.metaTitle': 'Egen situasjon, chat',
    'customChat.genericSituation': 'situasjon',
    'customChat.metaDescriptionPrefix': 'Samtaleøvelse:',
    'customChat.backAria': 'Tilbake til oppsett',
    'customChat.inputPlaceholder': 'Skriv meldingen din...',
    'customChat.inputAria': 'Skriv meldingen din',
    'customChat.finishToastTitle': 'Samtalen er ferdig',
    'customChat.finishToastDescription': 'Samtalen er avsluttet. Du kan starte en ny.',
    'customChat.errorTitle': 'Feil',
    'customChat.errorDescription': 'Kunne ikke sende meldingen. Prøv igjen.',
    'customChat.finishFallbackShort': 'Ha det!',
    'customChat.finishFallbackLong': 'Jeg må gå nå, takk!',
    'customChat.finishedNotice': 'Samtalen er ferdig',
    'customChat.fallback': 'Skjønner.',

    // Chat
    'chat.pageTitle': 'Chat med Timo',
    'chat.metaDescription': 'Snakk med Timo, få hjelp med hva du kan si',
    'chat.backAria': 'Tilbake',
    'chat.subtitle': 'Din KI-hjelper',
    'chat.end': 'Avslutt',
    'chat.helpDefault': 'Hjelp',
    'chat.greeting': 'Hei! Hva trenger du hjelp til å si?',
    'chat.suggestionsTitle': 'Hva skal jeg si?',
    'chat.suggestionsHint': 'Trykk på et valg, det leses opp og sendes',
    'chat.suggestionsUpdating': 'Oppdaterer...',
    'chat.noSuggestions': 'Ingen forslag tilgjengelig',
    'chat.thinking': 'Tenker...',
    'chat.gettingSuggestions': 'Henter forslag til deg',
    'chat.quickRepliesLabel': 'Hurtigsvar:',
    'chat.speaking': 'Snakker:',
    'chat.speakerMe': 'Meg',
    'chat.speakerOther': 'Andre',
    'chat.placeholder': 'Skriv en melding...',
    'chat.sendAria': 'Send melding',
    'chat.getHelpAria': 'Få hjelp',
    'chat.playTtsAria': 'Spill av tale',
    'chat.ariaHearTimo': 'Hør Timos melding',
    'chat.ariaHearIt': 'Hør det',
    'chat.ariaSaveScript': 'Lagre i skript',
    'chat.recordMicMe': 'Hold inne for å ta opp stemmen din',
    'chat.recordMicOther': 'Hold inne for å ta opp hva de sa',
    'chat.recordingMe': 'Tar opp stemmen din...',
    'chat.recordingOther': 'Tar opp hva de sa...',
    'chat.ttsWait': 'Vent {seconds}s... ({left} igjen)',
    'chat.youCan': 'Du kan si:',
    'chat.timoSuggests': 'Timo foreslår...',
    'chat.safetyTitle': 'Trygghetsvarsel',
    'chat.safetyBody': 'Denne samtalen kan være utrygg. Hvis du føler deg truet, gå unna med en gang.',
    'chat.fallbackAi': 'Hei! Hva trenger du hjelp til å si?',
    'chat.fallbackCoaching': 'Melding sendt! 👍 Trenger du noe mer?',
    'chat.needMoreHelp': 'Trenger du hjelp med noe annet?',
    'chat.praise1': 'Flott!',
    'chat.praise2': 'Bra!',
    'chat.praise3': 'Bra jobba!',
    'chat.toast.errorTitle': 'Feil',
    'chat.toast.errorDesc': 'Kunne ikke hente svar. Prøv igjen.',
    'chat.toast.ttsLimitTitle': 'Avspillingsgrense nådd',
    'chat.toast.ttsLimitDesc': 'Maks 5 avspillinger per økt for å spare ressurser.',
    'chat.toast.savedTitle': 'Lagret!',
    'chat.toast.savedDesc': 'Lagt til i skriptene dine.',
    'chat.toast.duplicateTitle': 'Allerede lagret',
    'chat.toast.duplicateDesc': 'Du har denne setningen fra før.',
    'chat.toast.voiceTestTitle': 'Stemmetest',
    'chat.toast.voiceTestDesc': 'Spiller av lydprøve...',
    'chat.toast.voiceFailTitle': 'Stemmetest mislyktes',
    'chat.toast.voiceFailDesc': 'Detaljer i konsollen.',
    'chat.toast.connectionTitle': 'Tilkoblingsproblem',
    'chat.toast.connectionDesc': 'Fikk ikke hele svaret, men meldingen din var fin!',
    'chat.testVoice.lt': 'Sveiki, aš esu Timo, jūsų dirbtinis intelektas.',
    'chat.testVoice.en': "Hi, I'm Timo, your AI helper.",
    'chat.testVoice.ru': 'Привет! Я Тимо, твой помощник на базе искусственного интеллекта.',
    'chat.qr.hey1': 'Hei!',
    'chat.qr.hey2': 'Hallo',
    'chat.qr.hey3': 'Hva skjer?',
    'chat.qr.yes1': 'Ja',
    'chat.qr.yes2': 'Nei',
    'chat.qr.yes3': 'Kanskje',
    'chat.qr.how1': 'Bra!',
    'chat.qr.how2': 'Ikke verst',
    'chat.qr.how3': 'Det går',
    'chat.qr.inv1': 'Klart!',
    'chat.qr.inv2': 'Kanskje senere',
    'chat.qr.inv3': 'Kan ikke, beklager',
    'chat.qr.help1': 'Klart',
    'chat.qr.help2': 'Hva skjer?',
    'chat.qr.help3': 'Hvordan kan jeg hjelpe?',
    'chat.qr.thanks1': 'Bare hyggelig!',
    'chat.qr.thanks2': 'Når som helst',
    'chat.qr.thanks3': 'Ingen årsak',
    'chat.qr.comp1': 'Takk!',
    'chat.qr.comp2': 'Hyggelig',
    'chat.qr.comp3': '😊',
    'chat.qr.sorry1': 'Ingen sak',
    'chat.qr.sorry2': 'Det går bra',
    'chat.qr.sorry3': 'Helt fint',
    'chat.qr.info1': 'Jaså?',
    'chat.qr.info2': 'Fortell',
    'chat.qr.info3': 'Hva?',
    'chat.qr.plan1': 'Høres bra ut',
    'chat.qr.plan2': 'Når da?',
    'chat.qr.plan3': 'Kanskje',
    'chat.qr.conf1': 'Jepp',
    'chat.qr.conf2': 'Akkurat',
    'chat.qr.conf3': 'Helt sikkert',
    'chat.qr.wq1': 'Usikker',
    'chat.qr.wq2': 'La meg tenke',
    'chat.qr.wq3': 'Jeg sjekker',
    'chat.qr.genq1': 'Ja',
    'chat.qr.genq2': 'Nei',
    'chat.qr.genq3': 'Kanskje',
    'chat.qr.stat1': 'Kult',
    'chat.qr.stat2': 'Fint',
    'chat.qr.stat3': 'Jaså?',
    'chat.qr.def1': 'Ok',
    'chat.qr.def2': 'Skjønner',
    'chat.qr.def3': 'Kult',

    // Push to talk
    'pushToTalk.title': 'Hjelp meg å svare',
    'pushToTalk.ready': 'Klar når du er',
    'pushToTalk.helpMeRespond': 'Hjelp meg å svare',
    'pushToTalk.tapToStart': 'Trykk for å ta opp hva de sa',
    'pushToTalk.recording': 'Tar opp hva de sa...',
    'pushToTalk.done': 'Ferdig',
    'pushToTalk.cancel': 'Avbryt',
    'pushToTalk.understanding': 'Forstår...',
    'pushToTalk.theySaid': 'De sa:',
    'pushToTalk.soundsLike': 'Dette høres ut som',
    'pushToTalk.yesHelpMe': 'Ja, hjelp meg å svare',
    'pushToTalk.notQuite': 'Ikke helt, prøv igjen',
    'pushToTalk.startOver': 'Start på nytt',
    'pushToTalk.findingResponses': 'Finner gode svar...',
    'pushToTalk.pickResponse': 'Velg et svar:',
    'pushToTalk.youllSay': 'Du sier:',
    'pushToTalk.illSayIt': 'Jeg sier det',
    'pushToTalk.speakForMe': 'Si det for meg',
    'pushToTalk.chooseAnother': 'Velg et annet',
    'pushToTalk.differentOptions': 'Andre alternativer',
    'pushToTalk.speaking': 'Snakker...',
    'pushToTalk.stop': 'Stopp',
    'pushToTalk.responseReady': 'Svaret er klart!',
    'pushToTalk.needMoreHelp': 'Mer hjelp',
    'pushToTalk.imDone': 'Jeg er ferdig',
    'pushToTalk.autoReset': 'Går automatisk tilbake',
    'pushToTalk.stillThere': 'Er du der?',
    'pushToTalk.takeYourTime': 'Ta deg tid, ingen hast.',
    'pushToTalk.continue': 'Fortsett',
    'pushToTalk.didntCatch': 'Jeg fikk ikke med meg det',
    'pushToTalk.tryAgainOrType': 'Prøv igjen eller skriv',
    'pushToTalk.tryAgain': 'Prøv igjen',
    'pushToTalk.typeInstead': 'Skriv i stedet',
    'pushToTalk.whatDidTheySay': 'Hva sa de?',
    'pushToTalk.typeHere': 'Skriv hva de sa...',
    'pushToTalk.somethingWrong': 'Noe gikk galt',
    'pushToTalk.pleaseTryAgain': 'Prøv igjen',
    'pushToTalk.panic': 'Stopp og gå tilbake',

    // --- Native iOS port (WS-2 auth, WS-3 purchases, WS-4 speech, WS-5 media,
    //     WS-6 install, WS-7 AI consent and content reporting). Merged from
    //     src/native/_i18n/*.strings.json. Additive: no existing key was changed.
    'native.auth.browserUnavailable': 'Innloggingsvinduet kunne ikke åpnes. Prøv igjen.',
    'native.auth.oauthCancelled': 'Innloggingen ble avbrutt.',
    'native.auth.oauthFailed': 'Innloggingen ble ikke fullført. Prøv igjen.',
    'native.auth.passwordResetOpensBrowser': 'Endring av passord åpner en sikker side i nettleseren. Endre passordet der, kom så tilbake og logg inn med det nye.',
    'native.auth.sessionFailed': 'Vi klarte ikke å fullføre innloggingen. Prøv igjen.',
    'native.consent.agree': 'Jeg samtykker',
    'native.consent.contact': 'Har du spørsmål? Skriv til oss:',
    'native.consent.declinedAgree': 'Jeg har ombestemt meg, jeg samtykker',
    'native.consent.declinedBody': 'Uten dette kan ikke Timo lytte eller svare. Du kan fortsatt bruke bildene, de lagrede manusene og alle innstillingene. Når du er klar, slår du det på i innstillingene under Personvern.',
    'native.consent.declinedContinue': 'Fortsett uten at Timo snakker',
    'native.consent.declinedTitle': 'Timo holder seg stille foreløpig',
    'native.consent.forLabel': 'Til:',
    'native.consent.getsLabel': 'Får:',
    'native.consent.intro': 'Timo bruker noen eksterne selskaper: de gjør tale om til tekst, skriver svarene hans og leser dem høyt. Det betyr at noe av det du sier og skriver blir sendt til dem. Her er nøyaktig hvem de er og hva hver av dem får.',
    'native.consent.notNow': 'Ikke nå',
    'native.consent.privacyLink': 'Les personvernerklæringen',
    'native.consent.proc.anthropic.purpose': 'Å skrive Timos svar',
    'native.consent.proc.anthropic.receives': 'Samtalen din med Timo, som tekst',
    'native.consent.proc.deepgram.purpose': 'Å gjøre tale om til tekst',
    'native.consent.proc.deepgram.receives': 'Stemmen din mens mikrofonen er på',
    'native.consent.proc.elevenlabs.purpose': 'Å gjøre den teksten om til Timos stemme',
    'native.consent.proc.elevenlabs.receives': 'Teksten Timo skal si',
    'native.consent.proc.google.purpose': 'Å skrive Timos svar når Google er aktiv',
    'native.consent.proc.google.receives': 'Samtalen din med Timo, som tekst',
    'native.consent.proc.openai.purpose': 'Å sjekke litauisk grammatikk',
    'native.consent.proc.openai.receives': 'Timos svar på litauisk, som tekst',
    'native.consent.promise': 'Vi selger ikke dataene dine, og vi bruker dem ikke til reklame. Du kan slå dette av når som helst i innstillingene. Slår du det av, kan ikke Timo lytte eller svare, og alt annet i appen fortsetter å virke.',
    'native.consent.settings.agreedOn': 'Du samtykket',
    'native.consent.settings.confirmBody': 'Timo slutter å lytte og svare. Alt annet i appen fortsetter å virke, og du kan slå det på igjen når som helst.',
    'native.consent.settings.confirmKeep': 'La det stå på',
    'native.consent.settings.confirmTitle': 'Slå av dette?',
    'native.consent.settings.confirmTurnOff': 'Slå av',
    'native.consent.settings.description': 'Lar Timo sende tale og samtaletekst til selskapene i listen nedenfor, slik at han kan lytte, svare og snakke.',
    'native.consent.settings.label': 'Deling med KI-tjenester',
    'native.consent.settings.offNote': 'Så lenge dette er av, kan ikke Timo lytte eller svare.',
    'native.consent.settings.section': 'Personvern',
    'native.consent.settings.whoGetsWhat': 'Se hvem som får hva',
    'native.consent.title': 'Før Timo begynner å snakke',
    'native.install.alreadyInstalledBody': 'Du bruker Timo-appen på denne enheten, så det er ingenting å installere.',
    'native.install.alreadyInstalledTitle': 'Du har allerede appen',
    'native.install.otherDevices': 'Vil du ha Timo på en annen enhet? Logg inn der med samme konto, så er alt klart for deg.',
    'native.manage.appleBilled': 'Apple håndterer dette abonnementet. Du kan avslutte det eller bytte plan i abonnementsinnstillingene i App Store.',
    'native.manage.cta': 'Administrer i App Store',
    'native.manage.failed': 'Vi kunne ikke åpne App Store-abonnementene dine. Åpne Innstillinger, trykk på navnet ditt, og velg Abonnementer.',
    'native.mic.backgroundStopped': 'Lyttingen stoppet fordi appen gikk i bakgrunnen. Trykk for å starte på nytt.',
    'native.mic.continueWithoutMic': 'Fortsett uten mikrofon',
    'native.mic.deniedBody': 'iPhone spør bare én gang. Åpne innstillingene og slå på mikrofonen for Timo.',
    'native.mic.deniedTitle': 'Mikrofonen er slått av',
    'native.mic.openSettings': 'Åpne innstillinger',
    'native.mic.primerAllow': 'Tillat mikrofon',
    'native.mic.primerBody': 'Slik at Timo kan høre hva den andre personen sa og hjelpe deg å svare.',
    'native.mic.primerNotNow': 'Ikke nå',
    'native.mic.primerPoint1': 'Stemmen din brukes bare til å gjøre tale om til tekst.',
    'native.mic.primerPoint2': 'Opptak skjer bare mens en tur pågår, aldri i bakgrunnen.',
    'native.mic.primerPoint3': 'Du kan slå av mikrofonen igjen i innstillingene.',
    'native.mic.primerTitle': 'Timo trenger mikrofonen din',
    'native.mic.unavailableBody': 'Denne enheten har ingen mikrofon Timo kan bruke.',
    'native.mic.unavailableTitle': 'Fant ingen mikrofon',
    'native.minors.affirmation': 'Når du trykker på «Jeg samtykker», bekrefter du at du er forelder eller foresatt, eller at du er 16 år eller eldre.',
    'native.minors.ageNote': 'I de fleste land i Europa må en forelder eller foresatt samtykke for alle under 16 år. I Litauen er denne aldersgrensen 14 år, og i USA er den 13 år.',
    'native.minors.askGrownUp': 'Be en forelder eller foresatt se på dette sammen med deg og trykke «Jeg samtykker» for deg.',
    'native.minors.underAgeLink': 'Jeg er under 16',
    'native.personalVoice.allow': 'Tillat personlig stemme',
    'native.personalVoice.denied': 'Timo har ikke tillatelse til å bruke den personlige stemmen din. Slå på La apper be om tilgang under Innstillinger, Tilgjengelighet, Personlig stemme.',
    'native.personalVoice.description': 'Hvis du har spilt inn en personlig stemme på denne iPhonen eller iPaden, kan Timo snakke med den. Stemmen lages på enheten, blir værende på enheten og sendes aldri noe sted.',
    'native.personalVoice.languageUnavailable': 'Apple tilbyr personlig stemme bare på engelsk, spansk og kinesisk, så den kan ikke snakke dette språket ennå.',
    'native.personalVoice.none': 'Det er ennå ikke spilt inn noen personlig stemme på denne enheten. Du kan lage en under Innstillinger, Tilgjengelighet, Personlig stemme.',
    'native.personalVoice.ready': 'Den personlige stemmen er klar. Velg den i listen over stemmer.',
    'native.personalVoice.speaking': 'Snakker med din personlige stemme',
    'native.personalVoice.title': 'Bruk en personlig stemme',
    'native.personalVoice.unsupportedDevice': 'Denne enheten kan ikke lage en personlig stemme. Det kreves en nyere iPhone eller iPad.',
    'native.purchase.alreadyOwned': 'Du har allerede denne planen. Trykk på «Gjenopprett kjøp» for å få tilgangen tilbake.',
    'native.purchase.failed': 'Vi kunne ikke fullføre kjøpet. Prøv igjen, eller skriv til oss så hjelper vi deg.',
    'native.purchase.network': 'Ingen forbindelse til App Store. Sjekk internettforbindelsen og prøv igjen.',
    'native.purchase.notAllowed': 'Denne enheten har ikke lov til å gjøre kjøp. Sjekk Skjermtid-begrensningene i Innstillinger.',
    'native.purchase.pending': 'Kjøpet ditt venter på godkjenning. Så snart det er godkjent, åpnes tilgangen automatisk.',
    'native.purchase.signInFirst': 'Logg inn først, slik at abonnementet knyttes til kontoen din.',
    'native.purchase.unavailable': 'App Store er ikke tilgjengelig akkurat nå. Prøv igjen om noen minutter.',
    'native.report.body': 'Takk for at du sier fra. Timos svar er skrevet av en datamaskin, så han tar noen ganger feil. Fortell oss hva som skjedde, så leser et menneske det.',
    'native.report.cancel': 'Avbryt',
    'native.report.done': 'Ferdig',
    'native.report.error': 'Rapporten kunne ikke sendes. Sjekk tilkoblingen og prøv igjen.',
    'native.report.noteLabel': 'Vil du legge til noe? (valgfritt)',
    'native.report.reason.language': 'Det var på feil språk',
    'native.report.reason.other': 'Noe annet',
    'native.report.reason.unkind': 'Det var uhøflig eller sårende',
    'native.report.reason.unsafe': 'Det var ikke trygt for et barn',
    'native.report.reason.wrong': 'Det var feil eller forvirrende',
    'native.report.safetyNote': 'Hvis noen er i fare akkurat nå, kontakt nødetatene.',
    'native.report.send': 'Send rapport',
    'native.report.sending': 'Sender...',
    'native.report.sentBody': 'Et menneske leser hver rapport. Hvis du vil ha svar, skriv til oss:',
    'native.report.sentTitle': 'Rapport sendt. Takk.',
    'native.report.stopConversation': 'Avslutt også denne samtalen',
    'native.report.title': 'Rapporter dette svaret',
    'native.report.trigger': 'Rapporter dette svaret',
    'native.restore.restored': 'Tilgangen din er tilbake. Velkommen tilbake!',
    'native.speech.interrupted': 'Lyttingen stoppet på grunn av en samtale eller en annen lyd. Trykk for å starte på nytt.',
    'native.speech.languageNotSupported': 'Denne iPhonen kan ikke gjenkjenne dette språket på egen hånd, så Timo lytter slik han alltid har gjort.',
    'native.speech.onDevice': 'Stemmen din blir værende på denne enheten',
    'native.speech.permissionNeeded': 'Timo trenger mikrofonen og talegjenkjenning for å høre deg. Du kan slå dem på i Innstillinger.',
    'native.voice.preview': 'Hør denne stemmen',
    'native.voice.systemVoices': 'Stemmer på denne enheten',
    'native.voice.title': 'Timos stemme',
    'pushToTalk.micBackgroundTitle': 'Lyttingen stoppet',
    'pushToTalk.micBlockedBody': 'Mikrofonen er blokkert, så ingenting ble tatt opp. Gi tilgang til mikrofonen, eller skriv det de sa.',
    'pushToTalk.micBlockedTitle': 'Timo kan ikke høre',
    'pushToTalk.micNotNowBody': 'Du kan slå på mikrofonen når som helst. Skriv det de sa for nå.',
    'pushToTalk.micNotNowTitle': 'Mikrofonen er av',
    'pushToTalk.micProblemBody': 'Lyttingen stoppet uventet, så ingenting ble tatt opp. Prøv igjen, eller skriv det de sa.',
    'pushToTalk.micProblemTitle': 'Lyttingen stoppet',
    'pushToTalk.micUnavailableBody': 'Denne enheten har ingen mikrofon Timo kan bruke. Du kan skrive det de sa i stedet.',
    'pushToTalk.micUnavailableTitle': 'Fant ingen mikrofon',
    'pushToTalk.micUnsupportedBody': 'Talegjenkjenning er ikke tilgjengelig her, så ingenting ble tatt opp. Du kan skrive det de sa i stedet.',
    'pushToTalk.micUnsupportedTitle': 'Denne nettleseren kan ikke lytte',
    'settings.microphone.checkDesc': 'Se om Timo hører deg, og fiks det hvis ikke',
    'settings.microphone.checkLabel': 'Sjekk mikrofontilgang',
    'settings.microphone.denied': 'Mikrofonen er blokkert. Åpne innstillingene for å gi tilgang.',
    'settings.microphone.granted': 'Mikrofonen virker',
    'settings.microphone.title': 'Mikrofon',
    'settings.microphone.unavailable': 'Fant ingen mikrofon på denne enheten',

    // --- merged from src/native/_i18n: WS-C, WS-F, PRIVACY ---
    // WS-C
    'chat.ariaGoBack': 'Tilbake',
    'chat.ariaInputMode': 'Inndatametode',
    'chat.ariaInputModeSpeak': 'Snakk',
    'chat.ariaInputModeType': 'Skriv',
    'chat.ariaPlayAloud': 'Les høyt',
    'chat.ariaSendMessage': 'Send melding',
    'chat.ariaRecordMe': 'Ta opp stemmen min',
    'chat.ariaRecordOther': 'Ta opp den andre personen',
    'live.ariaFlipSpeakers': 'Bytt om på talerne',
    'live.ariaClearConversation': 'Tøm samtalen',
    'live.ariaCalibrationSettings': 'Kalibreringsinnstillinger',
    'live.ariaClose': 'Lukk',
    'live.whatShouldISay': 'Hva skal jeg si?',
    'live.manageScriptsHint': 'Du kan administrere de lagrede tekstene dine under Tekster.',
    'live.safetyTitle': 'Sikkerhetsvarsel',
    'live.safetyBody': 'Denne samtalen er kanskje ikke trygg. Føler du deg truet, gå med en gang.',
    'quickChoice.send': 'Send',
    'quickChoice.tellMeMorePlaceholder': 'Fortell meg mer...',
    // WS-F
    'common.closeAria': 'Lukk',
    'common.goBackAria': 'Tilbake',
    // PRIVACY
    'privacy.minors.heading': '5. Barn, mindreårige og samtykke fra foreldre',
    'privacy.minors.s1.heading': '5.1 Hvem appen er for, og hvem som eier kontoen',
    'privacy.minors.s1.p1': 'Time To Talk (Timo-appen) er laget for barn med forsinket språkutvikling, for autistiske barn og voksne, og for alle som synes det er vanskelig å snakke. Mange av brukerne våre er barn.',
    'privacy.minors.s1.p2': 'Kontoen tilhører en voksen: en forelder, verge, omsorgsperson, terapeut eller lærer. Den voksne oppretter kontoen, har innloggingen og betaler abonnementet. Et barn registrerer seg ikke selv.',
    'privacy.minors.s1.p3': 'Men det er barnet som bruker appen. Da mottar appen det barnet skriver, og, mens mikrofonen er på, det barnet sier. Vi sier det heller rett ut enn å påstå at vi aldri hører fra et barn.',
    'privacy.minors.s2.heading': '5.2 Alderen der en forelder eller verge må samtykke',
    'privacy.minors.s2.intro': 'Hvis den som bruker appen er under alderen som gjelder for landet ditt, må en forelder, verge eller omsorgsperson samtykke før appen tas i bruk.',
    'privacy.minors.s2.col.where': 'Hvor du er',
    'privacy.minors.s2.col.age': 'En forelder eller verge må samtykke for alle under',
    'privacy.minors.s2.col.rule': 'Regelen bak',
    'privacy.minors.s2.lt.where': 'Litauen',
    'privacy.minors.s2.lt.age': '14',
    'privacy.minors.s2.lt.rule': 'GDPR artikkel 8, med aldersgrensen fastsatt i litauisk lov',
    'privacy.minors.s2.us.where': 'USA',
    'privacy.minors.s2.us.age': '13',
    'privacy.minors.s2.us.rule': 'COPPA, den amerikanske loven om barns personvern på nett',
    'privacy.minors.s2.eu.where': 'Resten av EU og EØS',
    'privacy.minors.s2.eu.age': '16, med mindre landet ditt har satt en lavere alder, som aldri kan være under 13',
    'privacy.minors.s2.eu.rule': 'GDPR artikkel 8',
    'privacy.minors.s2.world.where': 'Alle andre steder',
    'privacy.minors.s2.world.age': '16',
    'privacy.minors.s2.world.rule': 'Vår egen minstestandard, som vi bruker over hele verden',
    'privacy.minors.s2.p1': 'Litauen er hjemlandet vårt og hovedmarkedet vårt. Der er aldersgrensen 14 år.',
    'privacy.minors.s2.p2': 'Før en samtale sendes til selskapene i punkt 5.4, viser appen en skjerm som navngir hvert eneste av dem og ber om samtykke. Setningen over knappen "Jeg samtykker" ber deg bekrefte at du er forelder, verge eller omsorgsperson, eller at du er 16 år eller eldre. Hvis et barn trykker "Jeg er under 16", skjer det ikke noe galt og ingen blir irettesatt: appen ber rett og slett barnet hente en voksen. Du kan trekke samtykket tilbake senere i innstillingene, under Personvern.',
    'privacy.minors.s2.p3': 'Vi spør aldri om fødselsdato. Å spørre ville bety å samle inn mer informasjon om et barn, og dette avsnittet handler om det motsatte.',
    'privacy.minors.s3.heading': '5.3 Hva vi samler inn når et barn bruker appen',
    'privacy.minors.s3.intro': 'Tre ting:',
    'privacy.minors.s3.email': 'En e-postadresse, én gang, ved registrering. Det er adressen til den voksne som eier kontoen. Vi ber aldri et barn om en egen e-postadresse.',
    'privacy.minors.s3.text': 'Samtaletekst. Det som skrives eller sies til Timo, og det Timo svarer. Øvingssamtaler lagres på kontoen slik at de kan åpnes igjen senere i Historikk. Der kan hver enkelt slettes.',
    'privacy.minors.s3.voice': 'Stemme, kun mens mikrofonen er på. Lyden går fra enheten rett til Deepgram, som gjør den om til tekst. Vi lagrer ikke lydopptak på serverne våre. Mikrofonen er av til du slår den på.',
    'privacy.minors.s3.p2': 'Vi spør ikke et barn om ekte navn, hjemmeadresse, telefonnummer, skole, bilde, alder eller diagnose. Ingenting i appen krever det. Skrives noe slikt inn i en samtale, lagres det sammen med samtalen, og du kan slette det i Historikk.',
    'privacy.minors.s4.heading': '5.4 Selskapene som mottar disse dataene',
    'privacy.minors.s4.intro': 'Timo kan verken lytte, svare eller snakke uten hjelp fra eksterne selskaper. Disse fem ser innholdet i samtalen. Det er den samme listen appen viser deg før du samtykker.',
    'privacy.minors.s4.col.company': 'Selskap',
    'privacy.minors.s4.col.receives': 'Hva det mottar',
    'privacy.minors.s4.col.purpose': 'Hva det brukes til',
    'privacy.minors.s4.anthropic.receives': 'Samtalen din med Timo, som tekst',
    'privacy.minors.s4.anthropic.purpose': 'Å skrive Timos svar',
    'privacy.minors.s4.google.receives': 'Samtalen din med Timo, som tekst',
    'privacy.minors.s4.google.purpose': 'Å skrive Timos svar når Google er aktiv',
    'privacy.minors.s4.openai.receives': 'Timos svar på litauisk, som tekst',
    'privacy.minors.s4.openai.purpose': 'Å sjekke litauisk grammatikk',
    'privacy.minors.s4.deepgram.receives': 'Stemmen din mens mikrofonen er på',
    'privacy.minors.s4.deepgram.purpose': 'Å gjøre tale om til tekst',
    'privacy.minors.s4.elevenlabs.receives': 'Teksten Timo skal si',
    'privacy.minors.s4.elevenlabs.purpose': 'Å gjøre den teksten om til Timos stemme',
    'privacy.minors.s4.note': 'Google mottar samtaletekst bare når Google er aktiv modelleverandør. OpenAI brukes bare for litauisk, for å rette grammatikken i et svar Timo allerede har skrevet. Deepgram brukes også som reservestemme i noen språk, og da mottar det teksten Timo skal si.',
    'privacy.minors.s4.others': 'De andre selskapene vi samarbeider med, listet i punkt 7, tar seg av konto, betaling, e-post og analyse, ikke selve samtalen.',
    'privacy.minors.s4.noPermission': 'Ingen av disse selskapene har lov til å bruke et barns data til egen reklame eller til å trene egne modeller utover det som står i deres publiserte retningslinjer.',
    'privacy.minors.s5.heading': '5.5 Hva vi aldri gjør med et barns data',
    'privacy.minors.s5.item1': 'Vi selger dem aldri. Ikke til noen, i noen form, til noen pris.',
    'privacy.minors.s5.item2': 'Vi bruker dem aldri til reklame, og vi lager aldri reklameprofiler av barn.',
    'privacy.minors.s5.item3': 'Vi bruker dem aldri til å trene KI-modeller, verken våre egne eller andres.',
    'privacy.minors.s5.item4': 'Vi bruker dem aldri til å lage atferdsmessige, psykologiske, kliniske eller pedagogiske profiler av et barn.',
    'privacy.minors.s5.item5': 'Vi publiserer dem aldri, og vi viser dem aldri til andre brukere.',
    'privacy.minors.s5.pixel': 'Nettstedet vårt og appsidene inneholder Metas målingstagg for annonser, beskrevet i punkt 12. Den teller sidevisninger og registreringer så vi vet hvilke annonser som virker. Den mottar aldri samtaleinnhold, stemme eller det et barn skriver.',
    'privacy.minors.s6.heading': '5.6 Hva en forelder eller verge kan be om',
    'privacy.minors.s6.intro': 'Når som helst kan du:',
    'privacy.minors.s6.see': 'Se dem. Be om en kopi av alt vi har lagret om kontoen.',
    'privacy.minors.s6.correct': 'Rette dem. Be oss rette opp det som er feil.',
    'privacy.minors.s6.delete': 'Slette dem. Slette samtaler én og én i Historikk, eller slette hele kontoen.',
    'privacy.minors.s6.withdraw': 'Trekke tilbake samtykket. Trekk KI-samtykket tilbake i innstillingene, under Personvern. Da slutter Timo å lytte og svare. Bildene, de lagrede manusene og alle innstillingene virker fortsatt. Tilbaketrekkingen opphever ikke behandling som allerede har skjedd lovlig.',
    'privacy.minors.s6.deleteHeading': 'Slette kontoen. Innstillingene har en knapp for å slette kontoen. Når du bruker den:',
    'privacy.minors.s6.step1': 'Vi avslutter først alle løpende abonnementer du har hos Stripe, slik at du ikke kan bli belastet igjen.',
    'privacy.minors.s6.step2': 'Hvis en av avslutningene mislykkes, stopper vi, og kontoen din blir ikke slettet. Du får en feilmelding som ber deg kontakte oss, og vi fullfører manuelt. Å la deg være innlogget er bedre enn å la deg betale for en konto du ikke lenger kommer inn på.',
    'privacy.minors.s6.step3': 'Hvis avslutningen lykkes, sletter vi innloggingen og kontooppføringen din fra autentiseringssystemet vårt: e-postadressen, passordet og innstillingene og samtykkene som er lagret sammen med dem.',
    'privacy.minors.s6.step4': 'Vi merker abonnementsoppføringen din som avsluttet og beholder en liten sletteoppføring: e-postadressen, datoen og referansen til det avsluttede abonnementet. Den finnes for at vi skal kunne vise når kontoen ble slettet og at faktureringen stoppet.',
    'privacy.minors.s6.step5': 'Betalings- og fakturaopplysninger blir liggende hos Stripe så lenge litauisk regnskapslov krever, altså ti år. Se punkt 9. Vi kan ikke slette dem tidligere.',
    'privacy.minors.s6.after': 'Er det noe annet du vil ha fjernet som knappen ikke når, send oss en e-post, så gjør vi det manuelt.',
    'privacy.minors.s7.heading': '5.7 Hvordan du kontakter oss om et barns data',
    'privacy.minors.s7.p1': 'Send e-post til info@timetotalk.lt. Skriv "Forespørsel om barns data" i emnefeltet, og oppgi e-postadressen til kontoen.',
    'privacy.minors.s7.p2': 'Vi svarer på alle henvendelser. Vi bekrefter din innen 5 virkedager og fullfører den innen 30 dager, som er fristen GDPR setter. Er en forespørsel komplisert og vi trenger mer tid, sier vi fra før de 30 dagene er omme og forklarer hvorfor. Vi må kanskje først kontrollere at du er kontoeieren, for å gi et barns data til feil person ville vært en langt verre feil enn et sent svar.',
    'privacy.minors.s7.p3': 'Du kan også klage til Litauens datatilsyn (Valstybine duomenu apsaugos inspekcija) på vdai.lrv.lt eller ada@ada.lt, eller til datatilsynet i ditt eget EØS-land.',
    'privacy.minors.s8.heading': '5.8 Hvor lenge vi oppbevarer et barns data',
    'privacy.minors.s8.intro': 'Punkt 9 oppgir lagringstiden for hver datakategori. Kortversjonen:',
    'privacy.minors.s8.voice': 'Stemme: vi lagrer den ikke i det hele tatt.',
    'privacy.minors.s8.conversations': 'Samtaler: ligger på kontoen til du sletter dem i Historikk eller sletter kontoen.',
    'privacy.minors.s8.account': 'Kontodata, inkludert e-postadressen: som beskrevet i punkt 9.',
    'privacy.minors.s8.p2': 'Tror du et barn har registrert seg uten at en forelder eller verge vet om det, kontakt info@timetotalk.lt. Når vi har bekreftet forespørselen, sletter vi kontoen og dataene umiddelbart.',
  },
  es: {
    // daily-words
    "dailyWords.row": "Palabras para aprender",
    "dailyWords.rowHint": "Las palabras que tu hijo aprende cada día",
    "dailyWords.title": "Palabras para aprender",
    "dailyWords.intro": "Escribe las palabras que tu hijo está aprendiendo. Timo muestra una cada día y le pide que la diga.",
    "dailyWords.close": "Cerrar",
    "dailyWords.modeTitle": "Qué palabras muestra Timo",
    "dailyWords.modeMine": "Solo mis palabras",
    "dailyWords.modeMineHint": "Una de tus palabras cada día, en el orden de la lista.",
    "dailyWords.modeMix": "Mis palabras y las de Timo",
    "dailyWords.modeMixHint": "Un día tu palabra, al día siguiente una de Timo.",
    "dailyWords.today": "Palabra del día: {word}",
    "dailyWords.todayBadge": "Hoy",
    "dailyWords.add": "Añadir palabra",
    "dailyWords.inputLabel": "Palabra",
    "dailyWords.placeholder": "Por ejemplo: manzana",
    "dailyWords.pictureTitle": "Imagen (opcional)",
    "dailyWords.noPicture": "Sin imagen",
    "dailyWords.photo": "Foto",
    "dailyWords.removePhoto": "Quitar foto",
    "dailyWords.listTitle": "Tus palabras",
    "dailyWords.empty": "Aún no hay palabras. Mientras la lista esté vacía, Timo muestra sus propias palabras.",
    "dailyWords.edit": "Cambiar",
    "dailyWords.save": "Guardar",
    "dailyWords.cancel": "Cancelar",
    "dailyWords.delete": "Borrar",
    "dailyWords.deleteConfirm": "¿Borrar «{word}»?",
    "dailyWords.listen": "Escuchar",
    "dailyWords.moveUp": "Subir",
    "dailyWords.moveDown": "Bajar",
    "dailyWords.saved": "Guardado",
    "dailyWords.deviceOnly": "Las palabras se guardan solo en este dispositivo. Otro teléfono o tableta no las tendrá.",
    "dailyWords.errEmpty": "Escribe una palabra primero.",
    "dailyWords.errDuplicate": "Esa palabra ya está en la lista.",
    "dailyWords.errFull": "La lista ya tiene {max} palabras. Borra una para añadir otra.",
    "dailyWords.errSave": "No se pudo guardar. Puede que la memoria del dispositivo esté llena. Prueba sin foto.",
    "dailyWords.errImage": "No se pudo abrir esa foto. Elige otra.",
    // end daily-words
    'house.room.living': 'Sala de estar',
    'house.room.talk': 'Sala del teléfono',
    'house.room.play': 'Sala de juegos',
    'house.room.study': 'Rincón de estudio',
    'house.hotspot.couch': 'Saltar en el sofá',
    'house.hotspot.window': 'Mirar por la ventana',
    'house.hotspot.timo': 'Jugar con Timo',
    'house.hotspot.pet': 'Jugar con Timo',
    'house.hotspot.phone': 'Hablar por teléfono',
    'house.hotspot.shelf': 'Abrir las tarjetas de imágenes',
    'house.hotspot.toybox': 'Abrir la caja de juguetes',
    'house.hotspot.desk': 'Palabra del día',
    'house.parent.settings': 'Para adultos',
    'house.parent.button': 'Para adultos',
    'house.nav.rooms': 'Habitaciones',
    'house.nav.prev': 'Habitación anterior',
    'house.nav.next': 'Habitación siguiente',
    'house.badge.stars': 'Estrellas ganadas',
    'house.hotspot.beanbag': 'Puf',
    'house.hotspot.bookshelf': 'Estantería',
    'house.hotspot.curtain': 'Cortina',
    'house.hotspot.easel': 'Caballete',
    'house.hotspot.lamp': 'Lámpara',
    'house.hotspot.lights': 'Luces',
    'house.hotspot.pinboard': 'Tablero',
    'house.hotspot.plant': 'Planta',
    'house.hotspot.playwindow': 'Ventana',
    'house.hotspot.rainbowrug': 'Alfombra arcoíris',
    'house.hotspot.rug': 'Alfombra',
    'house.hotspot.stool': 'Taburete',
    'house.map.title': 'Mapa de la casa',
    'house.map.close': 'Cerrar mapa',
    'house.map.here': 'Estás aquí',
    'house.map.go': 'Ir',
    'house.map.activity.talk': 'Hablar',
    'house.map.activity.cards': 'Tarjetas',
    'house.map.activity.word': 'Palabra',
    'house.a11y.roomOf': 'Habitación {n} de {total}',
    'iab.title': 'Cambia tu navegador',
    'iab.body': 'El inicio de sesión no funcionará dentro de {source}.',
    'iab.openChrome': 'Abrir en Chrome',
    'iab.openSafari': 'Abrir en Safari',
    'iab.openBrowser': 'Abrir en el navegador',
    'iab.copyLink': 'Copiar enlace',
    'iab.copied': 'copiado',
    'iab.hintIos': 'O toque el menú ⋯ → Abrir en Safari',
    'iab.hintAndroid': 'O toque el menú ⋮ → Abrir en el navegador',
    'iab.hintOther': 'O pega el enlace en tu navegador',
    'iab.iosCopyAndOpen': 'Copiar enlace',
    'iab.iosLinkCopied': 'Enlace copiado. Abra Safari a continuación.',
    'iab.iosStep1': 'Toque el botón de enlace para copiarlo.',
    'iab.iosStep2': 'Abra Safari (mantenga presionado el indicador de inicio o deslice hacia arriba).',
    'iab.iosStep3': 'Pega el enlace en la barra de direcciones.',
    'iab.continueAnyway': 'Continuar aquí',
    'obp.successTitle': '¡Estás listo!',
    'obp.successBody': 'Estás en tu navegador ahora. Todo funciona aquí, incluido el inicio de sesión.',
    'obp.successCta': 'Continuar',
    'streak.popupTitle': '¡AUMENTÓ LA RACHA DE CHAT DIARIA!',
    'streak.popupDayStreak': 'RACHA DEL DÍA',
    'streak.popupGreatStart': '¡GRAN COMIENZO!',
    'streak.popupOnFire': '¡ESTÁS EN FUEGO!🔥',
    'profile.viewStreakDetails': 'Ver racha',
    'newsletter.subscribe': 'Suscribirse',
    'newsletter.subscribing': 'Suscribiendo...',
    'newsletter.success': '¡Gracias por suscribirte!',
    'newsletter.successMessage': 'Revisa tu correo electrónico para confirmar tu suscripción.',
    'newsletter.error': 'Algo salió mal. Por favor inténtalo de nuevo.',
    'newsletter.emailInvalid': 'Por favor introduce una dirección de correo electrónico válida',
    'newsletter.emailRequired': 'Se requiere correo electrónico',
    'newsletter.features.title': 'Qué esperar',
    'newsletter.features.earlyAccess': 'Acceso temprano',
    'newsletter.features.earlyAccessDesc': 'Sea uno de los primeros en probar nuestra aplicación',
    'newsletter.features.updates': 'Actualizaciones exclusivas',
    'newsletter.features.updatesDesc': 'Obtenga las últimas noticias y características',
    'newsletter.features.tips': 'Consejos de comunicación',
    'newsletter.features.tipsDesc': 'Guías y estrategias útiles',
    'newsletter.requestAccess': 'Solicitar acceso',
    'newsletter.requestAccessTitle': 'Solicitar acceso al sitio web',
    'newsletter.requestAccessSuccess': '¡Solicitud enviada! Lo revisaremos y nos comunicaremos con usted.',
    'newsletter.name': 'Nombre',
    'newsletter.namePlaceholder': 'Tu nombre (opcional)',
    'newsletter.reason': 'Razón',
    'newsletter.reasonPlaceholder': '¿Por qué necesitas acceso?(opcional)',
    'newsletter.submitRequest': 'Enviar solicitud',
    'newsletter.submitting': 'Enviando...',
    'newsletter.beTheFirst': 'Sé el primero',
    'newsletter.beTheFirstDesc': 'Obtenga acceso temprano y consejos de comunicación en su bandeja de entrada.',
    'newsletter.emailPlaceholderExample': 'your@email.com',
    'newsletter.gettingAccess': 'Obteniendo acceso...',
    'newsletter.getEarlyAccess': 'Obtenga acceso temprano',
    'newsletter.noSpam': 'Sin spam. Darse de baja en cualquier momento.',
    'newsletter.thankYouJoining': '¡Gracias por unirte! Lo mantendremos informado.',
    'newsletter.learnMoreBelow': 'Obtenga más información a continuación',
    'newsletter.downloadApp': 'Descarga la aplicación',
    'newsletter.whyBuilding': 'Por qué estamos construyendo esto',
    'newsletter.whyBuildingDesc': 'Las situaciones sociales se mueven rápidamente. Las palabras adecuadas no vienen cuando las necesitas. Estamos construyendo esto porque la comunicación no debería parecer imposible.',
    'newsletter.whoWeHelp': 'A quién ayudamos',
    'newsletter.whoWeHelpDesc': 'Ansiosos sociales, introvertidos, TEA y cualquier persona que quiera intentar hablar y necesite ayuda.',
    'newsletter.whatWeDo': 'Qué hacemos',
    'newsletter.whatWeDoDesc': 'Aplicación de IA que te ayuda a comprender conversaciones y responder. Suavemente, claramente, sin presión. Todo es parecido a un juego para que la práctica sea divertida.',
    'newsletter.nonVerbalSupport': 'Apoyo no verbal',
    'newsletter.nonVerbalSupportDesc': 'Ayudamos a las personas no verbales y a los padres de niños no verbales a comunicarse. Nuestro modo Hablar proporciona herramientas para hablar sin forzar el habla.',
    'newsletter.safe': 'Seguro',
    'newsletter.simple': 'Sencillo',
    'newsletter.supportive': 'De apoyo',
    'newsletter.reportBug': 'reportar un error',
    'common.startVoice': 'Iniciar entrada de voz',
    'common.stopRecording': 'dejar de grabar',
    'common.close': 'Cerrar',
    'common.help': 'Ayuda',
    'common.back': 'Atrás',
    'practice.pageTitle': 'Charla de práctica',
    'practice.greeting': '¡Oye! ¿Listo para charlar?',
    'practice.thinking': 'Pensando...',
    'practice.fallback': '¡Entiendo!',
    'practice.end': 'Finalizar',
    'practice.me': 'Yo',
    'practice.other': 'Otro',
    'practice.placeholder': 'Escribe algo...',
    'practice.switchText': 'Cambiar a texto',
    'practice.switchVoice': 'Cambiar a voz',
    'practice.errorTitle': 'error',
    'practice.errorDesc': 'No se pudo obtener respuesta',
    'home.goodMorning': 'Buenos dias',
    'home.goodAfternoon': 'Buenas tardes',
    'home.goodEvening': 'Buenas noches',
    'home.needHelpTalking': '¿Necesitas ayuda para hablar?',
    'home.suggestWhatToSay': 'Te sugeriré qué decir',
    'home.quickActions': 'Acciones rápidas',
    'home.nonVerbal': 'hablar',
    'home.history': 'Historia',
    'home.scripts': 'Guiones',
    'home.startTalking': 'empezar a hablar',
    'home.reportBug': 'Informar error',
    'home.underConstruction': 'En construcción',
    'home.stillBuilding': '¡Aún estamos construyendo! Es posible que algunas cosas aún no funcionen.',
    'home.dontShowAgain': 'No volver a mostrar',
    'home.gotIt': '¡Entendido!',
    'home.howToUse': 'como usar',
    'home.settings': 'Configuración',
    'home.talkModeBeta': 'Beta',
    'home.talkModeUnderDevelopment': 'Actualmente en desarrollo',
    'home.talk': 'hablar',
    'home.show': 'Mostrar',
    'home.breathing': 'Respiración',
    'home.greeting.morning': '¡Buenos días!',
    'home.greeting.afternoon': '¡Buenas tardes!',
    'home.greeting.evening': '¡Buenas noches!',
    'home.timoHomeHint': '¡Tocame para entrar!',
    'timo.home.title': 'La casa de Timo.',
    'timo.home.back': 'Atrás',
    'timo.home.close': 'Cerrar',
    // teacher-first-run: the help screen and its door on the landing screen. English for now, translate later.
    "timo.home.helpButton": "How to use",
    "help.metaTitle": "How to use Timo",
    "help.title": "How to use Timo",
    "help.intro": "Five short steps. It takes a minute to read.",
    "help.back": "Back",
    "help.langLabel": "Language",
    "help.teacher.title": "For teachers and therapists",
    "help.teacher.body": "The app says \"your child\". If you are a teacher, that means your student. Everything works the same, even if you signed up as a parent.",
    // school-use
    "help.school.title": "At school, with a student",
    "help.school.point1": "Use one account on the school tablet. Sign in once and it stays signed in.",
    "help.school.point2": "Hand the tablet to the child on the Timo screen. The child talks to Timo or taps the cards.",
    "help.school.point3": "Everything for grown-ups sits behind the Grown-ups button at the top: settings, progress and the subscription.",
    "help.school.point4": "Type the child's name under Grown-ups > Progress and the child's name. Then the cards and Timo use the child's name, not yours.",
    "help.school.point5": "Got a code from the school or an event? Tap “I have a code” on the start page, the sign-in screen, the payment page or in Settings.",
    "help.step1.title": "Start in Timo's room",
    "help.step1.body": "After you log in, you always land here. This is the start screen, and everything is one tap away.",
    "help.step1.alt": "Timo's room on a phone",
    "help.step2.title": "Tap Timo and talk",
    "help.step2.body": "Tap Timo or the Talk button and allow the microphone. The child speaks, Timo answers out loud.",
    "help.step2.alt": "The Talk button at the bottom of the screen",
    "help.step3.title": "Pictures when talking is hard",
    "help.step3.body": "The Pictures button opens picture cards. The child taps a card and the app says it out loud. No microphone needed, so it still works when the mic does not.",
    "help.step3.alt": "Picture cards",
    "help.step4.title": "Word of the day",
    "help.step4.body": "Every day Timo picks one new word. Tap the word card and say it together with the child.",
    "help.step4.alt": "The word of the day card",
    "help.step5.title": "For grown-ups",
    "help.step5.body": "The Grown-ups button at the top opens settings: language, voice and subscription. This guide is always right next to it.",
    "help.step5.alt": "The How to use and Grown-ups buttons at the top of the screen",
    "help.cta": "Go to Timo",
    "help.contact": "Questions? Email info@timetotalk.lt",
    // The paywall a teacher meets: this label had no key anywhere, so every language showed "per day".
    "pricing.perDayLabel": "al día",
    // Settings rows for what the hidden homes used to link: progress, profile, breathing.
    "settings.grownUps.title": "For grown-ups",
    "settings.grownUps.progress": "Progress and the child's name",
    "settings.grownUps.progressHint": "Words, streaks and the name Timo says",
    "settings.grownUps.profile": "Profile",
    "settings.grownUps.breathing": "Breathing exercise",
    "settings.grownUps.breathingHint": "Calm breathing together with the child",
    // Promo codes (MOKOMES and the rest): the landing confirmation and the banner on /timo.
    "promoGrant.accepted": "Code accepted: {days} free. Log in to activate it.",
    "promoGrant.acceptedUnlimited": "Code accepted: free unlimited access. Log in to activate it.",
    "promoGrant.continue": "Continue",
    "promoGrant.day.one": "day",
    "promoGrant.day.few": "days",
    "promoGrant.day.many": "days",
    "promoGrant.day.other": "days",
    "promoGrant.banner": "You have {days} of free access until {date}.",
    "promoGrant.bannerUnlimited": "You have free unlimited access.",
    "promoGrant.alreadyUsed": "The code {code} was already used, so it could not be activated again.",
    "promoGrant.close": "Close",
    // promo-codes-2: "I have a code" for signed-in people (/pricing, Settings) and the entry links. English for now.
    "promoCodes2.open": "I have a code",
    "promoCodes2.label": "Enter your code",
    "promoCodes2.submit": "Activate",
    "promoCodes2.checking": "Checking...",
    "promoCodes2.success": "Code accepted: {days} free, until {date}.",
    "promoCodes2.successUnlimited": "Code accepted: free unlimited access.",
    "promoCodes2.alreadyActive": "Your access is already active, no code needed.",
    "promoCodes2.err.empty": "Type the code first.",
    "promoCodes2.err.invalid": "That code does not exist. Check it and try again.",
    "promoCodes2.err.usedOnAccount": "This code was already used on your account.",
    "promoCodes2.err.usedOnNetwork": "This code was already used from this network. Email info@timetotalk.lt and we will help.",
    "promoCodes2.err.fullyClaimed": "This code has been fully claimed.",
    "promoCodes2.err.network": "Could not connect. Check the internet and try again.",
    "promoCodes2.err.error": "Could not activate the code. Try again.",
    'timo.home.dressTitle': 'Viste a Timo',
    'timo.home.foodTitle': '¿Qué quiere Timo?',
    'timo.home.action.feed': 'alimentar',
    'timo.home.action.drink': 'beber',
    'timo.home.action.sleep': 'Dormir',
    'timo.home.action.walk': 'caminar',
    'timo.home.action.potty': 'orinal',
    'timo.home.action.cheer': 'animar',
    'timo.home.action.dress': 'vestirse',
    'timo.home.sleep.notNight': 'Timo aún no tiene sueño',
    'timo.home.outfit.default': 'normales',
    'timo.home.outfit.beanie': 'Gorro',
    'timo.home.outfit.panama': 'Panamá',
    'timo.home.outfit.cool': 'Tonos fríos',
    'timo.home.outfit.ai': 'Timo del futuro',
    'timo.home.outfit.yoga': 'yoga timo',
    'timo.home.food.apple': 'manzana',
    'timo.home.food.banana': 'Plátano',
    'timo.home.food.berries': 'bayas',
    'timo.home.food.bread': 'pan',
    'timo.home.food.fish': 'pescado',
    'timo.home.food.acorn': 'bellota',
    'timo.home.food.cheese': 'Queso',
    'timo.home.food.cookie': 'galleta',
    'timo.talk.tapHint': 'Tócame para hablar!',
    'timo.talk.greeting': 'Hola! Soy Timo. De qué quieres hablar?',
    'timo.talk.tapToTalk': 'Toca para hablar',
    'timo.talk.listening': 'Te escucho',
    'timo.talk.tapWhenDone': 'Toca cuando termines',
    'timo.talk.thinking': 'Timo está pensando',
    'timo.talk.speaking': 'Timo está hablando',
    'timo.talk.emptyReprompt': 'Te escucho! Cuéntame algo.',
    'timo.talk.llmErrorReply': 'Me encanta hablar contigo! Cuál es tu animal favorito?',
    'timo.talk.micDenied': 'Timo necesita tu micrófono',
    'timo.talk.micDeniedHelp': 'Pide a una persona adulta que permita el micrófono en los ajustes del navegador y vuelve a tocar.',
    // mic-school-devices
    'mic.fail.blocked.title': 'The microphone is blocked',
    'mic.fail.blocked.body': 'Timo cannot hear because this browser is not allowed to use the microphone. Allow it, then tap Try again.',
    'mic.fail.blocked.again': 'Tapped Block before? The browser will not ask again on its own. Change it in the settings, then reload the page.',
    'mic.fail.steps.ios': 'iPad or iPhone: tap aA in the address bar, then Website Settings, then set Microphone to Allow. Or open Settings, then Safari, then Microphone, and choose Allow.',
    'mic.fail.steps.chromebook': 'Chromebook: click the icon left of the web address, turn Microphone on, then reload the page. If the switch is grey, the school has blocked it. Ask your IT admin.',
    'mic.fail.steps.android': 'Android: tap the icon left of the web address, then Permissions, then set Microphone to Allow. Reload the page.',
    'mic.fail.steps.desktop': 'Computer: click the icon left of the web address, set Microphone to Allow, then reload the page. If it still does not work, check the privacy settings of the computer.',
    'mic.fail.steps.native': 'In the Timo app: open your phone Settings, then Timo, and turn Microphone on. Come back and tap Try again.',
    'mic.fail.no_device.title': 'No microphone found',
    'mic.fail.no_device.body': 'This device has no working microphone. Plug in a microphone or a headset, then tap Try again.',
    'mic.fail.in_use.title': 'The microphone is busy',
    'mic.fail.in_use.body': 'Another app or tab is using the microphone. Close it, video calls too, then tap Try again.',
    'mic.fail.insecure_context.title': 'This link cannot use the microphone',
    'mic.fail.insecure_context.body': 'The page is not on a secure address, so the browser hides the microphone. Open the address that starts with https://.',
    'mic.fail.unsupported.title': 'This browser cannot use the microphone',
    'mic.fail.unsupported.body': 'Open Timo in Chrome or Safari to talk. You can use the picture cards now.',
    'mic.fail.in_app_browser.title': 'Open Timo in your browser',
    'mic.fail.in_app_browser.body': 'Instagram, Facebook and similar apps open links in their own window, and the microphone does not work there. Open this page in Chrome or Safari.',
    'mic.fail.inapp.ios': 'Tap the three dots (...) at the top, then choose to open in the browser.',
    'mic.fail.inapp.android': 'Tap the three dots in the corner, then choose Open in Chrome.',
    'mic.fail.offline.title': 'No internet',
    'mic.fail.offline.body': 'Timo needs the internet to hear. Connect to Wi-Fi or mobile data, then tap Try again.',
    'mic.fail.stt_unreachable.title': 'Timo cannot reach his listening service',
    'mic.fail.stt_unreachable.body': 'The microphone works, but the network is blocking the speech service. This often happens on school Wi-Fi. Tap Try again, or ask your IT admin to allow api.deepgram.com and time-to-talk.onrender.com.',
    'mic.fail.stt_service_error.title': 'The listening service is having trouble',
    'mic.fail.stt_service_error.body': 'The microphone and the internet work, but the speech service answered with an error. Wait a minute, then tap Try again.',
    'mic.fail.signed_out.title': 'Please sign in again',
    'mic.fail.signed_out.body': 'Your sign-in has run out, so Timo cannot listen. Sign in again, then tap Try again.',
    'mic.fail.unknown.title': 'Timo cannot hear right now',
    'mic.fail.unknown.body': 'Something stopped the microphone. Tap Try again. If it keeps happening, reload the page.',
    'mic.fail.retry': 'Try again',
    'mic.fail.tiles': 'Use picture cards',
    'mic.fail.openBrowser': 'Open in browser',
    'mic.fail.signIn': 'Sign in',
    'timo.talk.exit': 'Listo',
    'timo.word.title': 'Palabra del día',
    'timo.word.sayIt': 'Dilo!',
    'timo.word.listening': 'Te escucho',
    'timo.word.hearAgain': 'Escuchar otra vez',
    'timo.word.tryAgain': 'La decimos juntos?',
    'timo.word.great': 'Muy bien!',
    'timo.word.days': 'días seguidos',
    'timo.word.open': 'Palabra del día',
    'timo.word.close': 'Cerrar',
    'timo.word.newWordSoon': '¡Una palabra nueva mañana!',
    'timo.talk.waiting': 'Timo está pensando...',
    'timo.talk.youSaid': 'Dijiste:',
    'timo.talk.voiceResting': 'La voz grande de Timo está descansando, por eso esta suena como un robot.',
    'timo.teach.remember': 'Recuérdalo',
    'timo.teach.hearIt': 'Escúchalo',
    'timo.teach.gotIt': '¡Entendido!',
    'timo.reward.earned': '¡Ganaste {amount} estrellas!',
    'timo.words.title': 'Mis palabras',
    'timo.words.wordSingular': 'palabra',
    'timo.words.wordPlural': 'palabras',
    'timo.words.tapHint': 'Toca una palabra para escucharla',
    'timo.words.lockedHint': 'Di esta palabra con Timo para desbloquearla',
    'timo.words.empty': 'Aún no hay palabras',
    'timo.words.emptySub': '¡Di la palabra del día con Timo para empezar tu colección!',
    'timo.words.close': 'Cerrar',
    'timo.words.locked': 'Todavía no',
    'timo.recap.title': 'Hoy con Timo',
    'timo.recap.wordsLead': 'Palabras que dijo tu hijo hoy',
    'timo.recap.noWords': 'Hoy hubo mucha charla feliz',
    'timo.recap.turnsLabel': 'pequeñas conversaciones',
    'timo.recap.streakLabel': 'días seguidos',
    'timo.recap.minutesLabel': 'min juntos',
    'timo.recap.tipLead': 'Consejo',
    'timo.recap.tip1': 'Intenta decir una de estas palabras juntos esta noche en la cena.',
    'timo.recap.tip2': 'Cada pequeña charla cuenta. Unos minutos al día suman rápido.',
    'timo.recap.tip3': 'Pídele a tu hijo que te enseñe lo que Timo dijo hoy.',
    'timo.recap.tip4': 'Elogia el intento, no solo el acierto.',
    'timo.recap.dismiss': 'Cerrar',
    'timo.recap.historyTitle': 'Esta semana con Timo',
    'timo.recap.historyEmpty': 'Aún no hay charlas. ¡Toca a Timo para empezar una!',
    'timo.talk.greetingNamed': '¡Hola, {name}! ¡Qué alegría verte!',
    'timo.talk.greetingWord': '¡Hola! La palabra de hoy es {word}. ¿Puedes decirla?',
    'timo.talk.greetingWordNamed': '¡Hola, {name}! La palabra de hoy es {word}. ¿Puedes decirla?',
    'timo.onboarding.intro': '¡Hola! Soy Timo. Soy tu amigo.',
    'timo.onboarding.askName': '¿Cómo te llamas?',
    'timo.onboarding.heard': '¿Escuché {name}?',
    'timo.onboarding.confirmYes': '¡Sí!',
    'timo.onboarding.confirmNo': 'Otra vez',
    'timo.onboarding.retry': '¡Ups! Di tu nombre otra vez.',
    'timo.onboarding.typeInstead': 'Escribir mi nombre',
    'timo.onboarding.namePlaceholder': 'Tu nombre',
    'timo.onboarding.save': 'Guardar',
    'timo.onboarding.skip': 'Ahora no',
    'timo.onboarding.welcome': '¡Mucho gusto, {name}!',
    'timo.onboarding.micDenied': 'No te escucho. Puedes escribir tu nombre.',
    // Timo tells a story: UI chrome only. The story prose itself lives in
    // src/copy/story.en.js under the story.* keys, not here.
    'timo.story.tapToStart': 'Empezar el cuento',
    'timo.story.listening': 'Te toca',
    'timo.story.narrating': 'Timo está contando el cuento',
    'timo.story.close': 'Listo',
    'timo.story.replay': 'Otra vez',
    'timo.story.finished': 'Fin',
    'timo.story.next': 'Siguiente',
    'parent.title': 'Progreso',
    'parent.backAria': 'Volver al inicio',
    'parent.noKidName': 'Tu hijo',
    'parent.subtitle': 'Progreso en la práctica del habla',
    'parent.tierLabel': 'Nivel',
    'parent.statStreak': 'Días seguidos',
    'parent.statWords': 'Palabras aprendidas',
    'parent.statStars': 'Estrellas ganadas',
    'parent.statDaysActive': 'Días activos',
    'parent.statDaysActiveHint': 'Últimos 30 días',
    'parent.statLongest': 'Racha más larga',
    'parent.statWordsWeek': 'Palabras nuevas esta semana',
    'parent.calendarTitle': 'Calendario de práctica',
    'parent.calendarPrevAria': 'Mes anterior',
    'parent.calendarNextAria': 'Mes siguiente',
    'parent.calendarLegendPracticed': 'Con práctica',
    'parent.calendarLegendToday': 'Hoy',
    'parent.calendarDayPracticed': 'con práctica',
    'parent.calendarEmptyMonth': 'Aún no hay práctica registrada este mes.',
    'parent.timelineTitle': 'Palabras que ha aprendido',
    'parent.timelineToday': 'Hoy',
    'parent.timelineYesterday': 'Ayer',
    'parent.timelineDaysAgo': 'hace {n} días',
    'parent.timelineEmptyTitle': 'El camino empieza aquí',
    'parent.timelineEmptyBody': 'Cada palabra que tu hijo aprenda con Timo aparecerá aquí. Incluso una palabra al día suma rápido.',
    'parent.timelineWordCount': '{n} palabras',
    'parent.timelineWordCountOne': '1 palabra',
    'parent.printLabel': 'Imprimir',
    'parent.printAria': 'Imprimir esta página',
    'parent.footerNote': 'El progreso se guarda en este dispositivo y se sincroniza con tu cuenta.',
    'timo.recap.today': 'Hoy',
    'timo.recap.yesterday': 'Ayer',
    'breathing.prototypeNotice': 'Esto sigue siendo un prototipo. Aún no funciona como estaba previsto, lo estamos mejorando.',
    'scripts.myScripts': 'Mis guiones',
    'scripts.searchPlaceholder': 'Buscar guiones...',
    'scripts.usedTime': 'Jugado 1 vez',
    'scripts.usedTimes': 'Jugado {count} veces',
    'scripts.use': 'uso',
    'scripts.listen': 'Escuchar',
    'scripts.delete': 'Eliminar',
    'scripts.swipeToDelete': '← Desliza para eliminar',
    'scripts.noScriptsYet': 'Aún no hay guiones',
    'scripts.savePhrasesDesc': 'Guarda frases para reutilizar más tarde 💬',
    'scripts.startTalking': 'empezar a hablar',
    'scripts.addScript': 'Agregar guión',
    'scripts.chooseEmoji': 'Elige un emoji',
    'scripts.yourPhrase': 'tu frase',
    'scripts.phrasePlaceholder': 'por ejemplo, gracias por ayudarme',
    'scripts.cancel': 'Cancelar',
    'scripts.save': 'Guardar',
    'scripts.addNewScript': 'Agregar nuevo guión',
    'scripts.noScriptsFound': 'No se encontraron scripts que coincidan con su búsqueda.',
    'scripts.copied': '¡Copiado!',
    'scripts.copiedToClipboard': 'Script copiado al portapapeles',
    'scripts.deleted': 'Eliminado',
    'scripts.removedFromCollection': 'Guión eliminado de tu colección',
    'scripts.saved': '¡Guardado!',
    'scripts.addedToCollection': 'Script agregado a tu colección',
    'scripts.alreadyExists': 'Ya existe',
    'scripts.alreadySaved': 'Ya tienes este script guardado',
    'scripts.categoryAll': 'Todos',
    'scripts.categoryNonverbal': 'hablar',
    'scripts.categoryChats': 'Charlas',
    'profile.title': 'Perfil',
    'profile.navSubscription': 'Suscripción',
    'profile.navAboutUs': 'Sobre nosotros',
    'profile.sessions': 'dias',
    'profile.trophies': 'Trofeos',
    'profile.sent': 'Enviado',
    'profile.streak': 'racha',
    'profile.activity': 'Actividad',
    'profile.awards': 'Premios',
    'profile.startChatting': 'Empezar a chatear',
    'profile.friend': 'amigo',
    'profile.chat1': '1 charla',
    'profile.chat5': '5 charlas',
    'profile.chat10': '10 charlas',
    'profile.chat25': '25 charlas',
    'profile.chat50': '50 charlas',
    'profile.chat100': '100 charlas',
    'profile.less': 'menos',
    'profile.more': 'Más',
    'profile.chats': 'charlas',
    'profile.goBack': 'volver',
    'profile.reportBug': 'Informar error',
    'profile.sendFeedback': 'Enviar comentarios',
    'profile.feedbackTypeBug': 'Informe de error',
    'profile.feedbackTypeComment': 'Comentario',
    'profile.feedbackPlaceholderBug': 'Describe el error...',
    'profile.feedbackPlaceholderComment': 'Comparte tus pensamientos...',
    'profile.feedbackSend': 'enviar',
    'profile.feedbackCancel': 'Cancelar',
    'profile.feedbackSending': 'Enviando...',
    'profile.feedbackSuccess': '¡Gracias!',
    'profile.feedbackError': 'Fallido. Intentar otra vez.',
    'profile.editProfile': 'Editar perfil',
    'profile.username': 'Nombre de usuario',
    'profile.enterName': 'Introduce tu nombre',
    'profile.borderColor': 'Color del borde',
    'profile.cancel': 'Cancelar',
    'profile.save': 'Guardar',
    'profile.nameInappropriate': 'Por favor elija un nombre apropiado',
    'profile.logout': 'Cerrar sesión',
    'profile.logoutConfirmTitle': '¿Estás seguro?',
    'profile.logoutConfirmText': 'Se cerrará tu sesión y volverás a aterrizar.',
    'profile.logoutYes': 'si',
    'profile.logoutNo': 'No',
    'profile.loggingOut': 'Cerrar sesión...',
    'login.welcome': 'Bienvenido',
    'login.subtitle': 'Por favor ingresa tus datos para continuar',
    'login.firstName': 'Nombre',
    'login.firstNamePlaceholder': 'Introduce tu nombre',
    'login.firstNameRequired': 'El nombre es obligatorio',
    'login.lastName': 'Apellido',
    'login.lastNamePlaceholder': 'Introduce tu apellido',
    'login.optional': 'opcional',
    'login.email': 'Correo electrónico',
    'login.emailPlaceholder': 'Introduce tu correo electrónico',
    'login.emailRequired': 'Se requiere correo electrónico',
    'login.emailInvalid': 'Por favor introduce una dirección de correo electrónico válida',
    'login.error': 'Algo salió mal. Por favor inténtalo de nuevo.',
    'login.pleaseWait': 'Por favor espera...',
    'login.continue': 'Continuar',
    'login.disclaimer': 'Esta información se puede utilizar para promocionar nuestra aplicación después del desarrollo final.',
    'appName': 'Hora de hablar',
    'tagline': 'A veces el paso más importante es simplemente decir "Hola"',
    'start': 'Empezar',
    'situations': 'Situaciones',
    'chat': 'Charla',
    'settings': 'Configuración',
    'home': 'Inicio',
    'nav.home': 'Inicio',
    'nav.scripts': 'Guiones',
    'nav.settings': 'Configuración',
    'nav.chat': 'Charla',
    'nav.live': 'en vivo',
    'nav.profile': 'Perfil',
    'nav.nonverbal': 'hablar',
    'selectSituation': 'Seleccione una situación',
    'store': 'Tienda',
    'cafe': 'cafetería',
    'bus': 'autobús',
    'hospital': 'hospitales',
    'school': 'escuela',
    'party': 'fiesta',
    'chatFriend': 'Amigo del chat de IA',
    'typeMessage': 'Escribe tu mensaje...',
    'send': 'enviar',
    'playVoice': 'Reproducir voz',
    'tts.ltPreviewTitle': 'Voz: cómo sonará',
    'accessibilitySettings': 'Configuración de accesibilidad',
    'hideImages': 'Ocultar imágenes',
    'showImages': 'Mostrar imágenes',
    'dyslexiaMode': 'Modo dislexia',
    'textSize': 'Tamaño del texto',
    'backgroundMode': 'Modo de fondo',
    'monochrome': 'monocromo',
    'colored': 'coloreado',
    'resetDefaults': 'Restablecer los valores predeterminados',
    'language': 'Idioma',
    'english': 'ingles',
    'lithuanian': 'lituano',
    'detailMode': 'Modo detalle',
    'detailModeDescription': 'Mostrar instrucciones más detalladas',
    'instructions': 'Instrucciones',
    'backToChat': 'Volver al chat',
    'startChat': 'Iniciar chat',
    'moreDetail': 'Más detalles',
    'lessDetail': 'Menos detalles',
    'addCustomSituation': 'Agregar situación personalizada',
    'createYourOwn': 'Crea tu propia situación',
    'situationName': 'Nombre de la situación (por ejemplo, biblioteca)',
    'situationIcon': 'Icono de situación (p. ej., 📚)',
    'situationNameEn': 'Nombre de la situación (inglés)',
    'situationNameLt': 'Nombre de la situación (lituano)',
    'steps': 'Pasos',
    'addStep': 'Agregar paso',
    'step': 'paso',
    'instructionSimpleEn': 'Instrucción sencilla (inglés)',
    'instructionDetailedEn': 'Instrucciones detalladas (inglés)',
    'instructionSimpleLt': 'Instrucción sencilla (lituano)',
    'instructionDetailedLt': 'Instrucciones detalladas (lituano)',
    'saveSituation': 'Guardar situación',
    'delete': 'Eliminar',
    'stageName': 'Nombre artístico',
    'stageNameEn': 'Nombre artístico (inglés)',
    'stageNameLt': 'Nombre artístico (lituano)',
    'coachLine': 'Línea de autocares',
    'icon': 'Icono',
    'textEn': 'Texto (inglés)',
    'textLt': 'Texto (lituano)',
    'removeStep': 'Eliminar paso',
    'edit': 'Editar',
    'awards': 'Premios',
    'totalTrophies': 'Trofeos totales',
    'colorThemes': 'Temas de color',
    'situationRewards': 'Estadísticas de conversación',
    'unlocksAt': 'Se desbloquea en',
    'trophies': 'trofeos',
    'successfulInteractions': 'Interacciones exitosas',
    'applyTheme': 'Aplicar tema',
    'applied': 'Aplicado',
    'chimeSound': 'Sonido de timbre de recompensa',
    'chimeSoundDescription': 'Reproduce un sonido al desbloquear una recompensa',
    'settings.title': 'Configuración',
    'settings.backAria': 'volver',
    'settings.appearance': 'Apariencia',
    'settings.sounds': 'sonidos',
    'settings.background': 'Antecedentes',
    'settings.language': 'Idioma',
    'settings.account': 'cuenta',
    'settings.voiceprint.title': 'reconocimiento de voz',
    'settings.voiceprint.description': 'Time to Talk aprende a reconocer su voz en este dispositivo para poder saber quién está hablando en conversaciones en vivo. Su perfil de voz se almacena localmente y nunca se envía a nuestros servidores.',
    'settings.voiceprint.forget': 'olvida mi voz',
    'settings.voiceprint.forgetDesc': 'Borre el perfil de voz guardado y comience de nuevo',
    'settings.voiceprint.forgotten': 'Perfil de voz borrado',
    'settings.voiceprint.forgottenDesc': 'Time to Talk volverá a aprender tu voz en la próxima sesión en vivo.',
    'settings.theme': 'Tema',
    'settings.dark': 'oscuro',
    'settings.light': 'Luz',
    'settings.textSize': 'Tamaño del texto',
    'settings.textSizeSmall': 'un',
    'settings.textSizeMedium': 'A+',
    'settings.textSizeLarge': 'A++',
    'settings.reduceMotion': 'Reducir el movimiento',
    'settings.dyslexiaFont': 'Fuente dislexia',
    'settings.showImages': 'Mostrar imágenes',
    'settings.rewardSounds': 'Sonidos de recompensa',
    'settings.rainAnimation': 'Animación de lluvia',
    'settings.rainSounds': 'Sonidos de lluvia',
    'settings.celebration': 'Efectos de celebración',
    'settings.partyModePhone': 'Efectos de celebración en el móvil',
    'settings.partyModeDesktop': 'Efectos de celebración en el ordenador',
    'settings.forest': 'bosque',
    'settings.city': 'ciudad',
    'settings.beach': 'playa',
    'settings.privacyPolicy': 'Política de privacidad',
    'settings.termsOfService': 'Términos de servicio',
    'settings.helpSupport': 'Ayuda y soporte',
    'settings.replayTutorial': 'Tutorial de repetición',
    'settings.replayTutorialDescription': 'Ver el tutorial de la aplicación nuevamente',
    'settings.resetPermissions': 'Restablecer permisos',
    'settings.resetPermissionsDescription': 'Solicitar acceso al micrófono y al dispositivo nuevamente',
    'settings.resetToDefaults': 'Restablecer los valores predeterminados',
    'settings.followUs': 'Síguenos',
    'settings.version': 'Timo v1.0.0 • Hecho con ❤️',
    'settings.deleteAccount': 'Eliminar cuenta',
    'settings.deleteAccountConfirmTitle': '¿Eliminar tu cuenta?',
    'settings.deleteAccountConfirmBody': 'Esto eliminará permanentemente su cuenta y todos sus datos. Esto no se puede deshacer.',
    'settings.deleteAccountConfirm': 'Sí, eliminar mi cuenta',
    'settings.deleteAccountCancel': 'Cancelar',
    'settings.deleteAccountSuccess': 'Cuenta eliminada',
    'settings.deleteAccountError': 'No se pudo eliminar la cuenta. Inténtelo de nuevo o comuníquese con el soporte.',
    'settings.voiceTitle': 'Voz',
    'settings.voiceDescription': 'Elige una voz',
    'settings.voiceChildishFemale': 'Infantil, Mujer',
    'settings.voiceAdultMale': 'Más adulto, Masculino',
    'tutorial.skip': 'Saltar',
    'tutorial.next': 'Siguiente',
    'tutorial.startApp': 'Comience a usar la aplicación',
    'tutorial.welcome.title': '¡Bienvenidos a Hora de Hablar!🎉',
    'tutorial.welcome.subtitle': 'Déjame mostrarte todo',
    'tutorial.welcome.description': 'Soy Timo, tu ayudante de comunicación. ¡Este recorrido rápido te mostrará todo lo que puedo hacer por ti!',
    'tutorial.welcome.timoMessage': '¿Listo para aprender? ¡Vamos!',
    'tutorial.home.title': 'Tu base de operaciones 🏠',
    'tutorial.home.subtitle': 'todo comienza aqui',
    'tutorial.home.description': 'La pantalla de inicio muestra tus acciones rápidas y el botón principal para empezar a hablar. Puede acceder a todas las funciones desde aquí.',
    'tutorial.home.timoMessage': '¡Aquí es donde empiezas!',
    'tutorial.chat.title': 'Chatea conmigo 💬',
    'tutorial.chat.subtitle': 'Tu principal ayudante',
    'tutorial.chat.description': 'Toca el botón Timo (¡ese soy yo!) en el centro del menú para obtener ayuda con las conversaciones. Dime lo que alguien dijo y te sugeriré lo que podrías responder.',
    'tutorial.chat.timoMessage': '¡Siempre estoy aquí para ayudar!',
    'tutorial.chat.tip1': 'Escribe o usa la voz para contarme qué pasó',
    'tutorial.chat.tip2': 'Te sugeriré respuestas que puedes usar.',
    'tutorial.chat.tip3': 'Toque el ícono del altavoz para escuchar sugerencias leídas en voz alta',
    'tutorial.nonverbal.title': 'Modo Hablar 🗣️',
    'tutorial.nonverbal.subtitle': 'Cuando las palabras son difíciles',
    'tutorial.nonverbal.description': 'A veces hablar es difícil. Utilice el modo Hablar para tocar símbolos y crear oraciones que yo hablaré por usted.',
    'tutorial.nonverbal.timoMessage': '¡No es necesario hablar aquí!',
    'tutorial.nonverbal.tip1': 'Toque los símbolos para crear su mensaje',
    'tutorial.nonverbal.tip2': 'Pulsa el botón de reproducción para hablarlo en voz alta.',
    'tutorial.nonverbal.tip3': 'Genial para cuando necesitas un descanso de la conversación',
    'tutorial.scripts.title': 'Tus guiones 📝',
    'tutorial.scripts.subtitle': 'Guardar frases favoritas',
    'tutorial.scripts.description': '¿Encontraste una respuesta que te encanta? ¡Guárdalo en Scripts! Tus frases guardadas siempre están listas cuando las necesitas.',
    'tutorial.scripts.timoMessage': '¡Mantén tus favoritos a mano!',
    'tutorial.scripts.tip1': 'Toca + para agregar una nueva frase',
    'tutorial.scripts.tip2': 'Organizar por categoría',
    'tutorial.scripts.tip3': 'Toca para copiar o leer cualquier guión',
    'tutorial.settings.title': 'Hazlo tuyo ⚙️',
    'tutorial.settings.subtitle': 'Personaliza tu experiencia',
    'tutorial.settings.description': 'Cambia tu tema, tamaño de texto, sonidos y más. ¡Haz que la aplicación sea cómoda para ti!',
    'tutorial.settings.timoMessage': '¡Configúralo a tu manera!',
    'tutorial.settings.tip1': 'Cambiar entre modo claro y oscuro',
    'tutorial.settings.tip2': 'Ajustar el tamaño del texto para una lectura más fácil',
    'tutorial.settings.tip3': 'Activar o desactivar sonidos',
    'tutorial.settings.tip4': 'Elige tu fondo favorito',
    'tutorial.profile.title': 'Tu perfil 📊',
    'tutorial.profile.subtitle': 'Sigue tus conversaciones',
    'tutorial.profile.description': '¡Cada conversación te ayuda a crecer! Consulta tu perfil para ver tu historial y realizar un seguimiento de tu progreso.',
    'tutorial.profile.timoMessage': '¡Lo estás haciendo genial!',
    'tutorial.profile.tip1': 'Ver tu historial de conversaciones',
    'tutorial.profile.tip2': 'Ver tu historial de conversaciones',
    'tutorial.profile.tip3': 'Sigue tu progreso a lo largo del tiempo',
    'tutorial.complete.title': '¡Estás listo!🌟',
    'tutorial.complete.subtitle': 'empecemos a hablar',
    'tutorial.complete.description': '¡Eso es todo! Recuerda, estoy aquí siempre que necesites ayuda. No hay presión: ve a tu propio ritmo.',
    'tutorial.complete.timoMessage': '¡Creo en ti!💚',
    'tour.skip': 'Saltar',
    'tour.next': 'Siguiente',
    'tour.back': 'Atrás',
    'tour.finish': '¡Entendido!',
    'tour.welcome.title': '¡Hola!👋',
    'tour.welcome.message': '¡Soy Timo, tu ayudante de comunicación! Déjame mostrarte la aplicación muy rápido.',
    'tour.navbar.title': 'Barra de navegación',
    'tour.navbar.message': '¡Así es como te mueves! Todas las características principales están aquí en la parte inferior.',
    'tour.timoButton.title': '¡Chatea conmigo!',
    'tour.timoButton.message': 'Tócame cuando necesites ayuda con las conversaciones. ¡Te sugeriré lo que podrías decir!',
    'tour.homeTab.title': 'Inicio',
    'tour.homeTab.message': 'Tu punto de partida. Acceso rápido a todo y a tu progreso diario.',
    'tour.nonverbalTab.title': 'Modo de hablar',
    'tour.nonverbalTab.message': 'Cuando le resulte difícil hablar, toque aquí. ¡Puedes crear mensajes con símbolos y yo hablaré por ti!',
    'tour.scriptsTab.title': 'Guiones',
    'tour.scriptsTab.message': 'Guarda aquí tus frases favoritas. ¡Acceso rápido a las respuestas que utilizas con frecuencia!',
    'tour.settingsTab.title': 'Configuración',
    'tour.settingsTab.message': '¡Haz tuya la aplicación! Cambie colores, tamaño del texto, sonidos y más.',
    'tour.profileTab.title': 'Perfil',
    'tour.profileTab.message': 'Vea su progreso aquí. ¡Cada conversación te ayuda a crecer!',
    'tour.complete.title': '¡Estás listo!🎉',
    'tour.complete.message': '¡Ese es el recorrido! Recuerda, solo tócame cada vez que necesites ayuda. Sin presiones: ¡ve a tu propio ritmo!',
    'settings.resetToastTitle': '✅ Restablecer configuración',
    'settings.resetToastDescription': 'Todas las configuraciones de accesibilidad se han restaurado a sus valores predeterminados.',
    'settings.metaDescription': 'Personalice la configuración de accesibilidad, incluido el modo dislexia, el tamaño del texto y las preferencias de fondo.',
    'settings.rainBackgroundTitle': 'Fondo de lluvia animado',
    'settings.rainBackgroundDescription': 'Mostrar animación de lluvia',
    'settings.disableRainBackground': 'Desactivar fondo de lluvia',
    'settings.enableRainBackground': 'Habilitar fondo de lluvia',
    'settings.rainSoundTitle': 'Sonido de lluvia en bucle',
    'settings.rainSoundDescription': 'Reproducir audio de lluvia de fondo',
    'settings.disableRainSound': 'Desactivar sonido de lluvia',
    'settings.enableRainSound': 'Habilitar sonido de lluvia',
    'settings.volumeLabel': 'Volumen',
    'settings.rainVolumeAria': 'Volumen del sonido de la lluvia',
    'settings.imagesDescription': 'Alternar iconos e imágenes visuales',
    'settings.openDyslexicTitle': 'fuente OpenDyslexic',
    'settings.openDyslexicDescription': 'Utiliza la fuente OpenDyslexic para que las letras sean más fáciles de distinguir.',
    'settings.openDyslexicAria': 'fuente OpenDyslexic',
    'settings.textSizeTitle': 'Tamaño del texto',
    'settings.mediumFont': 'Tamaño de texto mediano',
    'settings.largeFont': 'Tamaño de texto grande',
    'settings.xlargeFont': 'Tamaño de texto extra grande',
    'settings.ttsModelTitle': 'Modelo de voz',
    'settings.ttsModelDescription': 'Elija qué modelo de voz de IA usar para hablar',
    'settings.ttsModelBrowser': 'Robo',
    'settings.ttsModelElevenLabs': 'Natt',
    'settings.ttsModelOpenAI': 'Nova',
    'settings.ttsModelGemini': 'Puck',
    'settings.themeIconsTitle': 'Iconos de fondo',
    'settings.themeIconsDescription': 'Muestra íconos emoji flotantes que coincidan con tu tema',
    'settings.showImagesIcons': 'Mostrar imágenes e íconos',
    'settings.soundTitle': 'sonido',
    'settings.rewardSound': 'Sonido de recompensa',
    'firstTimeGuide.step1': 'Haz clic en "Tu situación".',
    'firstTimeGuide.step2': 'Escriba o use la voz para contar lo que pasó.',
    'firstTimeGuide.step3': 'La IA te sugerirá lo que podrías decir a continuación',
    'firstTimeGuide.step4': 'Después de la conversación, califica cómo se sintió.',
    'firstTimeGuide.reassurance': 'Siempre tienes el control. Puedes parar en cualquier momento.',
    'firstTimeGuide.dontShowAgain': 'No volver a mostrar esta guía',
    'firstTimeGuide.startButton': 'Comience a usar la aplicación',
    'newFeature.title': '¡Nueva característica!',
    'newFeature.subtitle': 'Hemos agregado algo nuevo para ayudarte a comunicarte.',
    'newFeature.feature1Title': 'Modo de hablar',
    'newFeature.feature1Desc': 'Toque símbolos para construir oraciones y pronunciarlas en voz alta.',
    'newFeature.feature2Title': 'Sencillo y tranquilo',
    'newFeature.feature2Desc': 'Diseñado para ser fácil de usar cuando las palabras son difíciles',
    'newFeature.feedbackRequest': 'Esta es una característica nueva. ¡Nos encantaría recibir tus comentarios! Háganos saber si encuentra algún error o tiene sugerencias.',
    'newFeature.dontShowAgain': 'No vuelvas a mostrar esto',
    'newFeature.messageButton': 'Envíanos un mensaje',
    'newFeature.tryButton': 'Pruébalo ahora',
    'home.feature1Title': 'Ayuda en tiempo real',
    'home.feature1Desc': 'Recibe sugerencias mientras hablas',
    'home.feature2Title': 'Soporte de voz',
    'home.feature2Desc': 'Habla o escribe: tú eliges',
    'home.feature3Title': 'Escucha de nuevo',
    'home.feature3Desc': 'Escuche las respuestas leídas en voz alta',
    'home.howItWorksTitle': 'como funciona',
    'home.howItWorksDesc': 'Cuéntanos qué dijeron y te ayudaremos a encontrar las palabras adecuadas.',
    'home.step1': 'Escuchar',
    'home.step2': 'pensar',
    'home.step3': 'Responder',
    'home.tryNow': 'Pruébalo ahora',
    'home.reassurance': 'Sin juicio. Sin presión. Sólo ayuda cuando lo necesites.',
    'home.reassuranceSub': 'Timo está aquí para ti, a tu propio ritmo.',
    'home.timoTitle': 'Conoce a Timo AI',
    'home.timoSubtitle': 'Tu guía de comunicación tranquila',
    'home.timoCard1Title': 'El mediador forestal',
    'home.timoCard1Text': 'La diplomacia eligió a Timo. En su bosque, todos los conflictos terminaron cuando él arregló las cosas.',
    'home.timoCard2Title': 'Caos forestal',
    'home.timoCard2Text': 'Antes de Timo, todos los animales tenían problemas entre ellos. Ardillas contra cuervos (las nueces desaparecían todos los días), patos contra literalmente todos (simplemente… graznaban agresivamente). Pero una vez que Timo se mudó, resolvió los problemas de todos como si nada.',
    'home.timoCard3Title': 'Un gran oyente',
    'home.timoCard3Text': 'Ni ruidoso ni mandón. Timo realmente puede escuchar y ayudar a los demás a entenderse.',
    'home.timoCard4Title': 'Una realización importante',
    'home.timoCard4Text': 'Los conflictos no surgen de malas intenciones. Provienen de no saber expresarse.',
    'home.timoCard5Title': 'Una misión clara',
    'home.timoCard5Text': 'La comunicación no se trata de quién es más inteligente o más ruidoso. Se trata de ayudar a los demás a entenderte.',
    'home.timoCard6Title': 'Ayudando a los humanos',
    'home.timoCard6Text': 'Cuando Timo escuchó que los humanos también tenían dificultades con las conversaciones, rápidamente abandonó su bosque para ayudar.',
    'home.timoCard7Title': 'Tu guía',
    'home.timoCard7Text': 'Paciente, observador, sin prejuicios. Timo te da las palabras adecuadas en el momento adecuado.',
    'home.drawerOpen': 'Leer más',
    'home.drawerClose': 'Leer menos',
    'unknown.startConversation': 'iniciar una conversación',
    'unknown.continueConversation': 'continuar la conversación',
    'unknown.askForHelp': 'pide ayuda',
    'unknown.sayNoPolitely': 'Di no cortésmente',
    'unknown.endConversation': 'Finalizar conversación',
    'unknown.metaTitle': 'Tu situación',
    'unknown.metaDescription': 'Practique una conversación con IA que infiera el contexto.',
    'unknown.backAria': 'Volver a "Tu situación"',
    'unknown.title': 'Tu situación',
    'unknown.subtitle': 'Escriba lo que usted o la otra persona dijeron. Timo AI lo resolverá y ayudará.',
    'unknown.subtitleShort': 'Escriba lo que dijo la otra persona para que Timo AI pueda ayudar.',
    'unknown.helper': '¿Cómo puede ayudar Timo AI?',
    'unknown.youCouldSay': 'También se podría decir...',
    'unknown.inputPlaceholder': 'Pídele ayuda a Timo AI',
    'unknown.inputAria': 'Pídele ayuda a Timo AI',
    'unknown.sendAria': 'enviar mensaje',
    'unknown.finishAria': 'Terminar la conversación',
    'unknown.finishButton': 'terminar',
    'unknown.finishedNotice': 'Conversación terminada',
    'unknown.startNewConversation': 'Iniciar una nueva conversación',
    'unknown.finishToastTitle': 'Conversación terminada',
    'unknown.finishToastDescription': 'La conversación ha terminado. Puedes empezar uno nuevo.',
    'unknown.errorTitle': 'error',
    'unknown.errorDescription': 'No se pudo enviar el mensaje. Por favor inténtalo de nuevo.',
    'unknown.contextPlace': 'Lugar',
    'unknown.contextRelationship': 'relación',
    'unknown.contextGoal': 'Objetivo',
    'unknown.emptyState': '¡Empieza escribiendo lo que pasó o lo que se dijo!',
    'unknown.playVoiceAria': 'reproducir voz',
    'unknown.finishedTitle': '¡Terminaste esta situación!',
    'unknown.motivationalMessage': 'Buen trabajo por intentarlo.',
    'unknown.howDidItFeel': '¿Cómo se sintió esta vez?',
    'unknown.itFeltGood': 'se sintió bien',
    'unknown.itWasHard': 'Fue difícil esta vez',
    'unknown.bothChoicesOkay': 'Ambas opciones están bien; lo importante es que lo intentaste.',
    'unknown.goalSelectionTitle': '¿Con qué necesitas ayuda?',
    'unknown.goalSelectionSubtitle': 'Elige la opción que mejor se adapte a tu situación.',
    'unknown.goalHelpSpeaking': 'necesito ayuda para hablar',
    'unknown.goalHelpAsking': 'necesito ayuda para preguntar algo',
    'unknown.goalLost': 'no se que decir',
    'unknown.goalSayNo': 'quiero decir que no cortésmente',
    'unknown.goalSkip': 'Esto no se ajusta a mi situación.',
    'unknown.goalBadgeHelpSpeaking': 'Objetivo: ayudar a hablar',
    'unknown.goalBadgeLost': 'Objetivo: No sé qué decir',
    'unknown.goalBadgeSayNo': 'Objetivo: decir no cortésmente',
    'unknown.recordOtherSpeaker': 'Graba lo que dijeron',
    'unknown.recording': 'Grabando…',
    'unknown.otherPersonSaid': 'Otra persona dijo:',
    'unknown.speakerLabel': 'Podrías decir:',
    'unknown.timoAILabel': 'Timo AI:',
    'unknown.otherPersonLabel': 'Otra persona:',
    'unknown.youLabel': 'Tú:',
    'voice.unsupportedAlert': 'La entrada de voz no es compatible con este navegador. Por favor escriba.',
    'voice.stopRecordingAria': 'dejar de grabar',
    'voice.startRecordingAria': 'grabar voz',
    'voice.stopRecordingTooltip': 'dejar de grabar',
    'voice.startRecordingTooltip': 'grabar voz',
    'voice.recordingIndicator': '● Grabación',
    'about': 'Acerca de',
    'about.metaDescription': 'Conoce la historia y la misión detrás de Time To Talk.',
    'about.intro1': 'Time To Talk se creó a partir de un momento simple y significativo.',
    'about.intro2': 'El hermano de nuestro fundador, que tiene autismo, una vez preguntó si podía tomar una fotografía de la luna; una pequeña pregunta que inspiró una gran idea: ayudar a las personas que encuentran confusas o estresantes las situaciones sociales cotidianas.',
    'about.founderImageAlt': 'El fundador y su hermano.',
    'about.teamImageAlt': 'El equipo de Time To Talk trabajando en conjunto',
    'about.missionTitle': 'Nuestra Misión',
    'about.missionText': 'Hacer que la comunicación sea más fácil de entender, practicar y experimentar. Time To Talk ayuda a los usuarios a aprender qué decir y hacer a través de una suave guía de IA, imágenes claras y un diseño tranquilo.',
    'about.goalTitle': 'Nuestro objetivo',
    'about.goalText': 'Para generar confianza, una situación a la vez. Estamos aquí para cualquier persona que necesite apoyo: personas con autismo, ansiedad social o cualquier persona que simplemente encuentre desafiantes los momentos sociales.',
    'about.back': 'Atrás',
    'about.timo': 'timo',
    'about.tagline': 'Tu compañero de conversación',
    'about.missionSub': 'Nuestro objetivo es simple: brindarle confianza cuando más la necesita, sin juzgar ni presionar.',
    'about.features': '¿Qué hace Timo?',
    'about.feature.conversation': 'Ayuda de conversación',
    'about.feature.conversationDesc': 'Recibe sugerencias de respuestas cuando no estés seguro de qué decir',
    'about.feature.voice': 'Entrada de voz',
    'about.feature.voiceDesc': 'Habla o escribe: lo que funcione mejor para ti',
    'about.feature.scripts': 'Guardar guiones',
    'about.feature.scriptsDesc': 'Guarde sus respuestas favoritas para un acceso rápido',
    'about.feature.privacy': 'Privado y seguro',
    'about.feature.privacyDesc': 'Tus conversaciones permanecen en tu dispositivo',
    'about.madeBy': 'Hecho por',
    'about.teamName': 'El equipo de Hora de Hablar',
    'about.teamRole': 'Construyendo herramientas para una mejor comunicación',
    'about.privacyPolicy': 'Política de privacidad',
    'about.terms': 'Términos de servicio',
    'about.contact': 'Contáctenos',
    'about.version': 'Versión 1.0.0',
    'about.madeWith': 'Hecho con ❤️ para mejores conversaciones',
    'header.disableRainBg': 'Desactivar el fondo de lluvia',
    'header.enableRainBg': 'Activar fondo de lluvia',
    'header.disableRainSound': 'Desactivar el sonido de la lluvia',
    'header.enableRainSound': 'Activar sonido de lluvia',
    'situations.metaDescription': 'Elija una situación de la vida real para practicar la comunicación con la guía de la IA.',
    'situations.helperText': 'Elija la situación para practicar o hablar con la ayuda de Timo AI',
    'situations.customTitle': 'Tu situación',
    'situations.customSubtitle': 'Haga clic para comenzar y Timo AI le ayudará',
    'situations.recommended': 'Recomendado',
    'situations.deleteConfirmTitle': '¿Estás seguro?',
    'situations.deleteConfirmDescription': 'Esto no se puede deshacer.',
    'situations.history': 'Historia',
    'situations.historySubtitle': 'Ver tus conversaciones pasadas',
    'situations.chooseWhereTitle': '¿Dónde estás?',
    'situations.chooseWhereSubtitle': 'Elige uno o inicia un chat libre',
    'situations.freeChat': 'Chat libre',
    'situations.liveModeBeta': 'Modo en vivo - Beta',
    'situations.backToHome': 'De vuelta a casa',
    'situations.accessCodeTitle': 'Código de acceso requerido',
    'situations.accessCodeHint': 'Ingrese el código de acceso para usar el Modo en Vivo:',
    'situations.enterCodePlaceholder': 'Introduce el código...',
    'situations.codeIncorrect': 'Código incorrecto. Por favor inténtalo de nuevo.',
    'situations.accessLiveModeButton': 'Acceder al modo en vivo',
    'chat.pageTitle': 'Chatea con Timo',
    'chat.metaDescription': 'Habla con Timo: obtén ayuda sobre qué decir',
    'chat.backAria': 'volver',
    'chat.subtitle': 'Tu ayudante de IA',
    'chat.end': 'Fin',
    'chat.helpDefault': 'Ayuda',
    'chat.greeting': '¡Oye! ¿Qué necesitas ayuda para decir?',
    'chat.suggestionsTitle': '¿Qué debería decir?',
    'chat.suggestionsHint': 'Toque una opción: la leerá y la enviará.',
    'chat.suggestionsUpdating': 'Actualizando...',
    'chat.noSuggestions': 'No hay sugerencias disponibles',
    'chat.thinking': 'Pensando...',
    'chat.gettingSuggestions': 'Obteniendo sugerencias para ti',
    'chat.quickRepliesLabel': 'Respuestas rápidas:',
    'chat.speaking': 'Diciendo:',
    'chat.speakerMe': 'Yo',
    'chat.speakerOther': 'Otro',
    'chat.placeholder': 'Escribe un mensaje...',
    'chat.sendAria': 'enviar mensaje',
    'chat.getHelpAria': 'obtener ayuda',
    'chat.playTtsAria': 'Reproducir texto a voz',
    'chat.ariaHearTimo': 'Escuche el mensaje de Timo',
    'chat.ariaHearIt': 'Escúchalo',
    'chat.ariaSaveScript': 'Guardar en guiones',
    'chat.recordMicMe': 'Mantén presionado para grabar tu voz.',
    'chat.recordMicOther': 'Mantenga presionado para grabar lo que dijeron.',
    'chat.recordingMe': 'Grabando tu voz...',
    'chat.recordingOther': 'Grabando lo que dijeron...',
    'chat.ttsWait': 'Espere {seconds} s... ({left} reproduce a la izquierda)',
    'chat.youCan': 'Puedes decir:',
    'chat.timoSuggests': 'Timo sugiere...',
    'chat.safetyTitle': 'Alerta de seguridad',
    'chat.safetyBody': 'Esta conversación puede ser peligrosa. Si te sientes amenazado, vete inmediatamente.',
    'chat.fallbackAi': '¡Ey! ¿Qué necesitas ayuda para decir?',
    'chat.fallbackCoaching': '¡Mensaje enviado exitosamente!👍 ¿Necesitas algo más?',
    'chat.needMoreHelp': '¿Necesitas ayuda con algo más?',
    'chat.praise1': '¡Bien!',
    'chat.praise2': '¡Genial!',
    'chat.praise3': '¡Bien hecho!',
    'chat.toast.errorTitle': 'error',
    'chat.toast.errorDesc': 'No se pudo obtener respuesta. Por favor inténtalo de nuevo.',
    'chat.toast.ttsLimitTitle': 'Límite TTS alcanzado',
    'chat.toast.ttsLimitDesc': 'Máximo 5 jugadas por sesión para ahorrar recursos.',
    'chat.toast.savedTitle': '¡Guardado!',
    'chat.toast.savedDesc': 'Agregado a sus scripts.',
    'chat.toast.duplicateTitle': 'Ya guardado',
    'chat.toast.duplicateDesc': 'Ya tienes esta frase.',
    'chat.toast.voiceTestTitle': 'prueba de voz',
    'chat.toast.voiceTestDesc': 'Reproduciendo audio de muestra...',
    'chat.toast.voiceFailTitle': 'La prueba de voz falló',
    'chat.toast.voiceFailDesc': 'Consulte la consola para obtener más detalles.',
    'chat.toast.connectionTitle': 'Problema de conexión',
    'chat.toast.connectionDesc': 'No pude obtener una respuesta completa, ¡pero tu mensaje fue genial!',
    'chat.testVoice.lt': 'Sveiki, aš esu Timo, jūsų dirbtinis intelektas.',
    'chat.testVoice.en': 'Hola, soy Timo, tu ayudante de IA.',
    'chat.testVoice.ru': '¡Привет! Mi Timo, dos pomos en la base de su inteligencia intelectual.',
    'chat.qr.hey1': '¡Hola!',
    'chat.qr.hey2': 'Hola',
    'chat.qr.hey3': '¿Qué pasa?',
    'chat.qr.yes1': 'si',
    'chat.qr.yes2': 'No',
    'chat.qr.yes3': 'tal vez',
    'chat.qr.how1': '¡Bien!',
    'chat.qr.how2': 'No está mal',
    'chat.qr.how3': 'estoy bien',
    'chat.qr.inv1': '¡Claro!',
    'chat.qr.inv2': 'tal vez más tarde',
    'chat.qr.inv3': 'no puedo lo siento',
    'chat.qr.help1': 'seguro',
    'chat.qr.help2': '¿Qué pasa?',
    'chat.qr.comp1': '¡Gracias!',
    'chat.qr.comp3': '😊',
    'chat.qr.sorry3': 'Todo bien',
    'chat.qr.info1': '¿De verdad?',
    'chat.qr.info2': 'Dime',
    'chat.qr.info3': '¿Qué?',
    'chat.qr.plan1': 'Suena bien',
    'chat.qr.plan2': '¿A qué hora?',
    'chat.qr.plan3': 'tal vez',
    'chat.qr.conf1': 'si',
    'chat.qr.conf2': 'exactamente',
    'chat.qr.conf3': 'seguro',
    'chat.qr.wq1': 'No estoy seguro',
    'chat.qr.wq2': 'Déjame pensar',
    'chat.qr.wq3': 'lo comprobaré',
    'chat.qr.genq1': 'si',
    'chat.qr.genq2': 'No',
    'chat.qr.genq3': 'tal vez',
    'chat.qr.stat1': 'genial',
    'chat.qr.def3': 'genial',
    'history.delete': 'Eliminar',
    'history.noTitle': 'Conversación sin título',
    'history.lastUpdated': 'Última actualización',
    'history.deleteAll': 'Eliminar todo',
    'history.deleteAllConfirm': '¿Eliminar todo?',
    'history.deleteAllConfirmDesc': 'Se eliminarán todas las conversaciones.',
    'history.deleteAllSuccess': 'Éxito',
    'history.deleteAllSuccessDesc': 'Todas las conversaciones eliminadas',
    'history.justNow': 'Justo ahora',
    'common.cancel': 'Cancelar',
    'common.delete': 'Eliminar',
    'customSetup.intentStart': 'iniciar una conversación',
    'customSetup.intentContinue': 'continuar la conversación',
    'customSetup.intentFinish': 'Terminar la conversación',
    'customSetup.metaTitle': 'Situación personalizada: configuración',
    'customSetup.metaDescription': 'Configure un escenario de práctica de conversación personalizado.',
    'customSetup.title': 'Situación personalizada',
    'customSetup.subtitle': 'Elige dónde estás y qué quieres hacer.',
    'customSetup.situationLabel': 'Situación',
    'customSetup.placeholder': 'por ejemplo, fiesta, escuela, tienda, autobús, hospital',
    'customSetup.examplesHint': 'O haga clic en un ejemplo a continuación:',
    'customSetup.examples.party': 'fiesta',
    'customSetup.examples.school': 'escuela',
    'customSetup.examples.store': 'Tienda',
    'customSetup.examples.bus': 'autobús',
    'customSetup.examples.hospital': 'hospitales',
    'customSetup.intentQuestion': '¿Qué quieres hacer?',
    'customSetup.startButton': 'Empezar',
    'customChat.metaTitle': 'Chat de situación personalizado',
    'customChat.genericSituation': 'situación',
    'customChat.metaDescriptionPrefix': 'Practica la conversación:',
    'customChat.backAria': 'Volver a la configuración',
    'customChat.inputPlaceholder': 'Escribe tu mensaje...',
    'customChat.inputAria': 'Escribe tu mensaje',
    'customChat.finishToastTitle': 'Conversación terminada',
    'customChat.finishToastDescription': 'La conversación ha terminado. Puedes empezar uno nuevo.',
    'customChat.errorTitle': 'error',
    'customChat.errorDescription': 'No se pudo enviar el mensaje. Por favor inténtalo de nuevo.',
    'customChat.finishFallbackShort': '¡Adiós!',
    'customChat.finishFallbackLong': 'Necesito irme ahora, ¡gracias!',
    'customChat.finishedNotice': 'Conversación terminada',
    'nonVerbalMode': 'hablar',
    'nonVerbalSelectPrompt': 'Toca los símbolos para construir tu oración.',
    'nonVerbalAIGrammar': 'Corrección de gramática de IA',
    'nv.speakModalTitle': 'Estoy diciendo:',
    'nv.speaking': 'Hablando...',
    'nv.speak': 'hablar',
    'nv.speakAgain': 'hablar de nuevo',
    'nv.kalbeti': 'hablar',
    'nv.backAria': 'Atrás',
    'nv.scriptsAria': 'Guiones',
    'nv.historyAria': 'Historia',
    'nv.searchPlaceholder': 'Símbolo de búsqueda...',
    'nv.noResults': 'No se encontro nada',
    'nv.ttsFailed': 'No salió el sonido. Toca para intentarlo otra vez.',
    'nv.searchAria': 'Símbolo de búsqueda',
    'nv.loading': 'Cargando...',
    'nv.noPhotos': 'Aún no hay fotos',
    'nv.addPhotosHint': 'Añade tus propias fotos para comunicarte.',
    'nv.addPhoto': 'Agregar foto',
    'nv.add': 'Añadir',
    'nv.showLess': 'Mostrar menos',
    'nv.moreCount': 'Más ({count})',
    'nv.comingSoon': '¡Próximamente!',
    'nv.historyTitle': 'Historia',
    'nv.historyEmpty': 'Aún no hay sentencias. Toca emojis y habla para crear historia.',
    'nv.useAgain': 'Usar de nuevo',
    'nv.addToScripts': 'Agregar a guiones',
    'nv.savedToScripts': '¡Guardado en scripts!',
    'nv.clearHistory': 'Borrar historial',
    'nv.customAddPhoto': 'Agregar foto',
    'nv.customPreview': 'Vista previa',
    'nv.customAddLabel': 'Agregar etiqueta',
    'nv.customTakePhoto': 'tomar foto',
    'nv.customWordOnly': 'Solo una palabra',
    'nv.customWordOnlyHint': 'Sin foto',
    'nv.customContinue': 'Continuar',
    'nv.customOptional': 'opcional',
    'nv.customCategory': 'Categoría',
    'nv.customBack': 'Atrás',
    'nv.customSave': 'Guardar',
    'nv.customSaving': 'Guardando...',
    'nv.customErrImage': 'Por favor seleccione un archivo de imagen',
    'nv.customErrSize': 'Archivo demasiado grande (máximo 10 MB)',
    'nv.customErrLabel': 'Por favor introduce una etiqueta',
    'nv.customErrSave': 'Error al guardar',
    'nv.manageTitle': 'Mis fotos',
    'nv.deleteConfirm': '¿Eliminar "{name}"?',
    'nv.cancel': 'Cancelar',
    'nv.delete': 'Eliminar',
    'speak': 'hablar',
    'speaking': 'Hablando...',
    'clear': 'Borrar',
    'back': 'Atrás',
    'skip': 'Saltar',
    'continue': 'Continuar',
    'onboarding.soundsDesc': 'Campanas suaves para recibir comentarios',
    'onboarding.showImages': 'Mostrar imágenes',
    'onboarding.showImagesDesc': 'Mostrar ilustraciones e iconos',
    'onboarding.howItWorksTitle': 'como funciona',
    'onboarding.howItWorksDesc': 'Tres sencillos pasos que le ayudarán a comunicarse',
    'onboarding.step1Title': 'ellos hablan',
    'onboarding.step1Desc': 'Cuéntanos qué dijo la otra persona.',
    'onboarding.step2Title': 'ayudamos',
    'onboarding.step2Desc': 'Timo sugiere lo que podrías decir.',
    'onboarding.step3Title': 'tu respondes',
    'onboarding.step3Desc': 'Elige una sugerencia o di la tuya propia',
    'onboarding.readyTitle': '¡Estás listo!',
    'onboarding.readyDesc': 'Timo está listo para ayudarte cuando lo necesites.',
    'onboarding.readyTip': 'Consejo: Siempre podrás acceder a la configuración más tarde para ajustar las preferencias.',
    'onboarding.startUsing': 'Comience a usar Time To Talk',
    'pushToTalk.title': 'Ayúdame a responder',
    'pushToTalk.ready': 'Listo cuando lo estés',
    'pushToTalk.helpMeRespond': 'Ayúdame a responder',
    'pushToTalk.tapToStart': 'Toca para grabar lo que dijeron.',
    'pushToTalk.recording': 'Grabando lo que dijeron...',
    'pushToTalk.done': 'hecho',
    'pushToTalk.cancel': 'Cancelar',
    'pushToTalk.understanding': 'Entendiendo...',
    'pushToTalk.theySaid': 'Dijeron:',
    'pushToTalk.soundsLike': 'Esto suena como',
    'pushToTalk.yesHelpMe': 'Si, ayúdame a responder',
    'pushToTalk.notQuite': 'No del todo, inténtalo de nuevo',
    'pushToTalk.startOver': 'Empezar de nuevo',
    'pushToTalk.findingResponses': 'Encontrar buenas respuestas...',
    'pushToTalk.pickResponse': 'Elija una respuesta:',
    'pushToTalk.youllSay': 'Dirás:',
    'pushToTalk.illSayIt': 'lo diré',
    'pushToTalk.speakForMe': 'habla por mi',
    'pushToTalk.chooseAnother': 'Elige otro',
    'pushToTalk.differentOptions': 'Diferentes opciones',
    'pushToTalk.speaking': 'Hablando...',
    'pushToTalk.stop': 'Detener',
    'pushToTalk.responseReady': '¡Respuesta lista!',
    'pushToTalk.needMoreHelp': 'Necesito más ayuda',
    'pushToTalk.imDone': 'ya terminé',
    'pushToTalk.autoReset': 'Regresará a casa automáticamente',
    'pushToTalk.stillThere': '¿Sigue ahí?',
    'pushToTalk.takeYourTime': 'Tómate tu tiempo, sin prisas.',
    'pushToTalk.continue': 'Continuar',
    'pushToTalk.didntCatch': 'no entendí eso',
    'pushToTalk.tryAgainOrType': 'Inténtalo de nuevo o escribe en su lugar',
    'pushToTalk.tryAgain': 'Inténtalo de nuevo',
    'pushToTalk.typeInstead': 'Escriba en su lugar',
    'pushToTalk.whatDidTheySay': '¿Qué dijeron?',
    'pushToTalk.typeHere': 'Escribe lo que dijeron...',
    'pushToTalk.somethingWrong': 'algo salió mal',
    'pushToTalk.pleaseTryAgain': 'Por favor inténtalo de nuevo',
    'pushToTalk.panic': 'Detente y regresa',
    'live.title': 'Modo en vivo',
    'live.back': 'Atrás',
    'live.endSession': 'Fin',
    'live.error': 'error',
    'live.dismiss': 'Descartar',
    'live.status.ready': 'Listo',
    'live.status.connecting': 'Conectando...',
    'live.status.listening': 'Escuchando...',
    'live.tapToStart': 'Empezar',
    'live.tapToStop': 'Detener',
    'live.connecting': 'Conectando...',
    'live.stats.totalMessages': 'totales',
    'live.stats.you': 'tu',
    'live.stats.otherPerson': 'Otro',
    'live.conversation': 'Conversación',
    'live.emptyState.listening': 'Escuchando...',
    'live.emptyState.startRecording': 'Empezar',
    'live.getAiHelp': 'Ayuda Timo',
    'live.askAi': 'Pregúntale a Timo',
    'live.theyreSpeaking': 'ellos estan hablando',
    'live.emptyState.instruction': 'Haga clic en el botón del micrófono para comenzar la conversación.',
    'live.betaWarning.title': 'Modo en vivo - Beta',
    'live.betaWarning.description': 'Esta característica está en desarrollo. ¡Siéntete libre de probar!',
    'live.betaWarning.note': 'Funciona mejor en ingles',
    'live.betaWarning.close': 'Lo tengo',
    'rateLimit.title': 'Has alcanzado el límite de hoy.',
    'rateLimit.message': 'Has alcanzado tu límite diario. Inténtelo de nuevo mañana.',
    'rateLimit.ok': 'OK',
    'rateLimit.close': 'Cerrar',
    // Landing copy lives in src/copy/landing.es.js
    ...landingEs,
    ...storyEs,
    'login.title': 'Iniciar sesión',
    'login.startSubtitle': 'Inicie sesión con Google o correo electrónico.',
    'login.fbBrowserWarning': 'El inicio de sesión de Google no funciona en el navegador de Facebook. Utilice el correo electrónico a continuación o abra esta página en Safari/Chrome.',
    'login.googleBtn': 'Continuar con Google',
    'login.facebookBtn': 'Continuar con Facebook',
    'login.appleBtn': 'Continuar con Apple',
    'login.openInBrowser': 'Para iniciar sesión en Google, Facebook o Apple, toque el menú y elija "Abrir en el navegador". O simplemente use el correo electrónico a continuación.',
    'login.emailBtn': 'Continuar con el correo electrónico',
    'login.signUpPrompt': '¿Aún no tienes una cuenta?',
    'login.signUpLink': 'Regístrese a continuación',
    'login.registerBtn': '¿Ya tienes una cuenta?',
    'login.signInLink': 'Iniciar sesión',
    'login.signinTitle': 'Iniciar sesión',
    'login.signupTitle': 'Registrarse',
    'login.signinSubtitle': 'Inicia sesión con tu correo electrónico',
    'login.signupSubtitle': 'Crea tu cuenta',
    'login.emailLabel': 'Dirección de correo electrónico',
    'login.passwordLabel': 'Contraseña',
    'login.passwordSignupPlaceholder': 'Contraseña (mínimo 6 caracteres)',
    'login.submitSignin': 'Iniciar sesión',
    'login.submitSignup': 'Registrarse',
    'login.processing': 'Procesando...',
    'login.noAccount': 'Inicia sesión con tu correo electrónico',
    'login.haveAccount': 'Crea tu cuenta',
    'login.successSignin': 'Dirección de correo electrónico',
    'login.successSignup': 'Contraseña',
    'login.failed': 'Contraseña (mínimo 6 caracteres)',
    'login.unknownError': '¿No tienes una cuenta? Registrarse',
    'login.registrationFailed': '¿Ya tienes una cuenta? Iniciar sesión',
    'login.confirmationEmail': '¡Inicia sesión correctamente!',
    'login.linkExpired': 'Su enlace de inicio de sesión expiró. Por favor solicite uno nuevo.',
    'login.resendMagicLink': 'Envíeme un correo electrónico con un nuevo enlace de inicio de sesión',
    'login.magicLinkSent': 'Revise su correo electrónico para ver si hay un nuevo enlace de inicio de sesión.',
    'login.loginSuccessful': '¡Inicia sesión correctamente!',
    'login.devAccessNotAvailable': 'Acceso para desarrolladores no disponible',
    'login.invalidCode': 'código no válido',
    'login.accessPlaceholder': 'acceso',
    'login.forgotPassword': '¿Olvidaste tu contraseña?',
    'login.resetTitle': 'Restablecer contraseña',
    'login.resetSubtitle': 'Le enviaremos un enlace de reinicio.',
    'login.submitReset': 'Enviar enlace de reinicio',
    'login.resetSent': 'Revise su correo electrónico para obtener un enlace de reinicio.',
    'login.resetRateLimited': 'El correo electrónico ya se envió: espere unos minutos antes de volver a intentarlo.',
    'login.resetWaitBtn': 'Espera {n}s',
    'login.newPasswordTitle': 'Establecer nueva contraseña',
    'login.newPasswordSubtitle': 'Ingrese su nueva contraseña a continuación.',
    'login.newPasswordLabel': 'Nueva contraseña (mínimo 6 caracteres)',
    'login.submitNewPassword': 'Establecer contraseña',
    'login.passwordUpdated': '¡Contraseña actualizada! Registrándote...',
    'login.backToSignin': 'Volver para iniciar sesión',
    'login.fbEmailFallback': 'O inicia sesión con correo electrónico',
    'login.fbLinkCopied': 'Enlace copiado: pégalo en Chrome o Safari',
    'home.urgencyBanner': 'Tu suscripción no está activa: desbloquea todas las funciones',
    'home.urgencyBannerCta': 'Ver planes',
    'subscription.choosePlanCta': 'Elegir un plan',
    'home.sessionsCompleted': '{n} sesiones completadas',

    // Landing v2 - direct-pay funnel
    'pricingCard.howManyMonths': '¿Cuantos meses?',
    'pricingCard.fullAccess': 'Acceso completo a todas las funciones.',
    'pricingCard.offline': 'Funciona sin conexión',
    'pricingCard.newFeatures': 'Nuevas funciones mensualmente',
    'pricingCard.cancelAnytime': 'Cancelar en cualquier momento',
    'pricingCard.tryBeforePay': 'Pruébalo antes de pagar',
    'pricingCard.lockInPrice': 'Bloquear el precio',
    'footer.privacy': 'Política de privacidad',
    'footer.articles': 'Artículos',
    'footer.terms': 'Términos',
    'footer.contact': 'Contacto',
    'footer.copyright': '© 2026 Es hora de hablar',
    'common.appName': 'Hora de hablar',
    'pricing.yourChildDeserves': 'Su hijo merece ser escuchado.',
    'pricing.feature1': 'Toca una imagen. Timo habla por ellos.',
    'pricing.feature2': 'Practique hablar de forma segura, a su propio ritmo.',
    'pricing.feature3': 'Ayuda en conversaciones reales. En tiempo real.',
    'pricing.letsGo': 'vamos',
    'pricing.cancelBeforeDay7': 'Cancela antes del día 7. No pagas nada.',
    'pricing.reminderTitle': 'Te lo recordaremos antes de que termine.',
    'pricing.today': 'hoy',
    'pricing.day5': 'Día 5',
    'pricing.day5Desc': 'Le enviamos un correo electrónico de recordatorio.',
    'pricing.day7': 'Día 7',
    'pricing.soundsGood': 'Suena bien',
    'pricing.controlIt': 'Tú lo controlas. Cancele en cualquier momento.',
    'pricing.choosePlan': 'Elige tu plan.',
    'pricing.fullAccessBadge': 'ACCESO COMPLETO',
    'pricing.perMonthLabel': 'al mes',
    'pricing.fullAccessFromToday': 'Los 3 modos, desbloqueados hoy',
    'pricing.billedMonthlyCancelAnytime': 'Facturación mensual. Cancela cuando quieras.',
    'pricing.getAccessCta': 'Obtener acceso',
    'pricing.chargedTodayNote': 'Se te cobra hoy. Cancela cuando quieras en Perfil y luego Suscripción.',
    'pricing.fullAccessSub': 'Acceso completo a los 3 modos. Cancela cuando quieras.',
    'pricing.cancelAnytimeNote': 'Cancela cuando quieras en Perfil y luego Suscripción.',
    'pricing.oldPrice': '11,49€/mes',
    'pricing.foundingRate': 'Tasa de fundación',
    'pricing.oneMonth': '1 mes',
    'pricing.threeMonths': '3 meses',
    'pricing.sixMonths': '6 meses',
    'pricing.monthlyPer': '/mo',
    'pricing.monthlyWeek': '1,50€/semana',
    'pricing.quarterlyPrice': '5,83 €',
    'pricing.quarterlyPer': '/mo',
    'pricing.quarterlyWeek': '1,35€/semana',
    'pricing.popularBadge': 'MÁS POPULAR',
    'pricing.saveQuarterly': 'Ahorra 16€',
    'pricing.biannualPrice': '5,00€',
    'pricing.biannualPer': '/mo',
    'pricing.biannualWeek': '1,15€/semana',
    'pricing.bestValueBadge': 'MEJOR VALOR',
    'pricing.saveBiannual': 'Ahorra 39€',
    'pricing.switchesTo': 'Cambia al plan de 6 meses',
    'pricing.families': '🌍 Más de 130 familias ya utilizan Time To Talk',
    'pricing.monthlyLabel': 'Mensual',
    'pricing.buyNowCta': 'Obtenga acceso completo',
    'pricing.cancelBeforeDay30': 'Cancela cuando quieras en Perfil y luego Suscripción.',
    'pricing.dueTodayLabel': 'vence hoy',
    'pricing.thenPerDayBilled': 'luego {día}/día, facturado {facturado}/mes',
    'pricing.reassureTitle': 'No pagas nada hoy',
    'pricing.reassureTodayLabel': 'hoy',
    'pricing.reassureAfterDesc': 'Solo {día}/día si te quedas, cancela en cualquier momento',
    'pricing.reassureCheap': 'Eso es menos de un café al mes.',
    'pricing.reassureCta': 'ver mi plan',
    'pricing.secureCheckoutStripe': 'Pago seguro a través de Stripe.',
    'pricing.offerPercentBadge': '{percent}% de descuento',
    'pricing.breakoutReminderCta': 'Muéstrame cómo',
    'pricing.founderName': 'Gintaras, fundador',
    'pricing.founderHeadline': '¿Quieres una oferta personal?',
    'pricing.founderBody': 'Llamada rápida de 10 minutos: obtenga más información, obtenga ayuda y tal vez comparta ideas que convertiré en nuevas funciones para usted.',
    'pricing.teacherHeadline': 'Configure Time to Talk para sus estudiantes.',
    'pricing.teacherSub': 'Acceso completo a los 3 modos para su salón de clases. Cancela cuando quieras.',
    'pricing.teacherFeature1': 'Úselo con cada estudiante que apoye',
    'pricing.teacherFeature2': 'Lituano e inglés, voz integrada.',
    'pricing.teacherFeature3': 'Una llamada de configuración gratuita para adaptarlo a su clase',
    'pricing.teacherFounderHeadline': 'Déjame configurarlo contigo',
    'pricing.teacherFounderBody': 'Llamada rápida de 15 minutos: te ayudaré a configurar Time to Talk para tus alumnos y responderé cualquier cosa que necesites.',
    'pricing.founderCtaPrimary': 'Reserva una llamada con Gintaras',
    'pricing.founderSkip': 'Continuar sin llamar',
    'pricing.day27': 'Día 27',
    'pricing.day27Desc': 'Le enviamos un correo electrónico de recordatorio.',
    'pricing.noActiveSubscription': 'No se encontró ninguna suscripción activa. Si acaba de pagar, espere unos minutos.',
    'pricing.errorCheckingSubscription': 'Error al comprobar la suscripción. Por favor inténtalo de nuevo.',
    'pricing.checking': 'Comprobando...',
    'pricing.restorePurchase': 'Restaurar compra',
    'pricing.backToOnboarding': 'Volver a la incorporación',
    'pricing.somethingWentWrong': 'Algo salió mal. Por favor inténtalo de nuevo.',
    'pricing.promoErrorAlreadyAccount': 'El código de promoción {code} ya se utilizó en su cuenta. Suscríbete a continuación para continuar, la suscripción está a un toque de distancia.',
    'pricing.promoErrorAlreadyNetwork': 'El código de promoción {code} ya se ha utilizado en su red. Suscríbase a continuación, la suscripción está a un toque de distancia.',
    'pricing.promoErrorGeneric': 'No pudimos aplicar el código de promoción {code}. Suscríbete a continuación o inténtalo de nuevo más tarde.',
    'pricing.promoErrorDismiss': 'Lo tengo',
    'pricing.terms': 'Términos',
    'pricing.privacy': 'Privacidad',
    'success.badge': 'Eres premium',
    'success.title': 'Ya está todo listo.',
    'success.sub': 'Timo está listo para ayudar a su hijo a encontrar su voz.',
    'success.cta': 'vamos',
    'success.unlock1': 'Acceso completo desbloqueado, nada retenido',
    'success.unlock2': 'Chatea, vive y habla listo para explorar',
    'success.unlock3': 'Sincronizado en todos los teléfonos y tabletas',
    'success.footer': 'Todas las funciones Premium están activas en su cuenta.',
    'download.appInstalled': 'Aplicación instalada',
    'download.continuingOnboarding': 'Continuando con la incorporación...',
    'download.installApp': 'Instalar aplicación',
    'download.bestExperience': 'La mejor experiencia está en la aplicación instalada.',
    'download.apple': 'manzana',
    'download.iphoneIpad': 'iPhone/iPad',
    'download.android': 'androide',
    'download.chromeInstall': 'Instalación de Chrome',
    'download.appleInstall': 'instalación de Apple',
    'download.homeScreenQuality': 'La experiencia de mejor calidad es desde la pantalla de inicio.',
    'download.openSafari1': '1. Abra esta página en Safari.',
    'download.openSafari2': '2. En Safari, toque Compartir.',
    'download.openSafari3': '3. Toque Agregar a la pantalla de inicio y luego Agregar.',
    'download.copyLinkSafari': 'Copiar enlace para Safari',
    'download.linkCopiedSafari': 'Enlace copiado. Abre Safari y pega el enlace.',
    'download.copyFailed': 'La copia falló. Copie la URL manualmente y ábrala en Safari.',
    'download.tapShare1': 'Toca Compartir (cuadrado + flecha).',
    'download.tapShare2': 'Toque Agregar a la pantalla de inicio.',
    'download.tapShare3': 'Toque Agregar.',
    'download.openShareMenu': 'Abrir menú Compartir',
    'download.inAppBrowserHint': 'Si está en el navegador Instagram/Facebook, abra el menú y toque Abrir en Safari.',
    'download.androidInstall': 'instalación de Android',
    'download.androidStep1': 'Abra el menú de Chrome (⋮ en la esquina superior derecha)',
    'download.androidStep2': 'Toca "Agregar a la pantalla de inicio" o "Instalar aplicación".',
    'download.androidStep3': 'Toca "Instalar" para confirmar',
    'download.otherDeviceTitle': '¿Quieres la aplicación en otro dispositivo?',
    'download.otherDeviceBody': 'Abra un navegador en ese dispositivo, vaya a timohelps.com e inicie sesión con los mismos detalles.',
    'download.otherDeviceHelp': '¿Algún problema? Envíanos un mensaje a',
    'download.promptAutoOpen': 'El mensaje de instalación debería abrirse automáticamente.',
    'download.promptAutoOpenAndroid': 'En Android (Chrome), el cuadro de diálogo de instalación puede abrirse automáticamente.',
    'download.androidInstallOnlyNote': 'La instalación con un solo toque es para Android (Chrome).iPhone y iPad usan Agregar a la pantalla de inicio; consulte a continuación.',
    'download.iosInstallTitle': 'iPhone y iPad',
    'download.iosInstallHint': 'En Safari, toque Compartir y luego Agregar a la pantalla de inicio. Si no lo ve, primero toque Más en la hoja para compartir, luego Agregar a la pantalla de inicio y luego Agregar.',
    'download.downloadApp': 'Descargar aplicación',
    'download.promptNotOpen': 'El mensaje de instalación no se abrió. Abra el menú del navegador y toque "Instalar aplicación" o "Agregar a la pantalla de inicio".',
    'download.desktopHint': 'Para obtener mejores resultados, ábralo en iPhone/iPad/Android e instale la aplicación.',
    'download.backToLanding': 'Volver al sitio web',
    'download.continueWeb': 'Continuar en la web',
    'download.webUseEverything': 'Aún puedes usar todo en la web.',
    'download.windowsTitle': 'Windows y escritorio',
    'download.windowsHint': 'Haga clic en el icono de instalación en la barra de direcciones de su navegador (se recomienda Chrome o Edge).',
    'download.iosVideoSoon': 'Próximamente video guía',
    'download.continueSetup': 'Continuar con la configuración',
    'download.installedSuccess': 'Aplicación instalada correctamente',
    'landingPricing.oldPriceCurrency': '11,49€/mes',
    'landingPricing.oneMonth': '1 mes',
    'landingPricing.threeMonths': '3 meses',
    'landingPricing.sixMonths': '6 meses',
    'landingPricing.perMonth': '/mo',
    'landingPricing.week1': '1,50€/semana',
    'landingPricing.week3': '1,35€/semana',
    'landingPricing.week6': '1,15€/semana',
    'landingPricing.badgePopular': 'MÁS POPULAR',
    'landingPricing.badgeBest': 'MEJOR VALOR',
    'landingPricing.save16': 'Ahorra 16€',
    'landingPricing.save39': 'Ahorra 39€',
    'cookie.title': 'Cookies',
    'cookie.body': 'Utilizamos cookies para análisis (PostHog) y medición de anuncios (Meta). Nunca vendemos sus datos y la aplicación funciona completamente si la rechaza.',
    'cookie.accept': 'Aceptar',
    'cookie.decline': 'Rechazar',
    'cookie.learnMore': 'Política de privacidad',
    'referral.pageTitle': 'Invita a amigos, gana meses gratis',
    'referral.pageSubtitle': 'Comparte Timo Helps. Cuando un amigo paga su primer mes, tú consigues uno gratis.',
    'referral.heroEarnedLabel': 'Has ganado',
    'referral.heroMonths': '{n} meses',
    'referral.heroOneMonth': '1 mes',
    'referral.heroNoMonths': '0 meses',
    'referral.heroFromConversions': 'de {n} invitaciones',
    'referral.heroFromOneConversion': 'de 1 invitación',
    'referral.heroFromZero': 'aún no hay invitaciones',
    'referral.heroCapUsed': '{used} de {total} del límite anual usado',
    'referral.heroFirstTime': 'Comparte tu enlace y gana tu primer mes gratis.',
    'referral.codeLabel': 'Tu código',
    'referral.linkLabel': 'Tu enlace',
    'referral.copy': 'Copiar enlace',
    'referral.copied': '¡Copiado!',
    'referral.share': 'Compartir',
    'referral.shareNative': 'Compartir',
    'referral.shareWhatsapp': 'WhatsApp',
    'referral.shareMessenger': 'Messenger',
    'referral.shareEmail': 'Correo electrónico',
    'referral.shareSms': 'SMS',
    'referral.shareMessage': 'Uso Timo Helps para ayudar a mi hijo a practicar el habla. Échale un vistazo: {link}',
    'referral.shareEmailSubject': 'Prueba Timo Helps conmigo',
    'referral.howTitle': 'Cómo funciona',
    'referral.howStep1': 'Envía tu enlace a un amigo.',
    'referral.howStep2': 'Se suscriben con tu enlace.',
    'referral.howStep3': 'Cuando pagan su primer mes, obtienes 1 mes gratis, automáticamente.',
    'referral.rules': 'Una recompensa por amigo. Hasta 12 meses gratis al año. Las autorreferencias y las cuentas compartidas no serán recompensadas.',
    'referral.errorLoad': 'No se pudo cargar tu información de referencia. Por favor actualice.',
    'referral.capReached': 'Has alcanzado el límite de 12 meses gratis de este año. Gracias por compartir.',
    'referral.bannerInvited': 'Invitado por un amigo. Bienvenido a Timo Helps.',
    'referral.bannerInvitedShort': 'Invitado por un amigo.',
    'referral.announceTitle': 'Nuevo: Obtén 1 mes gratis',
    'referral.announceBody': 'Invita a un amigo a Time To Talk. Cuando pagan su primer mes, obtienes uno gratis.',
    'referral.announceCta': 'Ver cómo funciona',
    'referral.announceLater': 'Quizás más tarde',
    'referral.youGetLabel': 'Tú consigues',
    'referral.youGetReward': '1 mes gratis',
    'referral.friendGetsLabel': 'Tu amigo consigue',
    'referral.friendGetsReward': 'Acceso completo desde el primer día',
    'referral.linkOnlyNote': 'Solo este enlace exacto acredita tu recompensa. Compartir el código por sí solo no funcionará.',

    // --- Native iOS port (WS-2 auth, WS-3 purchases, WS-4 speech, WS-5 media,
    //     WS-6 install, WS-7 AI consent and content reporting). Merged from
    //     src/native/_i18n/*.strings.json. Additive: no existing key was changed.
    'native.auth.browserUnavailable': 'No se pudo abrir la ventana de inicio de sesión. Inténtelo de nuevo.',
    'native.auth.oauthCancelled': 'Se canceló el inicio de sesión.',
    'native.auth.oauthFailed': 'No se completó el inicio de sesión. Inténtelo de nuevo.',
    'native.auth.passwordResetOpensBrowser': 'El restablecimiento de la contraseña abre una página segura en el navegador. Cambie allí su contraseña y vuelva aquí para iniciar sesión con la nueva.',
    'native.auth.sessionFailed': 'No pudimos completar su inicio de sesión. Inténtelo de nuevo.',
    'native.consent.agree': 'Acepto',
    'native.consent.contact': '¿Tienes dudas? Escríbenos:',
    'native.consent.declinedAgree': 'He cambiado de idea, acepto',
    'native.consent.declinedBody': 'Sin esto, Timo no puede escuchar ni responder. Puedes seguir usando las imágenes, los guiones guardados y todos los ajustes. Cuando quieras, actívalo en Ajustes, en Privacidad.',
    'native.consent.declinedContinue': 'Continuar sin la voz de Timo',
    'native.consent.declinedTitle': 'Timo se quedará en silencio por ahora',
    'native.consent.forLabel': 'Para:',
    'native.consent.getsLabel': 'Recibe:',
    'native.consent.intro': 'Timo utiliza algunas empresas externas: convierten el habla en texto, escriben sus respuestas y las dicen en voz alta. Eso significa que parte de lo que dices y escribes se envía a ellas. Aquí tienes exactamente quiénes son y qué recibe cada una.',
    'native.consent.notNow': 'Ahora no',
    'native.consent.privacyLink': 'Leer la política de privacidad',
    'native.consent.proc.anthropic.purpose': 'Escribir las respuestas de Timo',
    'native.consent.proc.anthropic.receives': 'Tu conversación con Timo, en texto',
    'native.consent.proc.deepgram.purpose': 'Convertir el habla en texto',
    'native.consent.proc.deepgram.receives': 'Tu voz mientras el micrófono está encendido',
    'native.consent.proc.elevenlabs.purpose': 'Convertir ese texto en la voz de Timo',
    'native.consent.proc.elevenlabs.receives': 'El texto que Timo va a decir',
    'native.consent.proc.google.purpose': 'Escribir las respuestas de Timo cuando Google está activo',
    'native.consent.proc.google.receives': 'Tu conversación con Timo, en texto',
    'native.consent.proc.openai.purpose': 'Revisar la gramática lituana',
    'native.consent.proc.openai.receives': 'Las respuestas de Timo en lituano, en texto',
    'native.consent.promise': 'No vendemos tus datos y no los usamos para publicidad. Puedes desactivar esto cuando quieras en Ajustes. Si lo desactivas, Timo no podrá escuchar ni responder, y todo lo demás seguirá funcionando.',
    'native.consent.settings.agreedOn': 'Aceptaste el',
    'native.consent.settings.confirmBody': 'Timo dejará de escuchar y de responder. Todo lo demás seguirá funcionando y puedes volver a activarlo cuando quieras.',
    'native.consent.settings.confirmKeep': 'Dejarlo activado',
    'native.consent.settings.confirmTitle': '¿Desactivar esto?',
    'native.consent.settings.confirmTurnOff': 'Desactivar',
    'native.consent.settings.description': 'Permite que Timo envíe el habla y el texto de la conversación a las empresas de la lista para poder escuchar, responder y hablar.',
    'native.consent.settings.label': 'Compartir con servicios de IA',
    'native.consent.settings.offNote': 'Mientras esto esté desactivado, Timo no puede escuchar ni responder.',
    'native.consent.settings.section': 'Privacidad',
    'native.consent.settings.whoGetsWhat': 'Ver quién recibe qué',
    'native.consent.title': 'Antes de que Timo empiece a hablar',
    'native.install.alreadyInstalledBody': 'En este dispositivo ya estás usando la aplicación Timo, así que no hay nada que instalar.',
    'native.install.alreadyInstalledTitle': 'Ya tienes la aplicación',
    'native.install.otherDevices': '¿Quieres Timo en otro dispositivo? Inicia sesión allí con la misma cuenta y lo tendrás todo listo.',
    'native.manage.appleBilled': 'Apple gestiona esta suscripción. Puedes cancelarla o cambiar de plan en los ajustes de suscripciones de la App Store.',
    'native.manage.cta': 'Gestionar en la App Store',
    'native.manage.failed': 'No pudimos abrir tus suscripciones de la App Store. Abre Ajustes, toca tu nombre y elige Suscripciones.',
    'native.mic.backgroundStopped': 'La escucha se detuvo porque la app pasó a segundo plano. Toca para empezar de nuevo.',
    'native.mic.continueWithoutMic': 'Continuar sin micrófono',
    'native.mic.deniedBody': 'El iPhone solo lo pregunta una vez. Abre los ajustes y activa el micrófono para Timo.',
    'native.mic.deniedTitle': 'El micrófono está desactivado',
    'native.mic.openSettings': 'Abrir ajustes',
    'native.mic.primerAllow': 'Permitir micrófono',
    'native.mic.primerBody': 'Para que Timo escuche lo que dijo la otra persona y te ayude a responder.',
    'native.mic.primerNotNow': 'Ahora no',
    'native.mic.primerPoint1': 'Tu voz solo se usa para convertir el habla en texto.',
    'native.mic.primerPoint2': 'Solo se graba durante un turno, nunca en segundo plano.',
    'native.mic.primerPoint3': 'Puedes volver a apagar el micrófono en los ajustes.',
    'native.mic.primerTitle': 'Timo necesita tu micrófono',
    'native.mic.unavailableBody': 'Este dispositivo no tiene un micrófono que Timo pueda usar.',
    'native.mic.unavailableTitle': 'No se encontró micrófono',
    'native.minors.affirmation': 'Al tocar «Acepto» confirmas que eres madre, padre o tutor, o que tienes 16 años o más.',
    'native.minors.ageNote': 'En la mayor parte de Europa, una madre, un padre o un tutor tiene que dar el consentimiento por cualquier menor de 16 años. En Lituania esa edad es de 14 años y en Estados Unidos es de 13.',
    'native.minors.askGrownUp': 'Pide a tu madre, padre o tutor que mire esto contigo y toque «Acepto» por ti.',
    'native.minors.underAgeLink': 'Tengo menos de 16',
    'native.personalVoice.allow': 'Permitir Voz personal',
    'native.personalVoice.denied': 'Timo no tiene permiso para usar tu Voz personal. Activa Permitir que las apps lo soliciten en Ajustes, Accesibilidad, Voz personal.',
    'native.personalVoice.description': 'Si has grabado una Voz personal en este iPhone o iPad, Timo puede hablar con ella. La voz se crea en el dispositivo, se queda en él y nunca se envía a ningún sitio.',
    'native.personalVoice.languageUnavailable': 'Apple ofrece la Voz personal solo en inglés, español y chino, así que todavía no puede hablar este idioma.',
    'native.personalVoice.none': 'Todavía no se ha grabado ninguna Voz personal en este dispositivo. Puedes crear una en Ajustes, Accesibilidad, Voz personal.',
    'native.personalVoice.ready': 'La Voz personal está lista. Elígela en la lista de voces.',
    'native.personalVoice.speaking': 'Hablando con tu Voz personal',
    'native.personalVoice.title': 'Usar una Voz personal',
    'native.personalVoice.unsupportedDevice': 'Este dispositivo no puede crear una Voz personal. Hace falta un iPhone o iPad más nuevo.',
    'native.purchase.alreadyOwned': 'Ya tienes este plan. Toca «Restaurar compra» para recuperar tu acceso.',
    'native.purchase.failed': 'No pudimos completar la compra. Inténtalo de nuevo o escríbenos y lo resolvemos.',
    'native.purchase.network': 'Sin conexión con la App Store. Comprueba tu conexión a internet e inténtalo de nuevo.',
    'native.purchase.notAllowed': 'Este dispositivo no permite compras. Revisa las restricciones de Tiempo de uso en Ajustes.',
    'native.purchase.pending': 'Tu compra está esperando aprobación. En cuanto se apruebe, tu acceso se abrirá automáticamente.',
    'native.purchase.signInFirst': 'Inicia sesión primero para que la suscripción quede vinculada a tu cuenta.',
    'native.purchase.unavailable': 'La App Store no está disponible ahora mismo. Inténtalo de nuevo en unos minutos.',
    'native.report.body': 'Gracias por avisarnos. Las respuestas de Timo las escribe un ordenador, así que a veces se equivoca. Cuéntanos qué ha pasado y una persona lo leerá.',
    'native.report.cancel': 'Cancelar',
    'native.report.done': 'Hecho',
    'native.report.error': 'No se ha podido enviar. Comprueba la conexión e inténtalo de nuevo.',
    'native.report.noteLabel': '¿Quieres añadir algo? (opcional)',
    'native.report.reason.language': 'Estaba en el idioma equivocado',
    'native.report.reason.other': 'Otra cosa',
    'native.report.reason.unkind': 'Fue grosero o hiriente',
    'native.report.reason.unsafe': 'No era seguro para un niño',
    'native.report.reason.wrong': 'Fue incorrecto o confuso',
    'native.report.safetyNote': 'Si alguien está en peligro ahora mismo, llama a los servicios de emergencia.',
    'native.report.send': 'Enviar informe',
    'native.report.sending': 'Enviando...',
    'native.report.sentBody': 'Una persona lee todos los informes. Si quieres una respuesta, escríbenos:',
    'native.report.sentTitle': 'Informe enviado. Gracias.',
    'native.report.stopConversation': 'Terminar también esta conversación',
    'native.report.title': 'Informar sobre esta respuesta',
    'native.report.trigger': 'Informar sobre esta respuesta',
    'native.restore.restored': 'Tu acceso ha vuelto. ¡Bienvenido de nuevo!',
    'native.speech.interrupted': 'La escucha se detuvo por una llamada u otro sonido. Toca para empezar de nuevo.',
    'native.speech.languageNotSupported': 'Este iPhone no reconoce este idioma por su cuenta, así que Timo escucha como siempre.',
    'native.speech.onDevice': 'Tu voz se queda en este dispositivo',
    'native.speech.permissionNeeded': 'Timo necesita el micrófono y el reconocimiento de voz para oírte. Puedes activarlos en Ajustes.',
    'native.voice.preview': 'Escuchar esta voz',
    'native.voice.systemVoices': 'Voces en este dispositivo',
    'native.voice.title': 'La voz de Timo',
    'pushToTalk.micBackgroundTitle': 'La escucha se detuvo',
    'pushToTalk.micBlockedBody': 'El micrófono está bloqueado, así que no se grabó nada. Permite el micrófono o escribe lo que dijeron.',
    'pushToTalk.micBlockedTitle': 'Timo no puede oír',
    'pushToTalk.micNotNowBody': 'Puedes activar el micrófono cuando quieras. Por ahora, escribe lo que dijeron.',
    'pushToTalk.micNotNowTitle': 'El micrófono está apagado',
    'pushToTalk.micProblemBody': 'La escucha se detuvo de forma inesperada, así que no se grabó nada. Inténtalo de nuevo o escribe lo que dijeron.',
    'pushToTalk.micProblemTitle': 'La escucha se detuvo',
    'pushToTalk.micUnavailableBody': 'Este dispositivo no tiene un micrófono que Timo pueda usar. Puedes escribir lo que dijeron.',
    'pushToTalk.micUnavailableTitle': 'No se encontró micrófono',
    'pushToTalk.micUnsupportedBody': 'El reconocimiento de voz no está disponible aquí, así que no se grabó nada. Puedes escribir lo que dijeron.',
    'pushToTalk.micUnsupportedTitle': 'Este navegador no puede escuchar',
    'settings.microphone.checkDesc': 'Comprueba si Timo te oye y arréglalo si no',
    'settings.microphone.checkLabel': 'Comprobar el acceso al micrófono',
    'settings.microphone.denied': 'El micrófono está bloqueado. Abre los ajustes para permitirlo.',
    'settings.microphone.granted': 'El micrófono funciona',
    'settings.microphone.title': 'Micrófono',
    'settings.microphone.unavailable': 'No se encontró ningún micrófono en este dispositivo',

    // --- merged from src/native/_i18n: WS-C, WS-F, PRIVACY ---
    // WS-C
    'chat.ariaGoBack': 'Volver',
    'chat.ariaInputMode': 'Modo de entrada',
    'chat.ariaInputModeSpeak': 'Hablar',
    'chat.ariaInputModeType': 'Escribir',
    'chat.ariaPlayAloud': 'Leer en voz alta',
    'chat.ariaSendMessage': 'Enviar mensaje',
    'chat.ariaRecordMe': 'Grabar mi voz',
    'chat.ariaRecordOther': 'Grabar a la otra persona',
    'live.ariaFlipSpeakers': 'Intercambiar los hablantes',
    'live.ariaClearConversation': 'Borrar la conversación',
    'live.ariaCalibrationSettings': 'Ajustes de calibración',
    'live.ariaClose': 'Cerrar',
    'live.whatShouldISay': '¿Qué puedo decir?',
    'live.manageScriptsHint': 'Puedes gestionar tus textos guardados en la sección Textos.',
    'live.safetyTitle': 'Aviso de seguridad',
    'live.safetyBody': 'Puede que esta conversación no sea segura. Si te sientes amenazado, márchate enseguida.',
    'quickChoice.send': 'Enviar',
    'quickChoice.tellMeMorePlaceholder': 'Cuéntame más...',
    // WS-F
    'common.closeAria': 'Cerrar',
    'common.goBackAria': 'Volver',
    // PRIVACY
    'privacy.minors.heading': '5. Menores, niños y consentimiento de los padres',
    'privacy.minors.s1.heading': '5.1 Para quién es esta aplicación y de quién es la cuenta',
    'privacy.minors.s1.p1': 'Time To Talk (la aplicación Timo) está hecha para niños con retraso del habla, para niños y adultos autistas y para cualquiera a quien le cueste hablar. Muchos de nuestros usuarios son niños.',
    'privacy.minors.s1.p2': 'La cuenta pertenece a un adulto: madre, padre, tutor, cuidador, terapeuta o docente. Ese adulto crea la cuenta, tiene el acceso y paga la suscripción. El niño no se registra por su cuenta.',
    'privacy.minors.s1.p3': 'Pero quien usa la aplicación es el niño. Cuando la usa, la aplicación recibe lo que escribe y, mientras el micrófono está encendido, lo que dice. Preferimos decirlo con claridad antes que afirmar que nunca recibimos nada de un niño.',
    'privacy.minors.s2.heading': '5.2 A partir de qué edad debe consentir un padre, madre o tutor',
    'privacy.minors.s2.intro': 'Si la persona que usa la aplicación es menor de la edad indicada para tu país, un padre, madre, tutor o cuidador debe dar su consentimiento antes de usarla.',
    'privacy.minors.s2.col.where': 'Dónde estás',
    'privacy.minors.s2.col.age': 'Un padre, madre o tutor debe consentir por menores de',
    'privacy.minors.s2.col.rule': 'La norma que lo establece',
    'privacy.minors.s2.lt.where': 'Lituania',
    'privacy.minors.s2.lt.age': '14',
    'privacy.minors.s2.lt.rule': 'Artículo 8 del RGPD, con la edad fijada por la ley lituana',
    'privacy.minors.s2.us.where': 'Estados Unidos',
    'privacy.minors.s2.us.age': '13',
    'privacy.minors.s2.us.rule': 'COPPA, la ley estadounidense de protección de la privacidad infantil en línea',
    'privacy.minors.s2.eu.where': 'Resto de la UE y del EEE',
    'privacy.minors.s2.eu.age': '16, salvo que tu país haya fijado una edad menor, que nunca puede ser inferior a 13',
    'privacy.minors.s2.eu.rule': 'Artículo 8 del RGPD',
    'privacy.minors.s2.world.where': 'En el resto del mundo',
    'privacy.minors.s2.world.age': '16',
    'privacy.minors.s2.world.rule': 'Nuestro propio criterio, que aplicamos en todo el mundo',
    'privacy.minors.s2.p1': 'Lituania es nuestro país de origen y nuestro mercado principal. Allí la edad es 14 años.',
    'privacy.minors.s2.p2': 'Antes de enviar cualquier conversación a las empresas del punto 5.4, la aplicación muestra una pantalla que nombra a cada una de ellas y te pide tu consentimiento. La frase encima del botón "Acepto" te pide confirmar que eres madre, padre, tutor o cuidador, o que tienes 16 años o más. Si un niño toca "Tengo menos de 16", no pasa nada malo y nadie le regaña: la aplicación simplemente le pide que llame a una persona adulta. Puedes retirar ese consentimiento más tarde en Ajustes, en Privacidad.',
    'privacy.minors.s2.p3': 'Nunca preguntamos la fecha de nacimiento. Preguntarla significaría recoger más datos sobre un niño, que es justo lo contrario de lo que busca esta sección.',
    'privacy.minors.s3.heading': '5.3 Qué recogemos cuando un niño usa la aplicación',
    'privacy.minors.s3.intro': 'Tres cosas:',
    'privacy.minors.s3.email': 'Una dirección de correo, una sola vez, al registrarse. Es la del adulto titular de la cuenta. Nunca pedimos a un niño una dirección propia.',
    'privacy.minors.s3.text': 'El texto de la conversación. Lo que se escribe o se dice a Timo y lo que Timo responde. Las conversaciones de práctica se guardan en la cuenta para poder abrirlas después en Historial. Allí se puede borrar cada una.',
    'privacy.minors.s3.voice': 'La voz, solo mientras el micrófono está encendido. El audio va del dispositivo directamente a Deepgram, que lo convierte en texto. No guardamos grabaciones de voz en nuestros servidores. El micrófono está apagado hasta que tú lo enciendes.',
    'privacy.minors.s3.p2': 'No pedimos a un niño su nombre real, su dirección, su teléfono, su colegio, una foto, su edad ni un diagnóstico. Nada en la aplicación lo exige. Si algo de eso se escribe en una conversación, se guarda con ella y puedes borrarlo en Historial.',
    'privacy.minors.s4.heading': '5.4 Las empresas que reciben estos datos',
    'privacy.minors.s4.intro': 'Timo no puede escuchar, responder ni hablar sin ayuda de empresas externas. Estas cinco ven el contenido de la conversación. Es la misma lista que la aplicación te muestra antes de que aceptes.',
    'privacy.minors.s4.col.company': 'Empresa',
    'privacy.minors.s4.col.receives': 'Qué recibe',
    'privacy.minors.s4.col.purpose': 'Para qué',
    'privacy.minors.s4.anthropic.receives': 'Tu conversación con Timo, en texto',
    'privacy.minors.s4.anthropic.purpose': 'Escribir las respuestas de Timo',
    'privacy.minors.s4.google.receives': 'Tu conversación con Timo, en texto',
    'privacy.minors.s4.google.purpose': 'Escribir las respuestas de Timo cuando Google está activo',
    'privacy.minors.s4.openai.receives': 'Las respuestas de Timo en lituano, en texto',
    'privacy.minors.s4.openai.purpose': 'Revisar la gramática lituana',
    'privacy.minors.s4.deepgram.receives': 'Tu voz mientras el micrófono está encendido',
    'privacy.minors.s4.deepgram.purpose': 'Convertir el habla en texto',
    'privacy.minors.s4.elevenlabs.receives': 'El texto que Timo va a decir',
    'privacy.minors.s4.elevenlabs.purpose': 'Convertir ese texto en la voz de Timo',
    'privacy.minors.s4.note': 'Google recibe el texto de la conversación solo cuando Google es el proveedor de modelo activo. OpenAI se usa solo para el lituano, para corregir la gramática de una respuesta que Timo ya ha escrito. Deepgram también se usa como voz de reserva en algunos idiomas, y entonces recibe el texto que Timo va a decir.',
    'privacy.minors.s4.others': 'Las demás empresas con las que trabajamos, listadas en la Sección 7, se ocupan de la cuenta, el pago, el correo y la analítica, no de la conversación en sí.',
    'privacy.minors.s4.noPermission': 'Ninguna de estas empresas puede usar los datos de un niño para su propia publicidad ni para entrenar sus propios modelos más allá de lo que indican sus políticas publicadas.',
    'privacy.minors.s5.heading': '5.5 Lo que nunca hacemos con los datos de un niño',
    'privacy.minors.s5.item1': 'Nunca los vendemos. A nadie, de ninguna forma y a ningún precio.',
    'privacy.minors.s5.item2': 'Nunca los usamos para publicidad y nunca creamos perfiles publicitarios de niños.',
    'privacy.minors.s5.item3': 'Nunca los usamos para entrenar modelos de IA, ni los nuestros ni los de nadie.',
    'privacy.minors.s5.item4': 'Nunca los usamos para crear perfiles conductuales, psicológicos, clínicos o educativos de un niño.',
    'privacy.minors.s5.item5': 'Nunca los publicamos y nunca los mostramos a otros usuarios.',
    'privacy.minors.s5.pixel': 'Nuestro sitio público y las páginas de la aplicación llevan la etiqueta de medición publicitaria de Meta descrita en la Sección 12. Cuenta visitas y registros para saber qué anuncios funcionan. Nunca recibe el contenido de las conversaciones, la voz ni lo que escribe un niño.',
    'privacy.minors.s6.heading': '5.6 Qué puede pedir un padre, madre o tutor',
    'privacy.minors.s6.intro': 'En cualquier momento puedes:',
    'privacy.minors.s6.see': 'Verlos. Pedir una copia de todo lo que guardamos sobre la cuenta.',
    'privacy.minors.s6.correct': 'Corregirlos. Pedirnos que arreglemos lo que esté mal.',
    'privacy.minors.s6.delete': 'Borrarlos. Borrar conversaciones una a una en Historial o borrar toda la cuenta.',
    'privacy.minors.s6.withdraw': 'Retirar tu consentimiento. Retira el consentimiento de IA en Ajustes, en Privacidad. Timo dejará de escuchar y de responder. Las imágenes, los guiones guardados y todos los ajustes siguen funcionando. Retirarlo no anula el tratamiento que ya se hizo de forma lícita.',
    'privacy.minors.s6.deleteHeading': 'Borrar la cuenta. En Ajustes hay un botón para borrar la cuenta. Cuando lo usas:',
    'privacy.minors.s6.step1': 'Primero cancelamos todas tus suscripciones abiertas en Stripe, para que no se te vuelva a cobrar.',
    'privacy.minors.s6.step2': 'Si alguna de esas cancelaciones falla, nos detenemos y tu cuenta no se borra. Verás un error que te pide que nos escribas, y lo terminaremos a mano. Es mejor dejarte con acceso que dejarte pagando por una cuenta a la que ya no puedes entrar.',
    'privacy.minors.s6.step3': 'Si la cancelación funciona, borramos tu acceso y el registro de la cuenta de nuestro sistema de autenticación: la dirección de correo, la contraseña y los ajustes y consentimientos guardados con ella.',
    'privacy.minors.s6.step4': 'Marcamos tu registro de suscripción como cancelado y guardamos un pequeño registro de borrado: la dirección de correo, la fecha y la referencia de la suscripción cancelada. Existe para poder demostrar cuándo se borró la cuenta y que dejaron de cobrarte.',
    'privacy.minors.s6.step5': 'Los registros de pago y las facturas se quedan en Stripe el tiempo que exige la ley contable lituana, es decir diez años. Consulta la Sección 9. No podemos borrarlos antes.',
    'privacy.minors.s6.after': 'Si quieres que borremos algo más a lo que el botón no llega, escríbenos y lo haremos a mano.',
    'privacy.minors.s7.heading': '5.7 Cómo contactarnos sobre los datos de un niño',
    'privacy.minors.s7.p1': 'Escribe a info@timetotalk.lt. Pon "Solicitud sobre datos de un menor" en el asunto e indícanos la dirección de correo de la cuenta.',
    'privacy.minors.s7.p2': 'Respondemos a todas las solicitudes. Confirmaremos la tuya en 5 días laborables y la completaremos en 30 días, que es el plazo que fija el RGPD. Si una solicitud es complicada y necesitamos más tiempo, te lo diremos antes de que se cumplan los 30 días y te explicaremos por qué. Puede que primero tengamos que comprobar que eres el titular de la cuenta, porque entregar los datos de un niño a la persona equivocada sería un fallo mucho peor que una respuesta lenta.',
    'privacy.minors.s7.p3': 'También puedes reclamar ante la Inspección Estatal de Protección de Datos de Lituania (Valstybine duomenu apsaugos inspekcija) en vdai.lrv.lt o ada@ada.lt, o ante la autoridad de protección de datos de tu país del EEE.',
    'privacy.minors.s8.heading': '5.8 Cuánto tiempo conservamos los datos de un niño',
    'privacy.minors.s8.intro': 'La Sección 9 indica el plazo de conservación de cada categoría de datos. En resumen:',
    'privacy.minors.s8.voice': 'La voz: no la guardamos en absoluto.',
    'privacy.minors.s8.conversations': 'Las conversaciones: se guardan en la cuenta hasta que las borras en Historial o borras la cuenta.',
    'privacy.minors.s8.account': 'Los datos de la cuenta, incluida la dirección de correo: como se indica en la Sección 9.',
    'privacy.minors.s8.p2': 'Si crees que un niño se ha registrado sin que lo sepa su padre, madre o tutor, escribe a info@timetotalk.lt. Una vez verificada la solicitud, borraremos la cuenta y sus datos de inmediato.',
  },
  fr: {
    // daily-words
    "dailyWords.row": "Mots à apprendre",
    "dailyWords.rowHint": "Les mots que votre enfant apprend chaque jour",
    "dailyWords.title": "Mots à apprendre",
    "dailyWords.intro": "Saisissez les mots que votre enfant apprend en ce moment. Timo en montre un chaque jour et demande à l'enfant de le dire.",
    "dailyWords.close": "Fermer",
    "dailyWords.modeTitle": "Quels mots Timo montre",
    "dailyWords.modeMine": "Seulement mes mots",
    "dailyWords.modeMineHint": "Un de vos mots chaque jour, dans l'ordre de la liste.",
    "dailyWords.modeMix": "Mes mots et ceux de Timo",
    "dailyWords.modeMixHint": "Un jour votre mot, le lendemain un mot de Timo.",
    "dailyWords.today": "Mot du jour : {word}",
    "dailyWords.todayBadge": "Aujourd'hui",
    "dailyWords.add": "Ajouter un mot",
    "dailyWords.inputLabel": "Mot",
    "dailyWords.placeholder": "Par exemple : pomme",
    "dailyWords.pictureTitle": "Image (facultatif)",
    "dailyWords.noPicture": "Sans image",
    "dailyWords.photo": "Photo",
    "dailyWords.removePhoto": "Retirer la photo",
    "dailyWords.listTitle": "Vos mots",
    "dailyWords.empty": "Pas encore de mots. Tant que la liste est vide, Timo montre ses propres mots.",
    "dailyWords.edit": "Modifier",
    "dailyWords.save": "Enregistrer",
    "dailyWords.cancel": "Annuler",
    "dailyWords.delete": "Supprimer",
    "dailyWords.deleteConfirm": "Supprimer « {word} » ?",
    "dailyWords.listen": "Écouter",
    "dailyWords.moveUp": "Monter",
    "dailyWords.moveDown": "Descendre",
    "dailyWords.saved": "Enregistré",
    "dailyWords.deviceOnly": "Les mots sont enregistrés sur cet appareil uniquement. Un autre téléphone ou une autre tablette ne les aura pas.",
    "dailyWords.errEmpty": "Saisissez d'abord un mot.",
    "dailyWords.errDuplicate": "Ce mot est déjà dans la liste.",
    "dailyWords.errFull": "La liste contient déjà {max} mots. Supprimez-en un pour en ajouter un nouveau.",
    "dailyWords.errSave": "Impossible d'enregistrer. La mémoire de l'appareil est peut-être pleine. Essayez sans photo.",
    "dailyWords.errImage": "Impossible d'ouvrir cette photo. Choisissez-en une autre.",
    // end daily-words
    'house.room.living': 'Salon',
    'house.room.talk': 'Salle du téléphone',
    'house.room.play': 'Salle de jeux',
    'house.room.study': 'Coin des devoirs',
    'house.hotspot.couch': 'Sauter sur le canapé',
    'house.hotspot.window': 'Regarder par la fenêtre',
    'house.hotspot.timo': 'Jouer avec Timo',
    'house.hotspot.pet': 'Jouer avec Timo',
    'house.hotspot.phone': 'Parler au téléphone',
    'house.hotspot.shelf': 'Ouvrir les cartes images',
    'house.hotspot.toybox': 'Ouvrir la boîte à jouets',
    'house.hotspot.desk': 'Le mot du jour',
    'house.parent.settings': 'Les grands',
    'house.parent.button': 'Les grands',
    'house.nav.rooms': 'Pièces',
    'house.nav.prev': 'Pièce précédente',
    'house.nav.next': 'Pièce suivante',
    'house.badge.stars': 'Étoiles gagnées',
    'house.hotspot.beanbag': 'Pouf',
    'house.hotspot.bookshelf': 'Étagère',
    'house.hotspot.curtain': 'Rideau',
    'house.hotspot.easel': 'Chevalet',
    'house.hotspot.lamp': 'Lampe',
    'house.hotspot.lights': 'Lumières',
    'house.hotspot.pinboard': 'Tableau',
    'house.hotspot.plant': 'Plante',
    'house.hotspot.playwindow': 'Fenêtre',
    'house.hotspot.rainbowrug': 'Tapis arc-en-ciel',
    'house.hotspot.rug': 'Tapis',
    'house.hotspot.stool': 'Tabouret',
    'house.map.title': 'Plan de la maison',
    'house.map.close': 'Fermer la carte',
    'house.map.here': 'Vous êtes ici',
    'house.map.go': 'Aller',
    'house.map.activity.talk': 'Parler',
    'house.map.activity.cards': 'Cartes',
    'house.map.activity.word': 'Mot',
    'house.a11y.roomOf': 'Pièce {n} sur {total}',
    'iab.title': 'Changez de navigateur',
    'iab.body': 'La connexion ne fonctionnera pas dans {source}.',
    'iab.openChrome': 'Ouvrir dans Chrome',
    'iab.openSafari': 'Ouvrir dans Safari',
    'iab.openBrowser': 'Ouvrir dans le navigateur',
    'iab.copyLink': 'Copier le lien',
    'iab.copied': 'Copié',
    'iab.hintIos': 'Ou touchez le menu ⋯ → Ouvrir dans Safari',
    'iab.hintAndroid': 'Ou touchez le menu ⋮ → Ouvrir dans le navigateur',
    'iab.hintOther': 'Ou collez le lien dans votre navigateur',
    'iab.iosCopyAndOpen': 'Copier le lien',
    'iab.iosLinkCopied': 'Lien copié. Ouvrez Safari ensuite.',
    'iab.iosStep1': 'Touchez le bouton de lien pour le copier.',
    'iab.iosStep2': 'Ouvrez Safari (appuyez longuement sur l\'indicateur d\'accueil ou balayez vers le haut).',
    'iab.iosStep3': 'Collez le lien dans la barre d\'adresse.',
    'iab.continueAnyway': 'Continuer ici',
    'obp.successTitle': 'Tout est prêt !',
    'obp.successBody': 'Vous êtes maintenant dans votre navigateur. Tout fonctionne ici, y compris la connexion.',
    'obp.successCta': 'Continuer',
    'streak.popupTitle': 'SÉRIE DE DISCUSSIONS QUOTIDIENNES AUGMENTÉE !',
    'streak.popupDayStreak': 'JOURS CONSÉCUTIFS',
    'streak.popupGreatStart': 'EXCELLENT DÉBUT !',
    'streak.popupOnFire': 'VOUS ÊTES EN FEU ! 🔥',
    'profile.viewStreakDetails': 'Voir la série',
    'newsletter.heroTitle': 'Time To Talk',
    'newsletter.heroSubtitle': 'Votre compagnon IA pour des conversations en toute confiance',
    'newsletter.description': 'Rejoignez notre newsletter pour être le premier à savoir quand notre application sera lancée. Obtenez un accès anticipé, des mises à jour exclusives et des conseils de communication utiles.',
    'newsletter.emailPlaceholder': 'Entrez votre adresse e-mail',
    'newsletter.subscribe': 'S\'abonner',
    'newsletter.subscribing': 'Abonnement en cours...',
    'newsletter.success': 'Merci de vous être abonné !',
    'newsletter.successMessage': 'Vérifiez vos e-mails pour confirmer votre abonnement.',
    'newsletter.error': 'Un problème est survenu. Veuillez réessayer.',
    'newsletter.emailInvalid': 'Veuillez entrer une adresse e-mail valide',
    'newsletter.emailRequired': 'L\'e-mail est requis',
    'newsletter.features.title': 'À quoi s\'attendre',
    'newsletter.features.earlyAccess': 'Accès anticipé',
    'newsletter.features.earlyAccessDesc': 'Soyez parmi les premiers à essayer notre application',
    'newsletter.features.updates': 'Mises à jour exclusives',
    'newsletter.features.updatesDesc': 'Recevez les dernières nouvelles et fonctionnalités',
    'newsletter.features.tips': 'Conseils de communication',
    'newsletter.features.tipsDesc': 'Guides et stratégies utiles',
    'newsletter.requestAccess': 'Demander l\'accès',
    'newsletter.requestAccessTitle': 'Demander l\'accès au site Web',
    'newsletter.requestAccessSuccess': 'Demande soumise ! Nous l\'examinerons et vous recontacterons.',
    'newsletter.name': 'Nom',
    'newsletter.namePlaceholder': 'Votre nom (facultatif)',
    'newsletter.reason': 'Raison',
    'newsletter.reasonPlaceholder': 'Pourquoi avez-vous besoin d\'accès ? (facultatif)',
    'newsletter.submitRequest': 'Soumettre la demande',
    'newsletter.submitting': 'Soumission...',
    'newsletter.beTheFirst': 'Soyez le premier',
    'newsletter.beTheFirstDesc': 'Obtenez un accès anticipé et des conseils de communication directement dans votre boîte de réception.',
    'newsletter.emailPlaceholderExample': 'votre@email.com',
    'newsletter.gettingAccess': 'Obtention de l\'accès...',
    'newsletter.getEarlyAccess': 'Obtenir un accès anticipé',
    'newsletter.noSpam': 'Pas de spam. Désabonnez-vous à tout moment.',
    'newsletter.thankYouJoining': 'Merci de nous avoir rejoints ! Nous vous tiendrons informé.',
    'newsletter.learnMoreBelow': 'En savoir plus ci-dessous',
    'newsletter.downloadApp': 'Télécharger l\'application',
    'newsletter.whyBuilding': 'Pourquoi nous construisons cela',
    'newsletter.whyBuildingDesc': 'Les situations sociales évoluent rapidement. Les bons mots ne viennent pas quand vous en avez besoin. Nous construisons cela parce que la communication ne devrait pas sembler impossible.',
    'newsletter.whoWeHelp': 'Qui nous aidons',
    'newsletter.whoWeHelpDesc': 'Les personnes socialement anxieuses, introverties, atteintes de TSA et quiconque souhaite essayer de parler et a besoin d\'aide.',
    'newsletter.whatWeDo': 'Ce que nous faisons',
    'newsletter.whatWeDoDesc': 'Application IA qui vous aide à comprendre les conversations et à répondre. Doucement, clairement, sans pression. Tout est sous forme de jeu pour rendre la pratique amusante.',
    'newsletter.nonVerbalSupport': 'Soutien non verbal',
    'newsletter.nonVerbalSupportDesc': 'Nous aidons les personnes non verbales et les parents d\'enfants non verbaux à communiquer. Notre mode Parler fournit des outils pour parler sans forcer la parole.',
    'newsletter.safe': 'Sûr',
    'newsletter.simple': 'Simple',
    'newsletter.supportive': 'Soutenant',
    'newsletter.reportBug': 'signaler un bug',
    'common.startVoice': 'Démarrer la saisie vocale',
    'common.stopRecording': 'Arrêter l\'enregistrement',
    'common.close': 'Fermer',
    'common.help': 'Aide',
    'common.back': 'Retour',
    'practice.pageTitle': 'S\'entraîner à discuter',
    'practice.greeting': 'Hé ! Prêt à discuter ?',
    'practice.thinking': 'Réflexion...',
    'practice.fallback': 'Compris !',
    'practice.end': 'Terminer',
    'practice.me': 'Moi',
    'practice.other': 'Autre',
    'practice.placeholder': 'Tapez quelque chose...',
    'practice.switchText': 'Passer au texte',
    'practice.switchVoice': 'Passer à la voix',
    'practice.errorTitle': 'Erreur',
    'practice.errorDesc': 'Échec de l\'obtention de la réponse',
    'home.goodMorning': 'Bonjour',
    'home.goodAfternoon': 'Bon après-midi',
    'home.goodEvening': 'Bonsoir',
    'home.needHelpTalking': 'Besoin d\'aide pour parler ?',
    'home.suggestWhatToSay': 'Je suggérerai quoi dire',
    'home.quickActions': 'Actions rapides',
    'home.nonVerbal': 'Parler',
    'home.history': 'Historique',
    'home.scripts': 'Scripts',
    'home.startTalking': 'Commencer à parler',
    'home.reportBug': 'Signaler un bug',
    'home.underConstruction': 'En construction',
    'home.stillBuilding': 'Encore en construction ! Certaines choses pourraient ne pas encore fonctionner.',
    'home.dontShowAgain': 'Ne plus afficher',
    'home.gotIt': 'Compris !',
    'home.howToUse': 'Comment utiliser',
    'home.settings': 'Paramètres',
    'home.talkModeBeta': 'Bêta',
    'home.talkModeUnderDevelopment': 'Actuellement en cours de développement',
    'home.talk': 'Parler',
    'home.show': 'Montrer',
    'home.breathing': 'Respiration',
    'home.greeting.morning': 'Bonjour !',
    'home.greeting.afternoon': 'Bon après-midi !',
    'home.greeting.evening': 'Bonsoir !',
    'home.timoHomeHint': 'Touchez-moi pour entrer !',
    'timo.home.title': 'Maison de Timo',
    'timo.home.back': 'Retour',
    'timo.home.close': 'Fermer',
    // teacher-first-run: the help screen and its door on the landing screen. English for now, translate later.
    "timo.home.helpButton": "How to use",
    "help.metaTitle": "How to use Timo",
    "help.title": "How to use Timo",
    "help.intro": "Five short steps. It takes a minute to read.",
    "help.back": "Back",
    "help.langLabel": "Language",
    "help.teacher.title": "For teachers and therapists",
    "help.teacher.body": "The app says \"your child\". If you are a teacher, that means your student. Everything works the same, even if you signed up as a parent.",
    // school-use
    "help.school.title": "At school, with a student",
    "help.school.point1": "Use one account on the school tablet. Sign in once and it stays signed in.",
    "help.school.point2": "Hand the tablet to the child on the Timo screen. The child talks to Timo or taps the cards.",
    "help.school.point3": "Everything for grown-ups sits behind the Grown-ups button at the top: settings, progress and the subscription.",
    "help.school.point4": "Type the child's name under Grown-ups > Progress and the child's name. Then the cards and Timo use the child's name, not yours.",
    "help.school.point5": "Got a code from the school or an event? Tap “I have a code” on the start page, the sign-in screen, the payment page or in Settings.",
    "help.step1.title": "Start in Timo's room",
    "help.step1.body": "After you log in, you always land here. This is the start screen, and everything is one tap away.",
    "help.step1.alt": "Timo's room on a phone",
    "help.step2.title": "Tap Timo and talk",
    "help.step2.body": "Tap Timo or the Talk button and allow the microphone. The child speaks, Timo answers out loud.",
    "help.step2.alt": "The Talk button at the bottom of the screen",
    "help.step3.title": "Pictures when talking is hard",
    "help.step3.body": "The Pictures button opens picture cards. The child taps a card and the app says it out loud. No microphone needed, so it still works when the mic does not.",
    "help.step3.alt": "Picture cards",
    "help.step4.title": "Word of the day",
    "help.step4.body": "Every day Timo picks one new word. Tap the word card and say it together with the child.",
    "help.step4.alt": "The word of the day card",
    "help.step5.title": "For grown-ups",
    "help.step5.body": "The Grown-ups button at the top opens settings: language, voice and subscription. This guide is always right next to it.",
    "help.step5.alt": "The How to use and Grown-ups buttons at the top of the screen",
    "help.cta": "Go to Timo",
    "help.contact": "Questions? Email info@timetotalk.lt",
    // The paywall a teacher meets: this label had no key anywhere, so every language showed "per day".
    "pricing.perDayLabel": "par jour",
    // Settings rows for what the hidden homes used to link: progress, profile, breathing.
    "settings.grownUps.title": "For grown-ups",
    "settings.grownUps.progress": "Progress and the child's name",
    "settings.grownUps.progressHint": "Words, streaks and the name Timo says",
    "settings.grownUps.profile": "Profile",
    "settings.grownUps.breathing": "Breathing exercise",
    "settings.grownUps.breathingHint": "Calm breathing together with the child",
    // Promo codes (MOKOMES and the rest): the landing confirmation and the banner on /timo.
    "promoGrant.accepted": "Code accepted: {days} free. Log in to activate it.",
    "promoGrant.acceptedUnlimited": "Code accepted: free unlimited access. Log in to activate it.",
    "promoGrant.continue": "Continue",
    "promoGrant.day.one": "day",
    "promoGrant.day.few": "days",
    "promoGrant.day.many": "days",
    "promoGrant.day.other": "days",
    "promoGrant.banner": "You have {days} of free access until {date}.",
    "promoGrant.bannerUnlimited": "You have free unlimited access.",
    "promoGrant.alreadyUsed": "The code {code} was already used, so it could not be activated again.",
    "promoGrant.close": "Close",
    // promo-codes-2: "I have a code" for signed-in people (/pricing, Settings) and the entry links. English for now.
    "promoCodes2.open": "I have a code",
    "promoCodes2.label": "Enter your code",
    "promoCodes2.submit": "Activate",
    "promoCodes2.checking": "Checking...",
    "promoCodes2.success": "Code accepted: {days} free, until {date}.",
    "promoCodes2.successUnlimited": "Code accepted: free unlimited access.",
    "promoCodes2.alreadyActive": "Your access is already active, no code needed.",
    "promoCodes2.err.empty": "Type the code first.",
    "promoCodes2.err.invalid": "That code does not exist. Check it and try again.",
    "promoCodes2.err.usedOnAccount": "This code was already used on your account.",
    "promoCodes2.err.usedOnNetwork": "This code was already used from this network. Email info@timetotalk.lt and we will help.",
    "promoCodes2.err.fullyClaimed": "This code has been fully claimed.",
    "promoCodes2.err.network": "Could not connect. Check the internet and try again.",
    "promoCodes2.err.error": "Could not activate the code. Try again.",
    'timo.home.dressTitle': 'Habiller Timo',
    'timo.home.foodTitle': 'Que veut Timo ?',
    'timo.home.action.feed': 'Nourrir',
    'timo.home.action.drink': 'Boire',
    'timo.home.action.sleep': 'Dormir',
    'timo.home.action.walk': 'Promener',
    'timo.home.action.potty': 'Pot',
    'timo.home.action.cheer': 'Encourager',
    'timo.home.action.dress': 'S\'habiller',
    'timo.home.sleep.notNight': 'Timo n\'a pas encore sommeil',
    'timo.home.outfit.default': 'Normal',
    'timo.home.outfit.beanie': 'Bonnet',
    'timo.home.outfit.panama': 'Panama',
    'timo.home.outfit.cool': 'Lunettes cool',
    'timo.home.outfit.ai': 'Futur Timo',
    'timo.home.outfit.yoga': 'Yoga Timo',
    'timo.home.food.apple': 'Pomme',
    'timo.home.food.banana': 'Banane',
    'timo.home.food.berries': 'Baies',
    'timo.home.food.bread': 'Pain',
    'timo.home.food.fish': 'Poisson',
    'timo.home.food.acorn': 'Gland',
    'timo.home.food.cheese': 'Fromage',
    'timo.home.food.cookie': 'Biscuit',
    'timo.talk.tapHint': 'Touche-moi pour parler !',
    'timo.talk.greeting': 'Salut ! Je suis Timo. De quoi veux-tu parler ?',
    'timo.talk.tapToTalk': 'Touche pour parler',
    'timo.talk.listening': "Je t'écoute",
    'timo.talk.tapWhenDone': 'Touche quand tu as fini',
    'timo.talk.thinking': 'Timo réfléchit',
    'timo.talk.speaking': 'Timo parle',
    'timo.talk.emptyReprompt': "Je t'écoute ! Raconte-moi quelque chose.",
    'timo.talk.llmErrorReply': "J'adore parler avec toi ! Quel est ton animal préféré ?",
    'timo.talk.micDenied': 'Timo a besoin de ton micro',
    'timo.talk.micDeniedHelp': "Demande à un adulte d'autoriser le micro dans les réglages du navigateur, puis touche à nouveau.",
    // mic-school-devices
    'mic.fail.blocked.title': 'The microphone is blocked',
    'mic.fail.blocked.body': 'Timo cannot hear because this browser is not allowed to use the microphone. Allow it, then tap Try again.',
    'mic.fail.blocked.again': 'Tapped Block before? The browser will not ask again on its own. Change it in the settings, then reload the page.',
    'mic.fail.steps.ios': 'iPad or iPhone: tap aA in the address bar, then Website Settings, then set Microphone to Allow. Or open Settings, then Safari, then Microphone, and choose Allow.',
    'mic.fail.steps.chromebook': 'Chromebook: click the icon left of the web address, turn Microphone on, then reload the page. If the switch is grey, the school has blocked it. Ask your IT admin.',
    'mic.fail.steps.android': 'Android: tap the icon left of the web address, then Permissions, then set Microphone to Allow. Reload the page.',
    'mic.fail.steps.desktop': 'Computer: click the icon left of the web address, set Microphone to Allow, then reload the page. If it still does not work, check the privacy settings of the computer.',
    'mic.fail.steps.native': 'In the Timo app: open your phone Settings, then Timo, and turn Microphone on. Come back and tap Try again.',
    'mic.fail.no_device.title': 'No microphone found',
    'mic.fail.no_device.body': 'This device has no working microphone. Plug in a microphone or a headset, then tap Try again.',
    'mic.fail.in_use.title': 'The microphone is busy',
    'mic.fail.in_use.body': 'Another app or tab is using the microphone. Close it, video calls too, then tap Try again.',
    'mic.fail.insecure_context.title': 'This link cannot use the microphone',
    'mic.fail.insecure_context.body': 'The page is not on a secure address, so the browser hides the microphone. Open the address that starts with https://.',
    'mic.fail.unsupported.title': 'This browser cannot use the microphone',
    'mic.fail.unsupported.body': 'Open Timo in Chrome or Safari to talk. You can use the picture cards now.',
    'mic.fail.in_app_browser.title': 'Open Timo in your browser',
    'mic.fail.in_app_browser.body': 'Instagram, Facebook and similar apps open links in their own window, and the microphone does not work there. Open this page in Chrome or Safari.',
    'mic.fail.inapp.ios': 'Tap the three dots (...) at the top, then choose to open in the browser.',
    'mic.fail.inapp.android': 'Tap the three dots in the corner, then choose Open in Chrome.',
    'mic.fail.offline.title': 'No internet',
    'mic.fail.offline.body': 'Timo needs the internet to hear. Connect to Wi-Fi or mobile data, then tap Try again.',
    'mic.fail.stt_unreachable.title': 'Timo cannot reach his listening service',
    'mic.fail.stt_unreachable.body': 'The microphone works, but the network is blocking the speech service. This often happens on school Wi-Fi. Tap Try again, or ask your IT admin to allow api.deepgram.com and time-to-talk.onrender.com.',
    'mic.fail.stt_service_error.title': 'The listening service is having trouble',
    'mic.fail.stt_service_error.body': 'The microphone and the internet work, but the speech service answered with an error. Wait a minute, then tap Try again.',
    'mic.fail.signed_out.title': 'Please sign in again',
    'mic.fail.signed_out.body': 'Your sign-in has run out, so Timo cannot listen. Sign in again, then tap Try again.',
    'mic.fail.unknown.title': 'Timo cannot hear right now',
    'mic.fail.unknown.body': 'Something stopped the microphone. Tap Try again. If it keeps happening, reload the page.',
    'mic.fail.retry': 'Try again',
    'mic.fail.tiles': 'Use picture cards',
    'mic.fail.openBrowser': 'Open in browser',
    'mic.fail.signIn': 'Sign in',
    'timo.talk.exit': 'Fini',
    'timo.word.title': 'Mot du jour',
    'timo.word.sayIt': 'Dis-le !',
    'timo.word.listening': "Je t'écoute",
    'timo.word.hearAgain': 'Écouter encore',
    'timo.word.tryAgain': 'On le dit ensemble ?',
    'timo.word.great': 'Bravo !',
    'timo.word.days': 'jours de suite',
    'timo.word.open': 'Mot du jour',
    'timo.word.close': 'Fermer',
    'timo.word.newWordSoon': 'Un nouveau mot demain !',
    'timo.talk.waiting': 'Timo réfléchit...',
    'timo.talk.youSaid': 'Tu as dit :',
    'timo.talk.voiceResting': 'La grande voix de Timo se repose, alors celle-ci ressemble à un robot.',
    'timo.teach.remember': 'Souviens-toi',
    'timo.teach.hearIt': 'Écoute',
    'timo.teach.gotIt': 'Compris !',
    'timo.reward.earned': 'Tu as gagné {amount} étoiles !',
    'timo.words.title': 'Mes mots',
    'timo.words.wordSingular': 'mot',
    'timo.words.wordPlural': 'mots',
    'timo.words.tapHint': "Touche un mot pour l'entendre",
    'timo.words.lockedHint': 'Dis ce mot avec Timo pour le débloquer',
    'timo.words.empty': 'Pas encore de mots',
    'timo.words.emptySub': 'Dis le mot du jour avec Timo pour commencer ta collection !',
    'timo.words.close': 'Fermer',
    'timo.words.locked': 'Pas encore',
    'timo.recap.title': "Aujourd'hui avec Timo",
    'timo.recap.wordsLead': "Les mots que votre enfant a dits aujourd'hui",
    'timo.recap.noWords': "Beaucoup de discussions joyeuses aujourd'hui",
    'timo.recap.turnsLabel': 'petites conversations',
    'timo.recap.streakLabel': "jours d'affilée",
    'timo.recap.minutesLabel': 'min ensemble',
    'timo.recap.tipLead': 'Astuce',
    'timo.recap.tip1': "Essayez de dire l'un de ces mots ensemble ce soir au dîner.",
    'timo.recap.tip2': "Chaque petite discussion compte. Quelques minutes par jour, ça s'additionne vite.",
    'timo.recap.tip3': "Demandez à votre enfant de vous apprendre ce que Timo a dit aujourd'hui.",
    'timo.recap.tip4': "Félicitez l'effort, pas seulement la réussite.",
    'timo.recap.dismiss': 'Fermer',
    'timo.recap.historyTitle': 'Cette semaine avec Timo',
    'timo.recap.historyEmpty': 'Pas encore de discussions. Touche Timo pour en commencer une !',
    'timo.talk.greetingNamed': 'Salut, {name} ! Je suis content de te voir !',
    'timo.talk.greetingWord': 'Salut ! Le mot du jour est {word}. Tu peux le dire ?',
    'timo.talk.greetingWordNamed': 'Salut, {name} ! Le mot du jour est {word}. Tu peux le dire ?',
    'timo.onboarding.intro': 'Salut ! Je suis Timo. Je suis ton ami.',
    'timo.onboarding.askName': "Comment tu t'appelles ?",
    'timo.onboarding.heard': "J'ai entendu {name} ?",
    'timo.onboarding.confirmYes': 'Oui !',
    'timo.onboarding.confirmNo': 'Encore',
    'timo.onboarding.retry': 'Oups ! Redis ton prénom.',
    'timo.onboarding.typeInstead': 'Écrire mon prénom',
    'timo.onboarding.namePlaceholder': 'Ton prénom',
    'timo.onboarding.save': 'Enregistrer',
    'timo.onboarding.skip': 'Plus tard',
    'timo.onboarding.welcome': 'Enchanté, {name} !',
    'timo.onboarding.micDenied': "Je ne t'entends pas. Tu peux écrire ton prénom.",
    // Timo tells a story: UI chrome only. The story prose itself lives in
    // src/copy/story.en.js under the story.* keys, not here.
    'timo.story.tapToStart': "Commencer l'histoire",
    'timo.story.listening': 'À toi',
    'timo.story.narrating': "Timo raconte l'histoire",
    'timo.story.close': 'Terminé',
    'timo.story.replay': 'Encore',
    'timo.story.finished': 'Fin',
    'timo.story.next': 'Suivant',
    'parent.title': 'Progression',
    'parent.backAria': "Retour à l'accueil",
    'parent.noKidName': 'Votre enfant',
    'parent.subtitle': 'Progression des exercices de langage',
    'parent.tierLabel': 'Niveau',
    'parent.statStreak': "Jours d'affilée",
    'parent.statWords': 'Mots appris',
    'parent.statStars': 'Étoiles gagnées',
    'parent.statDaysActive': 'Jours actifs',
    'parent.statDaysActiveHint': 'Les 30 derniers jours',
    'parent.statLongest': 'Plus longue série',
    'parent.statWordsWeek': 'Nouveaux mots cette semaine',
    'parent.calendarTitle': "Calendrier d'entraînement",
    'parent.calendarPrevAria': 'Mois précédent',
    'parent.calendarNextAria': 'Mois suivant',
    'parent.calendarLegendPracticed': 'Pratiqué',
    'parent.calendarLegendToday': "Aujourd'hui",
    'parent.calendarDayPracticed': 'pratiqué',
    'parent.calendarEmptyMonth': "Aucune séance enregistrée ce mois-ci pour l'instant.",
    'parent.timelineTitle': 'Les mots appris',
    'parent.timelineToday': "Aujourd'hui",
    'parent.timelineYesterday': 'Hier',
    'parent.timelineDaysAgo': 'il y a {n} jours',
    'parent.timelineEmptyTitle': 'Le parcours commence ici',
    'parent.timelineEmptyBody': 'Chaque mot que votre enfant apprend avec Timo apparaîtra ici. Même un mot par jour, cela avance vite.',
    'parent.timelineWordCount': '{n} mots',
    'parent.timelineWordCountOne': '1 mot',
    'parent.printLabel': 'Imprimer',
    'parent.printAria': 'Imprimer cette page',
    'parent.footerNote': 'La progression est enregistrée sur cet appareil et synchronisée avec votre compte.',
    'timo.recap.today': "Aujourd'hui",
    'timo.recap.yesterday': 'Hier',
    'breathing.prototypeNotice': 'Ceci est encore un prototype. Cela ne fonctionne pas encore comme prévu, nous l\'améliorons.',
    'scripts.myScripts': 'Mes scripts',
    'scripts.searchPlaceholder': 'Rechercher des scripts...',
    'scripts.usedTime': 'Joué 1 fois',
    'scripts.usedTimes': 'Joué {count} fois',
    'scripts.use': 'Utiliser',
    'scripts.listen': 'Écouter',
    'scripts.delete': 'Supprimer',
    'scripts.swipeToDelete': '← Balayer pour supprimer',
    'scripts.noScriptsYet': 'Pas encore de scripts',
    'scripts.savePhrasesDesc': 'Enregistrer des phrases pour les réutiliser plus tard 💬',
    'scripts.startTalking': 'Commencer à parler',
    'scripts.addScript': 'Ajouter un script',
    'scripts.chooseEmoji': 'Choisir un emoji',
    'scripts.yourPhrase': 'Votre phrase',
    'scripts.phrasePlaceholder': 'ex., Merci de m\'aider',
    'scripts.cancel': 'Annuler',
    'scripts.save': 'Enregistrer',
    'scripts.addNewScript': 'Ajouter un nouveau script',
    'scripts.noScriptsFound': 'Aucun script trouvé correspondant à votre recherche.',
    'scripts.copied': 'Copié !',
    'scripts.copiedToClipboard': 'Script copié dans le presse-papiers',
    'scripts.deleted': 'Supprimé',
    'scripts.removedFromCollection': 'Script retiré de votre collection',
    'scripts.saved': 'Enregistré !',
    'scripts.addedToCollection': 'Script ajouté à votre collection',
    'scripts.alreadyExists': 'Existe déjà',
    'scripts.alreadySaved': 'Vous avez déjà enregistré ce script',
    'scripts.categoryAll': 'Tout',
    'scripts.categoryNonverbal': 'Parler',
    'scripts.categoryChats': 'Discussions',
    'profile.title': 'Profil',
    'profile.navSubscription': 'Abonnement',
    'profile.navAboutUs': 'À propos',
    'profile.sessions': 'Jours',
    'profile.trophies': 'Trophées',
    'profile.sent': 'Envoyé',
    'profile.streak': 'Série',
    'profile.activity': 'Activité',
    'profile.awards': 'Récompenses',
    'profile.startChatting': 'Commencer à discuter',
    'profile.friend': 'Ami',
    'profile.chat1': '1 Discussion',
    'profile.chat5': '5 Discussions',
    'profile.chat10': '10 Discussions',
    'profile.chat25': '25 Discussions',
    'profile.chat50': '50 Discussions',
    'profile.chat100': '100 Discussions',
    'profile.less': 'Moins',
    'profile.more': 'Plus',
    'profile.chats': 'discussions',
    'profile.goBack': 'Retourner',
    'profile.reportBug': 'Signaler un bug',
    'profile.sendFeedback': 'Envoyer des commentaires',
    'profile.feedbackTypeBug': 'Rapport de bug',
    'profile.feedbackTypeComment': 'Commentaire',
    'profile.feedbackPlaceholderBug': 'Décrire le bug...',
    'profile.feedbackPlaceholderComment': 'Partagez vos pensées...',
    'profile.feedbackSend': 'Envoyer',
    'profile.feedbackCancel': 'Annuler',
    'profile.feedbackSending': 'Envoi...',
    'profile.feedbackSuccess': 'Merci !',
    'profile.feedbackError': 'Échec. Réessayez.',
    'profile.editProfile': 'Modifier le profil',
    'profile.username': 'Nom d\'utilisateur',
    'profile.enterName': 'Entrez votre nom',
    'profile.borderColor': 'Couleur de bordure',
    'profile.cancel': 'Annuler',
    'profile.save': 'Enregistrer',
    'profile.nameTooShort': 'Le nom doit comporter au moins 3 caractères',
    'profile.nameInappropriate': 'Veuillez choisir un nom approprié',
    'profile.logout': 'Se déconnecter',
    'profile.logoutConfirmTitle': 'Êtes-vous sûr ?',
    'profile.logoutConfirmText': 'Vous serez déconnecté et renvoyé à l\'accueil.',
    'profile.logoutYes': 'Oui',
    'profile.logoutNo': 'Non',
    'profile.loggingOut': 'Déconnexion...',
    'login.welcome': 'Bienvenue',
    'login.subtitle': 'Veuillez entrer vos coordonnées pour continuer',
    'login.firstName': 'Prénom',
    'login.firstNamePlaceholder': 'Entrez votre prénom',
    'login.firstNameRequired': 'Le prénom est requis',
    'login.lastName': 'Nom de famille',
    'login.lastNamePlaceholder': 'Entrez votre nom de famille',
    'login.optional': 'facultatif',
    'login.email': 'E-mail',
    'login.emailPlaceholder': 'Entrez votre e-mail',
    'login.emailRequired': 'L\'e-mail est requis',
    'login.emailInvalid': 'Veuillez entrer une adresse e-mail valide',
    'login.error': 'Un problème est survenu. Veuillez réessayer.',
    'login.pleaseWait': 'Veuillez patienter...',
    'login.continue': 'Continuer',
    'login.disclaimer': 'Ces informations peuvent être utilisées pour promouvoir notre application après le développement final.',
    'appName': 'Time To Talk',
    'tagline': 'Parfois, le plus grand pas est juste de dire "Salut"',
    'start': 'Commencer',
    'situations': 'Situations',
    'chat': 'Discuter',
    'settings': 'Paramètres',
    'home': 'Accueil',
    'nav.home': 'Accueil',
    'nav.scripts': 'Scripts',
    'nav.settings': 'Paramètres',
    'nav.chat': 'Discuter',
    'nav.live': 'En direct',
    'nav.profile': 'Profil',
    'nav.nonverbal': 'Parler',
    'selectSituation': 'Sélectionner une situation',
    'store': 'Magasin',
    'cafe': 'Café',
    'bus': 'Bus',
    'hospital': 'Hôpital',
    'school': 'École',
    'party': 'Fête',
    'chatFriend': 'Ami de chat IA',
    'typeMessage': 'Tapez votre message...',
    'send': 'Envoyer',
    'playVoice': 'Jouer la voix',
    'tts.ltPreviewTitle': 'Voix - comment ça va sonner',
    'accessibilitySettings': 'Paramètres d\'accessibilité',
    'hideImages': 'Masquer les images',
    'showImages': 'Afficher les images',
    'dyslexiaMode': 'Mode dyslexie',
    'textSize': 'Taille du texte',
    'backgroundMode': 'Mode d\'arrière-plan',
    'monochrome': 'Monochrome',
    'colored': 'Coloré',
    'resetDefaults': 'Rétablir les paramètres par défaut',
    'language': 'Langue',
    'english': 'Anglais',
    'lithuanian': 'Lituanien',
    'detailMode': 'Mode détail',
    'detailModeDescription': 'Afficher des instructions plus détaillées',
    'instructions': 'Instructions',
    'backToChat': 'Retour au chat',
    'startChat': 'Commencer le chat',
    'moreDetail': 'Plus de détails',
    'lessDetail': 'Moins de détails',
    'addCustomSituation': 'Ajouter une situation personnalisée',
    'createYourOwn': 'Créer votre propre situation',
    'situationName': 'Nom de la situation (ex., Bibliothèque)',
    'situationIcon': 'Icône de la situation (ex., 📚)',
    'situationNameEn': 'Nom de la situation (Anglais)',
    'situationNameLt': 'Nom de la situation (Lituanien)',
    'steps': 'Étapes',
    'addStep': 'Ajouter une étape',
    'step': 'Étape',
    'instructionSimpleEn': 'Instruction simple (Anglais)',
    'instructionDetailedEn': 'Instruction détaillée (Anglais)',
    'instructionSimpleLt': 'Instruction simple (Lituanien)',
    'instructionDetailedLt': 'Instruction détaillée (Lituanien)',
    'saveSituation': 'Enregistrer la situation',
    'delete': 'Supprimer',
    'stageName': 'Nom de l\'étape',
    'stageNameEn': 'Nom de l\'étape (Anglais)',
    'stageNameLt': 'Nom de l\'étape (Lituanien)',
    'coachLine': 'Ligne de coach',
    'icon': 'Icône',
    'textEn': 'Texte (Anglais)',
    'textLt': 'Texte (Lituanien)',
    'removeStep': 'Supprimer l\'étape',
    'edit': 'Modifier',
    'awards': 'Récompenses',
    'totalTrophies': 'Total des trophées',
    'colorThemes': 'Thèmes de couleur',
    'situationRewards': 'Statistiques de conversation',
    'unlocksAt': 'Débloque à',
    'trophies': 'trophées',
    'successfulInteractions': 'Interactions réussies',
    'applyTheme': 'Appliquer le thème',
    'applied': 'Appliqué',
    'chimeSound': 'Son de carillon de récompense',
    'chimeSoundDescription': 'Jouer un son lors du déblocage d\'une récompense',
    'settings.title': 'Paramètres',
    'settings.backAria': 'Retourner',
    'settings.appearance': 'Apparence',
    'settings.sounds': 'Sons',
    'settings.background': 'Arrière-plan',
    'settings.language': 'Langue',
    'settings.account': 'Compte',
    'settings.voiceprint.title': 'Reconnaissance vocale',
    'settings.voiceprint.description': 'Time to Talk apprend à reconnaître votre voix sur cet appareil afin de pouvoir dire qui parle dans les conversations en direct. Votre profil vocal est stocké localement et n\'est jamais envoyé à nos serveurs.',
    'settings.voiceprint.forget': 'Oublier ma voix',
    'settings.voiceprint.forgetDesc': 'Effacer le profil vocal enregistré et recommencer à zéro',
    'settings.voiceprint.forgotten': 'Profil vocal effacé',
    'settings.voiceprint.forgottenDesc': 'Time to Talk réapprendra votre voix lors de la prochaine session en direct.',
    'settings.theme': 'Thème',
    'settings.dark': 'Sombre',
    'settings.light': 'Clair',
    'settings.textSize': 'Taille du texte',
    'settings.textSizeSmall': 'A',
    'settings.textSizeMedium': 'A+',
    'settings.textSizeLarge': 'A++',
    'settings.reduceMotion': 'Réduire le mouvement',
    'settings.dyslexiaFont': 'Police pour dyslexie',
    'settings.showImages': 'Afficher les images',
    'settings.rewardSounds': 'Sons de récompense',
    'settings.rainAnimation': 'Animation de pluie',
    'settings.rainSounds': 'Sons de pluie',
    'settings.celebration': 'Effets de fête',
    'settings.partyModePhone': 'Effets de fête sur téléphone',
    'settings.partyModeDesktop': 'Effets de fête sur ordinateur',
    'settings.forest': 'Forêt',
    'settings.city': 'Ville',
    'settings.beach': 'Plage',
    'settings.privacyPolicy': 'Politique de confidentialité',
    'settings.termsOfService': 'Conditions d\'utilisation',
    'settings.helpSupport': 'Aide et support',
    'settings.replayTutorial': 'Rejouer le tutoriel',
    'settings.replayTutorialDescription': 'Revoir la visite guidée de l\'application',
    'settings.resetPermissions': 'Réinitialiser les permissions',
    'settings.resetPermissionsDescription': 'Demander à nouveau l\'accès au microphone et à l\'appareil',
    'settings.resetToDefaults': 'Rétablir les paramètres par défaut',
    'settings.followUs': 'Suivez-nous',
    'settings.version': 'Timo v1.0.0 • Fait avec ❤️',
    'settings.deleteAccount': 'Supprimer le compte',
    'settings.deleteAccountConfirmTitle': 'Supprimer votre compte ?',
    'settings.deleteAccountConfirmBody': 'Cela supprimera définitivement votre compte et toutes vos données. Cela ne peut pas être annulé.',
    'settings.deleteAccountConfirm': 'Oui, supprimer mon compte',
    'settings.deleteAccountCancel': 'Annuler',
    'settings.deleteAccountSuccess': 'Compte supprimé',
    'settings.deleteAccountError': 'Impossible de supprimer le compte. Veuillez réessayer ou contacter l\'assistance.',
    'settings.voiceTitle': 'Voix',
    'settings.voiceDescription': 'Choisir une voix',
    'settings.voiceChildishFemale': 'Enfantine, Féminine',
    'settings.voiceAdultMale': 'Plus adulte, Masculin',
    'tutorial.skip': 'Passer',
    'tutorial.next': 'Suivant',
    'tutorial.startApp': 'Commencer à utiliser l\'application',
    'tutorial.welcome.title': 'Bienvenue sur Time To Talk ! 🎉',
    'tutorial.welcome.subtitle': 'Laissez-moi vous faire visiter',
    'tutorial.welcome.description': 'Je suis Timo, votre assistant de communication. Cette visite rapide vous montrera tout ce que je peux faire pour vous !',
    'tutorial.welcome.timoMessage': 'Prêt à apprendre ? Allons-y !',
    'tutorial.home.title': 'Votre base d\'accueil 🏠',
    'tutorial.home.subtitle': 'Tout commence ici',
    'tutorial.home.description': 'L\'écran d\'accueil affiche vos actions rapides et le bouton principal pour commencer à parler. Vous pouvez accéder à toutes les fonctionnalités d\'ici.',
    'tutorial.home.timoMessage': 'C\'est ici que vous commencez !',
    'tutorial.chat.title': 'Discutez avec moi 💬',
    'tutorial.chat.subtitle': 'Votre assistant principal',
    'tutorial.chat.description': 'Touchez le bouton Timo (c\'est moi !) au centre du menu pour obtenir de l\'aide avec les conversations. Dites-moi ce que quelqu\'un a dit, et je vous suggérerai ce que vous pourriez répondre.',
    'tutorial.chat.timoMessage': 'Je suis toujours là pour vous aider !',
    'tutorial.chat.tip1': 'Tapez ou utilisez la voix pour me dire ce qui s\'est passé',
    'tutorial.chat.tip2': 'Je vous suggérerai des réponses que vous pouvez utiliser',
    'tutorial.chat.tip3': 'Touchez l\'icône de haut-parleur pour entendre les suggestions lues à haute voix',
    'tutorial.nonverbal.title': 'Mode Parler 🗣️',
    'tutorial.nonverbal.subtitle': 'Quand les mots sont difficiles',
    'tutorial.nonverbal.description': 'Parfois, parler est difficile. Utilisez le mode Parler pour toucher des symboles et construire des phrases que je prononcerai pour vous.',
    'tutorial.nonverbal.timoMessage': 'Pas besoin de parler ici !',
    'tutorial.nonverbal.tip1': 'Touchez des symboles pour construire votre message',
    'tutorial.nonverbal.tip2': 'Appuyez sur le bouton de lecture pour le prononcer à haute voix',
    'tutorial.nonverbal.tip3': 'Idéal pour quand vous avez besoin d\'une pause pour ne pas parler',
    'tutorial.scripts.title': 'Vos scripts 📝',
    'tutorial.scripts.subtitle': 'Enregistrer les phrases préférées',
    'tutorial.scripts.description': 'Vous avez trouvé une réponse que vous aimez ? Enregistrez-la dans les Scripts ! Vos phrases enregistrées sont toujours prêtes quand vous en avez besoin.',
    'tutorial.scripts.timoMessage': 'Gardez vos favoris à portée de main !',
    'tutorial.scripts.tip1': 'Touchez + pour ajouter une nouvelle phrase',
    'tutorial.scripts.tip2': 'Organiser par catégorie',
    'tutorial.scripts.tip3': 'Touchez pour copier ou dire n\'importe quel script',
    'tutorial.settings.title': 'Personnalisez-le ⚙️',
    'tutorial.settings.subtitle': 'Personnalisez votre expérience',
    'tutorial.settings.description': 'Changez votre thème, la taille du texte, les sons, et plus encore. Rendez l\'application confortable pour vous !',
    'tutorial.settings.timoMessage': 'Configurez-le à votre façon !',
    'tutorial.settings.tip1': 'Basculez entre le mode clair et sombre',
    'tutorial.settings.tip2': 'Ajustez la taille du texte pour une lecture plus facile',
    'tutorial.settings.tip3': 'Activez ou désactivez les sons',
    'tutorial.settings.tip4': 'Choisissez votre arrière-plan préféré',
    'tutorial.profile.title': 'Votre profil 📊',
    'tutorial.profile.subtitle': 'Suivez vos conversations',
    'tutorial.profile.description': 'Chaque conversation vous aide à grandir ! Consultez votre profil pour voir votre historique et suivre vos progrès.',
    'tutorial.profile.timoMessage': 'Vous vous en sortez très bien !',
    'tutorial.profile.tip1': 'Voir l\'historique de vos conversations',
    'tutorial.profile.tip2': 'Voir l\'historique de vos conversations',
    'tutorial.profile.tip3': 'Suivez vos progrès au fil du temps',
    'tutorial.complete.title': 'Vous êtes prêt ! 🌟',
    'tutorial.complete.subtitle': 'Commençons à parler',
    'tutorial.complete.description': 'C\'est tout ! N\'oubliez pas, je suis là chaque fois que vous avez besoin d\'aide. Il n\'y a pas de pression - allez à votre propre rythme.',
    'tutorial.complete.timoMessage': 'Je crois en vous ! 💚',
    'tour.skip': 'Passer',
    'tour.next': 'Suivant',
    'tour.back': 'Retour',
    'tour.finish': 'Compris !',
    'tour.welcome.title': 'Salut ! 👋',
    'tour.welcome.message': 'Je suis Timo, votre assistant de communication ! Laissez-moi vous faire visiter l\'application rapidement.',
    'tour.navbar.title': 'Barre de navigation',
    'tour.navbar.message': 'C\'est comme ça que vous vous déplacez ! Toutes les fonctionnalités principales sont juste ici en bas.',
    'tour.timoButton.title': 'Discutez avec moi !',
    'tour.timoButton.message': 'Touchez-moi à chaque fois que vous avez besoin d\'aide avec les conversations. Je vous suggérerai quoi dire !',
    'tour.homeTab.title': 'Accueil',
    'tour.homeTab.message': 'Votre point de départ. Accès rapide à tout et à vos progrès quotidiens.',
    'tour.nonverbalTab.title': 'Mode Parler',
    'tour.nonverbalTab.message': 'Quand parler semble difficile, touchez ici. Vous pouvez construire des messages avec des symboles et je parlerai pour vous !',
    'tour.scriptsTab.title': 'Scripts',
    'tour.scriptsTab.message': 'Enregistrez vos phrases préférées ici. Accès rapide aux réponses que vous utilisez souvent !',
    'tour.settingsTab.title': 'Paramètres',
    'tour.settingsTab.message': 'Personnalisez l\'application ! Changez les couleurs, la taille du texte, les sons, et plus encore.',
    'tour.profileTab.title': 'Profil',
    'tour.profileTab.message': 'Voyez vos progrès ici. Chaque conversation vous aide à grandir !',
    'tour.complete.title': 'Tout est prêt ! 🎉',
    'tour.complete.message': 'C\'est la fin de la visite ! N\'oubliez pas, touchez-moi à tout moment si vous avez besoin d\'aide. Pas de pression - allez à votre propre rythme !',
    'settings.resetToastTitle': '✅ Paramètres réinitialisés',
    'settings.resetToastDescription': 'Tous les paramètres d\'accessibilité ont été restaurés à leurs valeurs par défaut.',
    'settings.metaDescription': 'Personnalisez les paramètres d\'accessibilité, y compris le mode dyslexie, la taille du texte et les préférences d\'arrière-plan.',
    'settings.rainBackgroundTitle': 'Arrière-plan de pluie animé',
    'settings.rainBackgroundDescription': 'Afficher l\'animation de pluie',
    'settings.disableRainBackground': 'Désactiver l\'arrière-plan de pluie',
    'settings.enableRainBackground': 'Activer le fond de pluie',
    'settings.rainSoundTitle': 'Son de pluie en boucle',
    'settings.rainSoundDescription': 'Jouer le son de pluie en arrière-plan',
    'settings.disableRainSound': 'Désactiver le son de pluie',
    'settings.enableRainSound': 'Activer le son de pluie',
    'settings.volumeLabel': 'Volume',
    'settings.rainVolumeAria': 'Volume du son de pluie',
    'settings.imagesDescription': 'Basculer les icônes et images visuelles',
    'settings.openDyslexicTitle': 'Police OpenDyslexic',
    'settings.openDyslexicDescription': 'Utilise la police OpenDyslexic pour rendre les lettres plus faciles à distinguer.',
    'settings.openDyslexicAria': 'Police OpenDyslexic',
    'settings.textSizeTitle': 'Taille du texte',
    'settings.mediumFont': 'Texte de taille moyenne',
    'settings.largeFont': 'Texte de grande taille',
    'settings.xlargeFont': 'Texte de très grande taille',
    'settings.ttsModelTitle': 'Modèle vocal',
    'settings.ttsModelDescription': 'Choisissez quel modèle vocal IA utiliser pour la parole',
    'settings.ttsModelBrowser': 'Robo',
    'settings.ttsModelElevenLabs': 'Natt',
    'settings.ttsModelOpenAI': 'Nova',
    'settings.ttsModelGemini': 'Puck',
    'settings.themeIconsTitle': 'Icônes d\'arrière-plan',
    'settings.themeIconsDescription': 'Afficher les icônes emoji flottantes qui correspondent à votre thème',
    'settings.showImagesIcons': 'Afficher les images et icônes',
    'settings.soundTitle': 'Son',
    'settings.rewardSound': 'Son de récompense',
    'firstTimeGuide.title': 'Comment fonctionne Time To Talk',
    'firstTimeGuide.step1': 'Cliquez sur "Votre Situation".',
    'firstTimeGuide.step2': 'Tapez ou utilisez la voix pour raconter ce qui s\'est passé.',
    'firstTimeGuide.step3': 'L\'IA suggérera ce que vous pourriez dire ensuite',
    'firstTimeGuide.step4': 'Après la conversation, évaluez comment vous vous êtes senti.',
    'firstTimeGuide.step5': 'Vous pouvez aussi vous entraîner avec l\'IA en cliquant sur "Instructions".',
    'firstTimeGuide.reassurance': 'Vous êtes toujours aux commandes. Vous pouvez arrêter à tout moment.',
    'firstTimeGuide.dontShowAgain': 'Ne plus afficher ce guide',
    'firstTimeGuide.startButton': 'Commencer à utiliser l\'application',
    'newFeature.title': 'Nouvelle fonctionnalité !',
    'newFeature.subtitle': 'Nous avons ajouté quelque chose de nouveau pour vous aider à communiquer',
    'newFeature.feature1Title': 'Mode parole',
    'newFeature.feature1Desc': 'Touchez les symboles pour construire des phrases et les dire à voix haute',
    'newFeature.feature2Title': 'Simple et calme',
    'newFeature.feature2Desc': 'Conçu pour être facile à utiliser quand les mots sont difficiles',
    'newFeature.feedbackRequest': 'Ceci est une nouvelle fonctionnalité, nous aimerions avoir vos retours ! Faites-nous savoir si vous trouvez des bugs ou avez des suggestions.',
    'newFeature.dontShowAgain': 'Ne plus afficher ceci',
    'newFeature.messageButton': 'Nous envoyer un message',
    'newFeature.tryButton': 'Essayer maintenant',
    'home.feature1Title': 'Aide en temps réel',
    'home.feature1Desc': 'Obtenez des suggestions pendant que vous parlez',
    'home.feature2Title': 'Support vocal',
    'home.feature2Desc': 'Parlez ou tapez, à vous de choisir',
    'home.feature3Title': 'Écouter en retour',
    'home.feature3Desc': 'Entendre les réponses lues à voix haute',
    'home.howItWorksTitle': 'Comment ça marche',
    'home.howItWorksDesc': 'Dites-nous ce qu\'ils ont dit, et nous vous aiderons à trouver les bons mots.',
    'home.step1': 'Écouter',
    'home.step2': 'Réfléchir',
    'home.step3': 'Répondre',
    'home.tryNow': 'Essayer maintenant',
    'home.reassurance': 'Pas de jugement. Pas de pression. Juste de l\'aide quand vous en avez besoin.',
    'home.reassuranceSub': 'Timo est là pour vous, à votre propre rythme.',
    'home.timoTitle': 'Rencontrez Timo AI',
    'home.timoSubtitle': 'Votre guide de communication calme',
    'home.timoCard1Title': 'Le médiateur de la forêt',
    'home.timoCard1Text': 'La diplomatie a choisi Timo. Dans sa forêt, tout conflit se terminait avec lui remettant les choses en ordre.',
    'home.timoCard2Title': 'Le chaos de la forêt',
    'home.timoCard2Text': 'Avant Timo, tous les animaux avaient des problèmes entre eux. Les écureuils contre les corbeaux (des noix disparaissaient tous les jours), les canards contre littéralement tout le monde (ils... cancanaient de manière agressive). Mais une fois que Timo a emménagé, il a réglé les problèmes de tout le monde comme si de rien n\'était.',
    'home.timoCard3Title': 'Un excellent auditeur',
    'home.timoCard3Text': 'Pas bruyant ni autoritaire. Timo sait vraiment écouter et aider les autres à se comprendre.',
    'home.timoCard4Title': 'Une prise de conscience importante',
    'home.timoCard4Text': 'Les conflits ne viennent pas de mauvaises intentions. Ils viennent du fait de ne pas savoir comment s\'exprimer.',
    'home.timoCard5Title': 'Une mission claire',
    'home.timoCard5Text': 'La communication ne consiste pas à savoir qui est le plus intelligent ou le plus bruyant. Il s\'agit d\'aider les autres à vous comprendre.',
    'home.timoCard6Title': 'Aider les humains',
    'home.timoCard6Text': 'Quand Timo a entendu que les humains avaient aussi des difficultés avec les conversations, il a rapidement quitté sa forêt pour aider.',
    'home.timoCard7Title': 'Votre guide',
    'home.timoCard7Text': 'Patient, observateur, sans jugement. Timo vous donne les bons mots au bon moment.',
    'home.drawerOpen': 'Lire la suite',
    'home.drawerClose': 'Lire moins',
    'unknown.startConversation': 'Commencer une conversation',
    'unknown.continueConversation': 'Continuer la conversation',
    'unknown.askForHelp': 'Demander de l\'aide',
    'unknown.sayNoPolitely': 'Dire non poliment',
    'unknown.endConversation': 'Terminer la conversation',
    'unknown.metaTitle': 'Votre Situation',
    'unknown.metaDescription': 'Pratiquez la conversation avec l\'IA qui déduit le contexte.',
    'unknown.backAria': 'Retour à "Votre Situation"',
    'unknown.title': 'Votre Situation',
    'unknown.subtitle': 'Tapez ce que vous ou l\'autre personne avez dit. Timo AI va comprendre et aider.',
    'unknown.subtitleShort': 'Tapez ce que l\'autre personne a dit, pour que Timo AI puisse aider.',
    'unknown.helper': 'Comment Timo AI peut-il aider ?',
    'unknown.youCouldSay': 'Vous pourriez aussi dire...',
    'unknown.firstMessage': 'Dites-moi ce qui s\'est passé ou ce qu\'ils ont dit.',
    'unknown.inputPlaceholder': 'Demander de l\'aide à Timo AI...',
    'unknown.inputAria': 'Demander de l\'aide à Timo AI',
    'unknown.sendAria': 'Envoyer le message',
    'unknown.finishAria': 'Terminer la conversation',
    'unknown.finishButton': 'Terminer',
    'unknown.finishedNotice': 'Conversation terminée',
    'unknown.startNewConversation': 'Commencer une nouvelle conversation',
    'unknown.finishToastTitle': 'Conversation terminée',
    'unknown.finishToastDescription': 'La conversation est terminée. Vous pouvez en commencer une nouvelle.',
    'unknown.errorTitle': 'Erreur',
    'unknown.errorDescription': 'Échec de l\'envoi du message. Veuillez réessayer.',
    'unknown.contextPlace': 'Lieu',
    'unknown.contextRelationship': 'Relation',
    'unknown.contextGoal': 'Objectif',
    'unknown.emptyState': 'Commencez par taper ce qui s\'est passé ou ce qui a été dit !',
    'unknown.playVoiceAria': 'Jouer la voix',
    'unknown.finishedTitle': 'Vous avez terminé cette situation !',
    'unknown.motivationalMessage': 'Beau travail pour avoir essayé.',
    'unknown.howDidItFeel': 'Comment vous êtes-vous senti cette fois ?',
    'unknown.itFeltGood': 'Je me suis bien senti',
    'unknown.itWasHard': 'C\'était difficile cette fois',
    'unknown.bothChoicesOkay': 'Les deux choix sont valables, l\'important est que vous ayez essayé.',
    'unknown.goalSelectionTitle': 'Avec quoi avez-vous besoin d\'aide ?',
    'unknown.goalSelectionSubtitle': 'Choisissez l\'option qui correspond le mieux à votre situation.',
    'unknown.goalHelpSpeaking': 'J\'ai besoin d\'aide pour parler',
    'unknown.goalHelpAsking': 'J\'ai besoin d\'aide pour demander quelque chose',
    'unknown.goalLost': 'Je ne sais pas quoi dire',
    'unknown.goalSayNo': 'Je veux dire non poliment',
    'unknown.goalSkip': 'Cela ne correspond pas à ma situation',
    'unknown.goalBadgeHelpSpeaking': 'Objectif : Aide pour parler',
    'unknown.goalBadgeHelpAsking': 'Objectif : Aide pour demander',
    'unknown.goalBadgeLost': 'Objectif : Je ne sais pas quoi dire',
    'unknown.goalBadgeSayNo': 'Objectif : Dire non poliment',
    'unknown.recordOtherSpeaker': 'Enregistrer ce qu\'ils ont dit',
    'unknown.recording': 'Enregistrement...',
    'unknown.otherPersonSaid': 'L\'autre personne a dit :',
    'unknown.speakerLabel': 'Vous pourriez dire :',
    'unknown.timoAILabel': 'Timo AI :',
    'unknown.otherPersonLabel': 'Autre personne :',
    'unknown.youLabel': 'Vous :',
    'voice.unsupportedAlert': 'Entrée vocale non prise en charge dans ce navigateur. Veuillez taper.',
    'voice.stopRecordingAria': 'Arrêter l\'enregistrement',
    'voice.startRecordingAria': 'Enregistrer la voix',
    'voice.stopRecordingTooltip': 'Arrêter l\'enregistrement',
    'voice.startRecordingTooltip': 'Enregistrer',
    'voice.recordingIndicator': '● Enr.',
    'about': 'À propos',
    'about.pageTitle': 'À propos de nous, Time To Talk',
    'about.metaDescription': 'Découvrez l\'histoire et la mission derrière Time To Talk.',
    'about.intro1': 'Time To Talk a été créé à partir d\'un moment simple et significatif.',
    'about.intro2': 'Le frère de notre fondateur, qui est atteint d\'autisme, a demandé un jour s\'il pouvait prendre une photo de la lune, une petite question qui a inspiré une grande idée : aider les personnes qui trouvent les situations sociales quotidiennes confuses ou stressantes.',
    'about.founderImageAlt': 'Le fondateur et son frère',
    'about.teamImageAlt': 'L\'équipe de Time To Talk travaillant ensemble',
    'about.missionTitle': 'Notre Mission',
    'about.missionText': 'Rendre la communication plus facile à comprendre, à pratiquer et à vivre. Time To Talk aide les utilisateurs à apprendre quoi dire et quoi faire grâce aux conseils bienveillants de l\'IA, à des visuels clairs et à un design calme.',
    'about.goalTitle': 'Notre Objectif',
    'about.goalText': 'Renforcer la confiance, une situation à la fois. Nous sommes là pour tous ceux qui ont besoin de soutien, les personnes atteintes d\'autisme, d\'anxiété sociale ou tous ceux qui trouvent simplement les moments sociaux difficiles.',
    'about.back': 'Retour',
    'about.timo': 'Timo',
    'about.tagline': 'Votre compagnon de conversation',
    'about.missionIntro': 'Nous croyons que tout le monde mérite un soutien dans ses conversations quotidiennes. Timo est conçu pour les personnes qui trouvent parfois les interactions sociales difficiles, que vous soyez autiste, anxieux, introverti ou que vous passiez simplement une mauvaise journée.',
    'about.missionSub': 'Notre objectif est simple : vous donner confiance quand vous en avez le plus besoin, sans jugement ni pression.',
    'about.features': 'Ce que fait Timo',
    'about.feature.conversation': 'Aide à la conversation',
    'about.feature.conversationDesc': 'Obtenez des suggestions de réponses lorsque vous ne savez pas quoi dire',
    'about.feature.voice': 'Entrée vocale',
    'about.feature.voiceDesc': 'Parlez ou tapez, ce qui vous convient le mieux',
    'about.feature.scripts': 'Sauvegarder les scripts',
    'about.feature.scriptsDesc': 'Gardez vos réponses préférées pour un accès rapide',
    'about.feature.privacy': 'Privé et Sécurisé',
    'about.feature.privacyDesc': 'Vos conversations restent sur votre appareil',
    'about.madeBy': 'Créé par',
    'about.teamName': 'L\'équipe Time to Talk',
    'about.teamRole': 'Construire des outils pour une meilleure communication',
    'about.privacyPolicy': 'Politique de confidentialité',
    'about.terms': 'Conditions d\'utilisation',
    'about.contact': 'Nous contacter',
    'about.version': 'Version 1.0.0',
    'about.madeWith': 'Fait avec ❤️ pour de meilleures conversations',
    'header.disableRainBg': 'Désactiver le fond de pluie',
    'header.enableRainBg': 'Activer le fond de pluie',
    'header.disableRainSound': 'Désactiver le son de pluie',
    'header.enableRainSound': 'Activer le son de pluie',
    'situations.metaDescription': 'Choisissez une situation de la vie réelle pour pratiquer la communication avec les conseils de l\'IA.',
    'situations.helperText': 'Choisissez la situation pour pratiquer ou parler avec l\'aide de Timo AI',
    'situations.customTitle': 'Votre Situation',
    'situations.customSubtitle': 'Cliquez pour commencer et Timo AI vous aidera',
    'situations.recommended': 'Recommandé',
    'situations.deleteConfirmTitle': 'Êtes-vous sûr ?',
    'situations.deleteConfirmDescription': 'Cela ne peut pas être annulé.',
    'situations.history': 'Historique',
    'situations.historySubtitle': 'Voir vos conversations passées',
    'situations.chooseWhereTitle': 'Où êtes-vous ?',
    'situations.chooseWhereSubtitle': 'Choisissez-en un ou commencez un chat libre',
    'situations.freeChat': 'Chat Libre',
    'situations.liveModeBeta': 'Mode en direct, Bêta',
    'situations.backToHome': 'Retour à l\'accueil',
    'situations.accessCodeTitle': 'Code d\'accès requis',
    'situations.accessCodeHint': 'Entrez le code d\'accès pour utiliser le Mode en direct :',
    'situations.enterCodePlaceholder': 'Entrez le code...',
    'situations.codeIncorrect': 'Code incorrect. Veuillez réessayer.',
    'situations.accessLiveModeButton': 'Accéder au Mode en direct',
    'chat.pageTitle': 'Discuter avec Timo',
    'chat.metaDescription': 'Parlez à Timo, Obtenez de l\'aide sur ce qu\'il faut dire',
    'chat.backAria': 'Retour',
    'chat.subtitle': 'Votre assistant IA',
    'chat.end': 'Terminer',
    'chat.helpDefault': 'Aide',
    'chat.greeting': 'Salut ! Qu\'avez-vous besoin de dire ?',
    'chat.suggestionsTitle': 'Que devrais-je dire ?',
    'chat.suggestionsHint': 'Touchez une option, elle sera lue et envoyée',
    'chat.suggestionsUpdating': 'Mise à jour...',
    'chat.noSuggestions': 'Aucune suggestion disponible',
    'chat.thinking': 'Réflexion...',
    'chat.gettingSuggestions': 'Obtention de suggestions pour vous',
    'chat.quickRepliesLabel': 'Réponses rapides :',
    'chat.speaking': 'Parle :',
    'chat.speakerMe': 'Moi',
    'chat.speakerOther': 'Autre',
    'chat.placeholder': 'Tapez un message...',
    'chat.sendAria': 'Envoyer le message',
    'chat.getHelpAria': 'Obtenir de l\'aide',
    'chat.playTtsAria': 'Jouer la synthèse vocale',
    'chat.ariaHearTimo': 'Entendre le message de Timo',
    'chat.ariaHearIt': 'L\'entendre',
    'chat.ariaSaveScript': 'Enregistrer dans les scripts',
    'chat.recordMicMe': 'Maintenez pour enregistrer votre voix',
    'chat.recordMicOther': 'Maintenez pour enregistrer ce qu\'ils ont dit',
    'chat.recordingMe': 'Enregistrement de votre voix...',
    'chat.recordingOther': 'Enregistrement de ce qu\'ils ont dit...',
    'chat.ttsWait': 'Attendez {seconds}s... ({left} lectures restantes)',
    'chat.youCan': 'Vous pouvez dire :',
    'chat.timoSuggests': 'Timo suggère...',
    'chat.safetyTitle': 'Alerte de sécurité',
    'chat.safetyBody': 'Cette conversation pourrait être dangereuse. Si vous vous sentez menacé, partez immédiatement.',
    'chat.fallbackAi': 'Salut ! Qu\'avez-vous besoin de dire ?',
    'chat.fallbackCoaching': 'Message envoyé avec succès ! 👍 Besoin d\'autre chose ?',
    'chat.needMoreHelp': 'Besoin d\'aide pour autre chose ?',
    'chat.praise1': 'Super !',
    'chat.praise2': 'Génial !',
    'chat.praise3': 'Bien joué !',
    'chat.toast.errorTitle': 'Erreur',
    'chat.toast.errorDesc': 'Échec de l\'obtention de la réponse. Veuillez réessayer.',
    'chat.toast.ttsLimitTitle': 'Limite de synthèse vocale atteinte',
    'chat.toast.ttsLimitDesc': 'Maximum de 5 lectures par session pour économiser les ressources.',
    'chat.toast.savedTitle': 'Enregistré !',
    'chat.toast.savedDesc': 'Ajouté à vos Scripts.',
    'chat.toast.duplicateTitle': 'Déjà enregistré',
    'chat.toast.duplicateDesc': 'Vous avez déjà cette phrase.',
    'chat.toast.voiceTestTitle': 'Test vocal',
    'chat.toast.voiceTestDesc': 'Lecture de l\'audio d\'exemple...',
    'chat.toast.voiceFailTitle': 'Échec du test vocal',
    'chat.toast.voiceFailDesc': 'Vérifiez la console pour plus de détails.',
    'chat.toast.connectionTitle': 'Problème de connexion',
    'chat.toast.connectionDesc': 'Impossible d\'obtenir la réponse complète, mais votre message était génial !',
    'chat.testVoice.lt': 'Salut, je suis Timo, votre assistant IA.',
    'chat.testVoice.en': 'Salut, je suis Timo, votre assistant IA.',
    'chat.testVoice.ru': 'Salut, je suis Timo, votre assistant IA.',
    'chat.qr.hey1': 'Hé !',
    'chat.qr.hey2': 'Salut',
    'chat.qr.hey3': 'Quoi de neuf ?',
    'chat.qr.yes1': 'Oui',
    'chat.qr.yes2': 'Non',
    'chat.qr.yes3': 'Peut-être',
    'chat.qr.how1': 'Bien !',
    'chat.qr.how2': 'Pas mal',
    'chat.qr.how3': 'Je vais bien',
    'chat.qr.inv1': 'Bien sûr !',
    'chat.qr.inv2': 'Peut-être plus tard',
    'chat.qr.inv3': 'Je ne peux pas, désolé',
    'chat.qr.help1': 'Bien sûr',
    'chat.qr.help2': 'Qu\'est-ce qu\'il y a ?',
    'chat.qr.help3': 'Comment puis-je aider ?',
    'chat.qr.thanks1': 'Pas de problème !',
    'chat.qr.thanks2': 'Quand vous voulez',
    'chat.qr.thanks3': 'De rien',
    'chat.qr.comp1': 'Merci !',
    'chat.qr.comp2': 'C\'est apprécié',
    'chat.qr.comp3': '😊',
    'chat.qr.sorry1': 'Pas de soucis',
    'chat.qr.sorry2': 'C\'est d\'accord',
    'chat.qr.sorry3': 'Tout va bien',
    'chat.qr.info1': 'Vraiment ?',
    'chat.qr.info2': 'Dis-m\'en plus',
    'chat.qr.info3': 'Quoi ?',
    'chat.qr.plan1': 'Ça a l\'air bien',
    'chat.qr.plan2': 'À quelle heure ?',
    'chat.qr.plan3': 'Peut-être',
    'chat.qr.conf1': 'Ouais',
    'chat.qr.conf2': 'Exactement',
    'chat.qr.conf3': 'C\'est sûr',
    'chat.qr.wq1': 'Pas sûr',
    'chat.qr.wq2': 'Laisse-moi réfléchir',
    'chat.qr.wq3': 'Je vais vérifier',
    'chat.qr.genq1': 'Ouais',
    'chat.qr.genq2': 'Nan',
    'chat.qr.genq3': 'Peut-être',
    'chat.qr.stat1': 'Cool',
    'chat.qr.stat2': 'Sympa',
    'chat.qr.stat3': 'Oh vraiment ?',
    'chat.qr.def1': 'D\'accord',
    'chat.qr.def2': 'Compris',
    'chat.qr.def3': 'Cool',
    'history.title': 'Historique des conversations',
    'history.empty': 'Aucune conversation pour le moment. Commencez à discuter pour voir votre historique ici !',
    'history.loading': 'Chargement des conversations...',
    'history.error': 'Échec du chargement des conversations. Veuillez réessayer.',
    'history.deleteConfirm': 'Supprimer cette conversation ?',
    'history.deleteError': 'Échec de la suppression de la conversation. Veuillez réessayer.',
    'history.resume': 'Reprendre',
    'history.view': 'Voir',
    'history.delete': 'Supprimer',
    'history.noTitle': 'Conversation sans titre',
    'history.lastUpdated': 'Dernière mise à jour',
    'history.deleteAll': 'Tout supprimer',
    'history.deleteAllConfirm': 'Tout supprimer ?',
    'history.deleteAllConfirmDesc': 'Toutes les conversations seront supprimées.',
    'history.deleteAllSuccess': 'Succès',
    'history.deleteAllSuccessDesc': 'Toutes les conversations ont été supprimées',
    'history.justNow': 'À l\'instant',
    'common.cancel': 'Annuler',
    'common.delete': 'Supprimer',
    'customSetup.intentStart': 'Commencer une conversation',
    'customSetup.intentContinue': 'Continuer la conversation',
    'customSetup.intentFinish': 'Terminer la conversation',
    'customSetup.metaTitle': 'Situation Personnalisée, Configuration',
    'customSetup.metaDescription': 'Configurez un scénario d\'entraînement de conversation personnalisé.',
    'customSetup.title': 'Situation Personnalisée',
    'customSetup.subtitle': 'Choisissez où vous êtes et ce que vous voulez faire.',
    'customSetup.situationLabel': 'Situation',
    'customSetup.placeholder': 'par ex., Fête, École, Magasin, Bus, Hôpital',
    'customSetup.examplesHint': 'Ou cliquez sur un exemple ci-dessous :',
    'customSetup.examples.party': 'Fête',
    'customSetup.examples.school': 'École',
    'customSetup.examples.store': 'Magasin',
    'customSetup.examples.bus': 'Bus',
    'customSetup.examples.hospital': 'Hôpital',
    'customSetup.intentQuestion': 'Que voulez-vous faire ?',
    'customSetup.startButton': 'Commencer',
    'customChat.metaTitle': 'Chat de Situation Personnalisée',
    'customChat.genericSituation': 'situation',
    'customChat.metaDescriptionPrefix': 'Pratiquer la conversation :',
    'customChat.backAria': 'Retour à la configuration',
    'customChat.inputPlaceholder': 'Tapez votre message...',
    'customChat.inputAria': 'Tapez votre message',
    'customChat.finishToastTitle': 'Conversation terminée',
    'customChat.finishToastDescription': 'La conversation est terminée. Vous pouvez en commencer une nouvelle.',
    'customChat.errorTitle': 'Erreur',
    'customChat.errorDescription': 'Échec de l\'envoi du message. Veuillez réessayer.',
    'customChat.finishFallbackShort': 'Au revoir !',
    'customChat.finishFallbackLong': 'Je dois y aller maintenant, merci !',
    'customChat.finishedNotice': 'Conversation terminée',
    'nonVerbalMode': 'Parler',
    'nonVerbalSelectPrompt': 'Touchez les symboles pour construire votre phrase',
    'nonVerbalAIGrammar': 'Correction grammaticale IA',
    'nv.speakModalTitle': 'Je suis en train de dire :',
    'nv.speaking': 'Parle...',
    'nv.speak': 'Parler',
    'nv.speakAgain': 'Parler encore',
    'nv.speakLoading': 'Construction de la phrase...',
    'nv.imageAlt': 'Image',
    'nv.sentenceBarAria': 'Barre de phrase',
    'nv.tapSymbol': 'Touchez un symbole...',
    'nv.clearAll': 'Tout effacer',
    'nv.deleteLast': 'Supprimer le dernier',
    'nv.speakSentence': 'Dire la phrase',
    'nv.kalbeti': 'Parler',
    'nv.clear': '✕ Effacer',
    'nv.backAria': 'Retour',
    'nv.scriptsAria': 'Scripts',
    'nv.historyAria': 'Historique',
    'nv.searchPlaceholder': 'Rechercher un symbole...',
    'nv.noResults': 'Aucun resultat',
    'nv.ttsFailed': 'Pas de son. Touchez pour réessayer.',
    'nv.searchAria': 'Rechercher un symbole',
    'nv.loading': 'Chargement...',
    'nv.noPhotos': 'Pas encore de photos',
    'nv.addPhotosHint': 'Ajoutez vos propres photos pour la communication',
    'nv.addPhoto': 'Ajouter une Photo',
    'nv.add': 'Ajouter',
    'nv.showLess': 'Voir moins',
    'nv.moreCount': 'Plus ({count})',
    'nv.comingSoon': 'Bientôt disponible !',
    'nv.historyTitle': 'Historique',
    'nv.historyEmpty': 'Aucune phrase pour le moment. Touchez des emojis et parlez pour créer un historique.',
    'nv.useAgain': 'Utiliser à nouveau',
    'nv.addToScripts': 'Ajouter aux scripts',
    'nv.savedToScripts': 'Enregistré dans les scripts !',
    'nv.clearHistory': 'Effacer l\'historique',
    'nv.customAddPhoto': 'Ajouter une Photo',
    'nv.customPreview': 'Aperçu',
    'nv.customAddLabel': 'Ajouter une Étiquette',
    'nv.customTakePhoto': 'Prendre une Photo',
    'nv.customUseCamera': 'Utiliser l\'appareil photo',
    'nv.customFromGallery': 'Choisir dans la Galerie',
    'nv.customFromDevice': 'Depuis l\'ordinateur ou le téléphone',
    'nv.customWordOnly': 'Juste un mot',
    'nv.customWordOnlyHint': 'Pas besoin de photo',
    'nv.customChange': 'Changer',
    'nv.customContinue': 'Continuer',
    'nv.customHintLabels': 'Ajouter du texte qui sera affiché et dit',
    'nv.customNameEn': 'Nom (Anglais)',
    'nv.customPlaceholderName': 'par ex., "Maman", "Jean"',
    'nv.customNameLt': 'Nom en Lituanien',
    'nv.customNameRu': 'Nom en Russe',
    'nv.customOptional': 'optionnel',
    'nv.customCategory': 'Catégorie',
    'nv.customBack': 'Retour',
    'nv.customSave': 'Enregistrer',
    'nv.customSaving': 'Enregistrement...',
    'nv.customErrImage': 'Veuillez sélectionner un fichier image',
    'nv.customErrSize': 'Fichier trop volumineux (max 10 Mo)',
    'nv.customErrLabel': 'Veuillez entrer une étiquette',
    'nv.customErrSave': 'Erreur lors de l\'enregistrement',
    'nv.manageTitle': 'Mes Photos',
    'nv.deleteConfirm': 'Supprimer "{name}" ?',
    'nv.cancel': 'Annuler',
    'nv.delete': 'Supprimer',
    'speak': 'Parler',
    'speaking': 'Parle...',
    'clear': 'Effacer',
    'back': 'Retour',
    'skip': 'Passer',
    'continue': 'Continuer',
    'onboarding.welcomeTitle': 'Salut, je suis Timo',
    'onboarding.welcomeSubtitle': 'Votre compagnon calme pour les conversations de tous les jours',
    'onboarding.welcomeDesc': 'Je suis là pour vous aider quand parler semble difficile. Mettons les choses en place en une minute.',
    'onboarding.getStarted': 'Commençons',
    'onboarding.languageTitle': 'Choisissez votre langue',
    'onboarding.languageDesc': 'Vous pourrez la modifier plus tard dans les paramètres',
    'onboarding.accessibilityTitle': 'Rendez-le confortable',
    'onboarding.accessibilityDesc': 'Ajustez ceci selon vos besoins',
    'onboarding.reducedMotion': 'Mouvements réduits',
    'onboarding.reducedMotionDesc': 'Des animations plus simples pour moins de distraction',
    'onboarding.sounds': 'Effets sonores',
    'onboarding.soundsDesc': 'De doux carillons pour les retours',
    'onboarding.showImages': 'Afficher les images',
    'onboarding.showImagesDesc': 'Afficher des illustrations et des icônes',
    'onboarding.howItWorksTitle': 'Comment ça marche',
    'onboarding.howItWorksDesc': 'Trois étapes simples pour vous aider à communiquer',
    'onboarding.step1Title': 'Ils parlent',
    'onboarding.step1Desc': 'Dites-nous ce que l\'autre personne a dit',
    'onboarding.step2Title': 'Nous aidons',
    'onboarding.step2Desc': 'Timo suggère ce que vous pourriez dire',
    'onboarding.step3Title': 'Vous répondez',
    'onboarding.step3Desc': 'Choisissez une suggestion ou dites la vôtre',
    'onboarding.readyTitle': 'Vous êtes prêt !',
    'onboarding.readyDesc': 'Timo est prêt à aider dès que vous en avez besoin.',
    'onboarding.readyTip': 'Astuce : Vous pouvez toujours accéder aux paramètres plus tard pour ajuster vos préférences.',
    'onboarding.startUsing': 'Commencer à utiliser Time To Talk',
    'pushToTalk.title': 'Aidez-Moi À Répondre',
    'pushToTalk.ready': 'Prêt quand vous l\'êtes',
    'pushToTalk.helpMeRespond': 'Aidez-moi à répondre',
    'pushToTalk.tapToStart': 'Touchez pour enregistrer ce qu\'ils ont dit',
    'pushToTalk.recording': 'Enregistrement de ce qu\'ils ont dit...',
    'pushToTalk.done': 'Terminé',
    'pushToTalk.cancel': 'Annuler',
    'pushToTalk.understanding': 'Compréhension...',
    'pushToTalk.theySaid': 'Ils ont dit :',
    'pushToTalk.soundsLike': 'Cela ressemble à',
    'pushToTalk.yesHelpMe': 'Oui, aidez-moi à répondre',
    'pushToTalk.notQuite': 'Pas tout à fait, essaie encore',
    'pushToTalk.startOver': 'Recommencer',
    'pushToTalk.findingResponses': 'Recherche de bonnes réponses...',
    'pushToTalk.pickResponse': 'Choisis une réponse :',
    'pushToTalk.youllSay': 'Tu diras :',
    'pushToTalk.illSayIt': 'Je le dirai',
    'pushToTalk.speakForMe': 'Parle pour moi',
    'pushToTalk.chooseAnother': 'Choisir une autre',
    'pushToTalk.differentOptions': 'Options différentes',
    'pushToTalk.speaking': 'Parle...',
    'pushToTalk.stop': 'Arrêter',
    'pushToTalk.responseReady': 'Réponse prête !',
    'pushToTalk.needMoreHelp': 'Besoin de plus d\'aide',
    'pushToTalk.imDone': 'J\'ai terminé',
    'pushToTalk.autoReset': 'Retour automatique à l\'accueil',
    'pushToTalk.stillThere': 'Toujours là ?',
    'pushToTalk.takeYourTime': 'Prends ton temps, pas d\'urgence.',
    'pushToTalk.continue': 'Continuer',
    'pushToTalk.didntCatch': 'Je n\'ai pas compris',
    'pushToTalk.tryAgainOrType': 'Essaie encore ou tape plutôt',
    'pushToTalk.tryAgain': 'Essaie encore',
    'pushToTalk.typeInstead': 'Tape plutôt',
    'pushToTalk.whatDidTheySay': 'Qu\'ont-ils dit ?',
    'pushToTalk.typeHere': 'Tape ce qu\'ils ont dit...',
    'pushToTalk.somethingWrong': 'Un problème est survenu',
    'pushToTalk.pleaseTryAgain': 'Veuillez réessayer',
    'pushToTalk.panic': 'Arrêter et revenir',
    'live.title': 'Mode en direct',
    'live.back': 'Retour',
    'live.endSession': 'Terminer',
    'live.error': 'Erreur',
    'live.dismiss': 'Ignorer',
    'live.status.ready': 'Prêt',
    'live.status.connecting': 'Connexion...',
    'live.status.listening': 'Écoute...',
    'live.tapToStart': 'Démarrer',
    'live.tapToStop': 'Arrêter',
    'live.connecting': 'Connexion...',
    'live.stats.totalMessages': 'Total',
    'live.stats.you': 'Toi',
    'live.stats.otherPerson': 'Autre',
    'live.conversation': 'Conversation',
    'live.emptyState.listening': 'Écoute...',
    'live.emptyState.startRecording': 'Démarrer',
    'live.getAiHelp': 'Aide de Timo',
    'live.askAi': 'Demander à Timo',
    'live.theyreSpeaking': 'Ils parlent',
    'live.emptyState.instruction': 'Cliquez sur le bouton du microphone pour commencer la conversation',
    'live.betaWarning.title': 'Mode en direct - Bêta',
    'live.betaWarning.description': 'Cette fonctionnalité est en cours de développement. N\'hésitez pas à la tester !',
    'live.betaWarning.note': 'Fonctionne mieux en anglais',
    'live.betaWarning.close': 'Compris',
    'rateLimit.title': 'Vous avez atteint la limite du jour',
    'rateLimit.message': 'Vous avez atteint votre limite quotidienne. Veuillez réessayer demain.',
    'rateLimit.ok': 'OK',
    'rateLimit.close': 'Fermer',
    // Landing copy lives in src/copy/landing.fr.js
    ...landingFr,
    ...storyFr,
    'login.title': 'Connexion',
    'login.startSubtitle': 'Connectez-vous avec Google ou par e-mail.',
    'login.fbBrowserWarning': 'La connexion Google ne fonctionne pas dans le navigateur Facebook. Utilisez l\'e-mail ci-dessous, ou ouvrez cette page dans Safari / Chrome.',
    'login.googleBtn': 'Continuer avec Google',
    'login.facebookBtn': 'Continuer avec Facebook',
    'login.appleBtn': 'Continuer avec Apple',
    'login.openInBrowser': 'Pour la connexion Google, Facebook ou Apple, touchez le menu et choisissez "Ouvrir dans le navigateur". Ou utilisez simplement l\'e-mail ci-dessous.',
    'login.emailBtn': 'Continuer avec l\'e-mail',
    'login.signUpPrompt': 'Vous n\'avez pas encore de compte ?',
    'login.signUpLink': 'Inscrivez-vous ci-dessous',
    'login.registerBtn': 'Vous avez déjà un compte ?',
    'login.signInLink': 'Se connecter',
    'login.signinTitle': 'Se connecter',
    'login.signupTitle': 'S\'inscrire',
    'login.signinSubtitle': 'Connectez-vous avec votre e-mail',
    'login.signupSubtitle': 'Créez votre compte',
    'login.emailLabel': 'Adresse e-mail',
    'login.passwordLabel': 'Mot de passe',
    'login.passwordSignupPlaceholder': 'Mot de passe (min. 6 car.)',
    'login.submitSignin': 'Se connecter',
    'login.submitSignup': 'S\'inscrire',
    'login.processing': 'Traitement...',
    'login.noAccount': 'Vous n\'avez pas de compte ? S\'inscrire',
    'login.haveAccount': 'Vous avez déjà un compte ? Se connecter',
    'login.successSignin': 'Connexion réussie !',
    'login.successSignup': 'Vérifiez vos e-mails pour confirmation !',
    'login.failed': 'Échec de la connexion. Veuillez réessayer.',
    'login.unknownError': 'Erreur inconnue. Veuillez réessayer.',
    'login.registrationFailed': 'Échec de l\'inscription :',
    'login.confirmationEmail': 'Vérifiez vos e-mails - nous avons envoyé un lien de confirmation.',
    'login.linkExpired': 'Votre lien de connexion a expiré. Veuillez en demander un nouveau.',
    'login.resendMagicLink': 'M\'envoyer un nouveau lien de connexion',
    'login.magicLinkSent': 'Vérifiez vos e-mails pour un nouveau lien de connexion.',
    'login.loginSuccessful': 'Connexion réussie !',
    'login.devAccessNotAvailable': 'Accès dev non disponible',
    'login.invalidCode': 'Code invalide',
    'login.accessPlaceholder': 'accès',
    'login.forgotPassword': 'Mot de passe oublié ?',
    'login.resetTitle': 'Réinitialiser le mot de passe',
    'login.resetSubtitle': 'Nous vous enverrons un lien de réinitialisation.',
    'login.submitReset': 'Envoyer le lien de réinitialisation',
    'login.resetSent': 'Vérifiez vos e-mails pour un lien de réinitialisation.',
    'login.resetRateLimited': 'E-mail déjà envoyé - attendez quelques minutes avant de réessayer.',
    'login.resetWaitBtn': 'Attendre {n}s',
    'login.newPasswordTitle': 'Définir un nouveau mot de passe',
    'login.newPasswordSubtitle': 'Entrez votre nouveau mot de passe ci-dessous.',
    'login.newPasswordLabel': 'Nouveau mot de passe (min. 6 car.)',
    'login.submitNewPassword': 'Définir le mot de passe',
    'login.passwordUpdated': 'Mot de passe mis à jour ! Connexion en cours...',
    'login.backToSignin': 'Retour à la connexion',
    'login.fbEmailFallback': 'Ou connectez-vous par e-mail',
    'login.fbLinkCopied': 'Lien copié - collez-le dans Chrome ou Safari',
    'home.urgencyBanner': 'Votre abonnement n\'est pas actif, débloquez toutes les fonctionnalités',
    'home.urgencyBannerCta': 'Voir les forfaits',
    'subscription.choosePlanCta': 'Choisir un forfait',
    'home.sessionsCompleted': '{n} sessions terminées',

    // Landing v2 - direct-pay funnel
    'pricingCard.howManyMonths': 'Combien de mois ?',
    'pricingCard.fullAccess': 'Accès complet à toutes les fonctionnalités',
    'pricingCard.offline': 'Fonctionne hors ligne',
    'pricingCard.newFeatures': 'Nouvelles fonctionnalités chaque mois',
    'pricingCard.cancelAnytime': 'Annulez à tout moment',
    'pricingCard.tryBeforePay': 'Essayez avant de payer',
    'pricingCard.lockInPrice': 'Bloquer le prix',
    'footer.privacy': 'Politique de confidentialité',
    'footer.articles': 'Articles',
    'footer.terms': 'Conditions',
    'footer.contact': 'Contact',
    'footer.copyright': '© 2026 Time To Talk',
    'common.appName': 'Time To Talk',
    'pricing.yourChildDeserves': 'Votre enfant mérite d\'être entendu.',
    'pricing.feature1': 'Touchez une image. Timo parle pour eux.',
    'pricing.feature2': 'Pratiquez la parole en toute sécurité, à leur propre rythme.',
    'pricing.feature3': 'Aide dans de vraies conversations. En temps réel.',
    'pricing.letsGo': 'C\'est parti',
    'pricing.cancelBeforeDay7': 'Annulez avant le 7ème jour. Vous ne payez rien.',
    'pricing.reminderTitle': 'Nous vous le rappellerons avant que cela ne se termine.',
    'pricing.today': 'Aujourd\'hui',
    'pricing.day5': 'Jour 5',
    'pricing.day5Desc': 'Nous vous envoyons un e-mail de rappel.',
    'pricing.day7': 'Jour 7',
    'pricing.soundsGood': 'Ça a l\'air bien',
    'pricing.controlIt': 'Vous contrôlez. Annulez à tout moment.',
    'pricing.choosePlan': 'Choisissez votre forfait.',
    'pricing.fullAccessBadge': 'ACCÈS COMPLET',
    'pricing.perMonthLabel': 'par mois',
    'pricing.fullAccessFromToday': 'Les 3 modes, débloqués aujourd\'hui',
    'pricing.billedMonthlyCancelAnytime': 'Facturé chaque mois. Annulez à tout moment.',
    'pricing.getAccessCta': 'Obtenir l\'accès',
    'pricing.chargedTodayNote': 'Vous êtes débité aujourd\'hui. Annulez à tout moment dans Profil puis Abonnement.',
    'pricing.fullAccessSub': 'Accès complet aux 3 modes. Annulez à tout moment.',
    'pricing.cancelAnytimeNote': 'Annulez à tout moment dans Profil puis Abonnement.',
    'pricing.oldPrice': '11,49 €/mois',
    'pricing.foundingRate': 'Tarif de fondation',
    'pricing.oneMonth': '1 Mois',
    'pricing.threeMonths': '3 Mois',
    'pricing.sixMonths': '6 Mois',
    'pricing.monthlyPer': '/mois',
    'pricing.monthlyWeek': '1,50 €/semaine',
    'pricing.quarterlyPrice': '5,83 €',
    'pricing.quarterlyPer': '/mois',
    'pricing.quarterlyWeek': '1,35 €/semaine',
    'pricing.popularBadge': 'LE PLUS POPULAIRE',
    'pricing.saveQuarterly': 'Économisez 16 €',
    'pricing.biannualPrice': '5,00 €',
    'pricing.biannualPer': '/mois',
    'pricing.biannualWeek': '1,15 €/semaine',
    'pricing.bestValueBadge': 'MEILLEUR PRIX',
    'pricing.saveBiannual': 'Économisez 39 €',
    'pricing.switchesTo': 'Passe au forfait de 6 Mois',
    'pricing.families': '🌍 Plus de 130 familles utilisent déjà Time To Talk',
    'pricing.monthlyLabel': 'Mensuel',
    'pricing.buyNowCta': 'Obtenir l\'accès complet',
    'pricing.cancelBeforeDay30': 'Annulez à tout moment dans Profil puis Abonnement.',
    'pricing.dueTodayLabel': 'dû aujourd\'hui',
    'pricing.thenPerDayBilled': 'puis {day}/jour, facturé {billed}/mois',
    'pricing.reassureTitle': 'Vous ne payez rien aujourd\'hui',
    'pricing.reassureTodayLabel': 'Aujourd\'hui',
    'pricing.reassureAfterDesc': 'Seulement {day}/jour si vous restez, annulez à tout moment',
    'pricing.reassureCheap': 'C\'est moins qu\'un café par mois',
    'pricing.reassureCta': 'Voir mon forfait',
    'pricing.secureCheckoutStripe': 'Paiement sécurisé via Stripe.',
    'pricing.offerPercentBadge': '{percent} % de réduction',
    'pricing.breakoutReminderCta': 'Montrez-moi comment',
    'pricing.founderName': 'Gintaras, fondateur',
    'pricing.founderHeadline': 'Vous voulez une offre personnalisée ?',
    'pricing.founderBody': 'Appel rapide de 10 minutes : en savoir plus, obtenir de l\'aide et peut-être partager des idées que je transformerai en nouvelles fonctionnalités pour vous.',
    'pricing.teacherHeadline': 'Configurez Time to Talk pour vos élèves.',
    'pricing.teacherSub': 'Accès complet aux 3 modes pour votre classe. Annulez à tout moment.',
    'pricing.teacherFeature1': 'Utilisez-le avec chaque élève que vous accompagnez',
    'pricing.teacherFeature2': 'Lituanien et anglais, voix intégrée',
    'pricing.teacherFeature3': 'Un appel de configuration gratuit pour l\'adapter à votre classe',
    'pricing.teacherFounderHeadline': 'Laissez-moi le configurer avec vous',
    'pricing.teacherFounderBody': 'Appel rapide de 15 minutes : je vous aiderai à configurer Time to Talk pour vos élèves et répondrai à tout ce dont vous avez besoin.',
    'pricing.founderCtaPrimary': 'Réserver un appel avec Gintaras',
    'pricing.founderSkip': 'Continuer sans appel',
    'pricing.day27': 'Jour 27',
    'pricing.day27Desc': 'Nous vous envoyons un e-mail de rappel.',
    'pricing.noActiveSubscription': 'Aucun abonnement actif trouvé. Si vous venez de payer, veuillez patienter quelques minutes.',
    'pricing.errorCheckingSubscription': 'Erreur lors de la vérification de l\'abonnement. Veuillez réessayer.',
    'pricing.checking': 'Vérification...',
    'pricing.restorePurchase': 'Restaurer l\'achat',
    'pricing.backToOnboarding': 'Retour à l\'intégration',
    'pricing.somethingWentWrong': 'Un problème est survenu. Veuillez réessayer.',
    'pricing.promoErrorAlreadyAccount': 'Le code promo {code} a déjà été utilisé sur votre compte. Abonnez-vous ci-dessous pour continuer, l\'abonnement est à un clic.',
    'pricing.promoErrorAlreadyNetwork': 'Le code promo {code} a déjà été utilisé depuis votre réseau. Abonnez-vous ci-dessous, l\'abonnement est à un clic.',
    'pricing.promoErrorGeneric': 'Nous n\'avons pas pu appliquer le code promo {code}. Abonnez-vous ci-dessous ou réessayez plus tard.',
    'pricing.promoErrorDismiss': 'Compris',
    'pricing.terms': 'Conditions',
    'pricing.privacy': 'Confidentialité',
    'success.badge': 'Vous êtes Premium',
    'success.title': 'Vous êtes prêt.',
    'success.sub': 'Timo est prêt à aider votre enfant à trouver sa voix.',
    'success.cta': 'C\'est parti',
    'success.unlock1': 'Accès complet débloqué, rien n\'est retenu',
    'success.unlock2': 'Discuter, En direct et Parler prêts à être explorés',
    'success.unlock3': 'Synchronisé sur chaque téléphone et tablette',
    'success.footer': 'Toutes les fonctionnalités Premium sont actives sur votre compte.',
    'download.appInstalled': 'Application installée',
    'download.continuingOnboarding': 'Poursuite de l\'intégration...',
    'download.installApp': 'Installer l\'application',
    'download.bestExperience': 'La meilleure expérience est dans l\'application installée.',
    'download.apple': 'Apple',
    'download.iphoneIpad': 'iPhone / iPad',
    'download.android': 'Android',
    'download.chromeInstall': 'Installation Chrome',
    'download.appleInstall': 'Installation Apple',
    'download.homeScreenQuality': 'La meilleure qualité d\'expérience est à partir de l\'écran d\'accueil.',
    'download.openSafari1': '1. Ouvrez cette page dans Safari.',
    'download.openSafari2': '2. Dans Safari, touchez Partager.',
    'download.openSafari3': '3. Touchez Sur l\'écran d\'accueil puis Ajouter.',
    'download.copyLinkSafari': 'Copier le lien pour Safari',
    'download.linkCopiedSafari': 'Lien copié. Ouvrez Safari et collez le lien.',
    'download.copyFailed': 'Échec de la copie. Veuillez copier l\'URL manuellement et l\'ouvrir dans Safari.',
    'download.tapShare1': 'Touchez Partager (carré + flèche).',
    'download.tapShare2': 'Touchez Sur l\'écran d\'accueil.',
    'download.tapShare3': 'Touchez Ajouter.',
    'download.openShareMenu': 'Ouvrir le menu de partage',
    'download.inAppBrowserHint': 'Si vous êtes dans le navigateur Instagram/Facebook, ouvrez le menu et touchez Ouvrir dans Safari.',
    'download.androidInstall': 'Installation Android',
    'download.androidStep1': 'Ouvrez le menu Chrome (⋮ dans le coin supérieur droit)',
    'download.androidStep2': 'Touchez "Ajouter à l\'écran d\'accueil" ou "Installer l\'application"',
    'download.androidStep3': 'Touchez "Installer" pour confirmer',
    'download.otherDeviceTitle': 'Vous voulez l\'application sur un autre appareil ?',
    'download.otherDeviceBody': 'Ouvrez un navigateur sur cet appareil, allez sur timohelps.com et connectez-vous avec les mêmes identifiants.',
    'download.otherDeviceHelp': 'Des problèmes ? Envoyez-nous un message à',
    'download.promptAutoOpen': 'La demande d\'installation devrait s\'ouvrir automatiquement.',
    'download.promptAutoOpenAndroid': 'Sur Android (Chrome), la boîte de dialogue d\'installation peut s\'ouvrir automatiquement.',
    'download.androidInstallOnlyNote': 'L\'installation en un clic est pour Android (Chrome). Les iPhone et iPad utilisent Ajouter à l\'écran d\'accueil - voir ci-dessous.',
    'download.iosInstallTitle': 'iPhone et iPad',
    'download.iosInstallHint': 'Dans Safari, touchez Partager, puis Sur l\'écran d\'accueil. Si vous ne le voyez pas, touchez d\'abord Plus dans la feuille de partage, puis Sur l\'écran d\'accueil, puis Ajouter.',
    'download.downloadApp': 'Télécharger l\'application',
    'download.promptNotOpen': 'La demande d\'installation ne s\'est pas ouverte. Ouvrez le menu du navigateur et touchez "Installer l\'application" ou "Ajouter à l\'écran d\'accueil".',
    'download.desktopHint': 'Pour de meilleurs résultats, ouvrez ceci sur iPhone/iPad/Android et installez l\'application.',
    'download.backToLanding': 'Retour au site web',
    'download.continueWeb': 'Continuer sur le web',
    'download.webUseEverything': 'Vous pouvez toujours tout utiliser sur le web.',
    'download.windowsTitle': 'Windows et ordinateur de bureau',
    'download.windowsHint': 'Cliquez sur l\'icône d\'installation dans la barre d\'adresse de votre navigateur (Chrome ou Edge recommandé).',
    'download.iosVideoSoon': 'Guide vidéo à venir',
    'download.continueSetup': 'Continuer la configuration',
    'download.installedSuccess': 'Application installée avec succès',
    'landingPricing.oldPriceCurrency': '11,49 €/mois',
    'landingPricing.oneMonth': '1 Mois',
    'landingPricing.threeMonths': '3 Mois',
    'landingPricing.sixMonths': '6 Mois',
    'landingPricing.perMonth': '/mois',
    'landingPricing.week1': '1,50 €/semaine',
    'landingPricing.week3': '1,35 €/semaine',
    'landingPricing.week6': '1,15 €/semaine',
    'landingPricing.badgePopular': 'LE PLUS POPULAIRE',
    'landingPricing.badgeBest': 'MEILLEUR PRIX',
    'landingPricing.save16': 'Économisez 16 €',
    'landingPricing.save39': 'Économisez 39 €',
    'cookie.title': 'Cookies',
    'cookie.body': 'Nous utilisons des cookies pour les statistiques (PostHog) et la mesure publicitaire (Meta). Nous ne vendons jamais vos données, et l\'application fonctionne parfaitement si vous refusez.',
    'cookie.accept': 'Accepter',
    'cookie.decline': 'Refuser',
    'cookie.learnMore': 'Politique de confidentialité',
    'referral.pageTitle': 'Invitez des amis, gagnez des mois gratuits',
    'referral.pageSubtitle': 'Partagez Time To Talk. Lorsqu\'un ami paie son premier mois, vous en obtenez un gratuit.',
    'referral.heroEarnedLabel': 'Vous avez gagné',
    'referral.heroMonths': '{n} mois',
    'referral.heroOneMonth': '1 mois',
    'referral.heroNoMonths': '0 mois',
    'referral.heroFromConversions': 'à partir de {n} parrainages',
    'referral.heroFromOneConversion': 'à partir de 1 parrainage',
    'referral.heroFromZero': 'aucun parrainage pour le moment',
    'referral.heroCapUsed': '{used} sur {total} de la limite annuelle utilisée',
    'referral.heroFirstTime': 'Partagez votre lien et gagnez votre premier mois gratuit.',
    'referral.codeLabel': 'Votre code',
    'referral.linkLabel': 'Votre lien',
    'referral.copy': 'Copier le lien',
    'referral.copied': 'Copié !',
    'referral.share': 'Partager',
    'referral.shareNative': 'Partager',
    'referral.shareWhatsapp': 'WhatsApp',
    'referral.shareMessenger': 'Messenger',
    'referral.shareEmail': 'E-mail',
    'referral.shareSms': 'SMS',
    'referral.shareMessage': 'J\'utilise Timo Helps pour aider mon enfant à s\'entraîner à parler. Jetez un oeil : {link}',
    'referral.shareEmailSubject': 'Essayez Time To Talk avec moi',
    'referral.howTitle': 'Comment ça marche',
    'referral.howStep1': 'Envoyez votre lien à un ami.',
    'referral.howStep2': 'Il s\'abonne avec votre lien.',
    'referral.howStep3': 'Lorsqu\'il paie son premier mois, vous obtenez 1 mois gratuit, automatiquement.',
    'referral.rules': 'Une récompense par ami. Jusqu\'à 12 mois gratuits par an. Les auto-parrainages et les comptes partagés ne seront pas récompensés.',
    'referral.errorLoad': 'Impossible de charger vos informations de parrainage. Veuillez actualiser.',
    'referral.capReached': 'Vous avez atteint la limite de 12 mois gratuits de cette année. Merci d\'avoir partagé.',
    'referral.bannerInvited': 'Invité par un ami. Bienvenue sur Timo Helps.',
    'referral.bannerInvitedShort': 'Invité par un ami.',
    'referral.announceTitle': 'Nouveau : Obtenez 1 mois gratuit',
    'referral.announceBody': 'Invitez un ami sur Time To Talk. Lorsqu\'il paie son premier mois, vous en obtenez un gratuit.',
    'referral.announceCta': 'Voir comment ça marche',
    'referral.announceLater': 'Peut-être plus tard',
    'referral.youGetLabel': 'Vous obtenez',
    'referral.youGetReward': '1 mois gratuit',
    'referral.friendGetsLabel': 'L\'ami obtient',
    'referral.friendGetsReward': 'accès complet dès le premier jour',
    'referral.linkOnlyNote': 'Seul ce lien exact valide votre récompense. Partager le code seul ne fonctionnera pas.',

    // --- Native iOS port (WS-2 auth, WS-3 purchases, WS-4 speech, WS-5 media,
    //     WS-6 install, WS-7 AI consent and content reporting). Merged from
    //     src/native/_i18n/*.strings.json. Additive: no existing key was changed.
    'native.auth.browserUnavailable': 'La fenêtre de connexion n\'a pas pu être ouverte. Veuillez réessayer.',
    'native.auth.oauthCancelled': 'La connexion a été annulée.',
    'native.auth.oauthFailed': 'La connexion n\'a pas abouti. Veuillez réessayer.',
    'native.auth.passwordResetOpensBrowser': 'La réinitialisation du mot de passe ouvre une page sécurisée dans votre navigateur. Modifiez-y votre mot de passe, puis revenez ici pour vous connecter avec le nouveau.',
    'native.auth.sessionFailed': 'Nous n\'avons pas pu terminer votre connexion. Veuillez réessayer.',
    'native.consent.agree': 'J\'accepte',
    'native.consent.contact': 'Une question ? Écrivez-nous :',
    'native.consent.declinedAgree': 'J\'ai changé d\'avis, j\'accepte',
    'native.consent.declinedBody': 'Sans cela, Timo ne peut ni écouter ni répondre. Vous pouvez toujours utiliser les images, les scripts enregistrés et tous les réglages. Quand vous serez prêt, activez-le dans les réglages, section Confidentialité.',
    'native.consent.declinedContinue': 'Continuer sans la voix de Timo',
    'native.consent.declinedTitle': 'Timo restera silencieux pour l\'instant',
    'native.consent.forLabel': 'Pour :',
    'native.consent.getsLabel': 'Reçoit :',
    'native.consent.intro': 'Timo fait appel à quelques entreprises extérieures : elles transforment la parole en texte, rédigent ses réponses et les prononcent. Une partie de ce que vous dites et écrivez leur est donc envoyée. Voici précisément qui elles sont et ce que chacune reçoit.',
    'native.consent.notNow': 'Pas maintenant',
    'native.consent.privacyLink': 'Lire la politique de confidentialité',
    'native.consent.proc.anthropic.purpose': 'Rédiger les réponses de Timo',
    'native.consent.proc.anthropic.receives': 'Votre conversation avec Timo, sous forme de texte',
    'native.consent.proc.deepgram.purpose': 'Transformer la parole en texte',
    'native.consent.proc.deepgram.receives': 'Votre voix pendant que le micro est allumé',
    'native.consent.proc.elevenlabs.purpose': 'Transformer ce texte en voix de Timo',
    'native.consent.proc.elevenlabs.receives': 'Le texte que Timo va prononcer',
    'native.consent.proc.google.purpose': 'Rédiger les réponses de Timo quand Google est actif',
    'native.consent.proc.google.receives': 'Votre conversation avec Timo, sous forme de texte',
    'native.consent.proc.openai.purpose': 'Vérifier la grammaire lituanienne',
    'native.consent.proc.openai.receives': 'Les réponses de Timo en lituanien, sous forme de texte',
    'native.consent.promise': 'Nous ne vendons pas vos données et nous ne les utilisons pas pour la publicité. Vous pouvez désactiver cela à tout moment dans les réglages. Si vous le désactivez, Timo ne peut ni écouter ni répondre, et tout le reste de l\'application continue de fonctionner.',
    'native.consent.settings.agreedOn': 'Accepté le',
    'native.consent.settings.confirmBody': 'Timo cessera d\'écouter et de répondre. Tout le reste de l\'application continue de fonctionner, et vous pouvez le réactiver quand vous voulez.',
    'native.consent.settings.confirmKeep': 'Laisser activé',
    'native.consent.settings.confirmTitle': 'Désactiver ?',
    'native.consent.settings.confirmTurnOff': 'Désactiver',
    'native.consent.settings.description': 'Permet à Timo d\'envoyer la parole et le texte de la conversation aux entreprises listées ci-dessous, afin qu\'il puisse écouter, répondre et parler.',
    'native.consent.settings.label': 'Partage avec les services d\'IA',
    'native.consent.settings.offNote': 'Tant que c\'est désactivé, Timo ne peut ni écouter ni répondre.',
    'native.consent.settings.section': 'Confidentialité',
    'native.consent.settings.whoGetsWhat': 'Voir qui reçoit quoi',
    'native.consent.title': 'Avant que Timo se mette à parler',
    'native.install.alreadyInstalledBody': 'Sur cet appareil, vous utilisez déjà l\'application Timo, il n\'y a donc rien à installer.',
    'native.install.alreadyInstalledTitle': 'Vous avez déjà l\'application',
    'native.install.otherDevices': 'Vous voulez Timo sur un autre appareil ? Connectez-vous avec le même compte et tout sera déjà là.',
    'native.manage.appleBilled': 'Apple gère cet abonnement. Vous pouvez le résilier ou changer de formule dans les réglages d\'abonnements de l\'App Store.',
    'native.manage.cta': 'Gérer dans l\'App Store',
    'native.manage.failed': 'Impossible d\'ouvrir vos abonnements App Store. Ouvrez Réglages, touchez votre nom, puis Abonnements.',
    'native.mic.backgroundStopped': 'L\'écoute s\'est arrêtée parce que l\'app est passée en arrière-plan. Touchez pour recommencer.',
    'native.mic.continueWithoutMic': 'Continuer sans microphone',
    'native.mic.deniedBody': 'L\'iPhone ne demande qu\'une seule fois. Ouvrez les réglages et activez le microphone pour Timo.',
    'native.mic.deniedTitle': 'Le microphone est désactivé',
    'native.mic.openSettings': 'Ouvrir les réglages',
    'native.mic.primerAllow': 'Autoriser le microphone',
    'native.mic.primerBody': 'Pour que Timo entende ce que l\'autre personne a dit et vous aide à répondre.',
    'native.mic.primerNotNow': 'Pas maintenant',
    'native.mic.primerPoint1': 'Votre voix sert uniquement à transformer la parole en texte.',
    'native.mic.primerPoint2': 'L\'enregistrement n\'a lieu que pendant un tour de parole, jamais en arrière-plan.',
    'native.mic.primerPoint3': 'Vous pouvez désactiver le microphone à nouveau dans les réglages.',
    'native.mic.primerTitle': 'Timo a besoin de votre microphone',
    'native.mic.unavailableBody': 'Cet appareil n\'a pas de microphone que Timo puisse utiliser.',
    'native.mic.unavailableTitle': 'Aucun microphone trouvé',
    'native.minors.affirmation': 'En appuyant sur « J\'accepte », vous confirmez que vous êtes un parent ou un tuteur, ou que vous avez 16 ans ou plus.',
    'native.minors.ageNote': 'Dans la plupart des pays d\'Europe, un parent ou un tuteur doit donner son accord pour toute personne de moins de 16 ans. En Lituanie, cet âge est de 14 ans, et aux États-Unis il est de 13 ans.',
    'native.minors.askGrownUp': 'Demande à un parent ou à un tuteur de regarder cela avec toi et d\'appuyer sur « J\'accepte » à ta place.',
    'native.minors.underAgeLink': 'J\'ai moins de 16 ans',
    'native.personalVoice.allow': 'Autoriser la voix personnelle',
    'native.personalVoice.denied': 'Timo n\'a pas l\'autorisation d\'utiliser votre voix personnelle. Activez Autoriser les apps à demander dans Réglages, Accessibilité, Voix personnelle.',
    'native.personalVoice.description': 'Si vous avez enregistré une voix personnelle sur cet iPhone ou iPad, Timo peut parler avec elle. La voix est créée sur l\'appareil, y reste et n\'est jamais envoyée ailleurs.',
    'native.personalVoice.languageUnavailable': 'Apple propose la voix personnelle uniquement en anglais, espagnol et chinois, elle ne peut donc pas encore parler cette langue.',
    'native.personalVoice.none': 'Aucune voix personnelle n\'a encore été enregistrée sur cet appareil. Vous pouvez en créer une dans Réglages, Accessibilité, Voix personnelle.',
    'native.personalVoice.ready': 'La voix personnelle est prête. Choisissez-la dans la liste des voix.',
    'native.personalVoice.speaking': 'Parle avec votre voix personnelle',
    'native.personalVoice.title': 'Utiliser une voix personnelle',
    'native.personalVoice.unsupportedDevice': 'Cet appareil ne peut pas créer de voix personnelle. Un iPhone ou iPad plus récent est nécessaire.',
    'native.purchase.alreadyOwned': 'Vous avez déjà cet abonnement. Touchez « Restaurer l\'achat » pour retrouver votre accès.',
    'native.purchase.failed': 'Nous n\'avons pas pu finaliser l\'achat. Réessayez ou écrivez-nous, nous vous aiderons.',
    'native.purchase.network': 'Pas de connexion à l\'App Store. Vérifiez votre connexion internet et réessayez.',
    'native.purchase.notAllowed': 'Les achats sont désactivés sur cet appareil. Vérifiez les restrictions Temps d\'écran dans les Réglages.',
    'native.purchase.pending': 'Votre achat attend une validation. Dès qu\'il sera validé, votre accès s\'ouvrira automatiquement.',
    'native.purchase.signInFirst': 'Connectez-vous d\'abord pour que l\'abonnement soit lié à votre compte.',
    'native.purchase.unavailable': 'L\'App Store est indisponible pour le moment. Réessayez dans quelques minutes.',
    'native.report.body': 'Merci de nous prévenir. Les réponses de Timo sont écrites par un ordinateur, il lui arrive donc de se tromper. Dites-nous ce qui s\'est passé, une personne le lira.',
    'native.report.cancel': 'Annuler',
    'native.report.done': 'Terminé',
    'native.report.error': 'Le signalement n\'a pas pu être envoyé. Vérifiez votre connexion et réessayez.',
    'native.report.noteLabel': 'Souhaitez-vous ajouter quelque chose ? (facultatif)',
    'native.report.reason.language': 'C\'était dans la mauvaise langue',
    'native.report.reason.other': 'Autre chose',
    'native.report.reason.unkind': 'C\'était impoli ou blessant',
    'native.report.reason.unsafe': 'Ce n\'était pas sûr pour un enfant',
    'native.report.reason.wrong': 'C\'était faux ou confus',
    'native.report.safetyNote': 'Si quelqu\'un est en danger en ce moment, contactez les services d\'urgence.',
    'native.report.send': 'Envoyer le signalement',
    'native.report.sending': 'Envoi...',
    'native.report.sentBody': 'Chaque signalement est lu par une personne. Si vous souhaitez une réponse, écrivez-nous :',
    'native.report.sentTitle': 'Signalement envoyé. Merci.',
    'native.report.stopConversation': 'Terminer aussi cette conversation',
    'native.report.title': 'Signaler cette réponse',
    'native.report.trigger': 'Signaler cette réponse',
    'native.restore.restored': 'Votre accès est de retour. Bon retour parmi nous !',
    'native.speech.interrupted': 'L\'écoute s\'est arrêtée à cause d\'un appel ou d\'un autre son. Touchez pour recommencer.',
    'native.speech.languageNotSupported': 'Cet iPhone ne reconnaît pas cette langue tout seul, donc Timo écoute comme d\'habitude.',
    'native.speech.onDevice': 'Votre voix reste sur cet appareil',
    'native.speech.permissionNeeded': 'Timo a besoin du microphone et de la reconnaissance vocale pour vous entendre. Vous pouvez les activer dans Réglages.',
    'native.voice.preview': 'Écouter cette voix',
    'native.voice.systemVoices': 'Voix sur cet appareil',
    'native.voice.title': 'La voix de Timo',
    'pushToTalk.micBackgroundTitle': 'L\'écoute s\'est arrêtée',
    'pushToTalk.micBlockedBody': 'Le microphone est bloqué, rien n\'a été enregistré. Autorisez le microphone ou écrivez ce qu\'ils ont dit.',
    'pushToTalk.micBlockedTitle': 'Timo n\'entend rien',
    'pushToTalk.micNotNowBody': 'Vous pouvez activer le microphone à tout moment. Pour l\'instant, écrivez ce qu\'ils ont dit.',
    'pushToTalk.micNotNowTitle': 'Le microphone est désactivé',
    'pushToTalk.micProblemBody': 'L\'écoute s\'est arrêtée de façon inattendue, rien n\'a été enregistré. Réessayez ou écrivez ce qu\'ils ont dit.',
    'pushToTalk.micProblemTitle': 'L\'écoute s\'est arrêtée',
    'pushToTalk.micUnavailableBody': 'Cet appareil n\'a pas de microphone que Timo puisse utiliser. Vous pouvez écrire ce qu\'ils ont dit.',
    'pushToTalk.micUnavailableTitle': 'Aucun microphone trouvé',
    'pushToTalk.micUnsupportedBody': 'La reconnaissance vocale n\'est pas disponible ici, rien n\'a été enregistré. Vous pouvez écrire ce qu\'ils ont dit.',
    'pushToTalk.micUnsupportedTitle': 'Ce navigateur ne peut pas écouter',
    'settings.microphone.checkDesc': 'Vérifiez si Timo vous entend, et corrigez si besoin',
    'settings.microphone.checkLabel': 'Vérifier l\'accès au microphone',
    'settings.microphone.denied': 'Le microphone est bloqué. Ouvrez les réglages pour l\'autoriser.',
    'settings.microphone.granted': 'Le microphone fonctionne',
    'settings.microphone.title': 'Microphone',
    'settings.microphone.unavailable': 'Aucun microphone trouvé sur cet appareil',

    // --- merged from src/native/_i18n: WS-C, WS-F, PRIVACY ---
    // WS-C
    'chat.ariaGoBack': 'Retour',
    'chat.ariaInputMode': 'Mode de saisie',
    'chat.ariaInputModeSpeak': 'Parler',
    'chat.ariaInputModeType': 'Écrire',
    'chat.ariaPlayAloud': 'Lire à voix haute',
    'chat.ariaSendMessage': 'Envoyer le message',
    'chat.ariaRecordMe': 'Enregistrer ma voix',
    'chat.ariaRecordOther': 'Enregistrer l\'autre personne',
    'live.ariaFlipSpeakers': 'Intervertir les interlocuteurs',
    'live.ariaClearConversation': 'Effacer la conversation',
    'live.ariaCalibrationSettings': 'Réglages de calibration',
    'live.ariaClose': 'Fermer',
    'live.whatShouldISay': 'Qu\'est-ce que je peux dire ?',
    'live.manageScriptsHint': 'Vous pouvez gérer vos textes enregistrés dans la section Textes.',
    'live.safetyTitle': 'Alerte de sécurité',
    'live.safetyBody': 'Cette conversation n\'est peut-être pas sûre. Si vous vous sentez menacé, partez tout de suite.',
    'quickChoice.send': 'Envoyer',
    'quickChoice.tellMeMorePlaceholder': 'Dis-m\'en plus...',
    // WS-F
    'common.closeAria': 'Fermer',
    'common.goBackAria': 'Retour',
    // PRIVACY
    'privacy.minors.heading': '5. Enfants, mineurs et consentement parental',
    'privacy.minors.s1.heading': '5.1 À qui s\'adresse cette application et à qui appartient le compte',
    'privacy.minors.s1.p1': 'Time To Talk (l\'application Timo) est conçue pour les enfants ayant un retard de langage, pour les enfants et adultes autistes, et pour toute personne qui a du mal à parler. Beaucoup de nos utilisateurs sont des enfants.',
    'privacy.minors.s1.p2': 'Le compte appartient à un adulte : un parent, un tuteur, un accompagnant, un thérapeute ou un enseignant. C\'est cet adulte qui crée le compte, détient les identifiants et paie l\'abonnement. Un enfant ne s\'inscrit pas seul.',
    'privacy.minors.s1.p3': 'C\'est pourtant l\'enfant qui utilise l\'application. Quand il l\'utilise, l\'application reçoit ce qu\'il écrit et, tant que le micro est allumé, ce qu\'il dit. Nous préférons l\'écrire clairement plutôt que prétendre ne jamais rien recevoir d\'un enfant.',
    'privacy.minors.s2.heading': '5.2 L\'âge à partir duquel un parent ou tuteur doit consentir',
    'privacy.minors.s2.intro': 'Si la personne qui utilise l\'application a moins que l\'âge indiqué pour votre pays, un parent, un tuteur ou un accompagnant doit donner son accord avant toute utilisation.',
    'privacy.minors.s2.col.where': 'Où vous êtes',
    'privacy.minors.s2.col.age': 'Un parent ou tuteur doit consentir pour toute personne de moins de',
    'privacy.minors.s2.col.rule': 'La règle qui s\'applique',
    'privacy.minors.s2.lt.where': 'Lituanie',
    'privacy.minors.s2.lt.age': '14',
    'privacy.minors.s2.lt.rule': 'Article 8 du RGPD, à l\'âge fixé par la loi lituanienne',
    'privacy.minors.s2.us.where': 'États-Unis',
    'privacy.minors.s2.us.age': '13',
    'privacy.minors.s2.us.rule': 'COPPA, la loi américaine sur la protection de la vie privée des enfants en ligne',
    'privacy.minors.s2.eu.where': 'Reste de l\'UE et de l\'EEE',
    'privacy.minors.s2.eu.age': '16, sauf si votre pays a fixé un âge inférieur, qui ne peut jamais descendre sous 13',
    'privacy.minors.s2.eu.rule': 'Article 8 du RGPD',
    'privacy.minors.s2.world.where': 'Partout ailleurs',
    'privacy.minors.s2.world.age': '16',
    'privacy.minors.s2.world.rule': 'Notre propre règle de base, appliquée dans le monde entier',
    'privacy.minors.s2.p1': 'La Lituanie est notre pays d\'origine et notre marché principal. L\'âge y est de 14 ans.',
    'privacy.minors.s2.p2': 'Avant qu\'une conversation ne soit envoyée aux entreprises listées au point 5.4, l\'application affiche un écran qui les nomme toutes et vous demande votre accord. La phrase au-dessus du bouton "J\'accepte" vous demande de confirmer que vous êtes parent, tuteur ou accompagnant, ou que vous avez 16 ans ou plus. Si un enfant appuie sur "J\'ai moins de 16 ans", rien de grave ne se passe et personne n\'est grondé : l\'application lui demande simplement d\'aller chercher un adulte. Vous pouvez retirer cet accord plus tard dans les réglages, section Confidentialité.',
    'privacy.minors.s2.p3': 'Nous ne demandons jamais de date de naissance. La demander reviendrait à collecter plus d\'informations sur un enfant, ce qui est l\'inverse du but de cette section.',
    'privacy.minors.s3.heading': '5.3 Ce que nous collectons quand un enfant utilise l\'application',
    'privacy.minors.s3.intro': 'Trois choses :',
    'privacy.minors.s3.email': 'Une adresse e-mail, une seule fois, à l\'inscription. C\'est celle de l\'adulte titulaire du compte. Nous ne demandons jamais à un enfant sa propre adresse e-mail.',
    'privacy.minors.s3.text': 'Le texte de la conversation. Ce qui est écrit ou dit à Timo, et ce que Timo répond. Les conversations d\'entraînement sont enregistrées dans le compte pour pouvoir être rouvertes plus tard dans l\'Historique. Chacune peut y être supprimée.',
    'privacy.minors.s3.voice': 'La voix, uniquement pendant que le micro est allumé. L\'audio part de l\'appareil directement vers Deepgram, qui le transforme en texte. Nous ne conservons aucun enregistrement vocal sur nos serveurs. Le micro reste éteint tant que vous ne l\'allumez pas.',
    'privacy.minors.s3.p2': 'Nous ne demandons pas à un enfant son vrai nom, son adresse, son numéro de téléphone, son école, une photo, son âge ou un diagnostic. Rien dans l\'application ne l\'exige. Si cela est écrit dans une conversation, c\'est enregistré avec elle et vous pouvez le supprimer dans l\'Historique.',
    'privacy.minors.s4.heading': '5.4 Les entreprises qui reçoivent ces données',
    'privacy.minors.s4.intro': 'Timo ne peut ni écouter, ni répondre, ni parler sans l\'aide d\'entreprises extérieures. Ces cinq-là voient le contenu des conversations. C\'est la même liste que l\'application vous montre avant que vous acceptiez.',
    'privacy.minors.s4.col.company': 'Entreprise',
    'privacy.minors.s4.col.receives': 'Ce qu\'elle reçoit',
    'privacy.minors.s4.col.purpose': 'À quoi cela sert',
    'privacy.minors.s4.anthropic.receives': 'Votre conversation avec Timo, sous forme de texte',
    'privacy.minors.s4.anthropic.purpose': 'Rédiger les réponses de Timo',
    'privacy.minors.s4.google.receives': 'Votre conversation avec Timo, sous forme de texte',
    'privacy.minors.s4.google.purpose': 'Rédiger les réponses de Timo quand Google est actif',
    'privacy.minors.s4.openai.receives': 'Les réponses de Timo en lituanien, sous forme de texte',
    'privacy.minors.s4.openai.purpose': 'Vérifier la grammaire lituanienne',
    'privacy.minors.s4.deepgram.receives': 'Votre voix pendant que le micro est allumé',
    'privacy.minors.s4.deepgram.purpose': 'Transformer la parole en texte',
    'privacy.minors.s4.elevenlabs.receives': 'Le texte que Timo va prononcer',
    'privacy.minors.s4.elevenlabs.purpose': 'Transformer ce texte en voix de Timo',
    'privacy.minors.s4.note': 'Google ne reçoit le texte des conversations que lorsque Google est le fournisseur de modèle actif. OpenAI n\'est utilisé que pour le lituanien, afin de corriger la grammaire d\'une réponse déjà rédigée par Timo. Deepgram sert aussi de voix de secours dans quelques langues, et il reçoit alors le texte que Timo va prononcer.',
    'privacy.minors.s4.others': 'Les autres entreprises avec lesquelles nous travaillons, listées à la Section 7, gèrent le compte, le paiement, les e-mails et les statistiques, pas la conversation elle-même.',
    'privacy.minors.s4.noPermission': 'Aucune de ces entreprises n\'est autorisée à utiliser les données d\'un enfant pour sa propre publicité, ni à entraîner ses propres modèles au-delà de ce qu\'indiquent ses politiques publiées.',
    'privacy.minors.s5.heading': '5.5 Ce que nous ne faisons jamais avec les données d\'un enfant',
    'privacy.minors.s5.item1': 'Nous ne les vendons jamais. À personne, sous aucune forme, à aucun prix.',
    'privacy.minors.s5.item2': 'Nous ne les utilisons jamais à des fins publicitaires et ne créons jamais de profils publicitaires d\'enfants.',
    'privacy.minors.s5.item3': 'Nous ne les utilisons jamais pour entraîner des modèles d\'IA, les nôtres ou ceux d\'autrui.',
    'privacy.minors.s5.item4': 'Nous ne les utilisons jamais pour établir des profils comportementaux, psychologiques, cliniques ou scolaires d\'un enfant.',
    'privacy.minors.s5.item5': 'Nous ne les publions jamais et ne les montrons jamais à d\'autres utilisateurs.',
    'privacy.minors.s5.pixel': 'Notre site public et les pages de l\'application contiennent la balise de mesure publicitaire de Meta décrite à la Section 12. Elle compte les vues de pages et les inscriptions pour savoir quelles publicités fonctionnent. Elle ne reçoit jamais le contenu des conversations, la voix, ni ce qu\'un enfant écrit.',
    'privacy.minors.s6.heading': '5.6 Ce qu\'un parent ou tuteur peut demander',
    'privacy.minors.s6.intro': 'À tout moment, vous pouvez :',
    'privacy.minors.s6.see': 'Les consulter. Demander une copie de tout ce que nous détenons sur le compte.',
    'privacy.minors.s6.correct': 'Les corriger. Nous demander de rectifier ce qui est inexact.',
    'privacy.minors.s6.delete': 'Les supprimer. Supprimer les conversations une par une dans l\'Historique, ou supprimer tout le compte.',
    'privacy.minors.s6.withdraw': 'Retirer votre accord. Retirez le consentement à l\'IA dans les réglages, section Confidentialité. Timo cesse alors d\'écouter et de répondre. Les images, les scripts enregistrés et tous les réglages continuent de fonctionner. Le retrait n\'annule pas les traitements déjà effectués licitement.',
    'privacy.minors.s6.deleteHeading': 'Supprimer le compte. Les réglages contiennent un bouton Supprimer le compte. Quand vous l\'utilisez :',
    'privacy.minors.s6.step1': 'Nous annulons d\'abord tous vos abonnements en cours chez Stripe, pour que vous ne puissiez plus être facturé.',
    'privacy.minors.s6.step2': 'Si l\'une de ces annulations échoue, nous nous arrêtons et votre compte n\'est pas supprimé. Vous verrez une erreur vous invitant à nous contacter, et nous terminerons manuellement. Mieux vaut vous laisser connecté que vous laisser payer pour un compte auquel vous n\'avez plus accès.',
    'privacy.minors.s6.step3': 'Si l\'annulation réussit, nous supprimons votre identifiant et l\'enregistrement du compte de notre système d\'authentification : l\'adresse e-mail, le mot de passe, ainsi que les réglages et consentements enregistrés avec.',
    'privacy.minors.s6.step4': 'Nous marquons votre abonnement comme annulé et conservons un petit enregistrement de suppression : l\'adresse e-mail, la date et la référence de l\'abonnement annulé. Il sert à prouver quand le compte a été supprimé et que la facturation s\'est arrêtée.',
    'privacy.minors.s6.step5': 'Les données de paiement et les factures restent chez Stripe aussi longtemps que l\'exige la loi comptable lituanienne, soit dix ans. Voir la Section 9. Nous ne pouvons pas les supprimer avant.',
    'privacy.minors.s6.after': 'S\'il reste autre chose à supprimer que le bouton n\'atteint pas, écrivez-nous et nous le ferons manuellement.',
    'privacy.minors.s7.heading': '5.7 Comment nous joindre au sujet des données d\'un enfant',
    'privacy.minors.s7.p1': 'Écrivez à info@timetotalk.lt. Indiquez "Demande concernant les données d\'un enfant" en objet et donnez-nous l\'adresse e-mail du compte.',
    'privacy.minors.s7.p2': 'Nous répondons à chaque demande. Nous accuserons réception de la vôtre sous 5 jours ouvrés et la traiterons sous 30 jours, le délai fixé par le RGPD. Si une demande est complexe et que nous avons besoin de plus de temps, nous vous le dirons avant la fin des 30 jours et vous expliquerons pourquoi. Nous devrons peut-être d\'abord vérifier que vous êtes bien le titulaire du compte, car confier les données d\'un enfant à la mauvaise personne serait une faute bien plus grave qu\'une réponse tardive.',
    'privacy.minors.s7.p3': 'Vous pouvez aussi saisir l\'Inspection nationale de la protection des données de Lituanie (Valstybine duomenu apsaugos inspekcija) sur vdai.lrv.lt ou ada@ada.lt, ou l\'autorité de protection des données de votre pays de l\'EEE.',
    'privacy.minors.s8.heading': '5.8 Combien de temps nous conservons les données d\'un enfant',
    'privacy.minors.s8.intro': 'La Section 9 indique la durée de conservation de chaque catégorie de données. En bref :',
    'privacy.minors.s8.voice': 'La voix : nous ne la conservons pas du tout.',
    'privacy.minors.s8.conversations': 'Les conversations : conservées dans le compte jusqu\'à ce que vous les supprimiez dans l\'Historique ou que vous supprimiez le compte.',
    'privacy.minors.s8.account': 'Les données du compte, y compris l\'adresse e-mail : comme indiqué à la Section 9.',
    'privacy.minors.s8.p2': 'Si vous pensez qu\'un enfant s\'est inscrit à l\'insu d\'un parent ou tuteur, écrivez à info@timetotalk.lt. Après vérification de la demande, nous supprimerons rapidement le compte et ses données.',
  },
};
